(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("Dkugg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dkpjW"));

});
parcelRegister("dkpjW", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $9b40c8c6dfd7ee7b$export$ffb0004e005737fa; }, function (v) { return $9b40c8c6dfd7ee7b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $9b40c8c6dfd7ee7b$export$34b9dba7ce09269b; }, function (v) { return $9b40c8c6dfd7ee7b$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $9b40c8c6dfd7ee7b$export$25062201e9e25d76; }, function (v) { return $9b40c8c6dfd7ee7b$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9b40c8c6dfd7ee7b$export$ffb0004e005737fa;
var $9b40c8c6dfd7ee7b$export$34b9dba7ce09269b;
var $9b40c8c6dfd7ee7b$export$25062201e9e25d76;
"use strict";
var $9b40c8c6dfd7ee7b$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $9b40c8c6dfd7ee7b$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $9b40c8c6dfd7ee7b$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $9b40c8c6dfd7ee7b$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$9b40c8c6dfd7ee7b$export$ffb0004e005737fa = $9b40c8c6dfd7ee7b$var$REACT_FRAGMENT_TYPE;
$9b40c8c6dfd7ee7b$export$34b9dba7ce09269b = $9b40c8c6dfd7ee7b$var$jsxProd;
$9b40c8c6dfd7ee7b$export$25062201e9e25d76 = $9b40c8c6dfd7ee7b$var$jsxProd;

});


parcelRegister("iBcuS", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $d8a5605a402fdc13$export$882461b6382ed46c; }, function (v) { return $d8a5605a402fdc13$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $d8a5605a402fdc13$export$757ceba2d55c277e; }, function (v) { return $d8a5605a402fdc13$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $d8a5605a402fdc13$export$83d89fbfd8236492; }, function (v) { return $d8a5605a402fdc13$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $d8a5605a402fdc13$export$882461b6382ed46c;
var $d8a5605a402fdc13$export$757ceba2d55c277e;
var $d8a5605a402fdc13$export$83d89fbfd8236492;

var $98Fbt = parcelRequire("98Fbt");
"use strict";

var $hXcSD = parcelRequire("hXcSD");

var $eyAY5 = parcelRequire("eyAY5");

var $bge4W = parcelRequire("bge4W");
function $d8a5605a402fdc13$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d8a5605a402fdc13$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $d8a5605a402fdc13$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $d8a5605a402fdc13$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $d8a5605a402fdc13$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $d8a5605a402fdc13$var$assertIsMounted(fiber) {
    if ($d8a5605a402fdc13$var$getNearestMountedFiber(fiber) !== fiber) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(188));
}
function $d8a5605a402fdc13$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $d8a5605a402fdc13$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $d8a5605a402fdc13$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $d8a5605a402fdc13$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $d8a5605a402fdc13$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $d8a5605a402fdc13$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $d8a5605a402fdc13$var$assign = Object.assign, $d8a5605a402fdc13$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $d8a5605a402fdc13$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d8a5605a402fdc13$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d8a5605a402fdc13$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d8a5605a402fdc13$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d8a5605a402fdc13$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d8a5605a402fdc13$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d8a5605a402fdc13$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d8a5605a402fdc13$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d8a5605a402fdc13$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d8a5605a402fdc13$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $d8a5605a402fdc13$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $d8a5605a402fdc13$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $d8a5605a402fdc13$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d8a5605a402fdc13$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d8a5605a402fdc13$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d8a5605a402fdc13$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d8a5605a402fdc13$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d8a5605a402fdc13$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $d8a5605a402fdc13$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $d8a5605a402fdc13$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $d8a5605a402fdc13$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $d8a5605a402fdc13$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $d8a5605a402fdc13$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $d8a5605a402fdc13$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $d8a5605a402fdc13$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $d8a5605a402fdc13$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $d8a5605a402fdc13$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $d8a5605a402fdc13$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $d8a5605a402fdc13$var$getComponentNameFromType(type.type) || "Memo";
        case $d8a5605a402fdc13$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $d8a5605a402fdc13$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $d8a5605a402fdc13$var$isArrayImpl = Array.isArray, $d8a5605a402fdc13$var$ReactSharedInternals = $eyAY5.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d8a5605a402fdc13$var$ReactDOMSharedInternals = $bge4W.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d8a5605a402fdc13$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $d8a5605a402fdc13$var$valueStack = [], $d8a5605a402fdc13$var$index = -1;
function $d8a5605a402fdc13$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $d8a5605a402fdc13$var$pop(cursor) {
    0 > $d8a5605a402fdc13$var$index || (cursor.current = $d8a5605a402fdc13$var$valueStack[$d8a5605a402fdc13$var$index], $d8a5605a402fdc13$var$valueStack[$d8a5605a402fdc13$var$index] = null, $d8a5605a402fdc13$var$index--);
}
function $d8a5605a402fdc13$var$push(cursor, value) {
    $d8a5605a402fdc13$var$index++;
    $d8a5605a402fdc13$var$valueStack[$d8a5605a402fdc13$var$index] = cursor.current;
    cursor.current = value;
}
var $d8a5605a402fdc13$var$contextStackCursor = $d8a5605a402fdc13$var$createCursor(null), $d8a5605a402fdc13$var$contextFiberStackCursor = $d8a5605a402fdc13$var$createCursor(null), $d8a5605a402fdc13$var$rootInstanceStackCursor = $d8a5605a402fdc13$var$createCursor(null), $d8a5605a402fdc13$var$hostTransitionProviderCursor = $d8a5605a402fdc13$var$createCursor(null);
function $d8a5605a402fdc13$var$pushHostContainer(fiber, nextRootInstance) {
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$rootInstanceStackCursor, nextRootInstance);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$contextFiberStackCursor, fiber);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $d8a5605a402fdc13$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $d8a5605a402fdc13$var$getOwnHostContext(nextRootInstance), fiber = $d8a5605a402fdc13$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$contextStackCursor);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$contextStackCursor, fiber);
}
function $d8a5605a402fdc13$var$popHostContainer() {
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$contextStackCursor);
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$contextFiberStackCursor);
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$rootInstanceStackCursor);
}
function $d8a5605a402fdc13$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$hostTransitionProviderCursor, fiber);
    var context = $d8a5605a402fdc13$var$contextStackCursor.current;
    var JSCompiler_inline_result = $d8a5605a402fdc13$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$contextFiberStackCursor, fiber), $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$contextStackCursor, JSCompiler_inline_result));
}
function $d8a5605a402fdc13$var$popHostContext(fiber) {
    $d8a5605a402fdc13$var$contextFiberStackCursor.current === fiber && ($d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$contextStackCursor), $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$contextFiberStackCursor));
    $d8a5605a402fdc13$var$hostTransitionProviderCursor.current === fiber && ($d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$hostTransitionProviderCursor), $d8a5605a402fdc13$var$HostTransitionContext._currentValue = $d8a5605a402fdc13$var$sharedNotPendingObject);
}
var $d8a5605a402fdc13$var$prefix, $d8a5605a402fdc13$var$suffix;
function $d8a5605a402fdc13$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $d8a5605a402fdc13$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $d8a5605a402fdc13$var$prefix = match && match[1] || "";
        $d8a5605a402fdc13$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $d8a5605a402fdc13$var$prefix + name + $d8a5605a402fdc13$var$suffix;
}
var $d8a5605a402fdc13$var$reentry = !1;
function $d8a5605a402fdc13$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $d8a5605a402fdc13$var$reentry) return "";
    $d8a5605a402fdc13$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $d8a5605a402fdc13$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $d8a5605a402fdc13$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $d8a5605a402fdc13$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $d8a5605a402fdc13$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $d8a5605a402fdc13$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $d8a5605a402fdc13$var$describeBuiltInComponentFrame("Suspense Fallback") : $d8a5605a402fdc13$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $d8a5605a402fdc13$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $d8a5605a402fdc13$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $d8a5605a402fdc13$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $d8a5605a402fdc13$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $d8a5605a402fdc13$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $d8a5605a402fdc13$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $d8a5605a402fdc13$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $d8a5605a402fdc13$var$hasOwnProperty = Object.prototype.hasOwnProperty, $d8a5605a402fdc13$var$scheduleCallback$3 = $hXcSD.unstable_scheduleCallback, $d8a5605a402fdc13$var$cancelCallback$1 = $hXcSD.unstable_cancelCallback, $d8a5605a402fdc13$var$shouldYield = $hXcSD.unstable_shouldYield, $d8a5605a402fdc13$var$requestPaint = $hXcSD.unstable_requestPaint, $d8a5605a402fdc13$var$now = $hXcSD.unstable_now, $d8a5605a402fdc13$var$getCurrentPriorityLevel = $hXcSD.unstable_getCurrentPriorityLevel, $d8a5605a402fdc13$var$ImmediatePriority = $hXcSD.unstable_ImmediatePriority, $d8a5605a402fdc13$var$UserBlockingPriority = $hXcSD.unstable_UserBlockingPriority, $d8a5605a402fdc13$var$NormalPriority$1 = $hXcSD.unstable_NormalPriority, $d8a5605a402fdc13$var$LowPriority = $hXcSD.unstable_LowPriority, $d8a5605a402fdc13$var$IdlePriority = $hXcSD.unstable_IdlePriority, $d8a5605a402fdc13$var$log$1 = $hXcSD.log, $d8a5605a402fdc13$var$unstable_setDisableYieldValue = $hXcSD.unstable_setDisableYieldValue, $d8a5605a402fdc13$var$rendererID = null, $d8a5605a402fdc13$var$injectedHook = null;
function $d8a5605a402fdc13$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $d8a5605a402fdc13$var$log$1 && $d8a5605a402fdc13$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($d8a5605a402fdc13$var$injectedHook && "function" === typeof $d8a5605a402fdc13$var$injectedHook.setStrictMode) try {
        $d8a5605a402fdc13$var$injectedHook.setStrictMode($d8a5605a402fdc13$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $d8a5605a402fdc13$var$clz32 = Math.clz32 ? Math.clz32 : $d8a5605a402fdc13$var$clz32Fallback, $d8a5605a402fdc13$var$log = Math.log, $d8a5605a402fdc13$var$LN2 = Math.LN2;
function $d8a5605a402fdc13$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($d8a5605a402fdc13$var$log(x) / $d8a5605a402fdc13$var$LN2 | 0) | 0;
}
var $d8a5605a402fdc13$var$nextTransitionUpdateLane = 256, $d8a5605a402fdc13$var$nextTransitionDeferredLane = 262144, $d8a5605a402fdc13$var$nextRetryLane = 4194304;
function $d8a5605a402fdc13$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $d8a5605a402fdc13$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $d8a5605a402fdc13$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $d8a5605a402fdc13$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d8a5605a402fdc13$var$claimNextRetryLane() {
    var lane = $d8a5605a402fdc13$var$nextRetryLane;
    $d8a5605a402fdc13$var$nextRetryLane <<= 1;
    0 === ($d8a5605a402fdc13$var$nextRetryLane & 62914560) && ($d8a5605a402fdc13$var$nextRetryLane = 4194304);
    return lane;
}
function $d8a5605a402fdc13$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $d8a5605a402fdc13$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $d8a5605a402fdc13$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $d8a5605a402fdc13$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $d8a5605a402fdc13$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $d8a5605a402fdc13$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $d8a5605a402fdc13$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $d8a5605a402fdc13$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $d8a5605a402fdc13$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $d8a5605a402fdc13$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $d8a5605a402fdc13$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $d8a5605a402fdc13$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $d8a5605a402fdc13$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $d8a5605a402fdc13$var$resolveUpdatePriority() {
    var updatePriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $d8a5605a402fdc13$var$getEventPriority(updatePriority.type);
}
function $d8a5605a402fdc13$var$runWithPriority(priority, fn) {
    var previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
    try {
        return $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $d8a5605a402fdc13$var$randomKey = Math.random().toString(36).slice(2), $d8a5605a402fdc13$var$internalInstanceKey = "__reactFiber$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalPropsKey = "__reactProps$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalContainerInstanceKey = "__reactContainer$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalEventHandlersKey = "__reactEvents$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalEventHandlerListenersKey = "__reactListeners$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalEventHandlesSetKey = "__reactHandles$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalRootNodeResourcesKey = "__reactResources$" + $d8a5605a402fdc13$var$randomKey, $d8a5605a402fdc13$var$internalHoistableMarker = "__reactMarker$" + $d8a5605a402fdc13$var$randomKey;
function $d8a5605a402fdc13$var$detachDeletedInstance(node) {
    delete node[$d8a5605a402fdc13$var$internalInstanceKey];
    delete node[$d8a5605a402fdc13$var$internalPropsKey];
    delete node[$d8a5605a402fdc13$var$internalEventHandlersKey];
    delete node[$d8a5605a402fdc13$var$internalEventHandlerListenersKey];
    delete node[$d8a5605a402fdc13$var$internalEventHandlesSetKey];
}
function $d8a5605a402fdc13$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$d8a5605a402fdc13$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$d8a5605a402fdc13$var$internalContainerInstanceKey] || parentNode[$d8a5605a402fdc13$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $d8a5605a402fdc13$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$d8a5605a402fdc13$var$internalInstanceKey]) return parentNode;
                targetNode = $d8a5605a402fdc13$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $d8a5605a402fdc13$var$getInstanceFromNode(node) {
    if (node = node[$d8a5605a402fdc13$var$internalInstanceKey] || node[$d8a5605a402fdc13$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $d8a5605a402fdc13$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(33));
}
function $d8a5605a402fdc13$var$getResourcesFromRoot(root) {
    var resources = root[$d8a5605a402fdc13$var$internalRootNodeResourcesKey];
    resources || (resources = root[$d8a5605a402fdc13$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $d8a5605a402fdc13$var$markNodeAsHoistable(node) {
    node[$d8a5605a402fdc13$var$internalHoistableMarker] = !0;
}
var $d8a5605a402fdc13$var$allNativeEvents = new Set(), $d8a5605a402fdc13$var$registrationNameDependencies = {};
function $d8a5605a402fdc13$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $d8a5605a402fdc13$var$registerDirectEvent(registrationName, dependencies);
    $d8a5605a402fdc13$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $d8a5605a402fdc13$var$registerDirectEvent(registrationName, dependencies) {
    $d8a5605a402fdc13$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$d8a5605a402fdc13$var$allNativeEvents.add(dependencies[registrationName]);
}
var $d8a5605a402fdc13$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $d8a5605a402fdc13$var$illegalAttributeNameCache = {}, $d8a5605a402fdc13$var$validatedAttributeNameCache = {};
function $d8a5605a402fdc13$var$isAttributeNameSafe(attributeName) {
    if ($d8a5605a402fdc13$var$hasOwnProperty.call($d8a5605a402fdc13$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($d8a5605a402fdc13$var$hasOwnProperty.call($d8a5605a402fdc13$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($d8a5605a402fdc13$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $d8a5605a402fdc13$var$validatedAttributeNameCache[attributeName] = !0;
    $d8a5605a402fdc13$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $d8a5605a402fdc13$var$setValueForAttribute(node, name, value) {
    if ($d8a5605a402fdc13$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $d8a5605a402fdc13$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $d8a5605a402fdc13$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $d8a5605a402fdc13$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $d8a5605a402fdc13$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $d8a5605a402fdc13$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $d8a5605a402fdc13$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $d8a5605a402fdc13$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $d8a5605a402fdc13$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $d8a5605a402fdc13$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $d8a5605a402fdc13$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $d8a5605a402fdc13$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $d8a5605a402fdc13$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $d8a5605a402fdc13$var$getToStringValue(value);
        } else element.value !== "" + $d8a5605a402fdc13$var$getToStringValue(value) && (element.value = "" + $d8a5605a402fdc13$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $d8a5605a402fdc13$var$setDefaultValue(element, type, $d8a5605a402fdc13$var$getToStringValue(value)) : null != defaultValue ? $d8a5605a402fdc13$var$setDefaultValue(element, type, $d8a5605a402fdc13$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $d8a5605a402fdc13$var$getToStringValue(name) : element.removeAttribute("name");
}
function $d8a5605a402fdc13$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $d8a5605a402fdc13$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $d8a5605a402fdc13$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $d8a5605a402fdc13$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $d8a5605a402fdc13$var$track(element);
}
function $d8a5605a402fdc13$var$setDefaultValue(node, type, value) {
    "number" === type && $d8a5605a402fdc13$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $d8a5605a402fdc13$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $d8a5605a402fdc13$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $d8a5605a402fdc13$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $d8a5605a402fdc13$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $d8a5605a402fdc13$var$getToStringValue(defaultValue) : "";
}
function $d8a5605a402fdc13$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(92));
            if ($d8a5605a402fdc13$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $d8a5605a402fdc13$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $d8a5605a402fdc13$var$track(element);
}
function $d8a5605a402fdc13$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $d8a5605a402fdc13$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $d8a5605a402fdc13$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $d8a5605a402fdc13$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $d8a5605a402fdc13$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $d8a5605a402fdc13$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $d8a5605a402fdc13$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $d8a5605a402fdc13$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d8a5605a402fdc13$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $d8a5605a402fdc13$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $d8a5605a402fdc13$var$sanitizeURL(url) {
    return $d8a5605a402fdc13$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $d8a5605a402fdc13$var$noop$1() {}
var $d8a5605a402fdc13$var$currentReplayingEvent = null;
function $d8a5605a402fdc13$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $d8a5605a402fdc13$var$restoreTarget = null, $d8a5605a402fdc13$var$restoreQueue = null;
function $d8a5605a402fdc13$var$restoreStateOfTarget(target) {
    var internalInstance = $d8a5605a402fdc13$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$d8a5605a402fdc13$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $d8a5605a402fdc13$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$d8a5605a402fdc13$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(90));
                            $d8a5605a402fdc13$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $d8a5605a402fdc13$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $d8a5605a402fdc13$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $d8a5605a402fdc13$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $d8a5605a402fdc13$var$isInsideEventHandler = !1;
function $d8a5605a402fdc13$var$batchedUpdates$1(fn, a, b) {
    if ($d8a5605a402fdc13$var$isInsideEventHandler) return fn(a, b);
    $d8a5605a402fdc13$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($d8a5605a402fdc13$var$isInsideEventHandler = !1, null !== $d8a5605a402fdc13$var$restoreTarget || null !== $d8a5605a402fdc13$var$restoreQueue) {
            if ($d8a5605a402fdc13$var$flushSyncWork$1(), $d8a5605a402fdc13$var$restoreTarget && (a = $d8a5605a402fdc13$var$restoreTarget, fn = $d8a5605a402fdc13$var$restoreQueue, $d8a5605a402fdc13$var$restoreQueue = $d8a5605a402fdc13$var$restoreTarget = null, $d8a5605a402fdc13$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$d8a5605a402fdc13$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $d8a5605a402fdc13$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$d8a5605a402fdc13$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $d8a5605a402fdc13$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d8a5605a402fdc13$var$passiveBrowserEventsSupported = !1;
if ($d8a5605a402fdc13$var$canUseDOM) try {
    var $d8a5605a402fdc13$var$options = {};
    Object.defineProperty($d8a5605a402fdc13$var$options, "passive", {
        get: function() {
            $d8a5605a402fdc13$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $d8a5605a402fdc13$var$options, $d8a5605a402fdc13$var$options);
    window.removeEventListener("test", $d8a5605a402fdc13$var$options, $d8a5605a402fdc13$var$options);
} catch (e) {
    $d8a5605a402fdc13$var$passiveBrowserEventsSupported = !1;
}
var $d8a5605a402fdc13$var$root = null, $d8a5605a402fdc13$var$startText = null, $d8a5605a402fdc13$var$fallbackText = null;
function $d8a5605a402fdc13$var$getData() {
    if ($d8a5605a402fdc13$var$fallbackText) return $d8a5605a402fdc13$var$fallbackText;
    var start, startValue = $d8a5605a402fdc13$var$startText, startLength = startValue.length, end, endValue = "value" in $d8a5605a402fdc13$var$root ? $d8a5605a402fdc13$var$root.value : $d8a5605a402fdc13$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $d8a5605a402fdc13$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $d8a5605a402fdc13$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $d8a5605a402fdc13$var$functionThatReturnsTrue() {
    return !0;
}
function $d8a5605a402fdc13$var$functionThatReturnsFalse() {
    return !1;
}
function $d8a5605a402fdc13$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $d8a5605a402fdc13$var$functionThatReturnsTrue : $d8a5605a402fdc13$var$functionThatReturnsFalse;
        this.isPropagationStopped = $d8a5605a402fdc13$var$functionThatReturnsFalse;
        return this;
    }
    $d8a5605a402fdc13$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $d8a5605a402fdc13$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $d8a5605a402fdc13$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $d8a5605a402fdc13$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $d8a5605a402fdc13$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d8a5605a402fdc13$var$SyntheticEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$EventInterface), $d8a5605a402fdc13$var$UIEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$EventInterface, {
    view: 0,
    detail: 0
}), $d8a5605a402fdc13$var$SyntheticUIEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$UIEventInterface), $d8a5605a402fdc13$var$lastMovementX, $d8a5605a402fdc13$var$lastMovementY, $d8a5605a402fdc13$var$lastMouseEvent, $d8a5605a402fdc13$var$MouseEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d8a5605a402fdc13$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $d8a5605a402fdc13$var$lastMouseEvent && ($d8a5605a402fdc13$var$lastMouseEvent && "mousemove" === event.type ? ($d8a5605a402fdc13$var$lastMovementX = event.screenX - $d8a5605a402fdc13$var$lastMouseEvent.screenX, $d8a5605a402fdc13$var$lastMovementY = event.screenY - $d8a5605a402fdc13$var$lastMouseEvent.screenY) : $d8a5605a402fdc13$var$lastMovementY = $d8a5605a402fdc13$var$lastMovementX = 0, $d8a5605a402fdc13$var$lastMouseEvent = event);
        return $d8a5605a402fdc13$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $d8a5605a402fdc13$var$lastMovementY;
    }
}), $d8a5605a402fdc13$var$SyntheticMouseEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$MouseEventInterface), $d8a5605a402fdc13$var$DragEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$MouseEventInterface, {
    dataTransfer: 0
}), $d8a5605a402fdc13$var$SyntheticDragEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$DragEventInterface), $d8a5605a402fdc13$var$FocusEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$UIEventInterface, {
    relatedTarget: 0
}), $d8a5605a402fdc13$var$SyntheticFocusEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$FocusEventInterface), $d8a5605a402fdc13$var$AnimationEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d8a5605a402fdc13$var$SyntheticAnimationEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$AnimationEventInterface), $d8a5605a402fdc13$var$ClipboardEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $d8a5605a402fdc13$var$SyntheticClipboardEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$ClipboardEventInterface), $d8a5605a402fdc13$var$CompositionEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$EventInterface, {
    data: 0
}), $d8a5605a402fdc13$var$SyntheticCompositionEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$CompositionEventInterface), $d8a5605a402fdc13$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d8a5605a402fdc13$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d8a5605a402fdc13$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d8a5605a402fdc13$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $d8a5605a402fdc13$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $d8a5605a402fdc13$var$getEventModifierState() {
    return $d8a5605a402fdc13$var$modifierStateGetter;
}
var $d8a5605a402fdc13$var$KeyboardEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $d8a5605a402fdc13$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $d8a5605a402fdc13$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $d8a5605a402fdc13$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d8a5605a402fdc13$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $d8a5605a402fdc13$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $d8a5605a402fdc13$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $d8a5605a402fdc13$var$SyntheticKeyboardEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$KeyboardEventInterface), $d8a5605a402fdc13$var$PointerEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d8a5605a402fdc13$var$SyntheticPointerEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$PointerEventInterface), $d8a5605a402fdc13$var$TouchEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d8a5605a402fdc13$var$getEventModifierState
}), $d8a5605a402fdc13$var$SyntheticTouchEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$TouchEventInterface), $d8a5605a402fdc13$var$TransitionEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d8a5605a402fdc13$var$SyntheticTransitionEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$TransitionEventInterface), $d8a5605a402fdc13$var$WheelEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d8a5605a402fdc13$var$SyntheticWheelEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$WheelEventInterface), $d8a5605a402fdc13$var$ToggleEventInterface = $d8a5605a402fdc13$var$assign({}, $d8a5605a402fdc13$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $d8a5605a402fdc13$var$SyntheticToggleEvent = $d8a5605a402fdc13$var$createSyntheticEvent($d8a5605a402fdc13$var$ToggleEventInterface), $d8a5605a402fdc13$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $d8a5605a402fdc13$var$canUseCompositionEvent = $d8a5605a402fdc13$var$canUseDOM && "CompositionEvent" in window, $d8a5605a402fdc13$var$documentMode = null;
$d8a5605a402fdc13$var$canUseDOM && "documentMode" in document && ($d8a5605a402fdc13$var$documentMode = document.documentMode);
var $d8a5605a402fdc13$var$canUseTextInputEvent = $d8a5605a402fdc13$var$canUseDOM && "TextEvent" in window && !$d8a5605a402fdc13$var$documentMode, $d8a5605a402fdc13$var$useFallbackCompositionData = $d8a5605a402fdc13$var$canUseDOM && (!$d8a5605a402fdc13$var$canUseCompositionEvent || $d8a5605a402fdc13$var$documentMode && 8 < $d8a5605a402fdc13$var$documentMode && 11 >= $d8a5605a402fdc13$var$documentMode), $d8a5605a402fdc13$var$SPACEBAR_CHAR = String.fromCharCode(32), $d8a5605a402fdc13$var$hasSpaceKeypress = !1;
function $d8a5605a402fdc13$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $d8a5605a402fdc13$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d8a5605a402fdc13$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $d8a5605a402fdc13$var$isComposing = !1;
function $d8a5605a402fdc13$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $d8a5605a402fdc13$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $d8a5605a402fdc13$var$hasSpaceKeypress = !0;
            return $d8a5605a402fdc13$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $d8a5605a402fdc13$var$SPACEBAR_CHAR && $d8a5605a402fdc13$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $d8a5605a402fdc13$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($d8a5605a402fdc13$var$isComposing) return "compositionend" === domEventName || !$d8a5605a402fdc13$var$canUseCompositionEvent && $d8a5605a402fdc13$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $d8a5605a402fdc13$var$getData(), $d8a5605a402fdc13$var$fallbackText = $d8a5605a402fdc13$var$startText = $d8a5605a402fdc13$var$root = null, $d8a5605a402fdc13$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $d8a5605a402fdc13$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $d8a5605a402fdc13$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d8a5605a402fdc13$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$d8a5605a402fdc13$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $d8a5605a402fdc13$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $d8a5605a402fdc13$var$restoreTarget ? $d8a5605a402fdc13$var$restoreQueue ? $d8a5605a402fdc13$var$restoreQueue.push(target) : $d8a5605a402fdc13$var$restoreQueue = [
        target
    ] : $d8a5605a402fdc13$var$restoreTarget = target;
    inst = $d8a5605a402fdc13$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $d8a5605a402fdc13$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $d8a5605a402fdc13$var$activeElement$1 = null, $d8a5605a402fdc13$var$activeElementInst$1 = null;
function $d8a5605a402fdc13$var$runEventInBatch(dispatchQueue) {
    $d8a5605a402fdc13$var$processDispatchQueue(dispatchQueue, 0);
}
function $d8a5605a402fdc13$var$getInstIfValueChanged(targetInst) {
    var targetNode = $d8a5605a402fdc13$var$getNodeFromInstance(targetInst);
    if ($d8a5605a402fdc13$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $d8a5605a402fdc13$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $d8a5605a402fdc13$var$isInputEventSupported = !1;
if ($d8a5605a402fdc13$var$canUseDOM) {
    var $d8a5605a402fdc13$var$JSCompiler_inline_result$jscomp$286;
    if ($d8a5605a402fdc13$var$canUseDOM) {
        var $d8a5605a402fdc13$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$d8a5605a402fdc13$var$isSupported$jscomp$inline_427) {
            var $d8a5605a402fdc13$var$element$jscomp$inline_428 = document.createElement("div");
            $d8a5605a402fdc13$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $d8a5605a402fdc13$var$isSupported$jscomp$inline_427 = "function" === typeof $d8a5605a402fdc13$var$element$jscomp$inline_428.oninput;
        }
        $d8a5605a402fdc13$var$JSCompiler_inline_result$jscomp$286 = $d8a5605a402fdc13$var$isSupported$jscomp$inline_427;
    } else $d8a5605a402fdc13$var$JSCompiler_inline_result$jscomp$286 = !1;
    $d8a5605a402fdc13$var$isInputEventSupported = $d8a5605a402fdc13$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $d8a5605a402fdc13$var$stopWatchingForValueChange() {
    $d8a5605a402fdc13$var$activeElement$1 && ($d8a5605a402fdc13$var$activeElement$1.detachEvent("onpropertychange", $d8a5605a402fdc13$var$handlePropertyChange), $d8a5605a402fdc13$var$activeElementInst$1 = $d8a5605a402fdc13$var$activeElement$1 = null);
}
function $d8a5605a402fdc13$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $d8a5605a402fdc13$var$getInstIfValueChanged($d8a5605a402fdc13$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $d8a5605a402fdc13$var$createAndAccumulateChangeEvent(dispatchQueue, $d8a5605a402fdc13$var$activeElementInst$1, nativeEvent, $d8a5605a402fdc13$var$getEventTarget(nativeEvent));
        $d8a5605a402fdc13$var$batchedUpdates$1($d8a5605a402fdc13$var$runEventInBatch, dispatchQueue);
    }
}
function $d8a5605a402fdc13$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($d8a5605a402fdc13$var$stopWatchingForValueChange(), $d8a5605a402fdc13$var$activeElement$1 = target, $d8a5605a402fdc13$var$activeElementInst$1 = targetInst, $d8a5605a402fdc13$var$activeElement$1.attachEvent("onpropertychange", $d8a5605a402fdc13$var$handlePropertyChange)) : "focusout" === domEventName && $d8a5605a402fdc13$var$stopWatchingForValueChange();
}
function $d8a5605a402fdc13$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $d8a5605a402fdc13$var$getInstIfValueChanged($d8a5605a402fdc13$var$activeElementInst$1);
}
function $d8a5605a402fdc13$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $d8a5605a402fdc13$var$getInstIfValueChanged(targetInst);
}
function $d8a5605a402fdc13$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $d8a5605a402fdc13$var$getInstIfValueChanged(targetInst);
}
function $d8a5605a402fdc13$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d8a5605a402fdc13$var$objectIs = "function" === typeof Object.is ? Object.is : $d8a5605a402fdc13$var$is;
function $d8a5605a402fdc13$var$shallowEqual(objA, objB) {
    if ($d8a5605a402fdc13$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$d8a5605a402fdc13$var$hasOwnProperty.call(objB, currentKey) || !$d8a5605a402fdc13$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $d8a5605a402fdc13$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $d8a5605a402fdc13$var$getNodeForCharacterOffset(root, offset) {
    var node = $d8a5605a402fdc13$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $d8a5605a402fdc13$var$getLeafNode(node);
    }
}
function $d8a5605a402fdc13$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $d8a5605a402fdc13$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $d8a5605a402fdc13$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $d8a5605a402fdc13$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $d8a5605a402fdc13$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $d8a5605a402fdc13$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $d8a5605a402fdc13$var$skipSelectionChangeEvent = $d8a5605a402fdc13$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $d8a5605a402fdc13$var$activeElement = null, $d8a5605a402fdc13$var$activeElementInst = null, $d8a5605a402fdc13$var$lastSelection = null, $d8a5605a402fdc13$var$mouseDown = !1;
function $d8a5605a402fdc13$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $d8a5605a402fdc13$var$mouseDown || null == $d8a5605a402fdc13$var$activeElement || $d8a5605a402fdc13$var$activeElement !== $d8a5605a402fdc13$var$getActiveElement(doc) || (doc = $d8a5605a402fdc13$var$activeElement, "selectionStart" in doc && $d8a5605a402fdc13$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $d8a5605a402fdc13$var$lastSelection && $d8a5605a402fdc13$var$shallowEqual($d8a5605a402fdc13$var$lastSelection, doc) || ($d8a5605a402fdc13$var$lastSelection = doc, doc = $d8a5605a402fdc13$var$accumulateTwoPhaseListeners($d8a5605a402fdc13$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $d8a5605a402fdc13$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $d8a5605a402fdc13$var$activeElement)));
}
function $d8a5605a402fdc13$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $d8a5605a402fdc13$var$vendorPrefixes = {
    animationend: $d8a5605a402fdc13$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $d8a5605a402fdc13$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $d8a5605a402fdc13$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $d8a5605a402fdc13$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $d8a5605a402fdc13$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $d8a5605a402fdc13$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $d8a5605a402fdc13$var$makePrefixMap("Transition", "TransitionEnd")
}, $d8a5605a402fdc13$var$prefixedEventNames = {}, $d8a5605a402fdc13$var$style = {};
$d8a5605a402fdc13$var$canUseDOM && ($d8a5605a402fdc13$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $d8a5605a402fdc13$var$vendorPrefixes.animationend.animation, delete $d8a5605a402fdc13$var$vendorPrefixes.animationiteration.animation, delete $d8a5605a402fdc13$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $d8a5605a402fdc13$var$vendorPrefixes.transitionend.transition);
function $d8a5605a402fdc13$var$getVendorPrefixedEventName(eventName) {
    if ($d8a5605a402fdc13$var$prefixedEventNames[eventName]) return $d8a5605a402fdc13$var$prefixedEventNames[eventName];
    if (!$d8a5605a402fdc13$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $d8a5605a402fdc13$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $d8a5605a402fdc13$var$style) return $d8a5605a402fdc13$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $d8a5605a402fdc13$var$ANIMATION_END = $d8a5605a402fdc13$var$getVendorPrefixedEventName("animationend"), $d8a5605a402fdc13$var$ANIMATION_ITERATION = $d8a5605a402fdc13$var$getVendorPrefixedEventName("animationiteration"), $d8a5605a402fdc13$var$ANIMATION_START = $d8a5605a402fdc13$var$getVendorPrefixedEventName("animationstart"), $d8a5605a402fdc13$var$TRANSITION_RUN = $d8a5605a402fdc13$var$getVendorPrefixedEventName("transitionrun"), $d8a5605a402fdc13$var$TRANSITION_START = $d8a5605a402fdc13$var$getVendorPrefixedEventName("transitionstart"), $d8a5605a402fdc13$var$TRANSITION_CANCEL = $d8a5605a402fdc13$var$getVendorPrefixedEventName("transitioncancel"), $d8a5605a402fdc13$var$TRANSITION_END = $d8a5605a402fdc13$var$getVendorPrefixedEventName("transitionend"), $d8a5605a402fdc13$var$topLevelEventsToReactNames = new Map(), $d8a5605a402fdc13$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$d8a5605a402fdc13$var$simpleEventPluginEvents.push("scrollEnd");
function $d8a5605a402fdc13$var$registerSimpleEvent(domEventName, reactName) {
    $d8a5605a402fdc13$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $d8a5605a402fdc13$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $d8a5605a402fdc13$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $98Fbt && "function" === typeof $98Fbt.emit) {
        $98Fbt.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $d8a5605a402fdc13$var$concurrentQueues = [], $d8a5605a402fdc13$var$concurrentQueuesIndex = 0, $d8a5605a402fdc13$var$concurrentlyUpdatedLanes = 0;
function $d8a5605a402fdc13$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $d8a5605a402fdc13$var$concurrentQueuesIndex, i = $d8a5605a402fdc13$var$concurrentlyUpdatedLanes = $d8a5605a402fdc13$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $d8a5605a402fdc13$var$concurrentQueues[i];
        $d8a5605a402fdc13$var$concurrentQueues[i++] = null;
        var queue = $d8a5605a402fdc13$var$concurrentQueues[i];
        $d8a5605a402fdc13$var$concurrentQueues[i++] = null;
        var update = $d8a5605a402fdc13$var$concurrentQueues[i];
        $d8a5605a402fdc13$var$concurrentQueues[i++] = null;
        var lane = $d8a5605a402fdc13$var$concurrentQueues[i];
        $d8a5605a402fdc13$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $d8a5605a402fdc13$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $d8a5605a402fdc13$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $d8a5605a402fdc13$var$concurrentQueues[$d8a5605a402fdc13$var$concurrentQueuesIndex++] = fiber;
    $d8a5605a402fdc13$var$concurrentQueues[$d8a5605a402fdc13$var$concurrentQueuesIndex++] = queue;
    $d8a5605a402fdc13$var$concurrentQueues[$d8a5605a402fdc13$var$concurrentQueuesIndex++] = update;
    $d8a5605a402fdc13$var$concurrentQueues[$d8a5605a402fdc13$var$concurrentQueuesIndex++] = lane;
    $d8a5605a402fdc13$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $d8a5605a402fdc13$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $d8a5605a402fdc13$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $d8a5605a402fdc13$var$getRootForUpdatedFiber(fiber);
}
function $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $d8a5605a402fdc13$var$enqueueUpdate$1(fiber, null, null, lane);
    return $d8a5605a402fdc13$var$getRootForUpdatedFiber(fiber);
}
function $d8a5605a402fdc13$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $d8a5605a402fdc13$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $d8a5605a402fdc13$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $d8a5605a402fdc13$var$nestedUpdateCount) throw $d8a5605a402fdc13$var$nestedUpdateCount = 0, $d8a5605a402fdc13$var$rootWithNestedUpdates = null, Error($d8a5605a402fdc13$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $d8a5605a402fdc13$var$emptyContextObject = {};
function $d8a5605a402fdc13$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d8a5605a402fdc13$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $d8a5605a402fdc13$var$FiberNode(tag, pendingProps, key, mode);
}
function $d8a5605a402fdc13$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $d8a5605a402fdc13$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $d8a5605a402fdc13$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $d8a5605a402fdc13$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $d8a5605a402fdc13$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $d8a5605a402fdc13$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $d8a5605a402fdc13$var$isHostHoistableType(type, pendingProps, $d8a5605a402fdc13$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $d8a5605a402fdc13$var$REACT_ACTIVITY_TYPE:
            return type = $d8a5605a402fdc13$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $d8a5605a402fdc13$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE:
            return $d8a5605a402fdc13$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $d8a5605a402fdc13$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $d8a5605a402fdc13$var$REACT_PROFILER_TYPE:
            return type = $d8a5605a402fdc13$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $d8a5605a402fdc13$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $d8a5605a402fdc13$var$REACT_SUSPENSE_TYPE:
            return type = $d8a5605a402fdc13$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $d8a5605a402fdc13$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $d8a5605a402fdc13$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $d8a5605a402fdc13$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $d8a5605a402fdc13$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $d8a5605a402fdc13$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $d8a5605a402fdc13$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $d8a5605a402fdc13$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $d8a5605a402fdc13$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($d8a5605a402fdc13$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $d8a5605a402fdc13$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $d8a5605a402fdc13$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $d8a5605a402fdc13$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $d8a5605a402fdc13$var$createFiberFromText(content, mode, lanes) {
    content = $d8a5605a402fdc13$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $d8a5605a402fdc13$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $d8a5605a402fdc13$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $d8a5605a402fdc13$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $d8a5605a402fdc13$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $d8a5605a402fdc13$var$CapturedStacks = new WeakMap();
function $d8a5605a402fdc13$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $d8a5605a402fdc13$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $d8a5605a402fdc13$var$getStackByFiberInDevAndProd(source)
        };
        $d8a5605a402fdc13$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $d8a5605a402fdc13$var$getStackByFiberInDevAndProd(source)
    };
}
var $d8a5605a402fdc13$var$forkStack = [], $d8a5605a402fdc13$var$forkStackIndex = 0, $d8a5605a402fdc13$var$treeForkProvider = null, $d8a5605a402fdc13$var$treeForkCount = 0, $d8a5605a402fdc13$var$idStack = [], $d8a5605a402fdc13$var$idStackIndex = 0, $d8a5605a402fdc13$var$treeContextProvider = null, $d8a5605a402fdc13$var$treeContextId = 1, $d8a5605a402fdc13$var$treeContextOverflow = "";
function $d8a5605a402fdc13$var$pushTreeFork(workInProgress, totalChildren) {
    $d8a5605a402fdc13$var$forkStack[$d8a5605a402fdc13$var$forkStackIndex++] = $d8a5605a402fdc13$var$treeForkCount;
    $d8a5605a402fdc13$var$forkStack[$d8a5605a402fdc13$var$forkStackIndex++] = $d8a5605a402fdc13$var$treeForkProvider;
    $d8a5605a402fdc13$var$treeForkProvider = workInProgress;
    $d8a5605a402fdc13$var$treeForkCount = totalChildren;
}
function $d8a5605a402fdc13$var$pushTreeId(workInProgress, totalChildren, index) {
    $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex++] = $d8a5605a402fdc13$var$treeContextId;
    $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex++] = $d8a5605a402fdc13$var$treeContextOverflow;
    $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex++] = $d8a5605a402fdc13$var$treeContextProvider;
    $d8a5605a402fdc13$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $d8a5605a402fdc13$var$treeContextId;
    workInProgress = $d8a5605a402fdc13$var$treeContextOverflow;
    var baseLength = 32 - $d8a5605a402fdc13$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $d8a5605a402fdc13$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $d8a5605a402fdc13$var$treeContextId = 1 << 32 - $d8a5605a402fdc13$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $d8a5605a402fdc13$var$treeContextOverflow = length + workInProgress;
    } else $d8a5605a402fdc13$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $d8a5605a402fdc13$var$treeContextOverflow = workInProgress;
}
function $d8a5605a402fdc13$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($d8a5605a402fdc13$var$pushTreeFork(workInProgress, 1), $d8a5605a402fdc13$var$pushTreeId(workInProgress, 1, 0));
}
function $d8a5605a402fdc13$var$popTreeContext(workInProgress) {
    for(; workInProgress === $d8a5605a402fdc13$var$treeForkProvider;)$d8a5605a402fdc13$var$treeForkProvider = $d8a5605a402fdc13$var$forkStack[--$d8a5605a402fdc13$var$forkStackIndex], $d8a5605a402fdc13$var$forkStack[$d8a5605a402fdc13$var$forkStackIndex] = null, $d8a5605a402fdc13$var$treeForkCount = $d8a5605a402fdc13$var$forkStack[--$d8a5605a402fdc13$var$forkStackIndex], $d8a5605a402fdc13$var$forkStack[$d8a5605a402fdc13$var$forkStackIndex] = null;
    for(; workInProgress === $d8a5605a402fdc13$var$treeContextProvider;)$d8a5605a402fdc13$var$treeContextProvider = $d8a5605a402fdc13$var$idStack[--$d8a5605a402fdc13$var$idStackIndex], $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex] = null, $d8a5605a402fdc13$var$treeContextOverflow = $d8a5605a402fdc13$var$idStack[--$d8a5605a402fdc13$var$idStackIndex], $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex] = null, $d8a5605a402fdc13$var$treeContextId = $d8a5605a402fdc13$var$idStack[--$d8a5605a402fdc13$var$idStackIndex], $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex] = null;
}
function $d8a5605a402fdc13$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex++] = $d8a5605a402fdc13$var$treeContextId;
    $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex++] = $d8a5605a402fdc13$var$treeContextOverflow;
    $d8a5605a402fdc13$var$idStack[$d8a5605a402fdc13$var$idStackIndex++] = $d8a5605a402fdc13$var$treeContextProvider;
    $d8a5605a402fdc13$var$treeContextId = suspendedContext.id;
    $d8a5605a402fdc13$var$treeContextOverflow = suspendedContext.overflow;
    $d8a5605a402fdc13$var$treeContextProvider = workInProgress;
}
var $d8a5605a402fdc13$var$hydrationParentFiber = null, $d8a5605a402fdc13$var$nextHydratableInstance = null, $d8a5605a402fdc13$var$isHydrating = !1, $d8a5605a402fdc13$var$hydrationErrors = null, $d8a5605a402fdc13$var$rootOrSingletonContext = !1, $d8a5605a402fdc13$var$HydrationMismatchException = Error($d8a5605a402fdc13$var$formatProdErrorMessage(519));
function $d8a5605a402fdc13$var$throwOnHydrationMismatch(fiber) {
    var error = Error($d8a5605a402fdc13$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $d8a5605a402fdc13$var$queueHydrationError($d8a5605a402fdc13$var$createCapturedValueAtFiber(error, fiber));
    throw $d8a5605a402fdc13$var$HydrationMismatchException;
}
function $d8a5605a402fdc13$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$d8a5605a402fdc13$var$internalInstanceKey] = fiber;
    instance[$d8a5605a402fdc13$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("cancel", instance);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $d8a5605a402fdc13$var$mediaEventTypes.length; type++)$d8a5605a402fdc13$var$listenToNonDelegatedEvent($d8a5605a402fdc13$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("error", instance);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("invalid", instance);
            $d8a5605a402fdc13$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("invalid", instance), $d8a5605a402fdc13$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $d8a5605a402fdc13$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($d8a5605a402fdc13$var$listenToNonDelegatedEvent("beforetoggle", instance), $d8a5605a402fdc13$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $d8a5605a402fdc13$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $d8a5605a402fdc13$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $d8a5605a402fdc13$var$noop$1), instance = !0) : instance = !1;
    instance || $d8a5605a402fdc13$var$throwOnHydrationMismatch(fiber, !0);
}
function $d8a5605a402fdc13$var$popToNextHostParent(fiber) {
    for($d8a5605a402fdc13$var$hydrationParentFiber = fiber.return; $d8a5605a402fdc13$var$hydrationParentFiber;)switch($d8a5605a402fdc13$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $d8a5605a402fdc13$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $d8a5605a402fdc13$var$rootOrSingletonContext = !0;
            return;
        default:
            $d8a5605a402fdc13$var$hydrationParentFiber = $d8a5605a402fdc13$var$hydrationParentFiber.return;
    }
}
function $d8a5605a402fdc13$var$popHydrationState(fiber) {
    if (fiber !== $d8a5605a402fdc13$var$hydrationParentFiber) return !1;
    if (!$d8a5605a402fdc13$var$isHydrating) return $d8a5605a402fdc13$var$popToNextHostParent(fiber), $d8a5605a402fdc13$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $d8a5605a402fdc13$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $d8a5605a402fdc13$var$nextHydratableInstance && $d8a5605a402fdc13$var$throwOnHydrationMismatch(fiber);
    $d8a5605a402fdc13$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(317));
        $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(317));
        $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $d8a5605a402fdc13$var$nextHydratableInstance, $d8a5605a402fdc13$var$isSingletonScope(fiber.type) ? (fiber = $d8a5605a402fdc13$var$previousHydratableOnEnteringScopedSingleton, $d8a5605a402fdc13$var$previousHydratableOnEnteringScopedSingleton = null, $d8a5605a402fdc13$var$nextHydratableInstance = fiber) : $d8a5605a402fdc13$var$nextHydratableInstance = tag) : $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$hydrationParentFiber ? $d8a5605a402fdc13$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $d8a5605a402fdc13$var$resetHydrationState() {
    $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$hydrationParentFiber = null;
    $d8a5605a402fdc13$var$isHydrating = !1;
}
function $d8a5605a402fdc13$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $d8a5605a402fdc13$var$hydrationErrors;
    null !== queuedErrors && (null === $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors ? $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors = queuedErrors : $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors.push.apply($d8a5605a402fdc13$var$workInProgressRootRecoverableErrors, queuedErrors), $d8a5605a402fdc13$var$hydrationErrors = null);
    return queuedErrors;
}
function $d8a5605a402fdc13$var$queueHydrationError(error) {
    null === $d8a5605a402fdc13$var$hydrationErrors ? $d8a5605a402fdc13$var$hydrationErrors = [
        error
    ] : $d8a5605a402fdc13$var$hydrationErrors.push(error);
}
var $d8a5605a402fdc13$var$valueCursor = $d8a5605a402fdc13$var$createCursor(null), $d8a5605a402fdc13$var$currentlyRenderingFiber$1 = null, $d8a5605a402fdc13$var$lastContextDependency = null;
function $d8a5605a402fdc13$var$pushProvider(providerFiber, context, nextValue) {
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $d8a5605a402fdc13$var$popProvider(context) {
    context._currentValue = $d8a5605a402fdc13$var$valueCursor.current;
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$valueCursor);
}
function $d8a5605a402fdc13$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $d8a5605a402fdc13$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $d8a5605a402fdc13$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $d8a5605a402fdc13$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $d8a5605a402fdc13$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $d8a5605a402fdc13$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $d8a5605a402fdc13$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($d8a5605a402fdc13$var$HostTransitionContext) : current = [
                $d8a5605a402fdc13$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $d8a5605a402fdc13$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $d8a5605a402fdc13$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$d8a5605a402fdc13$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $d8a5605a402fdc13$var$prepareToReadContext(workInProgress) {
    $d8a5605a402fdc13$var$currentlyRenderingFiber$1 = workInProgress;
    $d8a5605a402fdc13$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $d8a5605a402fdc13$var$readContext(context) {
    return $d8a5605a402fdc13$var$readContextForConsumer($d8a5605a402fdc13$var$currentlyRenderingFiber$1, context);
}
function $d8a5605a402fdc13$var$readContextDuringReconciliation(consumer, context) {
    null === $d8a5605a402fdc13$var$currentlyRenderingFiber$1 && $d8a5605a402fdc13$var$prepareToReadContext(consumer);
    return $d8a5605a402fdc13$var$readContextForConsumer(consumer, context);
}
function $d8a5605a402fdc13$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $d8a5605a402fdc13$var$lastContextDependency) {
        if (null === consumer) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(308));
        $d8a5605a402fdc13$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $d8a5605a402fdc13$var$lastContextDependency = $d8a5605a402fdc13$var$lastContextDependency.next = context;
    return value;
}
var $d8a5605a402fdc13$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $d8a5605a402fdc13$var$scheduleCallback$2 = $hXcSD.unstable_scheduleCallback, $d8a5605a402fdc13$var$NormalPriority = $hXcSD.unstable_NormalPriority, $d8a5605a402fdc13$var$CacheContext = {
    $$typeof: $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $d8a5605a402fdc13$var$createCache() {
    return {
        controller: new $d8a5605a402fdc13$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $d8a5605a402fdc13$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $d8a5605a402fdc13$var$scheduleCallback$2($d8a5605a402fdc13$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $d8a5605a402fdc13$var$currentEntangledListeners = null, $d8a5605a402fdc13$var$currentEntangledPendingCount = 0, $d8a5605a402fdc13$var$currentEntangledLane = 0, $d8a5605a402fdc13$var$currentEntangledActionThenable = null;
function $d8a5605a402fdc13$var$entangleAsyncAction(transition, thenable) {
    if (null === $d8a5605a402fdc13$var$currentEntangledListeners) {
        var entangledListeners = $d8a5605a402fdc13$var$currentEntangledListeners = [];
        $d8a5605a402fdc13$var$currentEntangledPendingCount = 0;
        $d8a5605a402fdc13$var$currentEntangledLane = $d8a5605a402fdc13$var$requestTransitionLane();
        $d8a5605a402fdc13$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $d8a5605a402fdc13$var$currentEntangledPendingCount++;
    thenable.then($d8a5605a402fdc13$var$pingEngtangledActionScope, $d8a5605a402fdc13$var$pingEngtangledActionScope);
    return thenable;
}
function $d8a5605a402fdc13$var$pingEngtangledActionScope() {
    if (0 === --$d8a5605a402fdc13$var$currentEntangledPendingCount && null !== $d8a5605a402fdc13$var$currentEntangledListeners) {
        null !== $d8a5605a402fdc13$var$currentEntangledActionThenable && ($d8a5605a402fdc13$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $d8a5605a402fdc13$var$currentEntangledListeners;
        $d8a5605a402fdc13$var$currentEntangledListeners = null;
        $d8a5605a402fdc13$var$currentEntangledLane = 0;
        $d8a5605a402fdc13$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $d8a5605a402fdc13$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $d8a5605a402fdc13$var$prevOnStartTransitionFinish = $d8a5605a402fdc13$var$ReactSharedInternals.S;
$d8a5605a402fdc13$var$ReactSharedInternals.S = function(transition, returnValue) {
    $d8a5605a402fdc13$var$globalMostRecentTransitionTime = $d8a5605a402fdc13$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $d8a5605a402fdc13$var$entangleAsyncAction(transition, returnValue);
    null !== $d8a5605a402fdc13$var$prevOnStartTransitionFinish && $d8a5605a402fdc13$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $d8a5605a402fdc13$var$resumedCache = $d8a5605a402fdc13$var$createCursor(null);
function $d8a5605a402fdc13$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $d8a5605a402fdc13$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $d8a5605a402fdc13$var$workInProgressRoot.pooledCache;
}
function $d8a5605a402fdc13$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$resumedCache, $d8a5605a402fdc13$var$resumedCache.current) : $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$resumedCache, prevCachePool.pool);
}
function $d8a5605a402fdc13$var$getSuspendedCache() {
    var cacheFromPool = $d8a5605a402fdc13$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $d8a5605a402fdc13$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $d8a5605a402fdc13$var$SuspenseException = Error($d8a5605a402fdc13$var$formatProdErrorMessage(460)), $d8a5605a402fdc13$var$SuspenseyCommitException = Error($d8a5605a402fdc13$var$formatProdErrorMessage(474)), $d8a5605a402fdc13$var$SuspenseActionException = Error($d8a5605a402fdc13$var$formatProdErrorMessage(542)), $d8a5605a402fdc13$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $d8a5605a402fdc13$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $d8a5605a402fdc13$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($d8a5605a402fdc13$var$noop$1, $d8a5605a402fdc13$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $d8a5605a402fdc13$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($d8a5605a402fdc13$var$noop$1, $d8a5605a402fdc13$var$noop$1);
            else {
                thenableState = $d8a5605a402fdc13$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $d8a5605a402fdc13$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $d8a5605a402fdc13$var$suspendedThenable = thenable;
            throw $d8a5605a402fdc13$var$SuspenseException;
    }
}
function $d8a5605a402fdc13$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $d8a5605a402fdc13$var$suspendedThenable = x, $d8a5605a402fdc13$var$SuspenseException;
        throw x;
    }
}
var $d8a5605a402fdc13$var$suspendedThenable = null;
function $d8a5605a402fdc13$var$getSuspendedThenable() {
    if (null === $d8a5605a402fdc13$var$suspendedThenable) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(459));
    var thenable = $d8a5605a402fdc13$var$suspendedThenable;
    $d8a5605a402fdc13$var$suspendedThenable = null;
    return thenable;
}
function $d8a5605a402fdc13$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $d8a5605a402fdc13$var$SuspenseException || rejectedReason === $d8a5605a402fdc13$var$SuspenseActionException) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(483));
}
var $d8a5605a402fdc13$var$thenableState$1 = null, $d8a5605a402fdc13$var$thenableIndexCounter$1 = 0;
function $d8a5605a402fdc13$var$unwrapThenable(thenable) {
    var index = $d8a5605a402fdc13$var$thenableIndexCounter$1;
    $d8a5605a402fdc13$var$thenableIndexCounter$1 += 1;
    null === $d8a5605a402fdc13$var$thenableState$1 && ($d8a5605a402fdc13$var$thenableState$1 = []);
    return $d8a5605a402fdc13$var$trackUsedThenable($d8a5605a402fdc13$var$thenableState$1, thenable, index);
}
function $d8a5605a402fdc13$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $d8a5605a402fdc13$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $d8a5605a402fdc13$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $d8a5605a402fdc13$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $d8a5605a402fdc13$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $d8a5605a402fdc13$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $d8a5605a402fdc13$var$REACT_LAZY_TYPE && $d8a5605a402fdc13$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $d8a5605a402fdc13$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $d8a5605a402fdc13$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $d8a5605a402fdc13$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $d8a5605a402fdc13$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $d8a5605a402fdc13$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $d8a5605a402fdc13$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d8a5605a402fdc13$var$REACT_ELEMENT_TYPE:
                    return lanes = $d8a5605a402fdc13$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d8a5605a402fdc13$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $d8a5605a402fdc13$var$REACT_PORTAL_TYPE:
                    return newChild = $d8a5605a402fdc13$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $d8a5605a402fdc13$var$REACT_LAZY_TYPE:
                    return newChild = $d8a5605a402fdc13$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($d8a5605a402fdc13$var$isArrayImpl(newChild) || $d8a5605a402fdc13$var$getIteratorFn(newChild)) return newChild = $d8a5605a402fdc13$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $d8a5605a402fdc13$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $d8a5605a402fdc13$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d8a5605a402fdc13$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d8a5605a402fdc13$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $d8a5605a402fdc13$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $d8a5605a402fdc13$var$REACT_LAZY_TYPE:
                    return newChild = $d8a5605a402fdc13$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($d8a5605a402fdc13$var$isArrayImpl(newChild) || $d8a5605a402fdc13$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $d8a5605a402fdc13$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $d8a5605a402fdc13$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d8a5605a402fdc13$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d8a5605a402fdc13$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $d8a5605a402fdc13$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $d8a5605a402fdc13$var$REACT_LAZY_TYPE:
                    return newChild = $d8a5605a402fdc13$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($d8a5605a402fdc13$var$isArrayImpl(newChild) || $d8a5605a402fdc13$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $d8a5605a402fdc13$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $d8a5605a402fdc13$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d8a5605a402fdc13$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d8a5605a402fdc13$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $d8a5605a402fdc13$var$REACT_LAZY_TYPE && $d8a5605a402fdc13$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $d8a5605a402fdc13$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $d8a5605a402fdc13$var$REACT_FRAGMENT_TYPE ? (lanes = $d8a5605a402fdc13$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $d8a5605a402fdc13$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d8a5605a402fdc13$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $d8a5605a402fdc13$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $d8a5605a402fdc13$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $d8a5605a402fdc13$var$REACT_LAZY_TYPE:
                    return newChild = $d8a5605a402fdc13$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($d8a5605a402fdc13$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($d8a5605a402fdc13$var$getIteratorFn(newChild)) {
                key = $d8a5605a402fdc13$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d8a5605a402fdc13$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d8a5605a402fdc13$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d8a5605a402fdc13$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $d8a5605a402fdc13$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $d8a5605a402fdc13$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $d8a5605a402fdc13$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $d8a5605a402fdc13$var$SuspenseException || x === $d8a5605a402fdc13$var$SuspenseActionException) throw x;
            var fiber = $d8a5605a402fdc13$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $d8a5605a402fdc13$var$reconcileChildFibers = $d8a5605a402fdc13$var$createChildReconciler(!0), $d8a5605a402fdc13$var$mountChildFibers = $d8a5605a402fdc13$var$createChildReconciler(!1), $d8a5605a402fdc13$var$hasForceUpdate = !1;
function $d8a5605a402fdc13$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $d8a5605a402fdc13$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $d8a5605a402fdc13$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d8a5605a402fdc13$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($d8a5605a402fdc13$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $d8a5605a402fdc13$var$getRootForUpdatedFiber(fiber);
        $d8a5605a402fdc13$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $d8a5605a402fdc13$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $d8a5605a402fdc13$var$getRootForUpdatedFiber(fiber);
}
function $d8a5605a402fdc13$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $d8a5605a402fdc13$var$markRootEntangled(root, lane);
    }
}
function $d8a5605a402fdc13$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $d8a5605a402fdc13$var$didReadFromEntangledAsyncAction = !1;
function $d8a5605a402fdc13$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($d8a5605a402fdc13$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $d8a5605a402fdc13$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $d8a5605a402fdc13$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $d8a5605a402fdc13$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $d8a5605a402fdc13$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $d8a5605a402fdc13$var$currentEntangledLane && ($d8a5605a402fdc13$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $d8a5605a402fdc13$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $d8a5605a402fdc13$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $d8a5605a402fdc13$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $d8a5605a402fdc13$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $d8a5605a402fdc13$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$d8a5605a402fdc13$var$callCallback(callbacks[updateQueue], context);
}
var $d8a5605a402fdc13$var$currentTreeHiddenStackCursor = $d8a5605a402fdc13$var$createCursor(null), $d8a5605a402fdc13$var$prevEntangledRenderLanesCursor = $d8a5605a402fdc13$var$createCursor(0);
function $d8a5605a402fdc13$var$pushHiddenContext(fiber, context) {
    fiber = $d8a5605a402fdc13$var$entangledRenderLanes;
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$prevEntangledRenderLanesCursor, fiber);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$currentTreeHiddenStackCursor, context);
    $d8a5605a402fdc13$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $d8a5605a402fdc13$var$reuseHiddenContextOnStack() {
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$prevEntangledRenderLanesCursor, $d8a5605a402fdc13$var$entangledRenderLanes);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$currentTreeHiddenStackCursor, $d8a5605a402fdc13$var$currentTreeHiddenStackCursor.current);
}
function $d8a5605a402fdc13$var$popHiddenContext() {
    $d8a5605a402fdc13$var$entangledRenderLanes = $d8a5605a402fdc13$var$prevEntangledRenderLanesCursor.current;
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$currentTreeHiddenStackCursor);
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$prevEntangledRenderLanesCursor);
}
var $d8a5605a402fdc13$var$suspenseHandlerStackCursor = $d8a5605a402fdc13$var$createCursor(null), $d8a5605a402fdc13$var$shellBoundary = null;
function $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, $d8a5605a402fdc13$var$suspenseStackCursor.current & 1);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseHandlerStackCursor, handler);
    null === $d8a5605a402fdc13$var$shellBoundary && (null === current || null !== $d8a5605a402fdc13$var$currentTreeHiddenStackCursor.current ? $d8a5605a402fdc13$var$shellBoundary = handler : null !== current.memoizedState && ($d8a5605a402fdc13$var$shellBoundary = handler));
}
function $d8a5605a402fdc13$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, $d8a5605a402fdc13$var$suspenseStackCursor.current);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseHandlerStackCursor, fiber);
    null === $d8a5605a402fdc13$var$shellBoundary && ($d8a5605a402fdc13$var$shellBoundary = fiber);
}
function $d8a5605a402fdc13$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, $d8a5605a402fdc13$var$suspenseStackCursor.current), $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseHandlerStackCursor, fiber), null === $d8a5605a402fdc13$var$shellBoundary && ($d8a5605a402fdc13$var$shellBoundary = fiber)) : $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(fiber);
}
function $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack() {
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, $d8a5605a402fdc13$var$suspenseStackCursor.current);
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseHandlerStackCursor, $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current);
}
function $d8a5605a402fdc13$var$popSuspenseHandler(fiber) {
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$suspenseHandlerStackCursor);
    $d8a5605a402fdc13$var$shellBoundary === fiber && ($d8a5605a402fdc13$var$shellBoundary = null);
    $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$suspenseStackCursor);
}
var $d8a5605a402fdc13$var$suspenseStackCursor = $d8a5605a402fdc13$var$createCursor(0);
function $d8a5605a402fdc13$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $d8a5605a402fdc13$var$isSuspenseInstancePending(state) || $d8a5605a402fdc13$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $d8a5605a402fdc13$var$renderLanes = 0, $d8a5605a402fdc13$var$currentlyRenderingFiber = null, $d8a5605a402fdc13$var$currentHook = null, $d8a5605a402fdc13$var$workInProgressHook = null, $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdate = !1, $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $d8a5605a402fdc13$var$localIdCounter = 0, $d8a5605a402fdc13$var$thenableIndexCounter = 0, $d8a5605a402fdc13$var$thenableState = null, $d8a5605a402fdc13$var$globalClientIdCounter = 0;
function $d8a5605a402fdc13$var$throwInvalidHookError() {
    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(321));
}
function $d8a5605a402fdc13$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$d8a5605a402fdc13$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $d8a5605a402fdc13$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $d8a5605a402fdc13$var$renderLanes = nextRenderLanes;
    $d8a5605a402fdc13$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $d8a5605a402fdc13$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $d8a5605a402fdc13$var$HooksDispatcherOnMount : $d8a5605a402fdc13$var$HooksDispatcherOnUpdate;
    $d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $d8a5605a402fdc13$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $d8a5605a402fdc13$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $d8a5605a402fdc13$var$finishRenderingHooks(current) {
    $d8a5605a402fdc13$var$ReactSharedInternals.H = $d8a5605a402fdc13$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $d8a5605a402fdc13$var$currentHook && null !== $d8a5605a402fdc13$var$currentHook.next;
    $d8a5605a402fdc13$var$renderLanes = 0;
    $d8a5605a402fdc13$var$workInProgressHook = $d8a5605a402fdc13$var$currentHook = $d8a5605a402fdc13$var$currentlyRenderingFiber = null;
    $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdate = !1;
    $d8a5605a402fdc13$var$thenableIndexCounter = 0;
    $d8a5605a402fdc13$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(300));
    null === current || $d8a5605a402fdc13$var$didReceiveUpdate || (current = current.dependencies, null !== current && $d8a5605a402fdc13$var$checkIfContextChanged(current) && ($d8a5605a402fdc13$var$didReceiveUpdate = !0));
}
function $d8a5605a402fdc13$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $d8a5605a402fdc13$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass && ($d8a5605a402fdc13$var$thenableState = null);
        $d8a5605a402fdc13$var$thenableIndexCounter = 0;
        $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $d8a5605a402fdc13$var$workInProgressHook = $d8a5605a402fdc13$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $d8a5605a402fdc13$var$ReactSharedInternals.H = $d8a5605a402fdc13$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $d8a5605a402fdc13$var$TransitionAwareHostComponent() {
    var dispatcher = $d8a5605a402fdc13$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $d8a5605a402fdc13$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $d8a5605a402fdc13$var$currentHook ? $d8a5605a402fdc13$var$currentHook.memoizedState : null) !== dispatcher && ($d8a5605a402fdc13$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $d8a5605a402fdc13$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $d8a5605a402fdc13$var$localIdCounter;
    $d8a5605a402fdc13$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $d8a5605a402fdc13$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $d8a5605a402fdc13$var$resetHooksOnUnwind(workInProgress) {
    if ($d8a5605a402fdc13$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdate = !1;
    }
    $d8a5605a402fdc13$var$renderLanes = 0;
    $d8a5605a402fdc13$var$workInProgressHook = $d8a5605a402fdc13$var$currentHook = $d8a5605a402fdc13$var$currentlyRenderingFiber = null;
    $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $d8a5605a402fdc13$var$thenableIndexCounter = $d8a5605a402fdc13$var$localIdCounter = 0;
    $d8a5605a402fdc13$var$thenableState = null;
}
function $d8a5605a402fdc13$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d8a5605a402fdc13$var$workInProgressHook ? $d8a5605a402fdc13$var$currentlyRenderingFiber.memoizedState = $d8a5605a402fdc13$var$workInProgressHook = hook : $d8a5605a402fdc13$var$workInProgressHook = $d8a5605a402fdc13$var$workInProgressHook.next = hook;
    return $d8a5605a402fdc13$var$workInProgressHook;
}
function $d8a5605a402fdc13$var$updateWorkInProgressHook() {
    if (null === $d8a5605a402fdc13$var$currentHook) {
        var nextCurrentHook = $d8a5605a402fdc13$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $d8a5605a402fdc13$var$currentHook.next;
    var nextWorkInProgressHook = null === $d8a5605a402fdc13$var$workInProgressHook ? $d8a5605a402fdc13$var$currentlyRenderingFiber.memoizedState : $d8a5605a402fdc13$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $d8a5605a402fdc13$var$workInProgressHook = nextWorkInProgressHook, $d8a5605a402fdc13$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $d8a5605a402fdc13$var$currentlyRenderingFiber.alternate) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(467));
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(310));
        }
        $d8a5605a402fdc13$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $d8a5605a402fdc13$var$currentHook.memoizedState,
            baseState: $d8a5605a402fdc13$var$currentHook.baseState,
            baseQueue: $d8a5605a402fdc13$var$currentHook.baseQueue,
            queue: $d8a5605a402fdc13$var$currentHook.queue,
            next: null
        };
        null === $d8a5605a402fdc13$var$workInProgressHook ? $d8a5605a402fdc13$var$currentlyRenderingFiber.memoizedState = $d8a5605a402fdc13$var$workInProgressHook = nextCurrentHook : $d8a5605a402fdc13$var$workInProgressHook = $d8a5605a402fdc13$var$workInProgressHook.next = nextCurrentHook;
    }
    return $d8a5605a402fdc13$var$workInProgressHook;
}
function $d8a5605a402fdc13$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $d8a5605a402fdc13$var$useThenable(thenable) {
    var index = $d8a5605a402fdc13$var$thenableIndexCounter;
    $d8a5605a402fdc13$var$thenableIndexCounter += 1;
    null === $d8a5605a402fdc13$var$thenableState && ($d8a5605a402fdc13$var$thenableState = []);
    thenable = $d8a5605a402fdc13$var$trackUsedThenable($d8a5605a402fdc13$var$thenableState, thenable, index);
    index = $d8a5605a402fdc13$var$currentlyRenderingFiber;
    null === (null === $d8a5605a402fdc13$var$workInProgressHook ? index.memoizedState : $d8a5605a402fdc13$var$workInProgressHook.next) && (index = index.alternate, $d8a5605a402fdc13$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $d8a5605a402fdc13$var$HooksDispatcherOnMount : $d8a5605a402fdc13$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $d8a5605a402fdc13$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $d8a5605a402fdc13$var$useThenable(usable);
        if (usable.$$typeof === $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE) return $d8a5605a402fdc13$var$readContext(usable);
    }
    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(438, String(usable)));
}
function $d8a5605a402fdc13$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $d8a5605a402fdc13$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $d8a5605a402fdc13$var$createFunctionComponentUpdateQueue(), $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $d8a5605a402fdc13$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $d8a5605a402fdc13$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $d8a5605a402fdc13$var$updateReducer(reducer) {
    var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    return $d8a5605a402fdc13$var$updateReducerImpl(hook, $d8a5605a402fdc13$var$currentHook, reducer);
}
function $d8a5605a402fdc13$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($d8a5605a402fdc13$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $d8a5605a402fdc13$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($d8a5605a402fdc13$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $d8a5605a402fdc13$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $d8a5605a402fdc13$var$currentlyRenderingFiber.lanes |= revertLane, $d8a5605a402fdc13$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $d8a5605a402fdc13$var$currentlyRenderingFiber.lanes |= updateLane, $d8a5605a402fdc13$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$d8a5605a402fdc13$var$objectIs(pendingQueue, hook.memoizedState) && ($d8a5605a402fdc13$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $d8a5605a402fdc13$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $d8a5605a402fdc13$var$rerenderReducer(reducer) {
    var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $d8a5605a402fdc13$var$objectIs(newState, hook.memoizedState) || ($d8a5605a402fdc13$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $d8a5605a402fdc13$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $d8a5605a402fdc13$var$currentlyRenderingFiber, hook = $d8a5605a402fdc13$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $d8a5605a402fdc13$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$d8a5605a402fdc13$var$objectIs(($d8a5605a402fdc13$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $d8a5605a402fdc13$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $d8a5605a402fdc13$var$updateEffect($d8a5605a402fdc13$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $d8a5605a402fdc13$var$workInProgressHook && $d8a5605a402fdc13$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $d8a5605a402fdc13$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $d8a5605a402fdc13$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $d8a5605a402fdc13$var$workInProgressRoot) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($d8a5605a402fdc13$var$renderLanes & 127) || $d8a5605a402fdc13$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $d8a5605a402fdc13$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $d8a5605a402fdc13$var$createFunctionComponentUpdateQueue(), $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $d8a5605a402fdc13$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $d8a5605a402fdc13$var$checkIfSnapshotChanged(inst) && $d8a5605a402fdc13$var$forceStoreRerender(fiber);
}
function $d8a5605a402fdc13$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $d8a5605a402fdc13$var$checkIfSnapshotChanged(inst) && $d8a5605a402fdc13$var$forceStoreRerender(fiber);
    });
}
function $d8a5605a402fdc13$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$d8a5605a402fdc13$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $d8a5605a402fdc13$var$forceStoreRerender(fiber) {
    var root = $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $d8a5605a402fdc13$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $d8a5605a402fdc13$var$mountStateImpl(initialState) {
    var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d8a5605a402fdc13$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $d8a5605a402fdc13$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $d8a5605a402fdc13$var$updateReducerImpl(hook, $d8a5605a402fdc13$var$currentHook, "function" === typeof reducer ? reducer : $d8a5605a402fdc13$var$basicStateReducer);
}
function $d8a5605a402fdc13$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($d8a5605a402fdc13$var$isRenderPhaseUpdate(fiber)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $d8a5605a402fdc13$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $d8a5605a402fdc13$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $d8a5605a402fdc13$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $d8a5605a402fdc13$var$ReactSharedInternals.T, currentTransition = {};
        $d8a5605a402fdc13$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $d8a5605a402fdc13$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $d8a5605a402fdc13$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $d8a5605a402fdc13$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d8a5605a402fdc13$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $d8a5605a402fdc13$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $d8a5605a402fdc13$var$onActionError(actionQueue, node, error$66);
    }
}
function $d8a5605a402fdc13$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $d8a5605a402fdc13$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $d8a5605a402fdc13$var$onActionError(actionQueue, node, error);
    }) : $d8a5605a402fdc13$var$onActionSuccess(actionQueue, node, returnValue);
}
function $d8a5605a402fdc13$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $d8a5605a402fdc13$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $d8a5605a402fdc13$var$runActionStateAction(actionQueue, nextState)));
}
function $d8a5605a402fdc13$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $d8a5605a402fdc13$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $d8a5605a402fdc13$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $d8a5605a402fdc13$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $d8a5605a402fdc13$var$mountActionState(action, initialStateProp) {
    if ($d8a5605a402fdc13$var$isHydrating) {
        var ssrFormState = $d8a5605a402fdc13$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $d8a5605a402fdc13$var$currentlyRenderingFiber;
                if ($d8a5605a402fdc13$var$isHydrating) {
                    if ($d8a5605a402fdc13$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $d8a5605a402fdc13$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $d8a5605a402fdc13$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $d8a5605a402fdc13$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $d8a5605a402fdc13$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $d8a5605a402fdc13$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d8a5605a402fdc13$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $d8a5605a402fdc13$var$dispatchSetState.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $d8a5605a402fdc13$var$mountStateImpl(!1);
    inRootOrSingleton = $d8a5605a402fdc13$var$dispatchOptimisticSetState.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $d8a5605a402fdc13$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $d8a5605a402fdc13$var$dispatchActionState.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $d8a5605a402fdc13$var$updateActionState(action) {
    var stateHook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    return $d8a5605a402fdc13$var$updateActionStateImpl(stateHook, $d8a5605a402fdc13$var$currentHook, action);
}
function $d8a5605a402fdc13$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $d8a5605a402fdc13$var$updateReducerImpl(stateHook, currentStateHook, $d8a5605a402fdc13$var$actionStateReducer)[0];
    stateHook = $d8a5605a402fdc13$var$updateReducer($d8a5605a402fdc13$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $d8a5605a402fdc13$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $d8a5605a402fdc13$var$SuspenseException) throw $d8a5605a402fdc13$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($d8a5605a402fdc13$var$currentlyRenderingFiber.flags |= 2048, $d8a5605a402fdc13$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $d8a5605a402fdc13$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $d8a5605a402fdc13$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $d8a5605a402fdc13$var$rerenderActionState(action) {
    var stateHook = $d8a5605a402fdc13$var$updateWorkInProgressHook(), currentStateHook = $d8a5605a402fdc13$var$currentHook;
    if (null !== currentStateHook) return $d8a5605a402fdc13$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $d8a5605a402fdc13$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $d8a5605a402fdc13$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $d8a5605a402fdc13$var$createFunctionComponentUpdateQueue(), $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $d8a5605a402fdc13$var$updateRef() {
    return $d8a5605a402fdc13$var$updateWorkInProgressHook().memoizedState;
}
function $d8a5605a402fdc13$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
    $d8a5605a402fdc13$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $d8a5605a402fdc13$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $d8a5605a402fdc13$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $d8a5605a402fdc13$var$currentHook && null !== deps && $d8a5605a402fdc13$var$areHookInputsEqual(deps, $d8a5605a402fdc13$var$currentHook.memoizedState.deps) ? hook.memoizedState = $d8a5605a402fdc13$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($d8a5605a402fdc13$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $d8a5605a402fdc13$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $d8a5605a402fdc13$var$mountEffect(create, deps) {
    $d8a5605a402fdc13$var$mountEffectImpl(8390656, 8, create, deps);
}
function $d8a5605a402fdc13$var$updateEffect(create, deps) {
    $d8a5605a402fdc13$var$updateEffectImpl(2048, 8, create, deps);
}
function $d8a5605a402fdc13$var$useEffectEventImpl(payload) {
    $d8a5605a402fdc13$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $d8a5605a402fdc13$var$createFunctionComponentUpdateQueue(), $d8a5605a402fdc13$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $d8a5605a402fdc13$var$updateEvent(callback) {
    var ref = $d8a5605a402fdc13$var$updateWorkInProgressHook().memoizedState;
    $d8a5605a402fdc13$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($d8a5605a402fdc13$var$executionContext & 2)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $d8a5605a402fdc13$var$updateInsertionEffect(create, deps) {
    return $d8a5605a402fdc13$var$updateEffectImpl(4, 2, create, deps);
}
function $d8a5605a402fdc13$var$updateLayoutEffect(create, deps) {
    return $d8a5605a402fdc13$var$updateEffectImpl(4, 4, create, deps);
}
function $d8a5605a402fdc13$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $d8a5605a402fdc13$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $d8a5605a402fdc13$var$updateEffectImpl(4, 4, $d8a5605a402fdc13$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $d8a5605a402fdc13$var$mountDebugValue() {}
function $d8a5605a402fdc13$var$updateCallback(callback, deps) {
    var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d8a5605a402fdc13$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $d8a5605a402fdc13$var$updateMemo(nextCreate, deps) {
    var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d8a5605a402fdc13$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $d8a5605a402fdc13$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($d8a5605a402fdc13$var$renderLanes & 1073741824) && 0 === ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $d8a5605a402fdc13$var$requestDeferredLane();
    $d8a5605a402fdc13$var$currentlyRenderingFiber.lanes |= hook;
    $d8a5605a402fdc13$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $d8a5605a402fdc13$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($d8a5605a402fdc13$var$objectIs(value, prevValue)) return value;
    if (null !== $d8a5605a402fdc13$var$currentTreeHiddenStackCursor.current) return hook = $d8a5605a402fdc13$var$mountDeferredValueImpl(hook, value, initialValue), $d8a5605a402fdc13$var$objectIs(hook, prevValue) || ($d8a5605a402fdc13$var$didReceiveUpdate = !0), hook;
    if (0 === ($d8a5605a402fdc13$var$renderLanes & 42) || 0 !== ($d8a5605a402fdc13$var$renderLanes & 1073741824) && 0 === ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 261930)) return $d8a5605a402fdc13$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $d8a5605a402fdc13$var$requestDeferredLane();
    $d8a5605a402fdc13$var$currentlyRenderingFiber.lanes |= hook;
    $d8a5605a402fdc13$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $d8a5605a402fdc13$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
    $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $d8a5605a402fdc13$var$ReactSharedInternals.T, currentTransition = {};
    $d8a5605a402fdc13$var$ReactSharedInternals.T = currentTransition;
    $d8a5605a402fdc13$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $d8a5605a402fdc13$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $d8a5605a402fdc13$var$chainThenableValue(returnValue, finishedState);
            $d8a5605a402fdc13$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $d8a5605a402fdc13$var$requestUpdateLane(fiber));
        } else $d8a5605a402fdc13$var$dispatchSetStateInternal(fiber, queue, finishedState, $d8a5605a402fdc13$var$requestUpdateLane(fiber));
    } catch (error) {
        $d8a5605a402fdc13$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $d8a5605a402fdc13$var$requestUpdateLane());
    } finally{
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $d8a5605a402fdc13$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d8a5605a402fdc13$var$noop() {}
function $d8a5605a402fdc13$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(476));
    var queue = $d8a5605a402fdc13$var$ensureFormComponentIsStateful(formFiber).queue;
    $d8a5605a402fdc13$var$startTransition(formFiber, queue, pendingState, $d8a5605a402fdc13$var$sharedNotPendingObject, null === action ? $d8a5605a402fdc13$var$noop : function() {
        $d8a5605a402fdc13$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $d8a5605a402fdc13$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $d8a5605a402fdc13$var$sharedNotPendingObject,
        baseState: $d8a5605a402fdc13$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d8a5605a402fdc13$var$basicStateReducer,
            lastRenderedState: $d8a5605a402fdc13$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d8a5605a402fdc13$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $d8a5605a402fdc13$var$requestFormReset$1(formFiber) {
    var stateHook = $d8a5605a402fdc13$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $d8a5605a402fdc13$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $d8a5605a402fdc13$var$requestUpdateLane());
}
function $d8a5605a402fdc13$var$useHostTransitionStatus() {
    return $d8a5605a402fdc13$var$readContext($d8a5605a402fdc13$var$HostTransitionContext);
}
function $d8a5605a402fdc13$var$updateId() {
    return $d8a5605a402fdc13$var$updateWorkInProgressHook().memoizedState;
}
function $d8a5605a402fdc13$var$updateRefresh() {
    return $d8a5605a402fdc13$var$updateWorkInProgressHook().memoizedState;
}
function $d8a5605a402fdc13$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $d8a5605a402fdc13$var$requestUpdateLane();
                fiber = $d8a5605a402fdc13$var$createUpdate(lane);
                var root$69 = $d8a5605a402fdc13$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($d8a5605a402fdc13$var$scheduleUpdateOnFiber(root$69, provider, lane), $d8a5605a402fdc13$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $d8a5605a402fdc13$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $d8a5605a402fdc13$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $d8a5605a402fdc13$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $d8a5605a402fdc13$var$isRenderPhaseUpdate(fiber) ? $d8a5605a402fdc13$var$enqueueRenderPhaseUpdate(queue, action) : (action = $d8a5605a402fdc13$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($d8a5605a402fdc13$var$scheduleUpdateOnFiber(action, fiber, lane), $d8a5605a402fdc13$var$entangleTransitionUpdate(action, queue, lane)));
}
function $d8a5605a402fdc13$var$dispatchSetState(fiber, queue, action) {
    var lane = $d8a5605a402fdc13$var$requestUpdateLane();
    $d8a5605a402fdc13$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $d8a5605a402fdc13$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d8a5605a402fdc13$var$isRenderPhaseUpdate(fiber)) $d8a5605a402fdc13$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($d8a5605a402fdc13$var$objectIs(eagerState, currentState)) return $d8a5605a402fdc13$var$enqueueUpdate$1(fiber, queue, update, 0), null === $d8a5605a402fdc13$var$workInProgressRoot && $d8a5605a402fdc13$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $d8a5605a402fdc13$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $d8a5605a402fdc13$var$scheduleUpdateOnFiber(action, fiber, lane), $d8a5605a402fdc13$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $d8a5605a402fdc13$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $d8a5605a402fdc13$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d8a5605a402fdc13$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $d8a5605a402fdc13$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $d8a5605a402fdc13$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $d8a5605a402fdc13$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $d8a5605a402fdc13$var$currentlyRenderingFiber || null !== alternate && alternate === $d8a5605a402fdc13$var$currentlyRenderingFiber;
}
function $d8a5605a402fdc13$var$enqueueRenderPhaseUpdate(queue, update) {
    $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdateDuringThisPass = $d8a5605a402fdc13$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $d8a5605a402fdc13$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $d8a5605a402fdc13$var$markRootEntangled(root, lane);
    }
}
var $d8a5605a402fdc13$var$ContextOnlyDispatcher = {
    readContext: $d8a5605a402fdc13$var$readContext,
    use: $d8a5605a402fdc13$var$use,
    useCallback: $d8a5605a402fdc13$var$throwInvalidHookError,
    useContext: $d8a5605a402fdc13$var$throwInvalidHookError,
    useEffect: $d8a5605a402fdc13$var$throwInvalidHookError,
    useImperativeHandle: $d8a5605a402fdc13$var$throwInvalidHookError,
    useLayoutEffect: $d8a5605a402fdc13$var$throwInvalidHookError,
    useInsertionEffect: $d8a5605a402fdc13$var$throwInvalidHookError,
    useMemo: $d8a5605a402fdc13$var$throwInvalidHookError,
    useReducer: $d8a5605a402fdc13$var$throwInvalidHookError,
    useRef: $d8a5605a402fdc13$var$throwInvalidHookError,
    useState: $d8a5605a402fdc13$var$throwInvalidHookError,
    useDebugValue: $d8a5605a402fdc13$var$throwInvalidHookError,
    useDeferredValue: $d8a5605a402fdc13$var$throwInvalidHookError,
    useTransition: $d8a5605a402fdc13$var$throwInvalidHookError,
    useSyncExternalStore: $d8a5605a402fdc13$var$throwInvalidHookError,
    useId: $d8a5605a402fdc13$var$throwInvalidHookError,
    useHostTransitionStatus: $d8a5605a402fdc13$var$throwInvalidHookError,
    useFormState: $d8a5605a402fdc13$var$throwInvalidHookError,
    useActionState: $d8a5605a402fdc13$var$throwInvalidHookError,
    useOptimistic: $d8a5605a402fdc13$var$throwInvalidHookError,
    useMemoCache: $d8a5605a402fdc13$var$throwInvalidHookError,
    useCacheRefresh: $d8a5605a402fdc13$var$throwInvalidHookError
};
$d8a5605a402fdc13$var$ContextOnlyDispatcher.useEffectEvent = $d8a5605a402fdc13$var$throwInvalidHookError;
var $d8a5605a402fdc13$var$HooksDispatcherOnMount = {
    readContext: $d8a5605a402fdc13$var$readContext,
    use: $d8a5605a402fdc13$var$use,
    useCallback: function(callback, deps) {
        $d8a5605a402fdc13$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $d8a5605a402fdc13$var$readContext,
    useEffect: $d8a5605a402fdc13$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $d8a5605a402fdc13$var$mountEffectImpl(4194308, 4, $d8a5605a402fdc13$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $d8a5605a402fdc13$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $d8a5605a402fdc13$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($d8a5605a402fdc13$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $d8a5605a402fdc13$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $d8a5605a402fdc13$var$dispatchReducerAction.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $d8a5605a402fdc13$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $d8a5605a402fdc13$var$dispatchSetState.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $d8a5605a402fdc13$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
        return $d8a5605a402fdc13$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $d8a5605a402fdc13$var$mountStateImpl(!1);
        stateHook = $d8a5605a402fdc13$var$startTransition.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $d8a5605a402fdc13$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $d8a5605a402fdc13$var$currentlyRenderingFiber, hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
        if ($d8a5605a402fdc13$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $d8a5605a402fdc13$var$workInProgressRoot) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(349));
            0 !== ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 127) || $d8a5605a402fdc13$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $d8a5605a402fdc13$var$mountEffect($d8a5605a402fdc13$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $d8a5605a402fdc13$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $d8a5605a402fdc13$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook(), identifierPrefix = $d8a5605a402fdc13$var$workInProgressRoot.identifierPrefix;
        if ($d8a5605a402fdc13$var$isHydrating) {
            var JSCompiler_inline_result = $d8a5605a402fdc13$var$treeContextOverflow;
            var idWithLeadingBit = $d8a5605a402fdc13$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $d8a5605a402fdc13$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $d8a5605a402fdc13$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $d8a5605a402fdc13$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $d8a5605a402fdc13$var$useHostTransitionStatus,
    useFormState: $d8a5605a402fdc13$var$mountActionState,
    useActionState: $d8a5605a402fdc13$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $d8a5605a402fdc13$var$dispatchOptimisticSetState.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $d8a5605a402fdc13$var$useMemoCache,
    useCacheRefresh: function() {
        return $d8a5605a402fdc13$var$mountWorkInProgressHook().memoizedState = $d8a5605a402fdc13$var$refreshCache.bind(null, $d8a5605a402fdc13$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $d8a5605a402fdc13$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($d8a5605a402fdc13$var$executionContext & 2)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $d8a5605a402fdc13$var$HooksDispatcherOnUpdate = {
    readContext: $d8a5605a402fdc13$var$readContext,
    use: $d8a5605a402fdc13$var$use,
    useCallback: $d8a5605a402fdc13$var$updateCallback,
    useContext: $d8a5605a402fdc13$var$readContext,
    useEffect: $d8a5605a402fdc13$var$updateEffect,
    useImperativeHandle: $d8a5605a402fdc13$var$updateImperativeHandle,
    useInsertionEffect: $d8a5605a402fdc13$var$updateInsertionEffect,
    useLayoutEffect: $d8a5605a402fdc13$var$updateLayoutEffect,
    useMemo: $d8a5605a402fdc13$var$updateMemo,
    useReducer: $d8a5605a402fdc13$var$updateReducer,
    useRef: $d8a5605a402fdc13$var$updateRef,
    useState: function() {
        return $d8a5605a402fdc13$var$updateReducer($d8a5605a402fdc13$var$basicStateReducer);
    },
    useDebugValue: $d8a5605a402fdc13$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
        return $d8a5605a402fdc13$var$updateDeferredValueImpl(hook, $d8a5605a402fdc13$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d8a5605a402fdc13$var$updateReducer($d8a5605a402fdc13$var$basicStateReducer)[0], start = $d8a5605a402fdc13$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d8a5605a402fdc13$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d8a5605a402fdc13$var$updateSyncExternalStore,
    useId: $d8a5605a402fdc13$var$updateId,
    useHostTransitionStatus: $d8a5605a402fdc13$var$useHostTransitionStatus,
    useFormState: $d8a5605a402fdc13$var$updateActionState,
    useActionState: $d8a5605a402fdc13$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
        return $d8a5605a402fdc13$var$updateOptimisticImpl(hook, $d8a5605a402fdc13$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $d8a5605a402fdc13$var$useMemoCache,
    useCacheRefresh: $d8a5605a402fdc13$var$updateRefresh
};
$d8a5605a402fdc13$var$HooksDispatcherOnUpdate.useEffectEvent = $d8a5605a402fdc13$var$updateEvent;
var $d8a5605a402fdc13$var$HooksDispatcherOnRerender = {
    readContext: $d8a5605a402fdc13$var$readContext,
    use: $d8a5605a402fdc13$var$use,
    useCallback: $d8a5605a402fdc13$var$updateCallback,
    useContext: $d8a5605a402fdc13$var$readContext,
    useEffect: $d8a5605a402fdc13$var$updateEffect,
    useImperativeHandle: $d8a5605a402fdc13$var$updateImperativeHandle,
    useInsertionEffect: $d8a5605a402fdc13$var$updateInsertionEffect,
    useLayoutEffect: $d8a5605a402fdc13$var$updateLayoutEffect,
    useMemo: $d8a5605a402fdc13$var$updateMemo,
    useReducer: $d8a5605a402fdc13$var$rerenderReducer,
    useRef: $d8a5605a402fdc13$var$updateRef,
    useState: function() {
        return $d8a5605a402fdc13$var$rerenderReducer($d8a5605a402fdc13$var$basicStateReducer);
    },
    useDebugValue: $d8a5605a402fdc13$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
        return null === $d8a5605a402fdc13$var$currentHook ? $d8a5605a402fdc13$var$mountDeferredValueImpl(hook, value, initialValue) : $d8a5605a402fdc13$var$updateDeferredValueImpl(hook, $d8a5605a402fdc13$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d8a5605a402fdc13$var$rerenderReducer($d8a5605a402fdc13$var$basicStateReducer)[0], start = $d8a5605a402fdc13$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d8a5605a402fdc13$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d8a5605a402fdc13$var$updateSyncExternalStore,
    useId: $d8a5605a402fdc13$var$updateId,
    useHostTransitionStatus: $d8a5605a402fdc13$var$useHostTransitionStatus,
    useFormState: $d8a5605a402fdc13$var$rerenderActionState,
    useActionState: $d8a5605a402fdc13$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d8a5605a402fdc13$var$updateWorkInProgressHook();
        if (null !== $d8a5605a402fdc13$var$currentHook) return $d8a5605a402fdc13$var$updateOptimisticImpl(hook, $d8a5605a402fdc13$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $d8a5605a402fdc13$var$useMemoCache,
    useCacheRefresh: $d8a5605a402fdc13$var$updateRefresh
};
$d8a5605a402fdc13$var$HooksDispatcherOnRerender.useEffectEvent = $d8a5605a402fdc13$var$updateEvent;
function $d8a5605a402fdc13$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $d8a5605a402fdc13$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $d8a5605a402fdc13$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d8a5605a402fdc13$var$requestUpdateLane(), update = $d8a5605a402fdc13$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d8a5605a402fdc13$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d8a5605a402fdc13$var$scheduleUpdateOnFiber(payload, inst, lane), $d8a5605a402fdc13$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d8a5605a402fdc13$var$requestUpdateLane(), update = $d8a5605a402fdc13$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d8a5605a402fdc13$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d8a5605a402fdc13$var$scheduleUpdateOnFiber(payload, inst, lane), $d8a5605a402fdc13$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $d8a5605a402fdc13$var$requestUpdateLane(), update = $d8a5605a402fdc13$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $d8a5605a402fdc13$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($d8a5605a402fdc13$var$scheduleUpdateOnFiber(callback, inst, lane), $d8a5605a402fdc13$var$entangleTransitions(callback, inst, lane));
    }
};
function $d8a5605a402fdc13$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$d8a5605a402fdc13$var$shallowEqual(oldProps, newProps) || !$d8a5605a402fdc13$var$shallowEqual(oldState, newState) : !0;
}
function $d8a5605a402fdc13$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $d8a5605a402fdc13$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $d8a5605a402fdc13$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $d8a5605a402fdc13$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $d8a5605a402fdc13$var$defaultOnUncaughtError(error) {
    $d8a5605a402fdc13$var$reportGlobalError(error);
}
function $d8a5605a402fdc13$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $d8a5605a402fdc13$var$defaultOnRecoverableError(error) {
    $d8a5605a402fdc13$var$reportGlobalError(error);
}
function $d8a5605a402fdc13$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $d8a5605a402fdc13$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $d8a5605a402fdc13$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $d8a5605a402fdc13$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $d8a5605a402fdc13$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $d8a5605a402fdc13$var$createClassErrorUpdate(lane) {
    lane = $d8a5605a402fdc13$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $d8a5605a402fdc13$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $d8a5605a402fdc13$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $d8a5605a402fdc13$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed ? $d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $d8a5605a402fdc13$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $d8a5605a402fdc13$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $d8a5605a402fdc13$var$shellBoundary ? $d8a5605a402fdc13$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $d8a5605a402fdc13$var$workInProgressRootExitStatus && ($d8a5605a402fdc13$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $d8a5605a402fdc13$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $d8a5605a402fdc13$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $d8a5605a402fdc13$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $d8a5605a402fdc13$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $d8a5605a402fdc13$var$attachPingListener(root, value, rootRenderLanes);
        $d8a5605a402fdc13$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($d8a5605a402fdc13$var$isHydrating) return returnFiber = $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $d8a5605a402fdc13$var$HydrationMismatchException && (root = Error($d8a5605a402fdc13$var$formatProdErrorMessage(422), {
        cause: value
    }), $d8a5605a402fdc13$var$queueHydrationError($d8a5605a402fdc13$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $d8a5605a402fdc13$var$HydrationMismatchException && (returnFiber = Error($d8a5605a402fdc13$var$formatProdErrorMessage(423), {
        cause: value
    }), $d8a5605a402fdc13$var$queueHydrationError($d8a5605a402fdc13$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $d8a5605a402fdc13$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $d8a5605a402fdc13$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $d8a5605a402fdc13$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $d8a5605a402fdc13$var$workInProgressRootExitStatus && ($d8a5605a402fdc13$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($d8a5605a402fdc13$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $d8a5605a402fdc13$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $d8a5605a402fdc13$var$workInProgressRootConcurrentErrors ? $d8a5605a402fdc13$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $d8a5605a402fdc13$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $d8a5605a402fdc13$var$workInProgressRootExitStatus && ($d8a5605a402fdc13$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $d8a5605a402fdc13$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $d8a5605a402fdc13$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $d8a5605a402fdc13$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed || !$d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $d8a5605a402fdc13$var$createClassErrorUpdate(rootRenderLanes), $d8a5605a402fdc13$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $d8a5605a402fdc13$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $d8a5605a402fdc13$var$SelectiveHydrationException = Error($d8a5605a402fdc13$var$formatProdErrorMessage(461)), $d8a5605a402fdc13$var$didReceiveUpdate = !1;
function $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $d8a5605a402fdc13$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $d8a5605a402fdc13$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $d8a5605a402fdc13$var$prepareToReadContext(workInProgress);
    nextProps = $d8a5605a402fdc13$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $d8a5605a402fdc13$var$checkDidRenderIdHook();
    if (null !== current && !$d8a5605a402fdc13$var$didReceiveUpdate) return $d8a5605a402fdc13$var$bailoutHooks(current, workInProgress, renderLanes), $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d8a5605a402fdc13$var$isHydrating && key && $d8a5605a402fdc13$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d8a5605a402fdc13$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$d8a5605a402fdc13$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $d8a5605a402fdc13$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $d8a5605a402fdc13$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$d8a5605a402fdc13$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $d8a5605a402fdc13$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $d8a5605a402fdc13$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $d8a5605a402fdc13$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($d8a5605a402fdc13$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($d8a5605a402fdc13$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $d8a5605a402fdc13$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($d8a5605a402fdc13$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $d8a5605a402fdc13$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $d8a5605a402fdc13$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $d8a5605a402fdc13$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $d8a5605a402fdc13$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $d8a5605a402fdc13$var$pushHiddenContext(workInProgress, prevState) : $d8a5605a402fdc13$var$reuseHiddenContextOnStack(), $d8a5605a402fdc13$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $d8a5605a402fdc13$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($d8a5605a402fdc13$var$pushTransition(workInProgress, prevState.cachePool), $d8a5605a402fdc13$var$pushHiddenContext(workInProgress, prevState), $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $d8a5605a402fdc13$var$pushTransition(workInProgress, null), $d8a5605a402fdc13$var$reuseHiddenContextOnStack(), $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress));
    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $d8a5605a402fdc13$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $d8a5605a402fdc13$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $d8a5605a402fdc13$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $d8a5605a402fdc13$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $d8a5605a402fdc13$var$pushTransition(workInProgress, null);
    $d8a5605a402fdc13$var$reuseHiddenContextOnStack();
    $d8a5605a402fdc13$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $d8a5605a402fdc13$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $d8a5605a402fdc13$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $d8a5605a402fdc13$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $d8a5605a402fdc13$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d8a5605a402fdc13$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $d8a5605a402fdc13$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($d8a5605a402fdc13$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $d8a5605a402fdc13$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $d8a5605a402fdc13$var$bailoutOffscreenComponent(null, current);
            $d8a5605a402fdc13$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $d8a5605a402fdc13$var$nextHydratableInstance) ? (current = $d8a5605a402fdc13$var$canHydrateHydrationBoundary(current, $d8a5605a402fdc13$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $d8a5605a402fdc13$var$treeContextProvider ? {
                    id: $d8a5605a402fdc13$var$treeContextId,
                    overflow: $d8a5605a402fdc13$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $d8a5605a402fdc13$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $d8a5605a402fdc13$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $d8a5605a402fdc13$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $d8a5605a402fdc13$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $d8a5605a402fdc13$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(558));
        } else if ($d8a5605a402fdc13$var$didReceiveUpdate || $d8a5605a402fdc13$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $d8a5605a402fdc13$var$didReceiveUpdate || didSuspend) {
            nextProps = $d8a5605a402fdc13$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $d8a5605a402fdc13$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(current, dehydrated), $d8a5605a402fdc13$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $d8a5605a402fdc13$var$SelectiveHydrationException;
            $d8a5605a402fdc13$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d8a5605a402fdc13$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratable(dehydrated.nextSibling), $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$isHydrating = !0, $d8a5605a402fdc13$var$hydrationErrors = null, $d8a5605a402fdc13$var$rootOrSingletonContext = !1, null !== current && $d8a5605a402fdc13$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $d8a5605a402fdc13$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $d8a5605a402fdc13$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $d8a5605a402fdc13$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $d8a5605a402fdc13$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d8a5605a402fdc13$var$prepareToReadContext(workInProgress);
    Component = $d8a5605a402fdc13$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $d8a5605a402fdc13$var$checkDidRenderIdHook();
    if (null !== current && !$d8a5605a402fdc13$var$didReceiveUpdate) return $d8a5605a402fdc13$var$bailoutHooks(current, workInProgress, renderLanes), $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d8a5605a402fdc13$var$isHydrating && nextProps && $d8a5605a402fdc13$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $d8a5605a402fdc13$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $d8a5605a402fdc13$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $d8a5605a402fdc13$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $d8a5605a402fdc13$var$finishRenderingHooks(current);
    Component = $d8a5605a402fdc13$var$checkDidRenderIdHook();
    if (null !== current && !$d8a5605a402fdc13$var$didReceiveUpdate) return $d8a5605a402fdc13$var$bailoutHooks(current, workInProgress, renderLanes), $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d8a5605a402fdc13$var$isHydrating && Component && $d8a5605a402fdc13$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d8a5605a402fdc13$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d8a5605a402fdc13$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $d8a5605a402fdc13$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $d8a5605a402fdc13$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $d8a5605a402fdc13$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $d8a5605a402fdc13$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $d8a5605a402fdc13$var$readContext(contextType) : $d8a5605a402fdc13$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($d8a5605a402fdc13$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $d8a5605a402fdc13$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $d8a5605a402fdc13$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $d8a5605a402fdc13$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $d8a5605a402fdc13$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $d8a5605a402fdc13$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $d8a5605a402fdc13$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $d8a5605a402fdc13$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $d8a5605a402fdc13$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d8a5605a402fdc13$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d8a5605a402fdc13$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $d8a5605a402fdc13$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($d8a5605a402fdc13$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $d8a5605a402fdc13$var$hasForceUpdate || $d8a5605a402fdc13$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $d8a5605a402fdc13$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $d8a5605a402fdc13$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $d8a5605a402fdc13$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $d8a5605a402fdc13$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $d8a5605a402fdc13$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $d8a5605a402fdc13$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d8a5605a402fdc13$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d8a5605a402fdc13$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $d8a5605a402fdc13$var$hasForceUpdate || null !== current && null !== current.dependencies && $d8a5605a402fdc13$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($d8a5605a402fdc13$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $d8a5605a402fdc13$var$hasForceUpdate || $d8a5605a402fdc13$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $d8a5605a402fdc13$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $d8a5605a402fdc13$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $d8a5605a402fdc13$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $d8a5605a402fdc13$var$resetHydrationState();
    workInProgress.flags |= 256;
    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $d8a5605a402fdc13$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $d8a5605a402fdc13$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $d8a5605a402fdc13$var$getSuspendedCache()
    };
}
function $d8a5605a402fdc13$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $d8a5605a402fdc13$var$workInProgressDeferredLane);
    return current;
}
function $d8a5605a402fdc13$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($d8a5605a402fdc13$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($d8a5605a402fdc13$var$isHydrating) {
            showFallback ? $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $d8a5605a402fdc13$var$nextHydratableInstance) ? (current = $d8a5605a402fdc13$var$canHydrateHydrationBoundary(current, $d8a5605a402fdc13$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $d8a5605a402fdc13$var$treeContextProvider ? {
                    id: $d8a5605a402fdc13$var$treeContextId,
                    overflow: $d8a5605a402fdc13$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $d8a5605a402fdc13$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $d8a5605a402fdc13$var$throwOnHydrationMismatch(workInProgress);
            $d8a5605a402fdc13$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $d8a5605a402fdc13$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $d8a5605a402fdc13$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $d8a5605a402fdc13$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d8a5605a402fdc13$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d8a5605a402fdc13$var$SUSPENDED_MARKER, $d8a5605a402fdc13$var$bailoutOffscreenComponent(null, nextProps);
        $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $d8a5605a402fdc13$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $d8a5605a402fdc13$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $d8a5605a402fdc13$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $d8a5605a402fdc13$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $d8a5605a402fdc13$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d8a5605a402fdc13$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d8a5605a402fdc13$var$SUSPENDED_MARKER, workInProgress = $d8a5605a402fdc13$var$bailoutOffscreenComponent(null, nextProps));
        else if ($d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress), $d8a5605a402fdc13$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($d8a5605a402fdc13$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $d8a5605a402fdc13$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $d8a5605a402fdc13$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($d8a5605a402fdc13$var$didReceiveUpdate || $d8a5605a402fdc13$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $d8a5605a402fdc13$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $d8a5605a402fdc13$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $d8a5605a402fdc13$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(current, nextProps), $d8a5605a402fdc13$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $d8a5605a402fdc13$var$SelectiveHydrationException;
            $d8a5605a402fdc13$var$isSuspenseInstancePending(nextPrimaryChildren) || $d8a5605a402fdc13$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d8a5605a402fdc13$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $d8a5605a402fdc13$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratable(nextPrimaryChildren.nextSibling), $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$isHydrating = !0, $d8a5605a402fdc13$var$hydrationErrors = null, $d8a5605a402fdc13$var$rootOrSingletonContext = !1, null !== current && $d8a5605a402fdc13$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $d8a5605a402fdc13$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $d8a5605a402fdc13$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $d8a5605a402fdc13$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $d8a5605a402fdc13$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $d8a5605a402fdc13$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $d8a5605a402fdc13$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $d8a5605a402fdc13$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $d8a5605a402fdc13$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $d8a5605a402fdc13$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $d8a5605a402fdc13$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d8a5605a402fdc13$var$SUSPENDED_MARKER, $d8a5605a402fdc13$var$bailoutOffscreenComponent(current.child, nextProps);
    $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $d8a5605a402fdc13$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $d8a5605a402fdc13$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $d8a5605a402fdc13$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $d8a5605a402fdc13$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $d8a5605a402fdc13$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $d8a5605a402fdc13$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d8a5605a402fdc13$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $d8a5605a402fdc13$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $d8a5605a402fdc13$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $d8a5605a402fdc13$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $d8a5605a402fdc13$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $d8a5605a402fdc13$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, suspenseContext);
    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $d8a5605a402fdc13$var$isHydrating ? $d8a5605a402fdc13$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $d8a5605a402fdc13$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $d8a5605a402fdc13$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $d8a5605a402fdc13$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $d8a5605a402fdc13$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $d8a5605a402fdc13$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $d8a5605a402fdc13$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $d8a5605a402fdc13$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $d8a5605a402fdc13$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($d8a5605a402fdc13$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $d8a5605a402fdc13$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $d8a5605a402fdc13$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $d8a5605a402fdc13$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $d8a5605a402fdc13$var$checkIfContextChanged(current) ? !0 : !1;
}
function $d8a5605a402fdc13$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $d8a5605a402fdc13$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $d8a5605a402fdc13$var$pushProvider(workInProgress, $d8a5605a402fdc13$var$CacheContext, current.memoizedState.cache);
            $d8a5605a402fdc13$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $d8a5605a402fdc13$var$pushHostContext(workInProgress);
            break;
        case 4:
            $d8a5605a402fdc13$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $d8a5605a402fdc13$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $d8a5605a402fdc13$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $d8a5605a402fdc13$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $d8a5605a402fdc13$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($d8a5605a402fdc13$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $d8a5605a402fdc13$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, $d8a5605a402fdc13$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $d8a5605a402fdc13$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $d8a5605a402fdc13$var$pushProvider(workInProgress, $d8a5605a402fdc13$var$CacheContext, current.memoizedState.cache);
    }
    return $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $d8a5605a402fdc13$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $d8a5605a402fdc13$var$didReceiveUpdate = !0;
        else {
            if (!$d8a5605a402fdc13$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $d8a5605a402fdc13$var$didReceiveUpdate = !1, $d8a5605a402fdc13$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $d8a5605a402fdc13$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $d8a5605a402fdc13$var$didReceiveUpdate = !1, $d8a5605a402fdc13$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $d8a5605a402fdc13$var$pushTreeId(workInProgress, $d8a5605a402fdc13$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $d8a5605a402fdc13$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $d8a5605a402fdc13$var$shouldConstruct(current) ? (props = $d8a5605a402fdc13$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $d8a5605a402fdc13$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $d8a5605a402fdc13$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $d8a5605a402fdc13$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $d8a5605a402fdc13$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $d8a5605a402fdc13$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $d8a5605a402fdc13$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $d8a5605a402fdc13$var$getComponentNameFromType(current) || current;
                    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $d8a5605a402fdc13$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $d8a5605a402fdc13$var$resolveClassComponentProps(props, workInProgress.pendingProps), $d8a5605a402fdc13$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $d8a5605a402fdc13$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $d8a5605a402fdc13$var$cloneUpdateQueue(current, workInProgress);
                $d8a5605a402fdc13$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $d8a5605a402fdc13$var$pushProvider(workInProgress, $d8a5605a402fdc13$var$CacheContext, props);
                props !== prevState.cache && $d8a5605a402fdc13$var$propagateContextChanges(workInProgress, [
                    $d8a5605a402fdc13$var$CacheContext
                ], renderLanes, !0);
                $d8a5605a402fdc13$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $d8a5605a402fdc13$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $d8a5605a402fdc13$var$createCapturedValueAtFiber(Error($d8a5605a402fdc13$var$formatProdErrorMessage(424)), workInProgress);
                        $d8a5605a402fdc13$var$queueHydrationError($$typeof);
                        workInProgress = $d8a5605a402fdc13$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratable(current.firstChild);
                        $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress;
                        $d8a5605a402fdc13$var$isHydrating = !0;
                        $d8a5605a402fdc13$var$hydrationErrors = null;
                        $d8a5605a402fdc13$var$rootOrSingletonContext = !0;
                        renderLanes = $d8a5605a402fdc13$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $d8a5605a402fdc13$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $d8a5605a402fdc13$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $d8a5605a402fdc13$var$markRef(current, workInProgress), null === current ? (renderLanes = $d8a5605a402fdc13$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $d8a5605a402fdc13$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $d8a5605a402fdc13$var$getOwnerDocumentFromRootContainer($d8a5605a402fdc13$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$d8a5605a402fdc13$var$internalInstanceKey] = workInProgress, props[$d8a5605a402fdc13$var$internalPropsKey] = current, $d8a5605a402fdc13$var$setInitialProperties(props, renderLanes, current), $d8a5605a402fdc13$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $d8a5605a402fdc13$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $d8a5605a402fdc13$var$pushHostContext(workInProgress), null === current && $d8a5605a402fdc13$var$isHydrating && (props = workInProgress.stateNode = $d8a5605a402fdc13$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $d8a5605a402fdc13$var$rootInstanceStackCursor.current), $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$rootOrSingletonContext = !0, $$typeof = $d8a5605a402fdc13$var$nextHydratableInstance, $d8a5605a402fdc13$var$isSingletonScope(workInProgress.type) ? ($d8a5605a402fdc13$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratable(props.firstChild)) : $d8a5605a402fdc13$var$nextHydratableInstance = $$typeof), $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $d8a5605a402fdc13$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $d8a5605a402fdc13$var$isHydrating) {
                if ($$typeof = props = $d8a5605a402fdc13$var$nextHydratableInstance) props = $d8a5605a402fdc13$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $d8a5605a402fdc13$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$nextHydratableInstance = $d8a5605a402fdc13$var$getNextHydratable(props.firstChild), $d8a5605a402fdc13$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $d8a5605a402fdc13$var$throwOnHydrationMismatch(workInProgress);
            }
            $d8a5605a402fdc13$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $d8a5605a402fdc13$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $d8a5605a402fdc13$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $d8a5605a402fdc13$var$renderWithHooks(current, workInProgress, $d8a5605a402fdc13$var$TransitionAwareHostComponent, null, null, renderLanes), $d8a5605a402fdc13$var$HostTransitionContext._currentValue = $$typeof);
            $d8a5605a402fdc13$var$markRef(current, workInProgress);
            $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $d8a5605a402fdc13$var$isHydrating) {
                if (current = renderLanes = $d8a5605a402fdc13$var$nextHydratableInstance) renderLanes = $d8a5605a402fdc13$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $d8a5605a402fdc13$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $d8a5605a402fdc13$var$hydrationParentFiber = workInProgress, $d8a5605a402fdc13$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $d8a5605a402fdc13$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $d8a5605a402fdc13$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $d8a5605a402fdc13$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $d8a5605a402fdc13$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $d8a5605a402fdc13$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $d8a5605a402fdc13$var$pushProvider(workInProgress, workInProgress.type, props.value), $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $d8a5605a402fdc13$var$prepareToReadContext(workInProgress), $$typeof = $d8a5605a402fdc13$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $d8a5605a402fdc13$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $d8a5605a402fdc13$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $d8a5605a402fdc13$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $d8a5605a402fdc13$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $d8a5605a402fdc13$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $d8a5605a402fdc13$var$prepareToReadContext(workInProgress), props = $d8a5605a402fdc13$var$readContext($d8a5605a402fdc13$var$CacheContext), null === current ? ($$typeof = $d8a5605a402fdc13$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $d8a5605a402fdc13$var$workInProgressRoot, prevState = $d8a5605a402fdc13$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $d8a5605a402fdc13$var$initializeUpdateQueue(workInProgress), $d8a5605a402fdc13$var$pushProvider(workInProgress, $d8a5605a402fdc13$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($d8a5605a402fdc13$var$cloneUpdateQueue(current, workInProgress), $d8a5605a402fdc13$var$processUpdateQueue(workInProgress, null, null, renderLanes), $d8a5605a402fdc13$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $d8a5605a402fdc13$var$pushProvider(workInProgress, $d8a5605a402fdc13$var$CacheContext, props)) : (props = prevState.cache, $d8a5605a402fdc13$var$pushProvider(workInProgress, $d8a5605a402fdc13$var$CacheContext, props), props !== $$typeof.cache && $d8a5605a402fdc13$var$propagateContextChanges(workInProgress, [
                $d8a5605a402fdc13$var$CacheContext
            ], renderLanes, !0))), $d8a5605a402fdc13$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d8a5605a402fdc13$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $d8a5605a402fdc13$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($d8a5605a402fdc13$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $d8a5605a402fdc13$var$suspendedThenable = $d8a5605a402fdc13$var$noopSuspenseyCommitThenable, $d8a5605a402fdc13$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $d8a5605a402fdc13$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$d8a5605a402fdc13$var$preloadResource(resource)) {
        if ($d8a5605a402fdc13$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $d8a5605a402fdc13$var$suspendedThenable = $d8a5605a402fdc13$var$noopSuspenseyCommitThenable, $d8a5605a402fdc13$var$SuspenseyCommitException;
    }
}
function $d8a5605a402fdc13$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $d8a5605a402fdc13$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $d8a5605a402fdc13$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$d8a5605a402fdc13$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $d8a5605a402fdc13$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $d8a5605a402fdc13$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $d8a5605a402fdc13$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
        case 1:
            return $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $d8a5605a402fdc13$var$popProvider($d8a5605a402fdc13$var$CacheContext);
            $d8a5605a402fdc13$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $d8a5605a402fdc13$var$popHydrationState(workInProgress) ? $d8a5605a402fdc13$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $d8a5605a402fdc13$var$upgradeHydrationErrorsToRecoverable());
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($d8a5605a402fdc13$var$markUpdate(workInProgress), null !== nextResource ? ($d8a5605a402fdc13$var$bubbleProperties(workInProgress), $d8a5605a402fdc13$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($d8a5605a402fdc13$var$bubbleProperties(workInProgress), $d8a5605a402fdc13$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($d8a5605a402fdc13$var$markUpdate(workInProgress), $d8a5605a402fdc13$var$bubbleProperties(workInProgress), $d8a5605a402fdc13$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($d8a5605a402fdc13$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $d8a5605a402fdc13$var$markUpdate(workInProgress), $d8a5605a402fdc13$var$bubbleProperties(workInProgress), $d8a5605a402fdc13$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $d8a5605a402fdc13$var$popHostContext(workInProgress);
            renderLanes = $d8a5605a402fdc13$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d8a5605a402fdc13$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(166));
                    $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $d8a5605a402fdc13$var$contextStackCursor.current;
                $d8a5605a402fdc13$var$popHydrationState(workInProgress) ? $d8a5605a402fdc13$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $d8a5605a402fdc13$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $d8a5605a402fdc13$var$markUpdate(workInProgress));
            }
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $d8a5605a402fdc13$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d8a5605a402fdc13$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(166));
                    $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $d8a5605a402fdc13$var$contextStackCursor.current;
                if ($d8a5605a402fdc13$var$popHydrationState(workInProgress)) $d8a5605a402fdc13$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $d8a5605a402fdc13$var$getOwnerDocumentFromRootContainer($d8a5605a402fdc13$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script></script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$d8a5605a402fdc13$var$internalInstanceKey] = workInProgress;
                    nextResource[$d8a5605a402fdc13$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($d8a5605a402fdc13$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $d8a5605a402fdc13$var$markUpdate(workInProgress);
                }
            }
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            $d8a5605a402fdc13$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d8a5605a402fdc13$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(166));
                current = $d8a5605a402fdc13$var$rootInstanceStackCursor.current;
                if ($d8a5605a402fdc13$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $d8a5605a402fdc13$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$d8a5605a402fdc13$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $d8a5605a402fdc13$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $d8a5605a402fdc13$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $d8a5605a402fdc13$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$d8a5605a402fdc13$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $d8a5605a402fdc13$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(557));
                        current[$d8a5605a402fdc13$var$internalInstanceKey] = workInProgress;
                    } else $d8a5605a402fdc13$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $d8a5605a402fdc13$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(558));
            }
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $d8a5605a402fdc13$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(317));
                        type[$d8a5605a402fdc13$var$internalInstanceKey] = workInProgress;
                    } else $d8a5605a402fdc13$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $d8a5605a402fdc13$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $d8a5605a402fdc13$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $d8a5605a402fdc13$var$popHostContainer(), null === current && $d8a5605a402fdc13$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
        case 10:
            return $d8a5605a402fdc13$var$popProvider(workInProgress.type), $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
        case 19:
            $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $d8a5605a402fdc13$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $d8a5605a402fdc13$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $d8a5605a402fdc13$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $d8a5605a402fdc13$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $d8a5605a402fdc13$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$d8a5605a402fdc13$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, $d8a5605a402fdc13$var$suspenseStackCursor.current & 1 | 2);
                            $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $d8a5605a402fdc13$var$now() > $d8a5605a402fdc13$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $d8a5605a402fdc13$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $d8a5605a402fdc13$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $d8a5605a402fdc13$var$scheduleRetryEffect(workInProgress, current), $d8a5605a402fdc13$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$d8a5605a402fdc13$var$isHydrating) return $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
                    } else 2 * $d8a5605a402fdc13$var$now() - newProps.renderingStartTime > $d8a5605a402fdc13$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $d8a5605a402fdc13$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $d8a5605a402fdc13$var$now(), current.sibling = null, renderLanes = $d8a5605a402fdc13$var$suspenseStackCursor.current, $d8a5605a402fdc13$var$push($d8a5605a402fdc13$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $d8a5605a402fdc13$var$isHydrating && $d8a5605a402fdc13$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $d8a5605a402fdc13$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress), $d8a5605a402fdc13$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($d8a5605a402fdc13$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $d8a5605a402fdc13$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $d8a5605a402fdc13$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $d8a5605a402fdc13$var$popProvider($d8a5605a402fdc13$var$CacheContext), $d8a5605a402fdc13$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d8a5605a402fdc13$var$unwindWork(current, workInProgress) {
    $d8a5605a402fdc13$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $d8a5605a402fdc13$var$popProvider($d8a5605a402fdc13$var$CacheContext), $d8a5605a402fdc13$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $d8a5605a402fdc13$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(340));
                $d8a5605a402fdc13$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(340));
                $d8a5605a402fdc13$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$suspenseStackCursor), null;
        case 4:
            return $d8a5605a402fdc13$var$popHostContainer(), null;
        case 10:
            return $d8a5605a402fdc13$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $d8a5605a402fdc13$var$popSuspenseHandler(workInProgress), $d8a5605a402fdc13$var$popHiddenContext(), null !== current && $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $d8a5605a402fdc13$var$popProvider($d8a5605a402fdc13$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $d8a5605a402fdc13$var$unwindInterruptedWork(current, interruptedWork) {
    $d8a5605a402fdc13$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $d8a5605a402fdc13$var$popProvider($d8a5605a402fdc13$var$CacheContext);
            $d8a5605a402fdc13$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $d8a5605a402fdc13$var$popHostContext(interruptedWork);
            break;
        case 4:
            $d8a5605a402fdc13$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $d8a5605a402fdc13$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $d8a5605a402fdc13$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$suspenseStackCursor);
            break;
        case 10:
            $d8a5605a402fdc13$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $d8a5605a402fdc13$var$popSuspenseHandler(interruptedWork);
            $d8a5605a402fdc13$var$popHiddenContext();
            null !== current && $d8a5605a402fdc13$var$pop($d8a5605a402fdc13$var$resumedCache);
            break;
        case 24:
            $d8a5605a402fdc13$var$popProvider($d8a5605a402fdc13$var$CacheContext);
    }
}
function $d8a5605a402fdc13$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d8a5605a402fdc13$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $d8a5605a402fdc13$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d8a5605a402fdc13$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $d8a5605a402fdc13$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d8a5605a402fdc13$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $d8a5605a402fdc13$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d8a5605a402fdc13$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d8a5605a402fdc13$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $d8a5605a402fdc13$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $d8a5605a402fdc13$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $d8a5605a402fdc13$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d8a5605a402fdc13$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $d8a5605a402fdc13$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$d8a5605a402fdc13$var$internalPropsKey] = newProps;
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d8a5605a402fdc13$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $d8a5605a402fdc13$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $d8a5605a402fdc13$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $d8a5605a402fdc13$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $d8a5605a402fdc13$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $d8a5605a402fdc13$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $d8a5605a402fdc13$var$noop$1));
    else if (4 !== tag && (27 === tag && $d8a5605a402fdc13$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($d8a5605a402fdc13$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$d8a5605a402fdc13$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $d8a5605a402fdc13$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $d8a5605a402fdc13$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($d8a5605a402fdc13$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$d8a5605a402fdc13$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $d8a5605a402fdc13$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $d8a5605a402fdc13$var$setInitialProperties(singleton, type, props);
        singleton[$d8a5605a402fdc13$var$internalInstanceKey] = finishedWork;
        singleton[$d8a5605a402fdc13$var$internalPropsKey] = props;
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $d8a5605a402fdc13$var$offscreenSubtreeIsHidden = !1, $d8a5605a402fdc13$var$offscreenSubtreeWasHidden = !1, $d8a5605a402fdc13$var$needsFormReset = !1, $d8a5605a402fdc13$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $d8a5605a402fdc13$var$nextEffect = null;
function $d8a5605a402fdc13$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $d8a5605a402fdc13$var$eventsEnabled = $d8a5605a402fdc13$var$_enabled;
    root = $d8a5605a402fdc13$var$getActiveElementDeep(root);
    if ($d8a5605a402fdc13$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $d8a5605a402fdc13$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $d8a5605a402fdc13$var$_enabled = !1;
    for($d8a5605a402fdc13$var$nextEffect = firstChild; null !== $d8a5605a402fdc13$var$nextEffect;)if (firstChild = $d8a5605a402fdc13$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $d8a5605a402fdc13$var$nextEffect = root;
    else for(; null !== $d8a5605a402fdc13$var$nextEffect;){
        firstChild = $d8a5605a402fdc13$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $d8a5605a402fdc13$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $d8a5605a402fdc13$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $d8a5605a402fdc13$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $d8a5605a402fdc13$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $d8a5605a402fdc13$var$nextEffect = root;
            break;
        }
        $d8a5605a402fdc13$var$nextEffect = firstChild.return;
    }
}
function $d8a5605a402fdc13$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d8a5605a402fdc13$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $d8a5605a402fdc13$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $d8a5605a402fdc13$var$commitClassCallbacks(finishedWork);
            flags & 512 && $d8a5605a402fdc13$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $d8a5605a402fdc13$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $d8a5605a402fdc13$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $d8a5605a402fdc13$var$commitHostMount(finishedWork);
            flags & 512 && $d8a5605a402fdc13$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d8a5605a402fdc13$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d8a5605a402fdc13$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $d8a5605a402fdc13$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $d8a5605a402fdc13$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $d8a5605a402fdc13$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $d8a5605a402fdc13$var$offscreenSubtreeWasHidden;
                prevProps = $d8a5605a402fdc13$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $d8a5605a402fdc13$var$offscreenSubtreeWasHidden;
                $d8a5605a402fdc13$var$offscreenSubtreeIsHidden = flags;
                ($d8a5605a402fdc13$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $d8a5605a402fdc13$var$offscreenSubtreeIsHidden = prevProps;
                $d8a5605a402fdc13$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $d8a5605a402fdc13$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $d8a5605a402fdc13$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $d8a5605a402fdc13$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $d8a5605a402fdc13$var$hostParent = null, $d8a5605a402fdc13$var$hostParentIsContainer = !1;
function $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$d8a5605a402fdc13$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $d8a5605a402fdc13$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($d8a5605a402fdc13$var$injectedHook && "function" === typeof $d8a5605a402fdc13$var$injectedHook.onCommitFiberUnmount) try {
        $d8a5605a402fdc13$var$injectedHook.onCommitFiberUnmount($d8a5605a402fdc13$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden || $d8a5605a402fdc13$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden || $d8a5605a402fdc13$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $d8a5605a402fdc13$var$hostParent, prevHostParentIsContainer = $d8a5605a402fdc13$var$hostParentIsContainer;
            $d8a5605a402fdc13$var$isSingletonScope(deletedFiber.type) && ($d8a5605a402fdc13$var$hostParent = deletedFiber.stateNode, $d8a5605a402fdc13$var$hostParentIsContainer = !1);
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d8a5605a402fdc13$var$releaseSingletonInstance(deletedFiber.stateNode);
            $d8a5605a402fdc13$var$hostParent = prevHostParent;
            $d8a5605a402fdc13$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden || $d8a5605a402fdc13$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $d8a5605a402fdc13$var$hostParent;
            prevHostParentIsContainer = $d8a5605a402fdc13$var$hostParentIsContainer;
            $d8a5605a402fdc13$var$hostParent = null;
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d8a5605a402fdc13$var$hostParent = prevHostParent;
            $d8a5605a402fdc13$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $d8a5605a402fdc13$var$hostParent) {
                if ($d8a5605a402fdc13$var$hostParentIsContainer) try {
                    (9 === $d8a5605a402fdc13$var$hostParent.nodeType ? $d8a5605a402fdc13$var$hostParent.body : "HTML" === $d8a5605a402fdc13$var$hostParent.nodeName ? $d8a5605a402fdc13$var$hostParent.ownerDocument.body : $d8a5605a402fdc13$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $d8a5605a402fdc13$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $d8a5605a402fdc13$var$hostParent && ($d8a5605a402fdc13$var$hostParentIsContainer ? (finishedRoot = $d8a5605a402fdc13$var$hostParent, $d8a5605a402fdc13$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $d8a5605a402fdc13$var$retryIfBlockedOn(finishedRoot)) : $d8a5605a402fdc13$var$clearHydrationBoundary($d8a5605a402fdc13$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $d8a5605a402fdc13$var$hostParent;
            prevHostParentIsContainer = $d8a5605a402fdc13$var$hostParentIsContainer;
            $d8a5605a402fdc13$var$hostParent = deletedFiber.stateNode.containerInfo;
            $d8a5605a402fdc13$var$hostParentIsContainer = !0;
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d8a5605a402fdc13$var$hostParent = prevHostParent;
            $d8a5605a402fdc13$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $d8a5605a402fdc13$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden || $d8a5605a402fdc13$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden || ($d8a5605a402fdc13$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $d8a5605a402fdc13$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden = (prevHostParent = $d8a5605a402fdc13$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $d8a5605a402fdc13$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $d8a5605a402fdc13$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $d8a5605a402fdc13$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d8a5605a402fdc13$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $d8a5605a402fdc13$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d8a5605a402fdc13$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $d8a5605a402fdc13$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $d8a5605a402fdc13$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $d8a5605a402fdc13$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $d8a5605a402fdc13$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $d8a5605a402fdc13$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($d8a5605a402fdc13$var$isSingletonScope(parent.type)) {
                        $d8a5605a402fdc13$var$hostParent = parent.stateNode;
                        $d8a5605a402fdc13$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $d8a5605a402fdc13$var$hostParent = parent.stateNode;
                    $d8a5605a402fdc13$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $d8a5605a402fdc13$var$hostParent = parent.stateNode.containerInfo;
                    $d8a5605a402fdc13$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $d8a5605a402fdc13$var$hostParent) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(160));
        $d8a5605a402fdc13$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $d8a5605a402fdc13$var$hostParent = null;
        $d8a5605a402fdc13$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$d8a5605a402fdc13$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $d8a5605a402fdc13$var$currentHoistableRoot = null;
function $d8a5605a402fdc13$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($d8a5605a402fdc13$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $d8a5605a402fdc13$var$commitHookEffectListMount(3, finishedWork), $d8a5605a402fdc13$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d8a5605a402fdc13$var$offscreenSubtreeWasHidden || null === current || $d8a5605a402fdc13$var$safelyDetachRef(current, current.return));
            flags & 64 && $d8a5605a402fdc13$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $d8a5605a402fdc13$var$currentHoistableRoot;
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d8a5605a402fdc13$var$offscreenSubtreeWasHidden || null === current || $d8a5605a402fdc13$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$d8a5605a402fdc13$var$internalHoistableMarker] || currentResource[$d8a5605a402fdc13$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $d8a5605a402fdc13$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$d8a5605a402fdc13$var$internalInstanceKey] = finishedWork;
                                        $d8a5605a402fdc13$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $d8a5605a402fdc13$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d8a5605a402fdc13$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $d8a5605a402fdc13$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d8a5605a402fdc13$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$d8a5605a402fdc13$var$internalInstanceKey] = finishedWork;
                                $d8a5605a402fdc13$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $d8a5605a402fdc13$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $d8a5605a402fdc13$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $d8a5605a402fdc13$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $d8a5605a402fdc13$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $d8a5605a402fdc13$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d8a5605a402fdc13$var$offscreenSubtreeWasHidden || null === current || $d8a5605a402fdc13$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $d8a5605a402fdc13$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d8a5605a402fdc13$var$offscreenSubtreeWasHidden || null === current || $d8a5605a402fdc13$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $d8a5605a402fdc13$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $d8a5605a402fdc13$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($d8a5605a402fdc13$var$needsFormReset = !0);
            break;
        case 6:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $d8a5605a402fdc13$var$tagCaches = null;
            hoistableRoot = $d8a5605a402fdc13$var$currentHoistableRoot;
            $d8a5605a402fdc13$var$currentHoistableRoot = $d8a5605a402fdc13$var$getHoistableRoot(root.containerInfo);
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$currentHoistableRoot = hoistableRoot;
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $d8a5605a402fdc13$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $d8a5605a402fdc13$var$needsFormReset && ($d8a5605a402fdc13$var$needsFormReset = !1, $d8a5605a402fdc13$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $d8a5605a402fdc13$var$currentHoistableRoot;
            $d8a5605a402fdc13$var$currentHoistableRoot = $d8a5605a402fdc13$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            $d8a5605a402fdc13$var$currentHoistableRoot = flags;
            break;
        case 12:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d8a5605a402fdc13$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($d8a5605a402fdc13$var$globalMostRecentFallbackTime = $d8a5605a402fdc13$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d8a5605a402fdc13$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $d8a5605a402fdc13$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $d8a5605a402fdc13$var$offscreenSubtreeWasHidden;
            $d8a5605a402fdc13$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $d8a5605a402fdc13$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $d8a5605a402fdc13$var$offscreenSubtreeIsHidden || $d8a5605a402fdc13$var$offscreenSubtreeWasHidden || $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $d8a5605a402fdc13$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $d8a5605a402fdc13$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $d8a5605a402fdc13$var$hideOrUnhideDehydratedBoundary(instance, !0) : $d8a5605a402fdc13$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $d8a5605a402fdc13$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $d8a5605a402fdc13$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d8a5605a402fdc13$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $d8a5605a402fdc13$var$recursivelyTraverseMutationEffects(root, finishedWork), $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork);
    }
}
function $d8a5605a402fdc13$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($d8a5605a402fdc13$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $d8a5605a402fdc13$var$getHostSibling(finishedWork);
                    $d8a5605a402fdc13$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($d8a5605a402fdc13$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $d8a5605a402fdc13$var$getHostSibling(finishedWork);
                    $d8a5605a402fdc13$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $d8a5605a402fdc13$var$getHostSibling(finishedWork);
                    $d8a5605a402fdc13$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $d8a5605a402fdc13$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $d8a5605a402fdc13$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $d8a5605a402fdc13$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$d8a5605a402fdc13$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $d8a5605a402fdc13$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $d8a5605a402fdc13$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $d8a5605a402fdc13$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $d8a5605a402fdc13$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $d8a5605a402fdc13$var$safelyDetachRef(finishedWork, finishedWork.return);
                $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $d8a5605a402fdc13$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d8a5605a402fdc13$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$d8a5605a402fdc13$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $d8a5605a402fdc13$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $d8a5605a402fdc13$var$commitClassCallbacks(finishedWork);
                $d8a5605a402fdc13$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $d8a5605a402fdc13$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $d8a5605a402fdc13$var$commitHostMount(finishedWork);
                $d8a5605a402fdc13$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d8a5605a402fdc13$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d8a5605a402fdc13$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d8a5605a402fdc13$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $d8a5605a402fdc13$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d8a5605a402fdc13$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $d8a5605a402fdc13$var$releaseCache(previousCache));
}
function $d8a5605a402fdc13$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $d8a5605a402fdc13$var$releaseCache(current));
}
function $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d8a5605a402fdc13$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $d8a5605a402fdc13$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d8a5605a402fdc13$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $d8a5605a402fdc13$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $d8a5605a402fdc13$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $d8a5605a402fdc13$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $d8a5605a402fdc13$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d8a5605a402fdc13$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $d8a5605a402fdc13$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $d8a5605a402fdc13$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $d8a5605a402fdc13$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $d8a5605a402fdc13$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d8a5605a402fdc13$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d8a5605a402fdc13$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $d8a5605a402fdc13$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d8a5605a402fdc13$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d8a5605a402fdc13$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d8a5605a402fdc13$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d8a5605a402fdc13$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $d8a5605a402fdc13$var$suspenseyCommitFlag = 8192;
function $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $d8a5605a402fdc13$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$d8a5605a402fdc13$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $d8a5605a402fdc13$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $d8a5605a402fdc13$var$suspenseyCommitFlag && null !== fiber.memoizedState && $d8a5605a402fdc13$var$suspendResource(suspendedState, $d8a5605a402fdc13$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $d8a5605a402fdc13$var$currentHoistableRoot;
            $d8a5605a402fdc13$var$currentHoistableRoot = $d8a5605a402fdc13$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $d8a5605a402fdc13$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $d8a5605a402fdc13$var$suspenseyCommitFlag, $d8a5605a402fdc13$var$suspenseyCommitFlag = 16777216, $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $d8a5605a402fdc13$var$suspenseyCommitFlag = previousHoistableRoot) : $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $d8a5605a402fdc13$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $d8a5605a402fdc13$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $d8a5605a402fdc13$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d8a5605a402fdc13$var$nextEffect = childToDelete;
            $d8a5605a402fdc13$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d8a5605a402fdc13$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d8a5605a402fdc13$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $d8a5605a402fdc13$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $d8a5605a402fdc13$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $d8a5605a402fdc13$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $d8a5605a402fdc13$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $d8a5605a402fdc13$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $d8a5605a402fdc13$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d8a5605a402fdc13$var$nextEffect = childToDelete;
            $d8a5605a402fdc13$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d8a5605a402fdc13$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $d8a5605a402fdc13$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $d8a5605a402fdc13$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $d8a5605a402fdc13$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $d8a5605a402fdc13$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d8a5605a402fdc13$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $d8a5605a402fdc13$var$nextEffect;){
        var fiber = $d8a5605a402fdc13$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $d8a5605a402fdc13$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $d8a5605a402fdc13$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $d8a5605a402fdc13$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $d8a5605a402fdc13$var$nextEffect;){
            cache = $d8a5605a402fdc13$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $d8a5605a402fdc13$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $d8a5605a402fdc13$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $d8a5605a402fdc13$var$nextEffect = sibling;
                break a;
            }
            $d8a5605a402fdc13$var$nextEffect = returnFiber;
        }
    }
}
var $d8a5605a402fdc13$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $d8a5605a402fdc13$var$readContext($d8a5605a402fdc13$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $d8a5605a402fdc13$var$readContext($d8a5605a402fdc13$var$CacheContext).controller.signal;
    }
}, $d8a5605a402fdc13$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $d8a5605a402fdc13$var$executionContext = 0, $d8a5605a402fdc13$var$workInProgressRoot = null, $d8a5605a402fdc13$var$workInProgress = null, $d8a5605a402fdc13$var$workInProgressRootRenderLanes = 0, $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0, $d8a5605a402fdc13$var$workInProgressThrownValue = null, $d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings = !1, $d8a5605a402fdc13$var$workInProgressRootIsPrerendering = !1, $d8a5605a402fdc13$var$workInProgressRootDidAttachPingListener = !1, $d8a5605a402fdc13$var$entangledRenderLanes = 0, $d8a5605a402fdc13$var$workInProgressRootExitStatus = 0, $d8a5605a402fdc13$var$workInProgressRootSkippedLanes = 0, $d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes = 0, $d8a5605a402fdc13$var$workInProgressRootPingedLanes = 0, $d8a5605a402fdc13$var$workInProgressDeferredLane = 0, $d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes = 0, $d8a5605a402fdc13$var$workInProgressRootConcurrentErrors = null, $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors = null, $d8a5605a402fdc13$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $d8a5605a402fdc13$var$globalMostRecentFallbackTime = 0, $d8a5605a402fdc13$var$globalMostRecentTransitionTime = 0, $d8a5605a402fdc13$var$workInProgressRootRenderTargetTime = Infinity, $d8a5605a402fdc13$var$workInProgressTransitions = null, $d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed = null, $d8a5605a402fdc13$var$pendingEffectsStatus = 0, $d8a5605a402fdc13$var$pendingEffectsRoot = null, $d8a5605a402fdc13$var$pendingFinishedWork = null, $d8a5605a402fdc13$var$pendingEffectsLanes = 0, $d8a5605a402fdc13$var$pendingEffectsRemainingLanes = 0, $d8a5605a402fdc13$var$pendingPassiveTransitions = null, $d8a5605a402fdc13$var$pendingRecoverableErrors = null, $d8a5605a402fdc13$var$nestedUpdateCount = 0, $d8a5605a402fdc13$var$rootWithNestedUpdates = null;
function $d8a5605a402fdc13$var$requestUpdateLane() {
    return 0 !== ($d8a5605a402fdc13$var$executionContext & 2) && 0 !== $d8a5605a402fdc13$var$workInProgressRootRenderLanes ? $d8a5605a402fdc13$var$workInProgressRootRenderLanes & -$d8a5605a402fdc13$var$workInProgressRootRenderLanes : null !== $d8a5605a402fdc13$var$ReactSharedInternals.T ? $d8a5605a402fdc13$var$requestTransitionLane() : $d8a5605a402fdc13$var$resolveUpdatePriority();
}
function $d8a5605a402fdc13$var$requestDeferredLane() {
    if (0 === $d8a5605a402fdc13$var$workInProgressDeferredLane) {
        if (0 === ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 536870912) || $d8a5605a402fdc13$var$isHydrating) {
            var lane = $d8a5605a402fdc13$var$nextTransitionDeferredLane;
            $d8a5605a402fdc13$var$nextTransitionDeferredLane <<= 1;
            0 === ($d8a5605a402fdc13$var$nextTransitionDeferredLane & 3932160) && ($d8a5605a402fdc13$var$nextTransitionDeferredLane = 262144);
            $d8a5605a402fdc13$var$workInProgressDeferredLane = lane;
        } else $d8a5605a402fdc13$var$workInProgressDeferredLane = 536870912;
    }
    lane = $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $d8a5605a402fdc13$var$workInProgressDeferredLane;
}
function $d8a5605a402fdc13$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $d8a5605a402fdc13$var$workInProgressRoot && (2 === $d8a5605a402fdc13$var$workInProgressSuspendedReason || 9 === $d8a5605a402fdc13$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $d8a5605a402fdc13$var$prepareFreshStack(root, 0), $d8a5605a402fdc13$var$markRootSuspended(root, $d8a5605a402fdc13$var$workInProgressRootRenderLanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, !1);
    $d8a5605a402fdc13$var$markRootUpdated$1(root, lane);
    if (0 === ($d8a5605a402fdc13$var$executionContext & 2) || root !== $d8a5605a402fdc13$var$workInProgressRoot) root === $d8a5605a402fdc13$var$workInProgressRoot && (0 === ($d8a5605a402fdc13$var$executionContext & 2) && ($d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $d8a5605a402fdc13$var$workInProgressRootExitStatus && $d8a5605a402fdc13$var$markRootSuspended(root, $d8a5605a402fdc13$var$workInProgressRootRenderLanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, !1)), $d8a5605a402fdc13$var$ensureRootIsScheduled(root);
}
function $d8a5605a402fdc13$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($d8a5605a402fdc13$var$executionContext & 6)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $d8a5605a402fdc13$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $d8a5605a402fdc13$var$renderRootConcurrent(root$jscomp$0, lanes) : $d8a5605a402fdc13$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $d8a5605a402fdc13$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $d8a5605a402fdc13$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$d8a5605a402fdc13$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $d8a5605a402fdc13$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $d8a5605a402fdc13$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($d8a5605a402fdc13$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $d8a5605a402fdc13$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($d8a5605a402fdc13$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors;
                            $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors ? $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors.push.apply($d8a5605a402fdc13$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $d8a5605a402fdc13$var$prepareFreshStack(root$jscomp$0, 0);
                $d8a5605a402fdc13$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $d8a5605a402fdc13$var$markRootSuspended(shouldTimeSlice, lanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, !$d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $d8a5605a402fdc13$var$globalMostRecentFallbackTime + 300 - $d8a5605a402fdc13$var$now(), 10 < exitStatus)) {
                    $d8a5605a402fdc13$var$markRootSuspended(shouldTimeSlice, lanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, !$d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $d8a5605a402fdc13$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $d8a5605a402fdc13$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $d8a5605a402fdc13$var$scheduleTimeout($d8a5605a402fdc13$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors, $d8a5605a402fdc13$var$workInProgressTransitions, $d8a5605a402fdc13$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, $d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes, $d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes, $d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $d8a5605a402fdc13$var$commitRootWhenReady(shouldTimeSlice, forceSync, $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors, $d8a5605a402fdc13$var$workInProgressTransitions, $d8a5605a402fdc13$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, $d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes, $d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes, $d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $d8a5605a402fdc13$var$ensureRootIsScheduled(root$jscomp$0);
}
function $d8a5605a402fdc13$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $d8a5605a402fdc13$var$noop$1
        };
        $d8a5605a402fdc13$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $d8a5605a402fdc13$var$globalMostRecentFallbackTime - $d8a5605a402fdc13$var$now() : (lanes & 4194048) === lanes ? $d8a5605a402fdc13$var$globalMostRecentTransitionTime - $d8a5605a402fdc13$var$now() : 0;
        timeoutOffset = $d8a5605a402fdc13$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $d8a5605a402fdc13$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($d8a5605a402fdc13$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $d8a5605a402fdc13$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $d8a5605a402fdc13$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $d8a5605a402fdc13$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$d8a5605a402fdc13$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $d8a5605a402fdc13$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$d8a5605a402fdc13$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $d8a5605a402fdc13$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $d8a5605a402fdc13$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $d8a5605a402fdc13$var$flushSyncWork$1() {
    return 0 === ($d8a5605a402fdc13$var$executionContext & 6) ? ($d8a5605a402fdc13$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $d8a5605a402fdc13$var$resetWorkInProgressStack() {
    if (null !== $d8a5605a402fdc13$var$workInProgress) {
        if (0 === $d8a5605a402fdc13$var$workInProgressSuspendedReason) var interruptedWork = $d8a5605a402fdc13$var$workInProgress.return;
        else interruptedWork = $d8a5605a402fdc13$var$workInProgress, $d8a5605a402fdc13$var$lastContextDependency = $d8a5605a402fdc13$var$currentlyRenderingFiber$1 = null, $d8a5605a402fdc13$var$resetHooksOnUnwind(interruptedWork), $d8a5605a402fdc13$var$thenableState$1 = null, $d8a5605a402fdc13$var$thenableIndexCounter$1 = 0, interruptedWork = $d8a5605a402fdc13$var$workInProgress;
        for(; null !== interruptedWork;)$d8a5605a402fdc13$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $d8a5605a402fdc13$var$workInProgress = null;
    }
}
function $d8a5605a402fdc13$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $d8a5605a402fdc13$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $d8a5605a402fdc13$var$pendingEffectsLanes = 0;
    $d8a5605a402fdc13$var$resetWorkInProgressStack();
    $d8a5605a402fdc13$var$workInProgressRoot = root;
    $d8a5605a402fdc13$var$workInProgress = timeoutHandle = $d8a5605a402fdc13$var$createWorkInProgress(root.current, null);
    $d8a5605a402fdc13$var$workInProgressRootRenderLanes = lanes;
    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
    $d8a5605a402fdc13$var$workInProgressThrownValue = null;
    $d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $d8a5605a402fdc13$var$workInProgressRootIsPrerendering = $d8a5605a402fdc13$var$checkIfRootIsPrerendering(root, lanes);
    $d8a5605a402fdc13$var$workInProgressRootDidAttachPingListener = !1;
    $d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes = $d8a5605a402fdc13$var$workInProgressDeferredLane = $d8a5605a402fdc13$var$workInProgressRootPingedLanes = $d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes = $d8a5605a402fdc13$var$workInProgressRootSkippedLanes = $d8a5605a402fdc13$var$workInProgressRootExitStatus = 0;
    $d8a5605a402fdc13$var$workInProgressRootRecoverableErrors = $d8a5605a402fdc13$var$workInProgressRootConcurrentErrors = null;
    $d8a5605a402fdc13$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $d8a5605a402fdc13$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $d8a5605a402fdc13$var$entangledRenderLanes = lanes;
    $d8a5605a402fdc13$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $d8a5605a402fdc13$var$handleThrow(root, thrownValue) {
    $d8a5605a402fdc13$var$currentlyRenderingFiber = null;
    $d8a5605a402fdc13$var$ReactSharedInternals.H = $d8a5605a402fdc13$var$ContextOnlyDispatcher;
    thrownValue === $d8a5605a402fdc13$var$SuspenseException || thrownValue === $d8a5605a402fdc13$var$SuspenseActionException ? (thrownValue = $d8a5605a402fdc13$var$getSuspendedThenable(), $d8a5605a402fdc13$var$workInProgressSuspendedReason = 3) : thrownValue === $d8a5605a402fdc13$var$SuspenseyCommitException ? (thrownValue = $d8a5605a402fdc13$var$getSuspendedThenable(), $d8a5605a402fdc13$var$workInProgressSuspendedReason = 4) : $d8a5605a402fdc13$var$workInProgressSuspendedReason = thrownValue === $d8a5605a402fdc13$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $d8a5605a402fdc13$var$workInProgressThrownValue = thrownValue;
    null === $d8a5605a402fdc13$var$workInProgress && ($d8a5605a402fdc13$var$workInProgressRootExitStatus = 1, $d8a5605a402fdc13$var$logUncaughtError(root, $d8a5605a402fdc13$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $d8a5605a402fdc13$var$shouldRemainOnPreviousScreen() {
    var handler = $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 4194048) === $d8a5605a402fdc13$var$workInProgressRootRenderLanes ? null === $d8a5605a402fdc13$var$shellBoundary ? !0 : !1 : ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 62914560) === $d8a5605a402fdc13$var$workInProgressRootRenderLanes || 0 !== ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 536870912) ? handler === $d8a5605a402fdc13$var$shellBoundary : !1;
}
function $d8a5605a402fdc13$var$pushDispatcher() {
    var prevDispatcher = $d8a5605a402fdc13$var$ReactSharedInternals.H;
    $d8a5605a402fdc13$var$ReactSharedInternals.H = $d8a5605a402fdc13$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $d8a5605a402fdc13$var$ContextOnlyDispatcher : prevDispatcher;
}
function $d8a5605a402fdc13$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $d8a5605a402fdc13$var$ReactSharedInternals.A;
    $d8a5605a402fdc13$var$ReactSharedInternals.A = $d8a5605a402fdc13$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $d8a5605a402fdc13$var$renderDidSuspendDelayIfPossible() {
    $d8a5605a402fdc13$var$workInProgressRootExitStatus = 4;
    $d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings || ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 4194048) !== $d8a5605a402fdc13$var$workInProgressRootRenderLanes && null !== $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current || ($d8a5605a402fdc13$var$workInProgressRootIsPrerendering = !0);
    0 === ($d8a5605a402fdc13$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($d8a5605a402fdc13$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $d8a5605a402fdc13$var$workInProgressRoot || $d8a5605a402fdc13$var$markRootSuspended($d8a5605a402fdc13$var$workInProgressRoot, $d8a5605a402fdc13$var$workInProgressRootRenderLanes, $d8a5605a402fdc13$var$workInProgressDeferredLane, !1);
}
function $d8a5605a402fdc13$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $d8a5605a402fdc13$var$executionContext;
    $d8a5605a402fdc13$var$executionContext |= 2;
    var prevDispatcher = $d8a5605a402fdc13$var$pushDispatcher(), prevAsyncDispatcher = $d8a5605a402fdc13$var$pushAsyncDispatcher();
    if ($d8a5605a402fdc13$var$workInProgressRoot !== root || $d8a5605a402fdc13$var$workInProgressRootRenderLanes !== lanes) $d8a5605a402fdc13$var$workInProgressTransitions = null, $d8a5605a402fdc13$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $d8a5605a402fdc13$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $d8a5605a402fdc13$var$workInProgressSuspendedReason && null !== $d8a5605a402fdc13$var$workInProgress) {
            var unitOfWork = $d8a5605a402fdc13$var$workInProgress, thrownValue = $d8a5605a402fdc13$var$workInProgressThrownValue;
            switch($d8a5605a402fdc13$var$workInProgressSuspendedReason){
                case 8:
                    $d8a5605a402fdc13$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $d8a5605a402fdc13$var$workInProgressSuspendedReason;
                    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
                    $d8a5605a402fdc13$var$workInProgressThrownValue = null;
                    $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $d8a5605a402fdc13$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $d8a5605a402fdc13$var$workInProgressSuspendedReason, $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0, $d8a5605a402fdc13$var$workInProgressThrownValue = null, $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $d8a5605a402fdc13$var$workLoopSync();
        exitStatus = $d8a5605a402fdc13$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $d8a5605a402fdc13$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $d8a5605a402fdc13$var$lastContextDependency = $d8a5605a402fdc13$var$currentlyRenderingFiber$1 = null;
    $d8a5605a402fdc13$var$executionContext = prevExecutionContext;
    $d8a5605a402fdc13$var$ReactSharedInternals.H = prevDispatcher;
    $d8a5605a402fdc13$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $d8a5605a402fdc13$var$workInProgress && ($d8a5605a402fdc13$var$workInProgressRoot = null, $d8a5605a402fdc13$var$workInProgressRootRenderLanes = 0, $d8a5605a402fdc13$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $d8a5605a402fdc13$var$workLoopSync() {
    for(; null !== $d8a5605a402fdc13$var$workInProgress;)$d8a5605a402fdc13$var$performUnitOfWork($d8a5605a402fdc13$var$workInProgress);
}
function $d8a5605a402fdc13$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $d8a5605a402fdc13$var$executionContext;
    $d8a5605a402fdc13$var$executionContext |= 2;
    var prevDispatcher = $d8a5605a402fdc13$var$pushDispatcher(), prevAsyncDispatcher = $d8a5605a402fdc13$var$pushAsyncDispatcher();
    $d8a5605a402fdc13$var$workInProgressRoot !== root || $d8a5605a402fdc13$var$workInProgressRootRenderLanes !== lanes ? ($d8a5605a402fdc13$var$workInProgressTransitions = null, $d8a5605a402fdc13$var$workInProgressRootRenderTargetTime = $d8a5605a402fdc13$var$now() + 500, $d8a5605a402fdc13$var$prepareFreshStack(root, lanes)) : $d8a5605a402fdc13$var$workInProgressRootIsPrerendering = $d8a5605a402fdc13$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $d8a5605a402fdc13$var$workInProgressSuspendedReason && null !== $d8a5605a402fdc13$var$workInProgress) {
            lanes = $d8a5605a402fdc13$var$workInProgress;
            var thrownValue = $d8a5605a402fdc13$var$workInProgressThrownValue;
            b: switch($d8a5605a402fdc13$var$workInProgressSuspendedReason){
                case 1:
                    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
                    $d8a5605a402fdc13$var$workInProgressThrownValue = null;
                    $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($d8a5605a402fdc13$var$isThenableResolved(thrownValue)) {
                        $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
                        $d8a5605a402fdc13$var$workInProgressThrownValue = null;
                        $d8a5605a402fdc13$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $d8a5605a402fdc13$var$workInProgressSuspendedReason && 9 !== $d8a5605a402fdc13$var$workInProgressSuspendedReason || $d8a5605a402fdc13$var$workInProgressRoot !== root || ($d8a5605a402fdc13$var$workInProgressSuspendedReason = 7);
                        $d8a5605a402fdc13$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $d8a5605a402fdc13$var$isThenableResolved(thrownValue) ? ($d8a5605a402fdc13$var$workInProgressSuspendedReason = 0, $d8a5605a402fdc13$var$workInProgressThrownValue = null, $d8a5605a402fdc13$var$replaySuspendedUnitOfWork(lanes)) : ($d8a5605a402fdc13$var$workInProgressSuspendedReason = 0, $d8a5605a402fdc13$var$workInProgressThrownValue = null, $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($d8a5605a402fdc13$var$workInProgress.tag){
                        case 26:
                            resource = $d8a5605a402fdc13$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $d8a5605a402fdc13$var$workInProgress;
                            if (resource ? $d8a5605a402fdc13$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
                                $d8a5605a402fdc13$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $d8a5605a402fdc13$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($d8a5605a402fdc13$var$workInProgress = returnFiber, $d8a5605a402fdc13$var$completeUnitOfWork(returnFiber)) : $d8a5605a402fdc13$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
                    $d8a5605a402fdc13$var$workInProgressThrownValue = null;
                    $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $d8a5605a402fdc13$var$workInProgressSuspendedReason = 0;
                    $d8a5605a402fdc13$var$workInProgressThrownValue = null;
                    $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $d8a5605a402fdc13$var$resetWorkInProgressStack();
                    $d8a5605a402fdc13$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(462));
            }
        }
        $d8a5605a402fdc13$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $d8a5605a402fdc13$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $d8a5605a402fdc13$var$lastContextDependency = $d8a5605a402fdc13$var$currentlyRenderingFiber$1 = null;
    $d8a5605a402fdc13$var$ReactSharedInternals.H = prevDispatcher;
    $d8a5605a402fdc13$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $d8a5605a402fdc13$var$executionContext = prevExecutionContext;
    if (null !== $d8a5605a402fdc13$var$workInProgress) return 0;
    $d8a5605a402fdc13$var$workInProgressRoot = null;
    $d8a5605a402fdc13$var$workInProgressRootRenderLanes = 0;
    $d8a5605a402fdc13$var$finishQueueingConcurrentUpdates();
    return $d8a5605a402fdc13$var$workInProgressRootExitStatus;
}
function $d8a5605a402fdc13$var$workLoopConcurrentByScheduler() {
    for(; null !== $d8a5605a402fdc13$var$workInProgress && !$d8a5605a402fdc13$var$shouldYield();)$d8a5605a402fdc13$var$performUnitOfWork($d8a5605a402fdc13$var$workInProgress);
}
function $d8a5605a402fdc13$var$performUnitOfWork(unitOfWork) {
    var next = $d8a5605a402fdc13$var$beginWork(unitOfWork.alternate, unitOfWork, $d8a5605a402fdc13$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d8a5605a402fdc13$var$completeUnitOfWork(unitOfWork) : $d8a5605a402fdc13$var$workInProgress = next;
}
function $d8a5605a402fdc13$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $d8a5605a402fdc13$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $d8a5605a402fdc13$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $d8a5605a402fdc13$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $d8a5605a402fdc13$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $d8a5605a402fdc13$var$resetHooksOnUnwind(next);
        default:
            $d8a5605a402fdc13$var$unwindInterruptedWork(current, next), next = $d8a5605a402fdc13$var$workInProgress = $d8a5605a402fdc13$var$resetWorkInProgress(next, $d8a5605a402fdc13$var$entangledRenderLanes), next = $d8a5605a402fdc13$var$beginWork(current, next, $d8a5605a402fdc13$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d8a5605a402fdc13$var$completeUnitOfWork(unitOfWork) : $d8a5605a402fdc13$var$workInProgress = next;
}
function $d8a5605a402fdc13$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $d8a5605a402fdc13$var$lastContextDependency = $d8a5605a402fdc13$var$currentlyRenderingFiber$1 = null;
    $d8a5605a402fdc13$var$resetHooksOnUnwind(unitOfWork);
    $d8a5605a402fdc13$var$thenableState$1 = null;
    $d8a5605a402fdc13$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($d8a5605a402fdc13$var$throwException(root, returnFiber, unitOfWork, thrownValue, $d8a5605a402fdc13$var$workInProgressRootRenderLanes)) {
            $d8a5605a402fdc13$var$workInProgressRootExitStatus = 1;
            $d8a5605a402fdc13$var$logUncaughtError(root, $d8a5605a402fdc13$var$createCapturedValueAtFiber(thrownValue, root.current));
            $d8a5605a402fdc13$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $d8a5605a402fdc13$var$workInProgress = returnFiber, error;
        $d8a5605a402fdc13$var$workInProgressRootExitStatus = 1;
        $d8a5605a402fdc13$var$logUncaughtError(root, $d8a5605a402fdc13$var$createCapturedValueAtFiber(thrownValue, root.current));
        $d8a5605a402fdc13$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($d8a5605a402fdc13$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($d8a5605a402fdc13$var$workInProgressRootIsPrerendering || 0 !== ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $d8a5605a402fdc13$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $d8a5605a402fdc13$var$unwindUnitOfWork(unitOfWork, root);
    } else $d8a5605a402fdc13$var$completeUnitOfWork(unitOfWork);
}
function $d8a5605a402fdc13$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $d8a5605a402fdc13$var$unwindUnitOfWork(completedWork, $d8a5605a402fdc13$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $d8a5605a402fdc13$var$completeWork(completedWork.alternate, completedWork, $d8a5605a402fdc13$var$entangledRenderLanes);
        if (null !== next) {
            $d8a5605a402fdc13$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $d8a5605a402fdc13$var$workInProgress = completedWork;
            return;
        }
        $d8a5605a402fdc13$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $d8a5605a402fdc13$var$workInProgressRootExitStatus && ($d8a5605a402fdc13$var$workInProgressRootExitStatus = 5);
}
function $d8a5605a402fdc13$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $d8a5605a402fdc13$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $d8a5605a402fdc13$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $d8a5605a402fdc13$var$workInProgress = unitOfWork;
            return;
        }
        $d8a5605a402fdc13$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $d8a5605a402fdc13$var$workInProgressRootExitStatus = 6;
    $d8a5605a402fdc13$var$workInProgress = null;
}
function $d8a5605a402fdc13$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $d8a5605a402fdc13$var$flushPendingEffects();
    while (0 !== $d8a5605a402fdc13$var$pendingEffectsStatus);
    if (0 !== ($d8a5605a402fdc13$var$executionContext & 6)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $d8a5605a402fdc13$var$concurrentlyUpdatedLanes;
        $d8a5605a402fdc13$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $d8a5605a402fdc13$var$workInProgressRoot && ($d8a5605a402fdc13$var$workInProgress = $d8a5605a402fdc13$var$workInProgressRoot = null, $d8a5605a402fdc13$var$workInProgressRootRenderLanes = 0);
        $d8a5605a402fdc13$var$pendingFinishedWork = finishedWork;
        $d8a5605a402fdc13$var$pendingEffectsRoot = root;
        $d8a5605a402fdc13$var$pendingEffectsLanes = lanes;
        $d8a5605a402fdc13$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $d8a5605a402fdc13$var$pendingPassiveTransitions = transitions;
        $d8a5605a402fdc13$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $d8a5605a402fdc13$var$scheduleCallback$1($d8a5605a402fdc13$var$NormalPriority$1, function() {
            $d8a5605a402fdc13$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $d8a5605a402fdc13$var$ReactSharedInternals.T;
            $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
            transitions = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
            $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $d8a5605a402fdc13$var$executionContext;
            $d8a5605a402fdc13$var$executionContext |= 4;
            try {
                $d8a5605a402fdc13$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $d8a5605a402fdc13$var$executionContext = spawnedLane, $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = transitions, $d8a5605a402fdc13$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $d8a5605a402fdc13$var$pendingEffectsStatus = 1;
        $d8a5605a402fdc13$var$flushMutationEffects();
        $d8a5605a402fdc13$var$flushLayoutEffects();
        $d8a5605a402fdc13$var$flushSpawnedWork();
    }
}
function $d8a5605a402fdc13$var$flushMutationEffects() {
    if (1 === $d8a5605a402fdc13$var$pendingEffectsStatus) {
        $d8a5605a402fdc13$var$pendingEffectsStatus = 0;
        var root = $d8a5605a402fdc13$var$pendingEffectsRoot, finishedWork = $d8a5605a402fdc13$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $d8a5605a402fdc13$var$ReactSharedInternals.T;
            $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
            var previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
            $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d8a5605a402fdc13$var$executionContext;
            $d8a5605a402fdc13$var$executionContext |= 4;
            try {
                $d8a5605a402fdc13$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $d8a5605a402fdc13$var$selectionInformation, curFocusedElem = $d8a5605a402fdc13$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $d8a5605a402fdc13$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $d8a5605a402fdc13$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $d8a5605a402fdc13$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $d8a5605a402fdc13$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $d8a5605a402fdc13$var$_enabled = !!$d8a5605a402fdc13$var$eventsEnabled;
                $d8a5605a402fdc13$var$selectionInformation = $d8a5605a402fdc13$var$eventsEnabled = null;
            } finally{
                $d8a5605a402fdc13$var$executionContext = prevExecutionContext, $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority, $d8a5605a402fdc13$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $d8a5605a402fdc13$var$pendingEffectsStatus = 2;
    }
}
function $d8a5605a402fdc13$var$flushLayoutEffects() {
    if (2 === $d8a5605a402fdc13$var$pendingEffectsStatus) {
        $d8a5605a402fdc13$var$pendingEffectsStatus = 0;
        var root = $d8a5605a402fdc13$var$pendingEffectsRoot, finishedWork = $d8a5605a402fdc13$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $d8a5605a402fdc13$var$ReactSharedInternals.T;
            $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
            var previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
            $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d8a5605a402fdc13$var$executionContext;
            $d8a5605a402fdc13$var$executionContext |= 4;
            try {
                $d8a5605a402fdc13$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $d8a5605a402fdc13$var$executionContext = prevExecutionContext, $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority, $d8a5605a402fdc13$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $d8a5605a402fdc13$var$pendingEffectsStatus = 3;
    }
}
function $d8a5605a402fdc13$var$flushSpawnedWork() {
    if (4 === $d8a5605a402fdc13$var$pendingEffectsStatus || 3 === $d8a5605a402fdc13$var$pendingEffectsStatus) {
        $d8a5605a402fdc13$var$pendingEffectsStatus = 0;
        $d8a5605a402fdc13$var$requestPaint();
        var root = $d8a5605a402fdc13$var$pendingEffectsRoot, finishedWork = $d8a5605a402fdc13$var$pendingFinishedWork, lanes = $d8a5605a402fdc13$var$pendingEffectsLanes, recoverableErrors = $d8a5605a402fdc13$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $d8a5605a402fdc13$var$pendingEffectsStatus = 5 : ($d8a5605a402fdc13$var$pendingEffectsStatus = 0, $d8a5605a402fdc13$var$pendingFinishedWork = $d8a5605a402fdc13$var$pendingEffectsRoot = null, $d8a5605a402fdc13$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $d8a5605a402fdc13$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($d8a5605a402fdc13$var$injectedHook && "function" === typeof $d8a5605a402fdc13$var$injectedHook.onCommitFiberRoot) try {
            $d8a5605a402fdc13$var$injectedHook.onCommitFiberRoot($d8a5605a402fdc13$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $d8a5605a402fdc13$var$ReactSharedInternals.T;
            remainingLanes = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
            $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 2;
            $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $d8a5605a402fdc13$var$ReactSharedInternals.T = finishedWork, $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($d8a5605a402fdc13$var$pendingEffectsLanes & 3) && $d8a5605a402fdc13$var$flushPendingEffects();
        $d8a5605a402fdc13$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $d8a5605a402fdc13$var$rootWithNestedUpdates ? $d8a5605a402fdc13$var$nestedUpdateCount++ : ($d8a5605a402fdc13$var$nestedUpdateCount = 0, $d8a5605a402fdc13$var$rootWithNestedUpdates = root) : $d8a5605a402fdc13$var$nestedUpdateCount = 0;
        $d8a5605a402fdc13$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $d8a5605a402fdc13$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $d8a5605a402fdc13$var$releaseCache(remainingLanes)));
}
function $d8a5605a402fdc13$var$flushPendingEffects() {
    $d8a5605a402fdc13$var$flushMutationEffects();
    $d8a5605a402fdc13$var$flushLayoutEffects();
    $d8a5605a402fdc13$var$flushSpawnedWork();
    return $d8a5605a402fdc13$var$flushPassiveEffects();
}
function $d8a5605a402fdc13$var$flushPassiveEffects() {
    if (5 !== $d8a5605a402fdc13$var$pendingEffectsStatus) return !1;
    var root = $d8a5605a402fdc13$var$pendingEffectsRoot, remainingLanes = $d8a5605a402fdc13$var$pendingEffectsRemainingLanes;
    $d8a5605a402fdc13$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $d8a5605a402fdc13$var$lanesToEventPriority($d8a5605a402fdc13$var$pendingEffectsLanes), prevTransition = $d8a5605a402fdc13$var$ReactSharedInternals.T, previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
    try {
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
        renderPriority = $d8a5605a402fdc13$var$pendingPassiveTransitions;
        $d8a5605a402fdc13$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $d8a5605a402fdc13$var$pendingEffectsRoot, lanes = $d8a5605a402fdc13$var$pendingEffectsLanes;
        $d8a5605a402fdc13$var$pendingEffectsStatus = 0;
        $d8a5605a402fdc13$var$pendingFinishedWork = $d8a5605a402fdc13$var$pendingEffectsRoot = null;
        $d8a5605a402fdc13$var$pendingEffectsLanes = 0;
        if (0 !== ($d8a5605a402fdc13$var$executionContext & 6)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(331));
        var prevExecutionContext = $d8a5605a402fdc13$var$executionContext;
        $d8a5605a402fdc13$var$executionContext |= 4;
        $d8a5605a402fdc13$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $d8a5605a402fdc13$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $d8a5605a402fdc13$var$executionContext = prevExecutionContext;
        $d8a5605a402fdc13$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($d8a5605a402fdc13$var$injectedHook && "function" === typeof $d8a5605a402fdc13$var$injectedHook.onPostCommitFiberRoot) try {
            $d8a5605a402fdc13$var$injectedHook.onPostCommitFiberRoot($d8a5605a402fdc13$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority, $d8a5605a402fdc13$var$ReactSharedInternals.T = prevTransition, $d8a5605a402fdc13$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $d8a5605a402fdc13$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $d8a5605a402fdc13$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $d8a5605a402fdc13$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $d8a5605a402fdc13$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($d8a5605a402fdc13$var$markRootUpdated$1(rootFiber, 2), $d8a5605a402fdc13$var$ensureRootIsScheduled(rootFiber));
}
function $d8a5605a402fdc13$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $d8a5605a402fdc13$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $d8a5605a402fdc13$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed || !$d8a5605a402fdc13$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $d8a5605a402fdc13$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $d8a5605a402fdc13$var$createClassErrorUpdate(2);
                instance = $d8a5605a402fdc13$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($d8a5605a402fdc13$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $d8a5605a402fdc13$var$markRootUpdated$1(instance, 2), $d8a5605a402fdc13$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $d8a5605a402fdc13$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $d8a5605a402fdc13$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($d8a5605a402fdc13$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $d8a5605a402fdc13$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $d8a5605a402fdc13$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $d8a5605a402fdc13$var$workInProgressRoot === root && ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $d8a5605a402fdc13$var$workInProgressRootExitStatus || 3 === $d8a5605a402fdc13$var$workInProgressRootExitStatus && ($d8a5605a402fdc13$var$workInProgressRootRenderLanes & 62914560) === $d8a5605a402fdc13$var$workInProgressRootRenderLanes && 300 > $d8a5605a402fdc13$var$now() - $d8a5605a402fdc13$var$globalMostRecentFallbackTime ? 0 === ($d8a5605a402fdc13$var$executionContext & 2) && $d8a5605a402fdc13$var$prepareFreshStack(root, 0) : $d8a5605a402fdc13$var$workInProgressRootPingedLanes |= pingedLanes, $d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes === $d8a5605a402fdc13$var$workInProgressRootRenderLanes && ($d8a5605a402fdc13$var$workInProgressSuspendedRetryLanes = 0));
    $d8a5605a402fdc13$var$ensureRootIsScheduled(root);
}
function $d8a5605a402fdc13$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $d8a5605a402fdc13$var$claimNextRetryLane());
    boundaryFiber = $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($d8a5605a402fdc13$var$markRootUpdated$1(boundaryFiber, retryLane), $d8a5605a402fdc13$var$ensureRootIsScheduled(boundaryFiber));
}
function $d8a5605a402fdc13$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $d8a5605a402fdc13$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d8a5605a402fdc13$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $d8a5605a402fdc13$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d8a5605a402fdc13$var$scheduleCallback$1(priorityLevel, callback) {
    return $d8a5605a402fdc13$var$scheduleCallback$3(priorityLevel, callback);
}
var $d8a5605a402fdc13$var$firstScheduledRoot = null, $d8a5605a402fdc13$var$lastScheduledRoot = null, $d8a5605a402fdc13$var$didScheduleMicrotask = !1, $d8a5605a402fdc13$var$mightHavePendingSyncWork = !1, $d8a5605a402fdc13$var$isFlushingWork = !1, $d8a5605a402fdc13$var$currentEventTransitionLane = 0;
function $d8a5605a402fdc13$var$ensureRootIsScheduled(root) {
    root !== $d8a5605a402fdc13$var$lastScheduledRoot && null === root.next && (null === $d8a5605a402fdc13$var$lastScheduledRoot ? $d8a5605a402fdc13$var$firstScheduledRoot = $d8a5605a402fdc13$var$lastScheduledRoot = root : $d8a5605a402fdc13$var$lastScheduledRoot = $d8a5605a402fdc13$var$lastScheduledRoot.next = root);
    $d8a5605a402fdc13$var$mightHavePendingSyncWork = !0;
    $d8a5605a402fdc13$var$didScheduleMicrotask || ($d8a5605a402fdc13$var$didScheduleMicrotask = !0, $d8a5605a402fdc13$var$scheduleImmediateRootScheduleTask());
}
function $d8a5605a402fdc13$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$d8a5605a402fdc13$var$isFlushingWork && $d8a5605a402fdc13$var$mightHavePendingSyncWork) {
        $d8a5605a402fdc13$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $d8a5605a402fdc13$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $d8a5605a402fdc13$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $d8a5605a402fdc13$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $d8a5605a402fdc13$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $d8a5605a402fdc13$var$getNextLanes(root$170, root$170 === $d8a5605a402fdc13$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $d8a5605a402fdc13$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $d8a5605a402fdc13$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $d8a5605a402fdc13$var$isFlushingWork = !1;
    }
}
function $d8a5605a402fdc13$var$processRootScheduleInImmediateTask() {
    $d8a5605a402fdc13$var$processRootScheduleInMicrotask();
}
function $d8a5605a402fdc13$var$processRootScheduleInMicrotask() {
    $d8a5605a402fdc13$var$mightHavePendingSyncWork = $d8a5605a402fdc13$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $d8a5605a402fdc13$var$currentEventTransitionLane && $d8a5605a402fdc13$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $d8a5605a402fdc13$var$currentEventTransitionLane);
    for(var currentTime = $d8a5605a402fdc13$var$now(), prev = null, root = $d8a5605a402fdc13$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $d8a5605a402fdc13$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $d8a5605a402fdc13$var$firstScheduledRoot = next : prev.next = next, null === next && ($d8a5605a402fdc13$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $d8a5605a402fdc13$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $d8a5605a402fdc13$var$pendingEffectsStatus && 5 !== $d8a5605a402fdc13$var$pendingEffectsStatus || $d8a5605a402fdc13$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $d8a5605a402fdc13$var$currentEventTransitionLane && ($d8a5605a402fdc13$var$currentEventTransitionLane = 0);
}
function $d8a5605a402fdc13$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $d8a5605a402fdc13$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $d8a5605a402fdc13$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $d8a5605a402fdc13$var$workInProgressRoot;
    suspendedLanes = $d8a5605a402fdc13$var$workInProgressRootRenderLanes;
    suspendedLanes = $d8a5605a402fdc13$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $d8a5605a402fdc13$var$workInProgressSuspendedReason || 9 === $d8a5605a402fdc13$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $d8a5605a402fdc13$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $d8a5605a402fdc13$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $d8a5605a402fdc13$var$cancelCallback$1(pingedLanes);
        switch($d8a5605a402fdc13$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $d8a5605a402fdc13$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $d8a5605a402fdc13$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $d8a5605a402fdc13$var$IdlePriority;
                break;
            default:
                suspendedLanes = $d8a5605a402fdc13$var$NormalPriority$1;
        }
        pingedLanes = $d8a5605a402fdc13$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $d8a5605a402fdc13$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $d8a5605a402fdc13$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $d8a5605a402fdc13$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $d8a5605a402fdc13$var$pendingEffectsStatus && 5 !== $d8a5605a402fdc13$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($d8a5605a402fdc13$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $d8a5605a402fdc13$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $d8a5605a402fdc13$var$getNextLanes(root, root === $d8a5605a402fdc13$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $d8a5605a402fdc13$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $d8a5605a402fdc13$var$scheduleTaskForRootDuringMicrotask(root, $d8a5605a402fdc13$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $d8a5605a402fdc13$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $d8a5605a402fdc13$var$performSyncWorkOnRoot(root, lanes) {
    if ($d8a5605a402fdc13$var$flushPendingEffects()) return null;
    $d8a5605a402fdc13$var$performWorkOnRoot(root, lanes, !0);
}
function $d8a5605a402fdc13$var$scheduleImmediateRootScheduleTask() {
    $d8a5605a402fdc13$var$scheduleMicrotask(function() {
        0 !== ($d8a5605a402fdc13$var$executionContext & 6) ? $d8a5605a402fdc13$var$scheduleCallback$3($d8a5605a402fdc13$var$ImmediatePriority, $d8a5605a402fdc13$var$processRootScheduleInImmediateTask) : $d8a5605a402fdc13$var$processRootScheduleInMicrotask();
    });
}
function $d8a5605a402fdc13$var$requestTransitionLane() {
    if (0 === $d8a5605a402fdc13$var$currentEventTransitionLane) {
        var actionScopeLane = $d8a5605a402fdc13$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $d8a5605a402fdc13$var$nextTransitionUpdateLane, $d8a5605a402fdc13$var$nextTransitionUpdateLane <<= 1, 0 === ($d8a5605a402fdc13$var$nextTransitionUpdateLane & 261888) && ($d8a5605a402fdc13$var$nextTransitionUpdateLane = 256));
        $d8a5605a402fdc13$var$currentEventTransitionLane = actionScopeLane;
    }
    return $d8a5605a402fdc13$var$currentEventTransitionLane;
}
function $d8a5605a402fdc13$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $d8a5605a402fdc13$var$sanitizeURL("" + actionProp);
}
function $d8a5605a402fdc13$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $d8a5605a402fdc13$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $d8a5605a402fdc13$var$coerceFormActionProp((nativeEventTarget[$d8a5605a402fdc13$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$d8a5605a402fdc13$var$internalPropsKey] || null) ? $d8a5605a402fdc13$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $d8a5605a402fdc13$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $d8a5605a402fdc13$var$currentEventTransitionLane) {
                                var formData = submitter ? $d8a5605a402fdc13$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $d8a5605a402fdc13$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $d8a5605a402fdc13$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $d8a5605a402fdc13$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $d8a5605a402fdc13$var$i$jscomp$inline_1577 = 0; $d8a5605a402fdc13$var$i$jscomp$inline_1577 < $d8a5605a402fdc13$var$simpleEventPluginEvents.length; $d8a5605a402fdc13$var$i$jscomp$inline_1577++){
    var $d8a5605a402fdc13$var$eventName$jscomp$inline_1578 = $d8a5605a402fdc13$var$simpleEventPluginEvents[$d8a5605a402fdc13$var$i$jscomp$inline_1577], $d8a5605a402fdc13$var$domEventName$jscomp$inline_1579 = $d8a5605a402fdc13$var$eventName$jscomp$inline_1578.toLowerCase(), $d8a5605a402fdc13$var$capitalizedEvent$jscomp$inline_1580 = $d8a5605a402fdc13$var$eventName$jscomp$inline_1578[0].toUpperCase() + $d8a5605a402fdc13$var$eventName$jscomp$inline_1578.slice(1);
    $d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$domEventName$jscomp$inline_1579, "on" + $d8a5605a402fdc13$var$capitalizedEvent$jscomp$inline_1580);
}
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$ANIMATION_END, "onAnimationEnd");
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$ANIMATION_ITERATION, "onAnimationIteration");
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$ANIMATION_START, "onAnimationStart");
$d8a5605a402fdc13$var$registerSimpleEvent("dblclick", "onDoubleClick");
$d8a5605a402fdc13$var$registerSimpleEvent("focusin", "onFocus");
$d8a5605a402fdc13$var$registerSimpleEvent("focusout", "onBlur");
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$TRANSITION_RUN, "onTransitionRun");
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$TRANSITION_START, "onTransitionStart");
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$TRANSITION_CANCEL, "onTransitionCancel");
$d8a5605a402fdc13$var$registerSimpleEvent($d8a5605a402fdc13$var$TRANSITION_END, "onTransitionEnd");
$d8a5605a402fdc13$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d8a5605a402fdc13$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d8a5605a402fdc13$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d8a5605a402fdc13$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d8a5605a402fdc13$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d8a5605a402fdc13$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d8a5605a402fdc13$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d8a5605a402fdc13$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d8a5605a402fdc13$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d8a5605a402fdc13$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d8a5605a402fdc13$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d8a5605a402fdc13$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($d8a5605a402fdc13$var$mediaEventTypes));
function $d8a5605a402fdc13$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d8a5605a402fdc13$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d8a5605a402fdc13$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $d8a5605a402fdc13$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$d8a5605a402fdc13$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$d8a5605a402fdc13$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($d8a5605a402fdc13$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $d8a5605a402fdc13$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $d8a5605a402fdc13$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $d8a5605a402fdc13$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $d8a5605a402fdc13$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$d8a5605a402fdc13$var$listeningMarker]) {
        rootContainerElement[$d8a5605a402fdc13$var$listeningMarker] = !0;
        $d8a5605a402fdc13$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($d8a5605a402fdc13$var$nonDelegatedEvents.has(domEventName) || $d8a5605a402fdc13$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $d8a5605a402fdc13$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$d8a5605a402fdc13$var$listeningMarker] || (ownerDocument[$d8a5605a402fdc13$var$listeningMarker] = !0, $d8a5605a402fdc13$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $d8a5605a402fdc13$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($d8a5605a402fdc13$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $d8a5605a402fdc13$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $d8a5605a402fdc13$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $d8a5605a402fdc13$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$d8a5605a402fdc13$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $d8a5605a402fdc13$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $d8a5605a402fdc13$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $d8a5605a402fdc13$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $d8a5605a402fdc13$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $d8a5605a402fdc13$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $d8a5605a402fdc13$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticTouchEvent;
                        break;
                    case $d8a5605a402fdc13$var$ANIMATION_END:
                    case $d8a5605a402fdc13$var$ANIMATION_ITERATION:
                    case $d8a5605a402fdc13$var$ANIMATION_START:
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticAnimationEvent;
                        break;
                    case $d8a5605a402fdc13$var$TRANSITION_END:
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $d8a5605a402fdc13$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $d8a5605a402fdc13$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($d8a5605a402fdc13$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $d8a5605a402fdc13$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($d8a5605a402fdc13$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$d8a5605a402fdc13$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $d8a5605a402fdc13$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $d8a5605a402fdc13$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $d8a5605a402fdc13$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $d8a5605a402fdc13$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $d8a5605a402fdc13$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $d8a5605a402fdc13$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $d8a5605a402fdc13$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $d8a5605a402fdc13$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $d8a5605a402fdc13$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $d8a5605a402fdc13$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $d8a5605a402fdc13$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $d8a5605a402fdc13$var$getTargetInstForChangeEvent;
                else if ($d8a5605a402fdc13$var$isTextInputElement(reactName)) {
                    if ($d8a5605a402fdc13$var$isInputEventSupported) getTargetInstFunc = $d8a5605a402fdc13$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $d8a5605a402fdc13$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $d8a5605a402fdc13$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $d8a5605a402fdc13$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $d8a5605a402fdc13$var$getTargetInstForChangeEvent) : getTargetInstFunc = $d8a5605a402fdc13$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $d8a5605a402fdc13$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $d8a5605a402fdc13$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $d8a5605a402fdc13$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($d8a5605a402fdc13$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $d8a5605a402fdc13$var$activeElement = handleEventFunc, $d8a5605a402fdc13$var$activeElementInst = targetInst, $d8a5605a402fdc13$var$lastSelection = null;
                    break;
                case "focusout":
                    $d8a5605a402fdc13$var$lastSelection = $d8a5605a402fdc13$var$activeElementInst = $d8a5605a402fdc13$var$activeElement = null;
                    break;
                case "mousedown":
                    $d8a5605a402fdc13$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d8a5605a402fdc13$var$mouseDown = !1;
                    $d8a5605a402fdc13$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($d8a5605a402fdc13$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $d8a5605a402fdc13$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($d8a5605a402fdc13$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $d8a5605a402fdc13$var$isComposing ? $d8a5605a402fdc13$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($d8a5605a402fdc13$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($d8a5605a402fdc13$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $d8a5605a402fdc13$var$isComposing && (fallbackData = $d8a5605a402fdc13$var$getData()) : ($d8a5605a402fdc13$var$root = nativeEventTarget, $d8a5605a402fdc13$var$startText = "value" in $d8a5605a402fdc13$var$root ? $d8a5605a402fdc13$var$root.value : $d8a5605a402fdc13$var$root.textContent, $d8a5605a402fdc13$var$isComposing = !0)), handleEventFunc = $d8a5605a402fdc13$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $d8a5605a402fdc13$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $d8a5605a402fdc13$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $d8a5605a402fdc13$var$canUseTextInputEvent ? $d8a5605a402fdc13$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $d8a5605a402fdc13$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $d8a5605a402fdc13$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $d8a5605a402fdc13$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $d8a5605a402fdc13$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $d8a5605a402fdc13$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $d8a5605a402fdc13$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $d8a5605a402fdc13$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $d8a5605a402fdc13$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($d8a5605a402fdc13$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $d8a5605a402fdc13$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($d8a5605a402fdc13$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $d8a5605a402fdc13$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $d8a5605a402fdc13$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $d8a5605a402fdc13$var$getListener(target, registrationName), null != stateNode && listeners.unshift($d8a5605a402fdc13$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $d8a5605a402fdc13$var$getListener(target, registrationName), null != stateNode && listeners.push($d8a5605a402fdc13$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $d8a5605a402fdc13$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $d8a5605a402fdc13$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $d8a5605a402fdc13$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($d8a5605a402fdc13$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($d8a5605a402fdc13$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $d8a5605a402fdc13$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $d8a5605a402fdc13$var$normalizeMarkupForTextOrAttribute(clientText);
    return $d8a5605a402fdc13$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $d8a5605a402fdc13$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $d8a5605a402fdc13$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $d8a5605a402fdc13$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $d8a5605a402fdc13$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $d8a5605a402fdc13$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $d8a5605a402fdc13$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $d8a5605a402fdc13$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $d8a5605a402fdc13$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d8a5605a402fdc13$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $d8a5605a402fdc13$var$setProp(domElement, tag, "name", props.name, props, null), $d8a5605a402fdc13$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $d8a5605a402fdc13$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $d8a5605a402fdc13$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($d8a5605a402fdc13$var$setProp(domElement, tag, "encType", props.encType, props, null), $d8a5605a402fdc13$var$setProp(domElement, tag, "method", props.method, props, null), $d8a5605a402fdc13$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d8a5605a402fdc13$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d8a5605a402fdc13$var$noop$1);
            break;
        case "onScroll":
            null != value && $d8a5605a402fdc13$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d8a5605a402fdc13$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $d8a5605a402fdc13$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("toggle", domElement);
            $d8a5605a402fdc13$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $d8a5605a402fdc13$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $d8a5605a402fdc13$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $d8a5605a402fdc13$var$aliases.get(key) || key, $d8a5605a402fdc13$var$setValueForAttribute(domElement, key, value);
    }
}
function $d8a5605a402fdc13$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $d8a5605a402fdc13$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $d8a5605a402fdc13$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $d8a5605a402fdc13$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $d8a5605a402fdc13$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d8a5605a402fdc13$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d8a5605a402fdc13$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$d8a5605a402fdc13$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$d8a5605a402fdc13$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $d8a5605a402fdc13$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $d8a5605a402fdc13$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("error", domElement);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(137, tag));
                    default:
                        $d8a5605a402fdc13$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $d8a5605a402fdc13$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $d8a5605a402fdc13$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $d8a5605a402fdc13$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $d8a5605a402fdc13$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $d8a5605a402fdc13$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $d8a5605a402fdc13$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(91));
                    break;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $d8a5605a402fdc13$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("toggle", domElement);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("cancel", domElement);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $d8a5605a402fdc13$var$mediaEventTypes.length; hasSrc++)$d8a5605a402fdc13$var$listenToNonDelegatedEvent($d8a5605a402fdc13$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("error", domElement);
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $d8a5605a402fdc13$var$listenToNonDelegatedEvent("error", domElement), $d8a5605a402fdc13$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(137, tag));
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($d8a5605a402fdc13$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $d8a5605a402fdc13$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $d8a5605a402fdc13$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $d8a5605a402fdc13$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $d8a5605a402fdc13$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $d8a5605a402fdc13$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $d8a5605a402fdc13$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $d8a5605a402fdc13$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $d8a5605a402fdc13$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $d8a5605a402fdc13$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $d8a5605a402fdc13$var$updateOptions(domElement, !!lastProps, tag, !0) : $d8a5605a402fdc13$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $d8a5605a402fdc13$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $d8a5605a402fdc13$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $d8a5605a402fdc13$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $d8a5605a402fdc13$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($d8a5605a402fdc13$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $d8a5605a402fdc13$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $d8a5605a402fdc13$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $d8a5605a402fdc13$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $d8a5605a402fdc13$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $d8a5605a402fdc13$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $d8a5605a402fdc13$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $d8a5605a402fdc13$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $d8a5605a402fdc13$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $d8a5605a402fdc13$var$eventsEnabled = null, $d8a5605a402fdc13$var$selectionInformation = null;
function $d8a5605a402fdc13$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $d8a5605a402fdc13$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $d8a5605a402fdc13$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $d8a5605a402fdc13$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $d8a5605a402fdc13$var$currentPopstateTransitionEvent = null;
function $d8a5605a402fdc13$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $d8a5605a402fdc13$var$currentPopstateTransitionEvent) return !1;
        $d8a5605a402fdc13$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $d8a5605a402fdc13$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $d8a5605a402fdc13$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $d8a5605a402fdc13$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $d8a5605a402fdc13$var$localPromise = "function" === typeof Promise ? Promise : void 0, $d8a5605a402fdc13$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d8a5605a402fdc13$var$localPromise ? function(callback) {
    return $d8a5605a402fdc13$var$localPromise.resolve(null).then(callback).catch($d8a5605a402fdc13$var$handleErrorInNextTick);
} : $d8a5605a402fdc13$var$scheduleTimeout;
function $d8a5605a402fdc13$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $d8a5605a402fdc13$var$isSingletonScope(type) {
    return "head" === type;
}
function $d8a5605a402fdc13$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $d8a5605a402fdc13$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $d8a5605a402fdc13$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $d8a5605a402fdc13$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$d8a5605a402fdc13$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $d8a5605a402fdc13$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $d8a5605a402fdc13$var$retryIfBlockedOn(hydrationInstance);
}
function $d8a5605a402fdc13$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $d8a5605a402fdc13$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $d8a5605a402fdc13$var$clearContainerSparingly(node);
                $d8a5605a402fdc13$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $d8a5605a402fdc13$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$d8a5605a402fdc13$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $d8a5605a402fdc13$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $d8a5605a402fdc13$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d8a5605a402fdc13$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d8a5605a402fdc13$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d8a5605a402fdc13$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d8a5605a402fdc13$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $d8a5605a402fdc13$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $d8a5605a402fdc13$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $d8a5605a402fdc13$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $d8a5605a402fdc13$var$previousHydratableOnEnteringScopedSingleton = null;
function $d8a5605a402fdc13$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $d8a5605a402fdc13$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $d8a5605a402fdc13$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $d8a5605a402fdc13$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $d8a5605a402fdc13$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(451));
    }
}
function $d8a5605a402fdc13$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $d8a5605a402fdc13$var$detachDeletedInstance(instance);
}
var $d8a5605a402fdc13$var$preloadPropsMap = new Map(), $d8a5605a402fdc13$var$preconnectsSet = new Set();
function $d8a5605a402fdc13$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $d8a5605a402fdc13$var$previousDispatcher = $d8a5605a402fdc13$var$ReactDOMSharedInternals.d;
$d8a5605a402fdc13$var$ReactDOMSharedInternals.d = {
    f: $d8a5605a402fdc13$var$flushSyncWork,
    r: $d8a5605a402fdc13$var$requestFormReset,
    D: $d8a5605a402fdc13$var$prefetchDNS,
    C: $d8a5605a402fdc13$var$preconnect,
    L: $d8a5605a402fdc13$var$preload,
    m: $d8a5605a402fdc13$var$preloadModule,
    X: $d8a5605a402fdc13$var$preinitScript,
    S: $d8a5605a402fdc13$var$preinitStyle,
    M: $d8a5605a402fdc13$var$preinitModuleScript
};
function $d8a5605a402fdc13$var$flushSyncWork() {
    var previousWasRendering = $d8a5605a402fdc13$var$previousDispatcher.f(), wasRendering = $d8a5605a402fdc13$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $d8a5605a402fdc13$var$requestFormReset(form) {
    var formInst = $d8a5605a402fdc13$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $d8a5605a402fdc13$var$requestFormReset$1(formInst) : $d8a5605a402fdc13$var$previousDispatcher.r(form);
}
var $d8a5605a402fdc13$var$globalDocument = "undefined" === typeof document ? null : document;
function $d8a5605a402fdc13$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $d8a5605a402fdc13$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $d8a5605a402fdc13$var$preconnectsSet.has(limitedEscapedHref) || ($d8a5605a402fdc13$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $d8a5605a402fdc13$var$setInitialProperties(href, "link", rel), $d8a5605a402fdc13$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $d8a5605a402fdc13$var$prefetchDNS(href) {
    $d8a5605a402fdc13$var$previousDispatcher.D(href);
    $d8a5605a402fdc13$var$preconnectAs("dns-prefetch", href, null);
}
function $d8a5605a402fdc13$var$preconnect(href, crossOrigin) {
    $d8a5605a402fdc13$var$previousDispatcher.C(href, crossOrigin);
    $d8a5605a402fdc13$var$preconnectAs("preconnect", href, crossOrigin);
}
function $d8a5605a402fdc13$var$preload(href, as, options) {
    $d8a5605a402fdc13$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $d8a5605a402fdc13$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $d8a5605a402fdc13$var$getStyleKey(href);
                break;
            case "script":
                key = $d8a5605a402fdc13$var$getScriptKey(href);
        }
        $d8a5605a402fdc13$var$preloadPropsMap.has(key) || (href = $d8a5605a402fdc13$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $d8a5605a402fdc13$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($d8a5605a402fdc13$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($d8a5605a402fdc13$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $d8a5605a402fdc13$var$setInitialProperties(as, "link", href), $d8a5605a402fdc13$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $d8a5605a402fdc13$var$preloadModule(href, options) {
    $d8a5605a402fdc13$var$previousDispatcher.m(href, options);
    var ownerDocument = $d8a5605a402fdc13$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $d8a5605a402fdc13$var$getScriptKey(href);
        }
        if (!$d8a5605a402fdc13$var$preloadPropsMap.has(key) && (href = $d8a5605a402fdc13$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $d8a5605a402fdc13$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($d8a5605a402fdc13$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $d8a5605a402fdc13$var$setInitialProperties(as, "link", href);
            $d8a5605a402fdc13$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $d8a5605a402fdc13$var$preinitStyle(href, precedence, options) {
    $d8a5605a402fdc13$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $d8a5605a402fdc13$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $d8a5605a402fdc13$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $d8a5605a402fdc13$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($d8a5605a402fdc13$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $d8a5605a402fdc13$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $d8a5605a402fdc13$var$preloadPropsMap.get(key)) && $d8a5605a402fdc13$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $d8a5605a402fdc13$var$markNodeAsHoistable(link);
                $d8a5605a402fdc13$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $d8a5605a402fdc13$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $d8a5605a402fdc13$var$preinitScript(src, options) {
    $d8a5605a402fdc13$var$previousDispatcher.X(src, options);
    var ownerDocument = $d8a5605a402fdc13$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d8a5605a402fdc13$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d8a5605a402fdc13$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d8a5605a402fdc13$var$getScriptSelectorFromKey(key)), resource || (src = $d8a5605a402fdc13$var$assign({
            src: src,
            async: !0
        }, options), (options = $d8a5605a402fdc13$var$preloadPropsMap.get(key)) && $d8a5605a402fdc13$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d8a5605a402fdc13$var$markNodeAsHoistable(resource), $d8a5605a402fdc13$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d8a5605a402fdc13$var$preinitModuleScript(src, options) {
    $d8a5605a402fdc13$var$previousDispatcher.M(src, options);
    var ownerDocument = $d8a5605a402fdc13$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d8a5605a402fdc13$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d8a5605a402fdc13$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d8a5605a402fdc13$var$getScriptSelectorFromKey(key)), resource || (src = $d8a5605a402fdc13$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $d8a5605a402fdc13$var$preloadPropsMap.get(key)) && $d8a5605a402fdc13$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d8a5605a402fdc13$var$markNodeAsHoistable(resource), $d8a5605a402fdc13$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d8a5605a402fdc13$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $d8a5605a402fdc13$var$rootInstanceStackCursor.current) ? $d8a5605a402fdc13$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $d8a5605a402fdc13$var$getStyleKey(pendingProps.href), pendingProps = $d8a5605a402fdc13$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $d8a5605a402fdc13$var$getStyleKey(pendingProps.href);
                var styles$243 = $d8a5605a402fdc13$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($d8a5605a402fdc13$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $d8a5605a402fdc13$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $d8a5605a402fdc13$var$preloadPropsMap.set(type, pendingProps), styles$243 || $d8a5605a402fdc13$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $d8a5605a402fdc13$var$getScriptKey(pendingProps), pendingProps = $d8a5605a402fdc13$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(444, type));
    }
}
function $d8a5605a402fdc13$var$getStyleKey(href) {
    return 'href="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $d8a5605a402fdc13$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $d8a5605a402fdc13$var$stylesheetPropsFromRawProps(rawProps) {
    return $d8a5605a402fdc13$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $d8a5605a402fdc13$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $d8a5605a402fdc13$var$setInitialProperties(key, "link", preloadProps), $d8a5605a402fdc13$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $d8a5605a402fdc13$var$getScriptKey(src) {
    return '[src="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $d8a5605a402fdc13$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $d8a5605a402fdc13$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $d8a5605a402fdc13$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $d8a5605a402fdc13$var$markNodeAsHoistable(instance), instance;
            var styleProps = $d8a5605a402fdc13$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $d8a5605a402fdc13$var$markNodeAsHoistable(instance);
            $d8a5605a402fdc13$var$setInitialProperties(instance, "style", styleProps);
            $d8a5605a402fdc13$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $d8a5605a402fdc13$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($d8a5605a402fdc13$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $d8a5605a402fdc13$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $d8a5605a402fdc13$var$stylesheetPropsFromRawProps(props);
            (styleProps = $d8a5605a402fdc13$var$preloadPropsMap.get(styleProps)) && $d8a5605a402fdc13$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $d8a5605a402fdc13$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d8a5605a402fdc13$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $d8a5605a402fdc13$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $d8a5605a402fdc13$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($d8a5605a402fdc13$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $d8a5605a402fdc13$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $d8a5605a402fdc13$var$preloadPropsMap.get(instance$249)) instance = $d8a5605a402fdc13$var$assign({}, props), $d8a5605a402fdc13$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $d8a5605a402fdc13$var$markNodeAsHoistable(styleProps);
            $d8a5605a402fdc13$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $d8a5605a402fdc13$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $d8a5605a402fdc13$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $d8a5605a402fdc13$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $d8a5605a402fdc13$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $d8a5605a402fdc13$var$tagCaches = null;
function $d8a5605a402fdc13$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $d8a5605a402fdc13$var$tagCaches) {
        var cache = new Map();
        var caches = $d8a5605a402fdc13$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $d8a5605a402fdc13$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$d8a5605a402fdc13$var$internalHoistableMarker] || node[$d8a5605a402fdc13$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $d8a5605a402fdc13$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $d8a5605a402fdc13$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $d8a5605a402fdc13$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $d8a5605a402fdc13$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $d8a5605a402fdc13$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($d8a5605a402fdc13$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $d8a5605a402fdc13$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $d8a5605a402fdc13$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $d8a5605a402fdc13$var$stylesheetPropsFromRawProps(props);
            (key = $d8a5605a402fdc13$var$preloadPropsMap.get(key)) && $d8a5605a402fdc13$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $d8a5605a402fdc13$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d8a5605a402fdc13$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $d8a5605a402fdc13$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $d8a5605a402fdc13$var$estimatedBytesWithinLimit = 0;
function $d8a5605a402fdc13$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $d8a5605a402fdc13$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $d8a5605a402fdc13$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $d8a5605a402fdc13$var$estimatedBytesWithinLimit && ($d8a5605a402fdc13$var$estimatedBytesWithinLimit = 62500 * $d8a5605a402fdc13$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $d8a5605a402fdc13$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $d8a5605a402fdc13$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $d8a5605a402fdc13$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $d8a5605a402fdc13$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $d8a5605a402fdc13$var$precedencesByRoot = null;
function $d8a5605a402fdc13$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $d8a5605a402fdc13$var$precedencesByRoot = new Map(), resources.forEach($d8a5605a402fdc13$var$insertStylesheetIntoRoot, state), $d8a5605a402fdc13$var$precedencesByRoot = null, $d8a5605a402fdc13$var$onUnsuspend.call(state));
}
function $d8a5605a402fdc13$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $d8a5605a402fdc13$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $d8a5605a402fdc13$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $d8a5605a402fdc13$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $d8a5605a402fdc13$var$HostTransitionContext = {
    $$typeof: $d8a5605a402fdc13$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $d8a5605a402fdc13$var$sharedNotPendingObject,
    _currentValue2: $d8a5605a402fdc13$var$sharedNotPendingObject,
    _threadCount: 0
};
function $d8a5605a402fdc13$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $d8a5605a402fdc13$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d8a5605a402fdc13$var$createLaneMap(0);
    this.hiddenUpdates = $d8a5605a402fdc13$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $d8a5605a402fdc13$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $d8a5605a402fdc13$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $d8a5605a402fdc13$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $d8a5605a402fdc13$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $d8a5605a402fdc13$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $d8a5605a402fdc13$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $d8a5605a402fdc13$var$emptyContextObject;
    parentComponent = $d8a5605a402fdc13$var$emptyContextObject;
    return parentComponent;
}
function $d8a5605a402fdc13$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $d8a5605a402fdc13$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $d8a5605a402fdc13$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $d8a5605a402fdc13$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($d8a5605a402fdc13$var$scheduleUpdateOnFiber(element, rootFiber, lane), $d8a5605a402fdc13$var$entangleTransitions(element, rootFiber, lane));
}
function $d8a5605a402fdc13$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $d8a5605a402fdc13$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $d8a5605a402fdc13$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $d8a5605a402fdc13$var$markRetryLaneImpl(fiber, retryLane);
}
function $d8a5605a402fdc13$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $d8a5605a402fdc13$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $d8a5605a402fdc13$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $d8a5605a402fdc13$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $d8a5605a402fdc13$var$requestUpdateLane();
        lane = $d8a5605a402fdc13$var$getBumpedLaneForHydrationByLane(lane);
        var root = $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $d8a5605a402fdc13$var$scheduleUpdateOnFiber(root, fiber, lane);
        $d8a5605a402fdc13$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $d8a5605a402fdc13$var$_enabled = !0;
function $d8a5605a402fdc13$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d8a5605a402fdc13$var$ReactSharedInternals.T;
    $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
    var previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
    try {
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 2, $d8a5605a402fdc13$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority, $d8a5605a402fdc13$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d8a5605a402fdc13$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d8a5605a402fdc13$var$ReactSharedInternals.T;
    $d8a5605a402fdc13$var$ReactSharedInternals.T = null;
    var previousPriority = $d8a5605a402fdc13$var$ReactDOMSharedInternals.p;
    try {
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = 8, $d8a5605a402fdc13$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d8a5605a402fdc13$var$ReactDOMSharedInternals.p = previousPriority, $d8a5605a402fdc13$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d8a5605a402fdc13$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($d8a5605a402fdc13$var$_enabled) {
        var blockedOn = $d8a5605a402fdc13$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $d8a5605a402fdc13$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d8a5605a402fdc13$var$return_targetInst, targetContainer), $d8a5605a402fdc13$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($d8a5605a402fdc13$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($d8a5605a402fdc13$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $d8a5605a402fdc13$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $d8a5605a402fdc13$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $d8a5605a402fdc13$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $d8a5605a402fdc13$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $d8a5605a402fdc13$var$ensureRootIsScheduled(fiber);
                                0 === ($d8a5605a402fdc13$var$executionContext & 6) && ($d8a5605a402fdc13$var$workInProgressRootRenderTargetTime = $d8a5605a402fdc13$var$now() + 500, $d8a5605a402fdc13$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $d8a5605a402fdc13$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $d8a5605a402fdc13$var$scheduleUpdateOnFiber(root, fiber, 2), $d8a5605a402fdc13$var$flushSyncWork$1(), $d8a5605a402fdc13$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $d8a5605a402fdc13$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $d8a5605a402fdc13$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d8a5605a402fdc13$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $d8a5605a402fdc13$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $d8a5605a402fdc13$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $d8a5605a402fdc13$var$getEventTarget(nativeEvent);
    return $d8a5605a402fdc13$var$findInstanceBlockingTarget(nativeEvent);
}
var $d8a5605a402fdc13$var$return_targetInst = null;
function $d8a5605a402fdc13$var$findInstanceBlockingTarget(targetNode) {
    $d8a5605a402fdc13$var$return_targetInst = null;
    targetNode = $d8a5605a402fdc13$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $d8a5605a402fdc13$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $d8a5605a402fdc13$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $d8a5605a402fdc13$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $d8a5605a402fdc13$var$return_targetInst = targetNode;
    return null;
}
function $d8a5605a402fdc13$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($d8a5605a402fdc13$var$getCurrentPriorityLevel()){
                case $d8a5605a402fdc13$var$ImmediatePriority:
                    return 2;
                case $d8a5605a402fdc13$var$UserBlockingPriority:
                    return 8;
                case $d8a5605a402fdc13$var$NormalPriority$1:
                case $d8a5605a402fdc13$var$LowPriority:
                    return 32;
                case $d8a5605a402fdc13$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $d8a5605a402fdc13$var$hasScheduledReplayAttempt = !1, $d8a5605a402fdc13$var$queuedFocus = null, $d8a5605a402fdc13$var$queuedDrag = null, $d8a5605a402fdc13$var$queuedMouse = null, $d8a5605a402fdc13$var$queuedPointers = new Map(), $d8a5605a402fdc13$var$queuedPointerCaptures = new Map(), $d8a5605a402fdc13$var$queuedExplicitHydrationTargets = [], $d8a5605a402fdc13$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $d8a5605a402fdc13$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $d8a5605a402fdc13$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $d8a5605a402fdc13$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $d8a5605a402fdc13$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $d8a5605a402fdc13$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d8a5605a402fdc13$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $d8a5605a402fdc13$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $d8a5605a402fdc13$var$getInstanceFromNode(blockedOn), null !== blockedOn && $d8a5605a402fdc13$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $d8a5605a402fdc13$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $d8a5605a402fdc13$var$queuedFocus = $d8a5605a402fdc13$var$accumulateOrCreateContinuousQueuedReplayableEvent($d8a5605a402fdc13$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $d8a5605a402fdc13$var$queuedDrag = $d8a5605a402fdc13$var$accumulateOrCreateContinuousQueuedReplayableEvent($d8a5605a402fdc13$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $d8a5605a402fdc13$var$queuedMouse = $d8a5605a402fdc13$var$accumulateOrCreateContinuousQueuedReplayableEvent($d8a5605a402fdc13$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $d8a5605a402fdc13$var$queuedPointers.set(pointerId, $d8a5605a402fdc13$var$accumulateOrCreateContinuousQueuedReplayableEvent($d8a5605a402fdc13$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $d8a5605a402fdc13$var$queuedPointerCaptures.set(pointerId, $d8a5605a402fdc13$var$accumulateOrCreateContinuousQueuedReplayableEvent($d8a5605a402fdc13$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $d8a5605a402fdc13$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $d8a5605a402fdc13$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $d8a5605a402fdc13$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $d8a5605a402fdc13$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d8a5605a402fdc13$var$runWithPriority(queuedTarget.priority, function() {
                        $d8a5605a402fdc13$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $d8a5605a402fdc13$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d8a5605a402fdc13$var$runWithPriority(queuedTarget.priority, function() {
                        $d8a5605a402fdc13$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $d8a5605a402fdc13$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $d8a5605a402fdc13$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $d8a5605a402fdc13$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $d8a5605a402fdc13$var$currentReplayingEvent = null;
        } else return targetContainers = $d8a5605a402fdc13$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $d8a5605a402fdc13$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $d8a5605a402fdc13$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $d8a5605a402fdc13$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $d8a5605a402fdc13$var$replayUnblockedEvents() {
    $d8a5605a402fdc13$var$hasScheduledReplayAttempt = !1;
    null !== $d8a5605a402fdc13$var$queuedFocus && $d8a5605a402fdc13$var$attemptReplayContinuousQueuedEvent($d8a5605a402fdc13$var$queuedFocus) && ($d8a5605a402fdc13$var$queuedFocus = null);
    null !== $d8a5605a402fdc13$var$queuedDrag && $d8a5605a402fdc13$var$attemptReplayContinuousQueuedEvent($d8a5605a402fdc13$var$queuedDrag) && ($d8a5605a402fdc13$var$queuedDrag = null);
    null !== $d8a5605a402fdc13$var$queuedMouse && $d8a5605a402fdc13$var$attemptReplayContinuousQueuedEvent($d8a5605a402fdc13$var$queuedMouse) && ($d8a5605a402fdc13$var$queuedMouse = null);
    $d8a5605a402fdc13$var$queuedPointers.forEach($d8a5605a402fdc13$var$attemptReplayContinuousQueuedEventInMap);
    $d8a5605a402fdc13$var$queuedPointerCaptures.forEach($d8a5605a402fdc13$var$attemptReplayContinuousQueuedEventInMap);
}
function $d8a5605a402fdc13$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $d8a5605a402fdc13$var$hasScheduledReplayAttempt || ($d8a5605a402fdc13$var$hasScheduledReplayAttempt = !0, $hXcSD.unstable_scheduleCallback($hXcSD.unstable_NormalPriority, $d8a5605a402fdc13$var$replayUnblockedEvents)));
}
var $d8a5605a402fdc13$var$lastScheduledReplayQueue = null;
function $d8a5605a402fdc13$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $d8a5605a402fdc13$var$lastScheduledReplayQueue !== formReplayingQueue && ($d8a5605a402fdc13$var$lastScheduledReplayQueue = formReplayingQueue, $hXcSD.unstable_scheduleCallback($hXcSD.unstable_NormalPriority, function() {
        $d8a5605a402fdc13$var$lastScheduledReplayQueue === formReplayingQueue && ($d8a5605a402fdc13$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $d8a5605a402fdc13$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $d8a5605a402fdc13$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $d8a5605a402fdc13$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $d8a5605a402fdc13$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $d8a5605a402fdc13$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $d8a5605a402fdc13$var$queuedFocus && $d8a5605a402fdc13$var$scheduleCallbackIfUnblocked($d8a5605a402fdc13$var$queuedFocus, unblocked);
    null !== $d8a5605a402fdc13$var$queuedDrag && $d8a5605a402fdc13$var$scheduleCallbackIfUnblocked($d8a5605a402fdc13$var$queuedDrag, unblocked);
    null !== $d8a5605a402fdc13$var$queuedMouse && $d8a5605a402fdc13$var$scheduleCallbackIfUnblocked($d8a5605a402fdc13$var$queuedMouse, unblocked);
    $d8a5605a402fdc13$var$queuedPointers.forEach(unblock);
    $d8a5605a402fdc13$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $d8a5605a402fdc13$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $d8a5605a402fdc13$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $d8a5605a402fdc13$var$queuedExplicitHydrationTargets.length && (i = $d8a5605a402fdc13$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$d8a5605a402fdc13$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $d8a5605a402fdc13$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$d8a5605a402fdc13$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $d8a5605a402fdc13$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$d8a5605a402fdc13$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $d8a5605a402fdc13$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $d8a5605a402fdc13$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $d8a5605a402fdc13$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $d8a5605a402fdc13$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d8a5605a402fdc13$var$ReactDOMHydrationRoot.prototype.render = $d8a5605a402fdc13$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(409));
    var current = root.current, lane = $d8a5605a402fdc13$var$requestUpdateLane();
    $d8a5605a402fdc13$var$updateContainerImpl(current, lane, children, root, null, null);
};
$d8a5605a402fdc13$var$ReactDOMHydrationRoot.prototype.unmount = $d8a5605a402fdc13$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $d8a5605a402fdc13$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $d8a5605a402fdc13$var$flushSyncWork$1();
        container[$d8a5605a402fdc13$var$internalContainerInstanceKey] = null;
    }
};
function $d8a5605a402fdc13$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d8a5605a402fdc13$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $d8a5605a402fdc13$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $d8a5605a402fdc13$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $d8a5605a402fdc13$var$queuedExplicitHydrationTargets[i].priority; i++);
        $d8a5605a402fdc13$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $d8a5605a402fdc13$var$attemptExplicitHydrationTarget(target);
    }
};
var $d8a5605a402fdc13$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $eyAY5.version;
if ("19.2.1" !== $d8a5605a402fdc13$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(527, $d8a5605a402fdc13$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.1"));
$d8a5605a402fdc13$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $d8a5605a402fdc13$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $d8a5605a402fdc13$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $d8a5605a402fdc13$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $d8a5605a402fdc13$var$ReactSharedInternals,
    reconcilerVersion: "19.2.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d8a5605a402fdc13$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d8a5605a402fdc13$var$hook$jscomp$inline_2348.isDisabled && $d8a5605a402fdc13$var$hook$jscomp$inline_2348.supportsFiber) try {
        $d8a5605a402fdc13$var$rendererID = $d8a5605a402fdc13$var$hook$jscomp$inline_2348.inject($d8a5605a402fdc13$var$internals$jscomp$inline_2347), $d8a5605a402fdc13$var$injectedHook = $d8a5605a402fdc13$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$d8a5605a402fdc13$export$882461b6382ed46c = function(container, options) {
    if (!$d8a5605a402fdc13$var$isValidContainer(container)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d8a5605a402fdc13$var$defaultOnUncaughtError, onCaughtError = $d8a5605a402fdc13$var$defaultOnCaughtError, onRecoverableError = $d8a5605a402fdc13$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $d8a5605a402fdc13$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $d8a5605a402fdc13$var$defaultOnDefaultTransitionIndicator);
    container[$d8a5605a402fdc13$var$internalContainerInstanceKey] = options.current;
    $d8a5605a402fdc13$var$listenToAllSupportedEvents(container);
    return new $d8a5605a402fdc13$var$ReactDOMRoot(options);
};
$d8a5605a402fdc13$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$d8a5605a402fdc13$var$isValidContainer(container)) throw Error($d8a5605a402fdc13$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d8a5605a402fdc13$var$defaultOnUncaughtError, onCaughtError = $d8a5605a402fdc13$var$defaultOnCaughtError, onRecoverableError = $d8a5605a402fdc13$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $d8a5605a402fdc13$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $d8a5605a402fdc13$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $d8a5605a402fdc13$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $d8a5605a402fdc13$var$requestUpdateLane();
    isStrictMode = $d8a5605a402fdc13$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $d8a5605a402fdc13$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $d8a5605a402fdc13$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $d8a5605a402fdc13$var$markRootUpdated$1(initialChildren, options);
    $d8a5605a402fdc13$var$ensureRootIsScheduled(initialChildren);
    container[$d8a5605a402fdc13$var$internalContainerInstanceKey] = initialChildren.current;
    $d8a5605a402fdc13$var$listenToAllSupportedEvents(container);
    return new $d8a5605a402fdc13$var$ReactDOMHydrationRoot(initialChildren);
};
$d8a5605a402fdc13$export$83d89fbfd8236492 = "19.2.1";

});
parcelRegister("98Fbt", function(module, exports) {
// shim for using process in browser
var $6a74ceb766ff6ddc$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $6a74ceb766ff6ddc$var$cachedSetTimeout;
var $6a74ceb766ff6ddc$var$cachedClearTimeout;
function $6a74ceb766ff6ddc$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $6a74ceb766ff6ddc$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $6a74ceb766ff6ddc$var$cachedSetTimeout = setTimeout;
        else $6a74ceb766ff6ddc$var$cachedSetTimeout = $6a74ceb766ff6ddc$var$defaultSetTimout;
    } catch (e) {
        $6a74ceb766ff6ddc$var$cachedSetTimeout = $6a74ceb766ff6ddc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $6a74ceb766ff6ddc$var$cachedClearTimeout = clearTimeout;
        else $6a74ceb766ff6ddc$var$cachedClearTimeout = $6a74ceb766ff6ddc$var$defaultClearTimeout;
    } catch (e) {
        $6a74ceb766ff6ddc$var$cachedClearTimeout = $6a74ceb766ff6ddc$var$defaultClearTimeout;
    }
})();
function $6a74ceb766ff6ddc$var$runTimeout(fun) {
    if ($6a74ceb766ff6ddc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($6a74ceb766ff6ddc$var$cachedSetTimeout === $6a74ceb766ff6ddc$var$defaultSetTimout || !$6a74ceb766ff6ddc$var$cachedSetTimeout) && setTimeout) {
        $6a74ceb766ff6ddc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6a74ceb766ff6ddc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $6a74ceb766ff6ddc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $6a74ceb766ff6ddc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $6a74ceb766ff6ddc$var$runClearTimeout(marker) {
    if ($6a74ceb766ff6ddc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($6a74ceb766ff6ddc$var$cachedClearTimeout === $6a74ceb766ff6ddc$var$defaultClearTimeout || !$6a74ceb766ff6ddc$var$cachedClearTimeout) && clearTimeout) {
        $6a74ceb766ff6ddc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6a74ceb766ff6ddc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $6a74ceb766ff6ddc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $6a74ceb766ff6ddc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $6a74ceb766ff6ddc$var$queue = [];
var $6a74ceb766ff6ddc$var$draining = false;
var $6a74ceb766ff6ddc$var$currentQueue;
var $6a74ceb766ff6ddc$var$queueIndex = -1;
function $6a74ceb766ff6ddc$var$cleanUpNextTick() {
    if (!$6a74ceb766ff6ddc$var$draining || !$6a74ceb766ff6ddc$var$currentQueue) return;
    $6a74ceb766ff6ddc$var$draining = false;
    if ($6a74ceb766ff6ddc$var$currentQueue.length) $6a74ceb766ff6ddc$var$queue = $6a74ceb766ff6ddc$var$currentQueue.concat($6a74ceb766ff6ddc$var$queue);
    else $6a74ceb766ff6ddc$var$queueIndex = -1;
    if ($6a74ceb766ff6ddc$var$queue.length) $6a74ceb766ff6ddc$var$drainQueue();
}
function $6a74ceb766ff6ddc$var$drainQueue() {
    if ($6a74ceb766ff6ddc$var$draining) return;
    var timeout = $6a74ceb766ff6ddc$var$runTimeout($6a74ceb766ff6ddc$var$cleanUpNextTick);
    $6a74ceb766ff6ddc$var$draining = true;
    var len = $6a74ceb766ff6ddc$var$queue.length;
    while(len){
        $6a74ceb766ff6ddc$var$currentQueue = $6a74ceb766ff6ddc$var$queue;
        $6a74ceb766ff6ddc$var$queue = [];
        while(++$6a74ceb766ff6ddc$var$queueIndex < len)if ($6a74ceb766ff6ddc$var$currentQueue) $6a74ceb766ff6ddc$var$currentQueue[$6a74ceb766ff6ddc$var$queueIndex].run();
        $6a74ceb766ff6ddc$var$queueIndex = -1;
        len = $6a74ceb766ff6ddc$var$queue.length;
    }
    $6a74ceb766ff6ddc$var$currentQueue = null;
    $6a74ceb766ff6ddc$var$draining = false;
    $6a74ceb766ff6ddc$var$runClearTimeout(timeout);
}
$6a74ceb766ff6ddc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $6a74ceb766ff6ddc$var$queue.push(new $6a74ceb766ff6ddc$var$Item(fun, args));
    if ($6a74ceb766ff6ddc$var$queue.length === 1 && !$6a74ceb766ff6ddc$var$draining) $6a74ceb766ff6ddc$var$runTimeout($6a74ceb766ff6ddc$var$drainQueue);
};
// v8 likes predictible objects
function $6a74ceb766ff6ddc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$6a74ceb766ff6ddc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$6a74ceb766ff6ddc$var$process.title = "browser";
$6a74ceb766ff6ddc$var$process.browser = true;
$6a74ceb766ff6ddc$var$process.env = {};
$6a74ceb766ff6ddc$var$process.argv = [];
$6a74ceb766ff6ddc$var$process.version = ""; // empty string to avoid regexp issues
$6a74ceb766ff6ddc$var$process.versions = {};
function $6a74ceb766ff6ddc$var$noop() {}
$6a74ceb766ff6ddc$var$process.on = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.addListener = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.once = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.off = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.removeListener = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.removeAllListeners = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.emit = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.prependListener = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.prependOnceListener = $6a74ceb766ff6ddc$var$noop;
$6a74ceb766ff6ddc$var$process.listeners = function(name) {
    return [];
};
$6a74ceb766ff6ddc$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$6a74ceb766ff6ddc$var$process.cwd = function() {
    return "/";
};
$6a74ceb766ff6ddc$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$6a74ceb766ff6ddc$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hXcSD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5Q0u1"));

});
parcelRegister("5Q0u1", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $44022f0ed80f20e9$export$c4744153514ff05d; }, function (v) { return $44022f0ed80f20e9$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $44022f0ed80f20e9$export$3e506c1ccc9cc1a7; }, function (v) { return $44022f0ed80f20e9$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $44022f0ed80f20e9$export$e26fe2ed2fa76875; }, function (v) { return $44022f0ed80f20e9$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $44022f0ed80f20e9$export$502329bbf4b505b1; }, function (v) { return $44022f0ed80f20e9$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $44022f0ed80f20e9$export$6e3807111c4874c4; }, function (v) { return $44022f0ed80f20e9$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $44022f0ed80f20e9$export$c27134553091fb3a; }, function (v) { return $44022f0ed80f20e9$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $44022f0ed80f20e9$export$33ee1acdc04fd2a2; }, function (v) { return $44022f0ed80f20e9$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $44022f0ed80f20e9$export$b00a404bbd5edef2; }, function (v) { return $44022f0ed80f20e9$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $44022f0ed80f20e9$export$d66a1c1c77bd778b; }, function (v) { return $44022f0ed80f20e9$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $44022f0ed80f20e9$export$d3dfb8e4810cb555; }, function (v) { return $44022f0ed80f20e9$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $44022f0ed80f20e9$export$72fdf0e06517287b; }, function (v) { return $44022f0ed80f20e9$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $44022f0ed80f20e9$export$816d2913ae6b83b1; }, function (v) { return $44022f0ed80f20e9$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $44022f0ed80f20e9$export$61bcfe829111a1d0; }, function (v) { return $44022f0ed80f20e9$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $44022f0ed80f20e9$export$7ee8c9beb337bc3f; }, function (v) { return $44022f0ed80f20e9$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $44022f0ed80f20e9$export$b5836b71941fa3ed; }, function (v) { return $44022f0ed80f20e9$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $44022f0ed80f20e9$export$cf845f2c119da08a; }, function (v) { return $44022f0ed80f20e9$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $44022f0ed80f20e9$export$c4744153514ff05d;
var $44022f0ed80f20e9$export$3e506c1ccc9cc1a7;
var $44022f0ed80f20e9$export$e26fe2ed2fa76875;
var $44022f0ed80f20e9$export$502329bbf4b505b1;
var $44022f0ed80f20e9$export$6e3807111c4874c4;
var $44022f0ed80f20e9$export$c27134553091fb3a;
var $44022f0ed80f20e9$export$33ee1acdc04fd2a2;
var $44022f0ed80f20e9$export$b00a404bbd5edef2;
var $44022f0ed80f20e9$export$d66a1c1c77bd778b;
var $44022f0ed80f20e9$export$d3dfb8e4810cb555;
var $44022f0ed80f20e9$export$72fdf0e06517287b;
var $44022f0ed80f20e9$export$816d2913ae6b83b1;
var $44022f0ed80f20e9$export$61bcfe829111a1d0;
var $44022f0ed80f20e9$export$7ee8c9beb337bc3f;
var $44022f0ed80f20e9$export$b5836b71941fa3ed;
var $44022f0ed80f20e9$export$cf845f2c119da08a;
"use strict";
function $44022f0ed80f20e9$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $44022f0ed80f20e9$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $44022f0ed80f20e9$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $44022f0ed80f20e9$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $44022f0ed80f20e9$var$compare(left, last)) rightIndex < length && 0 > $44022f0ed80f20e9$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $44022f0ed80f20e9$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $44022f0ed80f20e9$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$44022f0ed80f20e9$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $44022f0ed80f20e9$var$localPerformance = performance;
    $44022f0ed80f20e9$export$c4744153514ff05d = function() {
        return $44022f0ed80f20e9$var$localPerformance.now();
    };
} else {
    var $44022f0ed80f20e9$var$localDate = Date, $44022f0ed80f20e9$var$initialTime = $44022f0ed80f20e9$var$localDate.now();
    $44022f0ed80f20e9$export$c4744153514ff05d = function() {
        return $44022f0ed80f20e9$var$localDate.now() - $44022f0ed80f20e9$var$initialTime;
    };
}
var $44022f0ed80f20e9$var$taskQueue = [], $44022f0ed80f20e9$var$timerQueue = [], $44022f0ed80f20e9$var$taskIdCounter = 1, $44022f0ed80f20e9$var$currentTask = null, $44022f0ed80f20e9$var$currentPriorityLevel = 3, $44022f0ed80f20e9$var$isPerformingWork = !1, $44022f0ed80f20e9$var$isHostCallbackScheduled = !1, $44022f0ed80f20e9$var$isHostTimeoutScheduled = !1, $44022f0ed80f20e9$var$needsPaint = !1, $44022f0ed80f20e9$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $44022f0ed80f20e9$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $44022f0ed80f20e9$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $44022f0ed80f20e9$var$advanceTimers(currentTime) {
    for(var timer = $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$timerQueue); null !== timer;){
        if (null === timer.callback) $44022f0ed80f20e9$var$pop($44022f0ed80f20e9$var$timerQueue);
        else if (timer.startTime <= currentTime) $44022f0ed80f20e9$var$pop($44022f0ed80f20e9$var$timerQueue), timer.sortIndex = timer.expirationTime, $44022f0ed80f20e9$var$push($44022f0ed80f20e9$var$taskQueue, timer);
        else break;
        timer = $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$timerQueue);
    }
}
function $44022f0ed80f20e9$var$handleTimeout(currentTime) {
    $44022f0ed80f20e9$var$isHostTimeoutScheduled = !1;
    $44022f0ed80f20e9$var$advanceTimers(currentTime);
    if (!$44022f0ed80f20e9$var$isHostCallbackScheduled) {
        if (null !== $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$taskQueue)) $44022f0ed80f20e9$var$isHostCallbackScheduled = !0, $44022f0ed80f20e9$var$isMessageLoopRunning || ($44022f0ed80f20e9$var$isMessageLoopRunning = !0, $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$timerQueue);
            null !== firstTimer && $44022f0ed80f20e9$var$requestHostTimeout($44022f0ed80f20e9$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $44022f0ed80f20e9$var$isMessageLoopRunning = !1, $44022f0ed80f20e9$var$taskTimeoutID = -1, $44022f0ed80f20e9$var$frameInterval = 5, $44022f0ed80f20e9$var$startTime = -1;
function $44022f0ed80f20e9$var$shouldYieldToHost() {
    return $44022f0ed80f20e9$var$needsPaint ? !0 : $44022f0ed80f20e9$export$c4744153514ff05d() - $44022f0ed80f20e9$var$startTime < $44022f0ed80f20e9$var$frameInterval ? !1 : !0;
}
function $44022f0ed80f20e9$var$performWorkUntilDeadline() {
    $44022f0ed80f20e9$var$needsPaint = !1;
    if ($44022f0ed80f20e9$var$isMessageLoopRunning) {
        var currentTime = $44022f0ed80f20e9$export$c4744153514ff05d();
        $44022f0ed80f20e9$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $44022f0ed80f20e9$var$isHostCallbackScheduled = !1;
                $44022f0ed80f20e9$var$isHostTimeoutScheduled && ($44022f0ed80f20e9$var$isHostTimeoutScheduled = !1, $44022f0ed80f20e9$var$localClearTimeout($44022f0ed80f20e9$var$taskTimeoutID), $44022f0ed80f20e9$var$taskTimeoutID = -1);
                $44022f0ed80f20e9$var$isPerformingWork = !0;
                var previousPriorityLevel = $44022f0ed80f20e9$var$currentPriorityLevel;
                try {
                    b: {
                        $44022f0ed80f20e9$var$advanceTimers(currentTime);
                        for($44022f0ed80f20e9$var$currentTask = $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$taskQueue); null !== $44022f0ed80f20e9$var$currentTask && !($44022f0ed80f20e9$var$currentTask.expirationTime > currentTime && $44022f0ed80f20e9$var$shouldYieldToHost());){
                            var callback = $44022f0ed80f20e9$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $44022f0ed80f20e9$var$currentTask.callback = null;
                                $44022f0ed80f20e9$var$currentPriorityLevel = $44022f0ed80f20e9$var$currentTask.priorityLevel;
                                var continuationCallback = callback($44022f0ed80f20e9$var$currentTask.expirationTime <= currentTime);
                                currentTime = $44022f0ed80f20e9$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $44022f0ed80f20e9$var$currentTask.callback = continuationCallback;
                                    $44022f0ed80f20e9$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $44022f0ed80f20e9$var$currentTask === $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$taskQueue) && $44022f0ed80f20e9$var$pop($44022f0ed80f20e9$var$taskQueue);
                                $44022f0ed80f20e9$var$advanceTimers(currentTime);
                            } else $44022f0ed80f20e9$var$pop($44022f0ed80f20e9$var$taskQueue);
                            $44022f0ed80f20e9$var$currentTask = $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$taskQueue);
                        }
                        if (null !== $44022f0ed80f20e9$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$timerQueue);
                            null !== firstTimer && $44022f0ed80f20e9$var$requestHostTimeout($44022f0ed80f20e9$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $44022f0ed80f20e9$var$currentTask = null, $44022f0ed80f20e9$var$currentPriorityLevel = previousPriorityLevel, $44022f0ed80f20e9$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline() : $44022f0ed80f20e9$var$isMessageLoopRunning = !1;
        }
    }
}
var $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $44022f0ed80f20e9$var$localSetImmediate) $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline = function() {
    $44022f0ed80f20e9$var$localSetImmediate($44022f0ed80f20e9$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $44022f0ed80f20e9$var$channel = new MessageChannel(), $44022f0ed80f20e9$var$port = $44022f0ed80f20e9$var$channel.port2;
    $44022f0ed80f20e9$var$channel.port1.onmessage = $44022f0ed80f20e9$var$performWorkUntilDeadline;
    $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline = function() {
        $44022f0ed80f20e9$var$port.postMessage(null);
    };
} else $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline = function() {
    $44022f0ed80f20e9$var$localSetTimeout($44022f0ed80f20e9$var$performWorkUntilDeadline, 0);
};
function $44022f0ed80f20e9$var$requestHostTimeout(callback, ms) {
    $44022f0ed80f20e9$var$taskTimeoutID = $44022f0ed80f20e9$var$localSetTimeout(function() {
        callback($44022f0ed80f20e9$export$c4744153514ff05d());
    }, ms);
}
$44022f0ed80f20e9$export$3e506c1ccc9cc1a7 = 5;
$44022f0ed80f20e9$export$e26fe2ed2fa76875 = 1;
$44022f0ed80f20e9$export$502329bbf4b505b1 = 4;
$44022f0ed80f20e9$export$6e3807111c4874c4 = 3;
$44022f0ed80f20e9$export$c27134553091fb3a = null;
$44022f0ed80f20e9$export$33ee1acdc04fd2a2 = 2;
$44022f0ed80f20e9$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$44022f0ed80f20e9$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $44022f0ed80f20e9$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$44022f0ed80f20e9$export$d3dfb8e4810cb555 = function() {
    return $44022f0ed80f20e9$var$currentPriorityLevel;
};
$44022f0ed80f20e9$export$72fdf0e06517287b = function(eventHandler) {
    switch($44022f0ed80f20e9$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $44022f0ed80f20e9$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $44022f0ed80f20e9$var$currentPriorityLevel;
    $44022f0ed80f20e9$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $44022f0ed80f20e9$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$44022f0ed80f20e9$export$816d2913ae6b83b1 = function() {
    $44022f0ed80f20e9$var$needsPaint = !0;
};
$44022f0ed80f20e9$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $44022f0ed80f20e9$var$currentPriorityLevel;
    $44022f0ed80f20e9$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $44022f0ed80f20e9$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$44022f0ed80f20e9$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $44022f0ed80f20e9$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $44022f0ed80f20e9$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $44022f0ed80f20e9$var$push($44022f0ed80f20e9$var$timerQueue, priorityLevel), null === $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$taskQueue) && priorityLevel === $44022f0ed80f20e9$var$peek($44022f0ed80f20e9$var$timerQueue) && ($44022f0ed80f20e9$var$isHostTimeoutScheduled ? ($44022f0ed80f20e9$var$localClearTimeout($44022f0ed80f20e9$var$taskTimeoutID), $44022f0ed80f20e9$var$taskTimeoutID = -1) : $44022f0ed80f20e9$var$isHostTimeoutScheduled = !0, $44022f0ed80f20e9$var$requestHostTimeout($44022f0ed80f20e9$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $44022f0ed80f20e9$var$push($44022f0ed80f20e9$var$taskQueue, priorityLevel), $44022f0ed80f20e9$var$isHostCallbackScheduled || $44022f0ed80f20e9$var$isPerformingWork || ($44022f0ed80f20e9$var$isHostCallbackScheduled = !0, $44022f0ed80f20e9$var$isMessageLoopRunning || ($44022f0ed80f20e9$var$isMessageLoopRunning = !0, $44022f0ed80f20e9$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$44022f0ed80f20e9$export$b5836b71941fa3ed = $44022f0ed80f20e9$var$shouldYieldToHost;
$44022f0ed80f20e9$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $44022f0ed80f20e9$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $44022f0ed80f20e9$var$currentPriorityLevel;
        $44022f0ed80f20e9$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $44022f0ed80f20e9$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("eyAY5", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lb3AE"));

});
parcelRegister("lb3AE", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $f6ad68fce9d4bb62$export$9c16c1426311996d; }, function (v) { return $f6ad68fce9d4bb62$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $f6ad68fce9d4bb62$export$dca3b0875bd9a954; }, function (v) { return $f6ad68fce9d4bb62$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $f6ad68fce9d4bb62$export$16fa2f45be04daa8; }, function (v) { return $f6ad68fce9d4bb62$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f6ad68fce9d4bb62$export$ffb0004e005737fa; }, function (v) { return $f6ad68fce9d4bb62$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $f6ad68fce9d4bb62$export$e2c29f18771995cb; }, function (v) { return $f6ad68fce9d4bb62$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $f6ad68fce9d4bb62$export$221d75b3f55bb0bd; }, function (v) { return $f6ad68fce9d4bb62$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f6ad68fce9d4bb62$export$5f8d39834fd61797; }, function (v) { return $f6ad68fce9d4bb62$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f6ad68fce9d4bb62$export$74bf444e3cd11ea5; }, function (v) { return $f6ad68fce9d4bb62$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $f6ad68fce9d4bb62$export$1ced07cd6b1985ce; }, function (v) { return $f6ad68fce9d4bb62$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $f6ad68fce9d4bb62$export$abd8e32b826d7ea7; }, function (v) { return $f6ad68fce9d4bb62$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $f6ad68fce9d4bb62$export$69a3209f1a06c04d; }, function (v) { return $f6ad68fce9d4bb62$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $f6ad68fce9d4bb62$export$8c538325882c7eec; }, function (v) { return $f6ad68fce9d4bb62$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $f6ad68fce9d4bb62$export$e530037191fcd5d7; }, function (v) { return $f6ad68fce9d4bb62$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $f6ad68fce9d4bb62$export$fd42f52fd3ae1109; }, function (v) { return $f6ad68fce9d4bb62$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $f6ad68fce9d4bb62$export$c8a8987d4410bf2d; }, function (v) { return $f6ad68fce9d4bb62$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $f6ad68fce9d4bb62$export$7d1e3a5e95ceca43; }, function (v) { return $f6ad68fce9d4bb62$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $f6ad68fce9d4bb62$export$257a8862b851cb5b; }, function (v) { return $f6ad68fce9d4bb62$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $f6ad68fce9d4bb62$export$a8257692ac88316c; }, function (v) { return $f6ad68fce9d4bb62$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $f6ad68fce9d4bb62$export$488013bae63b21da; }, function (v) { return $f6ad68fce9d4bb62$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $f6ad68fce9d4bb62$export$7c73462e0d25e514; }, function (v) { return $f6ad68fce9d4bb62$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $f6ad68fce9d4bb62$export$7568632d0d33d16d; }, function (v) { return $f6ad68fce9d4bb62$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $f6ad68fce9d4bb62$export$f93f40ac0ca7e3a8; }, function (v) { return $f6ad68fce9d4bb62$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $f6ad68fce9d4bb62$export$1f96ae73734a86cc; }, function (v) { return $f6ad68fce9d4bb62$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $f6ad68fce9d4bb62$export$9a47ced3238df325; }, function (v) { return $f6ad68fce9d4bb62$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $f6ad68fce9d4bb62$export$35808ee640e87ca7; }, function (v) { return $f6ad68fce9d4bb62$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $f6ad68fce9d4bb62$export$fae74005e78b1a27; }, function (v) { return $f6ad68fce9d4bb62$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $f6ad68fce9d4bb62$export$dc8fbce3eb94dc1e; }, function (v) { return $f6ad68fce9d4bb62$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $f6ad68fce9d4bb62$export$6a7bc4e911dc01cf; }, function (v) { return $f6ad68fce9d4bb62$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $f6ad68fce9d4bb62$export$6d9c69b0de29b591; }, function (v) { return $f6ad68fce9d4bb62$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $f6ad68fce9d4bb62$export$7f54fc3180508a52; }, function (v) { return $f6ad68fce9d4bb62$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $f6ad68fce9d4bb62$export$f680877a34711e37; }, function (v) { return $f6ad68fce9d4bb62$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f6ad68fce9d4bb62$export$d5a552a76deda3c2; }, function (v) { return $f6ad68fce9d4bb62$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $f6ad68fce9d4bb62$export$aaabe4eda9ed9969; }, function (v) { return $f6ad68fce9d4bb62$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f6ad68fce9d4bb62$export$e5c5a5f917a5871c; }, function (v) { return $f6ad68fce9d4bb62$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $f6ad68fce9d4bb62$export$1538c33de8887b59; }, function (v) { return $f6ad68fce9d4bb62$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $f6ad68fce9d4bb62$export$fca7f784ae7a249a; }, function (v) { return $f6ad68fce9d4bb62$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $f6ad68fce9d4bb62$export$13e3392192263954; }, function (v) { return $f6ad68fce9d4bb62$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $f6ad68fce9d4bb62$export$b8f5890fc79d6aca; }, function (v) { return $f6ad68fce9d4bb62$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $f6ad68fce9d4bb62$export$60241385465d0a34; }, function (v) { return $f6ad68fce9d4bb62$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $f6ad68fce9d4bb62$export$306c0aa65ff9ec16; }, function (v) { return $f6ad68fce9d4bb62$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $f6ad68fce9d4bb62$export$7b286972b8d8ccbf; }, function (v) { return $f6ad68fce9d4bb62$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $f6ad68fce9d4bb62$export$83d89fbfd8236492; }, function (v) { return $f6ad68fce9d4bb62$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f6ad68fce9d4bb62$export$9c16c1426311996d;
var $f6ad68fce9d4bb62$export$dca3b0875bd9a954;
var $f6ad68fce9d4bb62$export$16fa2f45be04daa8;
var $f6ad68fce9d4bb62$export$ffb0004e005737fa;
var $f6ad68fce9d4bb62$export$e2c29f18771995cb;
var $f6ad68fce9d4bb62$export$221d75b3f55bb0bd;
var $f6ad68fce9d4bb62$export$5f8d39834fd61797;
var $f6ad68fce9d4bb62$export$74bf444e3cd11ea5;
var $f6ad68fce9d4bb62$export$1ced07cd6b1985ce;
var $f6ad68fce9d4bb62$export$abd8e32b826d7ea7;
var $f6ad68fce9d4bb62$export$69a3209f1a06c04d;
var $f6ad68fce9d4bb62$export$8c538325882c7eec;
var $f6ad68fce9d4bb62$export$e530037191fcd5d7;
var $f6ad68fce9d4bb62$export$fd42f52fd3ae1109;
var $f6ad68fce9d4bb62$export$c8a8987d4410bf2d;
var $f6ad68fce9d4bb62$export$7d1e3a5e95ceca43;
var $f6ad68fce9d4bb62$export$257a8862b851cb5b;
var $f6ad68fce9d4bb62$export$a8257692ac88316c;
var $f6ad68fce9d4bb62$export$488013bae63b21da;
var $f6ad68fce9d4bb62$export$7c73462e0d25e514;
var $f6ad68fce9d4bb62$export$7568632d0d33d16d;
var $f6ad68fce9d4bb62$export$f93f40ac0ca7e3a8;
var $f6ad68fce9d4bb62$export$1f96ae73734a86cc;
var $f6ad68fce9d4bb62$export$9a47ced3238df325;
var $f6ad68fce9d4bb62$export$35808ee640e87ca7;
var $f6ad68fce9d4bb62$export$fae74005e78b1a27;
var $f6ad68fce9d4bb62$export$dc8fbce3eb94dc1e;
var $f6ad68fce9d4bb62$export$6a7bc4e911dc01cf;
var $f6ad68fce9d4bb62$export$6d9c69b0de29b591;
var $f6ad68fce9d4bb62$export$7f54fc3180508a52;
var $f6ad68fce9d4bb62$export$f680877a34711e37;
var $f6ad68fce9d4bb62$export$d5a552a76deda3c2;
var $f6ad68fce9d4bb62$export$aaabe4eda9ed9969;
var $f6ad68fce9d4bb62$export$e5c5a5f917a5871c;
var $f6ad68fce9d4bb62$export$1538c33de8887b59;
var $f6ad68fce9d4bb62$export$fca7f784ae7a249a;
var $f6ad68fce9d4bb62$export$13e3392192263954;
var $f6ad68fce9d4bb62$export$b8f5890fc79d6aca;
var $f6ad68fce9d4bb62$export$60241385465d0a34;
var $f6ad68fce9d4bb62$export$306c0aa65ff9ec16;
var $f6ad68fce9d4bb62$export$7b286972b8d8ccbf;
var $f6ad68fce9d4bb62$export$83d89fbfd8236492;

var $98Fbt = parcelRequire("98Fbt");
"use strict";
var $f6ad68fce9d4bb62$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f6ad68fce9d4bb62$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f6ad68fce9d4bb62$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f6ad68fce9d4bb62$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f6ad68fce9d4bb62$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f6ad68fce9d4bb62$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f6ad68fce9d4bb62$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f6ad68fce9d4bb62$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f6ad68fce9d4bb62$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f6ad68fce9d4bb62$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f6ad68fce9d4bb62$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $f6ad68fce9d4bb62$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $f6ad68fce9d4bb62$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f6ad68fce9d4bb62$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f6ad68fce9d4bb62$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f6ad68fce9d4bb62$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f6ad68fce9d4bb62$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $f6ad68fce9d4bb62$var$assign = Object.assign, $f6ad68fce9d4bb62$var$emptyObject = {};
function $f6ad68fce9d4bb62$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $f6ad68fce9d4bb62$var$emptyObject;
    this.updater = updater || $f6ad68fce9d4bb62$var$ReactNoopUpdateQueue;
}
$f6ad68fce9d4bb62$var$Component.prototype.isReactComponent = {};
$f6ad68fce9d4bb62$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$f6ad68fce9d4bb62$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $f6ad68fce9d4bb62$var$ComponentDummy() {}
$f6ad68fce9d4bb62$var$ComponentDummy.prototype = $f6ad68fce9d4bb62$var$Component.prototype;
function $f6ad68fce9d4bb62$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $f6ad68fce9d4bb62$var$emptyObject;
    this.updater = updater || $f6ad68fce9d4bb62$var$ReactNoopUpdateQueue;
}
var $f6ad68fce9d4bb62$var$pureComponentPrototype = $f6ad68fce9d4bb62$var$PureComponent.prototype = new $f6ad68fce9d4bb62$var$ComponentDummy();
$f6ad68fce9d4bb62$var$pureComponentPrototype.constructor = $f6ad68fce9d4bb62$var$PureComponent;
$f6ad68fce9d4bb62$var$assign($f6ad68fce9d4bb62$var$pureComponentPrototype, $f6ad68fce9d4bb62$var$Component.prototype);
$f6ad68fce9d4bb62$var$pureComponentPrototype.isPureReactComponent = !0;
var $f6ad68fce9d4bb62$var$isArrayImpl = Array.isArray;
function $f6ad68fce9d4bb62$var$noop() {}
var $f6ad68fce9d4bb62$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $f6ad68fce9d4bb62$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f6ad68fce9d4bb62$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $f6ad68fce9d4bb62$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $f6ad68fce9d4bb62$var$cloneAndReplaceKey(oldElement, newKey) {
    return $f6ad68fce9d4bb62$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $f6ad68fce9d4bb62$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $f6ad68fce9d4bb62$var$REACT_ELEMENT_TYPE;
}
function $f6ad68fce9d4bb62$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $f6ad68fce9d4bb62$var$userProvidedKeyEscapeRegex = /\/+/g;
function $f6ad68fce9d4bb62$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $f6ad68fce9d4bb62$var$escape("" + element.key) : index.toString(36);
}
function $f6ad68fce9d4bb62$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($f6ad68fce9d4bb62$var$noop, $f6ad68fce9d4bb62$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $f6ad68fce9d4bb62$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $f6ad68fce9d4bb62$var$REACT_ELEMENT_TYPE:
                case $f6ad68fce9d4bb62$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $f6ad68fce9d4bb62$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $f6ad68fce9d4bb62$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $f6ad68fce9d4bb62$var$getElementKey(children, 0) : nameSoFar, $f6ad68fce9d4bb62$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($f6ad68fce9d4bb62$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $f6ad68fce9d4bb62$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($f6ad68fce9d4bb62$var$isValidElement(callback) && (callback = $f6ad68fce9d4bb62$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($f6ad68fce9d4bb62$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($f6ad68fce9d4bb62$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $f6ad68fce9d4bb62$var$getElementKey(nameSoFar, i), invokeCallback += $f6ad68fce9d4bb62$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $f6ad68fce9d4bb62$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $f6ad68fce9d4bb62$var$getElementKey(nameSoFar, i++), invokeCallback += $f6ad68fce9d4bb62$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $f6ad68fce9d4bb62$var$mapIntoArray($f6ad68fce9d4bb62$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $f6ad68fce9d4bb62$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $f6ad68fce9d4bb62$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $f6ad68fce9d4bb62$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $f6ad68fce9d4bb62$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $98Fbt && "function" === typeof $98Fbt.emit) {
        $98Fbt.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $f6ad68fce9d4bb62$var$Children = {
    map: $f6ad68fce9d4bb62$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $f6ad68fce9d4bb62$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $f6ad68fce9d4bb62$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $f6ad68fce9d4bb62$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$f6ad68fce9d4bb62$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$f6ad68fce9d4bb62$export$9c16c1426311996d = $f6ad68fce9d4bb62$var$REACT_ACTIVITY_TYPE;
$f6ad68fce9d4bb62$export$dca3b0875bd9a954 = $f6ad68fce9d4bb62$var$Children;
$f6ad68fce9d4bb62$export$16fa2f45be04daa8 = $f6ad68fce9d4bb62$var$Component;
$f6ad68fce9d4bb62$export$ffb0004e005737fa = $f6ad68fce9d4bb62$var$REACT_FRAGMENT_TYPE;
$f6ad68fce9d4bb62$export$e2c29f18771995cb = $f6ad68fce9d4bb62$var$REACT_PROFILER_TYPE;
$f6ad68fce9d4bb62$export$221d75b3f55bb0bd = $f6ad68fce9d4bb62$var$PureComponent;
$f6ad68fce9d4bb62$export$5f8d39834fd61797 = $f6ad68fce9d4bb62$var$REACT_STRICT_MODE_TYPE;
$f6ad68fce9d4bb62$export$74bf444e3cd11ea5 = $f6ad68fce9d4bb62$var$REACT_SUSPENSE_TYPE;
$f6ad68fce9d4bb62$export$1ced07cd6b1985ce = $f6ad68fce9d4bb62$var$ReactSharedInternals;
$f6ad68fce9d4bb62$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$f6ad68fce9d4bb62$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$f6ad68fce9d4bb62$export$8c538325882c7eec = function() {
    return null;
};
$f6ad68fce9d4bb62$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $f6ad68fce9d4bb62$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$f6ad68fce9d4bb62$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $f6ad68fce9d4bb62$var$ReactElement(element.type, key, props);
};
$f6ad68fce9d4bb62$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $f6ad68fce9d4bb62$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $f6ad68fce9d4bb62$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$f6ad68fce9d4bb62$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$f6ad68fce9d4bb62$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $f6ad68fce9d4bb62$var$ReactElement(type, key, props);
};
$f6ad68fce9d4bb62$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$f6ad68fce9d4bb62$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $f6ad68fce9d4bb62$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$f6ad68fce9d4bb62$export$a8257692ac88316c = $f6ad68fce9d4bb62$var$isValidElement;
$f6ad68fce9d4bb62$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $f6ad68fce9d4bb62$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $f6ad68fce9d4bb62$var$lazyInitializer
    };
};
$f6ad68fce9d4bb62$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $f6ad68fce9d4bb62$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$f6ad68fce9d4bb62$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $f6ad68fce9d4bb62$var$ReactSharedInternals.T, currentTransition = {};
    $f6ad68fce9d4bb62$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $f6ad68fce9d4bb62$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($f6ad68fce9d4bb62$var$noop, $f6ad68fce9d4bb62$var$reportGlobalError);
    } catch (error) {
        $f6ad68fce9d4bb62$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f6ad68fce9d4bb62$var$ReactSharedInternals.T = prevTransition;
    }
};
$f6ad68fce9d4bb62$export$f93f40ac0ca7e3a8 = function() {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useCacheRefresh();
};
$f6ad68fce9d4bb62$export$1f96ae73734a86cc = function(usable) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.use(usable);
};
$f6ad68fce9d4bb62$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$f6ad68fce9d4bb62$export$35808ee640e87ca7 = function(callback, deps) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$f6ad68fce9d4bb62$export$fae74005e78b1a27 = function(Context) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useContext(Context);
};
$f6ad68fce9d4bb62$export$dc8fbce3eb94dc1e = function() {};
$f6ad68fce9d4bb62$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$f6ad68fce9d4bb62$export$6d9c69b0de29b591 = function(create, deps) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useEffect(create, deps);
};
$f6ad68fce9d4bb62$export$7f54fc3180508a52 = function(callback) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$f6ad68fce9d4bb62$export$f680877a34711e37 = function() {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useId();
};
$f6ad68fce9d4bb62$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$f6ad68fce9d4bb62$export$aaabe4eda9ed9969 = function(create, deps) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$f6ad68fce9d4bb62$export$e5c5a5f917a5871c = function(create, deps) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$f6ad68fce9d4bb62$export$1538c33de8887b59 = function(create, deps) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useMemo(create, deps);
};
$f6ad68fce9d4bb62$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$f6ad68fce9d4bb62$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$f6ad68fce9d4bb62$export$b8f5890fc79d6aca = function(initialValue) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useRef(initialValue);
};
$f6ad68fce9d4bb62$export$60241385465d0a34 = function(initialState) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useState(initialState);
};
$f6ad68fce9d4bb62$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$f6ad68fce9d4bb62$export$7b286972b8d8ccbf = function() {
    return $f6ad68fce9d4bb62$var$ReactSharedInternals.H.useTransition();
};
$f6ad68fce9d4bb62$export$83d89fbfd8236492 = "19.2.1";

});


parcelRegister("bge4W", function(module, exports) {
"use strict";
function $832c1c102a016039$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($832c1c102a016039$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$832c1c102a016039$var$checkDCE();

module.exports = (parcelRequire("atQrU"));

});
parcelRegister("atQrU", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $7a154c1fb01568ba$export$69ce8ef3fe5cead0; }, function (v) { return $7a154c1fb01568ba$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $7a154c1fb01568ba$export$d39a5bbd09211389; }, function (v) { return $7a154c1fb01568ba$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $7a154c1fb01568ba$export$cd75ccfd720a3cd4; }, function (v) { return $7a154c1fb01568ba$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $7a154c1fb01568ba$export$a0816fa17a9e79be; }, function (v) { return $7a154c1fb01568ba$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $7a154c1fb01568ba$export$7292efcadded39f3; }, function (v) { return $7a154c1fb01568ba$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $7a154c1fb01568ba$export$da407abadb9b8f86; }, function (v) { return $7a154c1fb01568ba$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $7a154c1fb01568ba$export$314cfea32580671c; }, function (v) { return $7a154c1fb01568ba$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $7a154c1fb01568ba$export$513ccb98c53b8039; }, function (v) { return $7a154c1fb01568ba$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $7a154c1fb01568ba$export$dbca993bc2d264a; }, function (v) { return $7a154c1fb01568ba$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $7a154c1fb01568ba$export$4797a8006f0655d0; }, function (v) { return $7a154c1fb01568ba$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $7a154c1fb01568ba$export$c78a37762a8d58e1; }, function (v) { return $7a154c1fb01568ba$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $7a154c1fb01568ba$export$606f11b2eb45ecc6; }, function (v) { return $7a154c1fb01568ba$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $7a154c1fb01568ba$export$f7e8a0bf92324b1e; }, function (v) { return $7a154c1fb01568ba$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $7a154c1fb01568ba$export$83d89fbfd8236492; }, function (v) { return $7a154c1fb01568ba$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7a154c1fb01568ba$export$69ce8ef3fe5cead0;
var $7a154c1fb01568ba$export$d39a5bbd09211389;
var $7a154c1fb01568ba$export$cd75ccfd720a3cd4;
var $7a154c1fb01568ba$export$a0816fa17a9e79be;
var $7a154c1fb01568ba$export$7292efcadded39f3;
var $7a154c1fb01568ba$export$da407abadb9b8f86;
var $7a154c1fb01568ba$export$314cfea32580671c;
var $7a154c1fb01568ba$export$513ccb98c53b8039;
var $7a154c1fb01568ba$export$dbca993bc2d264a;
var $7a154c1fb01568ba$export$4797a8006f0655d0;
var $7a154c1fb01568ba$export$c78a37762a8d58e1;
var $7a154c1fb01568ba$export$606f11b2eb45ecc6;
var $7a154c1fb01568ba$export$f7e8a0bf92324b1e;
var $7a154c1fb01568ba$export$83d89fbfd8236492;
"use strict";

var $eyAY5 = parcelRequire("eyAY5");
function $7a154c1fb01568ba$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $7a154c1fb01568ba$var$noop() {}
var $7a154c1fb01568ba$var$Internals = {
    d: {
        f: $7a154c1fb01568ba$var$noop,
        r: function() {
            throw Error($7a154c1fb01568ba$var$formatProdErrorMessage(522));
        },
        D: $7a154c1fb01568ba$var$noop,
        C: $7a154c1fb01568ba$var$noop,
        L: $7a154c1fb01568ba$var$noop,
        m: $7a154c1fb01568ba$var$noop,
        X: $7a154c1fb01568ba$var$noop,
        S: $7a154c1fb01568ba$var$noop,
        M: $7a154c1fb01568ba$var$noop
    },
    p: 0,
    findDOMNode: null
}, $7a154c1fb01568ba$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $7a154c1fb01568ba$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $7a154c1fb01568ba$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $7a154c1fb01568ba$var$ReactSharedInternals = $eyAY5.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $7a154c1fb01568ba$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$7a154c1fb01568ba$export$69ce8ef3fe5cead0 = $7a154c1fb01568ba$var$Internals;
$7a154c1fb01568ba$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($7a154c1fb01568ba$var$formatProdErrorMessage(299));
    return $7a154c1fb01568ba$var$createPortal$1(children, container, null, key);
};
$7a154c1fb01568ba$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $7a154c1fb01568ba$var$ReactSharedInternals.T, previousUpdatePriority = $7a154c1fb01568ba$var$Internals.p;
    try {
        if ($7a154c1fb01568ba$var$ReactSharedInternals.T = null, $7a154c1fb01568ba$var$Internals.p = 2, fn) return fn();
    } finally{
        $7a154c1fb01568ba$var$ReactSharedInternals.T = previousTransition, $7a154c1fb01568ba$var$Internals.p = previousUpdatePriority, $7a154c1fb01568ba$var$Internals.d.f();
    }
};
$7a154c1fb01568ba$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $7a154c1fb01568ba$var$Internals.d.C(href, options));
};
$7a154c1fb01568ba$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $7a154c1fb01568ba$var$Internals.d.D(href);
};
$7a154c1fb01568ba$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $7a154c1fb01568ba$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $7a154c1fb01568ba$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $7a154c1fb01568ba$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$7a154c1fb01568ba$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $7a154c1fb01568ba$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $7a154c1fb01568ba$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $7a154c1fb01568ba$var$Internals.d.M(href);
    }
};
$7a154c1fb01568ba$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $7a154c1fb01568ba$var$getCrossOriginStringAs(as, options.crossOrigin);
        $7a154c1fb01568ba$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$7a154c1fb01568ba$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $7a154c1fb01568ba$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $7a154c1fb01568ba$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $7a154c1fb01568ba$var$Internals.d.m(href);
    }
};
$7a154c1fb01568ba$export$4797a8006f0655d0 = function(form) {
    $7a154c1fb01568ba$var$Internals.d.r(form);
};
$7a154c1fb01568ba$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$7a154c1fb01568ba$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $7a154c1fb01568ba$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$7a154c1fb01568ba$export$f7e8a0bf92324b1e = function() {
    return $7a154c1fb01568ba$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$7a154c1fb01568ba$export$83d89fbfd8236492 = "19.2.1";

});



parcelRegister("58OAM", function(module, exports) {

$parcel$export(module.exports, "ColorModeContext", function () { return $18cb66d1e7a58135$export$49ddd74a6729fdb0; });
$parcel$export(module.exports, "default", function () { return $18cb66d1e7a58135$export$2e2bcd8739ae039; });

var $Dkugg = parcelRequire("Dkugg");

var $eyAY5 = parcelRequire("eyAY5");


var $cbpgf = parcelRequire("cbpgf");

var $4hstI = parcelRequire("4hstI");
var $7dn22 = parcelRequire("7dn22");

var $lONbt = parcelRequire("lONbt");

var $6ljNb = parcelRequire("6ljNb");

var $bg4h8 = parcelRequire("bg4h8");

var $jM5Le = parcelRequire("jM5Le");

var $lONbt = parcelRequire("lONbt");

var $023Mx = parcelRequire("023Mx");

var $domgl = parcelRequire("domgl");

var $7N6qs = parcelRequire("7N6qs");

const $18cb66d1e7a58135$var$BasicInformation = /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("edX0V")));

const $18cb66d1e7a58135$var$Navbar = /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("hLnD1")));

const $18cb66d1e7a58135$var$CssBaseline = /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("cQI3P")));

const $18cb66d1e7a58135$var$Box = /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("iSo3z")));

const $18cb66d1e7a58135$var$GlobalStyles = /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("43mnz")));
const $18cb66d1e7a58135$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $eyAY5.createContext)({
    toggleColorMode: ()=>{}
});
function $18cb66d1e7a58135$var$App() {
    const [mode, setMode] = (0, $eyAY5.useState)((0, $bg4h8.default)("(prefers-color-scheme: dark)") ? "dark" : "light");
    const isMobile = (0, $023Mx.useIsMobile)();
    const theme = (0, $eyAY5.useMemo)(()=>(0, $4hstI.default)({
            //...baseTheme,
            palette: {
                mode: mode
            }
        }), [
        mode
    ]);
    const layoutBreak = (0, $bg4h8.default)("(max-width: 1529px)");
    const isDarkTheme = (0, $023Mx.useIsDarkTheme)(theme);
    const globalStyle = (0, $eyAY5.useMemo)(()=>({
            "::-webkit-scrollbar": {
                width: "15px"
            },
            "::-webkit-scrollbar-track": {
                backgroundColor: "transparent"
            },
            "::-webkit-scrollbar-thumb": {
                backgroundColor: isDarkTheme ? (0, $lONbt.darken)(theme.palette.text.primary, 0.4) : (0, $lONbt.lighten)(theme.palette.text.primary, 0.4),
                borderRadius: "15px",
                border: "4px solid transparent",
                backgroundClip: "content-box"
            },
            "::-webkit-scrollbar-thumb:hover": {
                backgroundColor: isDarkTheme ? (0, $lONbt.darken)(theme.palette.text.primary, 0.2) : (0, $lONbt.lighten)(theme.palette.text.primary, 0.2)
            },
            body: {
                backgroundImage: `url(${isDarkTheme ? (0, (/*@__PURE__*/$parcel$interopDefault($7N6qs))) : (0, (/*@__PURE__*/$parcel$interopDefault($domgl)))})`
            }
        }), [
        theme.palette.text.primary,
        isDarkTheme
    ]);
    return /*#__PURE__*/ (0, $Dkugg.jsx)($18cb66d1e7a58135$export$49ddd74a6729fdb0.Provider, {
        value: {
            toggleColorMode: ()=>setMode((prevMode)=>prevMode === "light" ? "dark" : "light")
        },
        children: /*#__PURE__*/ (0, $Dkugg.jsxs)((0, $7dn22.default), {
            theme: theme,
            children: [
                /*#__PURE__*/ (0, $Dkugg.jsx)($18cb66d1e7a58135$var$GlobalStyles, {
                    styles: isMobile ? undefined : globalStyle
                }),
                /*#__PURE__*/ (0, $Dkugg.jsx)((0, $cbpgf.BrowserRouter), {
                    children: /*#__PURE__*/ (0, $Dkugg.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            height: "100vh",
                            width: "100vw"
                        },
                        children: [
                            /*#__PURE__*/ (0, $Dkugg.jsx)($18cb66d1e7a58135$var$CssBaseline, {}),
                            /*#__PURE__*/ (0, $Dkugg.jsx)($18cb66d1e7a58135$var$Navbar, {}),
                            /*#__PURE__*/ (0, $Dkugg.jsxs)("div", {
                                style: {
                                    height: "100%",
                                    display: "flex",
                                    flexWrap: "wrap",
                                    overflow: "auto",
                                    flexDirection: "row-reverse"
                                },
                                id: "main-content",
                                children: [
                                    layoutBreak ? null : /*#__PURE__*/ (0, $Dkugg.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $Dkugg.jsx)("div", {
                                        style: {
                                            justifySelf: "center",
                                            padding: 0,
                                            display: "flex",
                                            flexDirection: layoutBreak ? "row" : "column",
                                            flexGrow: 1,
                                            width: layoutBreak ? undefined : "60vw"
                                        },
                                        children: /*#__PURE__*/ (0, $Dkugg.jsx)((0, $cbpgf.Routes), {
                                            children: Object.values((0, $jM5Le.pages)).map(({ path: path, Element: Element, title: title })=>/*#__PURE__*/ (0, $Dkugg.jsx)((0, $cbpgf.Route), {
                                                    path: path,
                                                    element: /*#__PURE__*/ (0, $Dkugg.jsx)((0, $eyAY5.Suspense), {
                                                        fallback: /*#__PURE__*/ (0, $Dkugg.jsx)("div", {
                                                            style: {
                                                                flexGrow: 1,
                                                                padding: "auto",
                                                                alignSelf: "center",
                                                                display: "flex",
                                                                top: "50%",
                                                                position: "absolute"
                                                            },
                                                            children: /*#__PURE__*/ (0, $Dkugg.jsx)((0, $6ljNb.default), {})
                                                        }),
                                                        children: /*#__PURE__*/ (0, $Dkugg.jsx)(Element, {})
                                                    })
                                                }, title))
                                        })
                                    }),
                                    layoutBreak ? null : /*#__PURE__*/ (0, $Dkugg.jsx)("div", {
                                        style: {
                                            flexGrow: 1
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $Dkugg.jsx)($18cb66d1e7a58135$var$Box, {
                                        sx: layoutBreak ? {
                                            margin: "auto"
                                        } : {
                                            pt: 24,
                                            width: 400,
                                            marginLeft: 0,
                                            left: 0
                                        },
                                        children: /*#__PURE__*/ (0, $Dkugg.jsx)($18cb66d1e7a58135$var$BasicInformation, {
                                            compact: layoutBreak
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $18cb66d1e7a58135$export$2e2bcd8739ae039 = $18cb66d1e7a58135$var$App;

});
parcelRegister("cbpgf", function(module, exports) {

$parcel$export(module.exports, "useLocation", function () { return $4d274c27f30533ed$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $4d274c27f30533ed$export$9770f232ac06a008; });
$parcel$export(module.exports, "Route", function () { return $4d274c27f30533ed$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $4d274c27f30533ed$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "BrowserRouter", function () { return $4d274c27f30533ed$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $4d274c27f30533ed$export$a6c7ac8248d6e38a; });
/**
 * react-router v7.10.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eyAY5 = parcelRequire("eyAY5");
var $4d274c27f30533ed$import_meta = Object.assign(Object.create(null), {
    url: "file:///.yarn/__virtual__/react-router-virtual-8f0c7899e9/0/cache/react-router-npm-7.10.1-fda1361f9c-0de854fe2d.zip/node_modules/react-router/dist/development/chunk-WWGJGFF6.mjs"
});
var $4d274c27f30533ed$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $4d274c27f30533ed$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $4d274c27f30533ed$var$__typeError("Cannot " + msg);
var $4d274c27f30533ed$var$__privateGet = (obj, member, getter)=>($4d274c27f30533ed$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $4d274c27f30533ed$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $4d274c27f30533ed$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $4d274c27f30533ed$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($4d274c27f30533ed$export$e19cd5f9376f8cee || {});
var $4d274c27f30533ed$var$PopStateEventType = "popstate";
function $4d274c27f30533ed$var$createMemoryHistory(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $4d274c27f30533ed$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $4d274c27f30533ed$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $4d274c27f30533ed$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $4d274c27f30533ed$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $4d274c27f30533ed$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $4d274c27f30533ed$export$fe53371bee54353d(to);
    }
    return $4d274c27f30533ed$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $4d274c27f30533ed$var$createHashHistory(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $4d274c27f30533ed$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $4d274c27f30533ed$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $4d274c27f30533ed$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $4d274c27f30533ed$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $4d274c27f30533ed$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $4d274c27f30533ed$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $4d274c27f30533ed$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $4d274c27f30533ed$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $4d274c27f30533ed$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $4d274c27f30533ed$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $4d274c27f30533ed$var$createKey()
    };
    return location;
}
function $4d274c27f30533ed$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $4d274c27f30533ed$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $4d274c27f30533ed$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $4d274c27f30533ed$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $4d274c27f30533ed$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $4d274c27f30533ed$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $4d274c27f30533ed$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $4d274c27f30533ed$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($4d274c27f30533ed$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($4d274c27f30533ed$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $4d274c27f30533ed$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $4d274c27f30533ed$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $4d274c27f30533ed$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $4d274c27f30533ed$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $4d274c27f30533ed$var$_map;
var $4d274c27f30533ed$export$b8d3e69d4b3eff04 = class {
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($4d274c27f30533ed$var$__privateGet(this, $4d274c27f30533ed$var$_map).has(context)) return $4d274c27f30533ed$var$__privateGet(this, $4d274c27f30533ed$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $4d274c27f30533ed$var$__privateGet(this, $4d274c27f30533ed$var$_map).set(context, value);
    }
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $4d274c27f30533ed$var$__privateAdd(this, $4d274c27f30533ed$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
};
$4d274c27f30533ed$var$_map = new WeakMap();
var $4d274c27f30533ed$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $4d274c27f30533ed$var$isUnsupportedLazyRouteObjectKey(key) {
    return $4d274c27f30533ed$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $4d274c27f30533ed$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $4d274c27f30533ed$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $4d274c27f30533ed$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $4d274c27f30533ed$var$isIndexRoute(route) {
    return route.index === true;
}
function $4d274c27f30533ed$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $4d274c27f30533ed$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $4d274c27f30533ed$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($4d274c27f30533ed$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $4d274c27f30533ed$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $4d274c27f30533ed$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $4d274c27f30533ed$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $4d274c27f30533ed$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $4d274c27f30533ed$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $4d274c27f30533ed$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $4d274c27f30533ed$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $4d274c27f30533ed$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $4d274c27f30533ed$var$flattenRoutes(routes);
    $4d274c27f30533ed$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $4d274c27f30533ed$var$decodePath(pathname);
        matches = $4d274c27f30533ed$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $4d274c27f30533ed$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $4d274c27f30533ed$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $4d274c27f30533ed$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $4d274c27f30533ed$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $4d274c27f30533ed$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $4d274c27f30533ed$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $4d274c27f30533ed$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route_path;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $4d274c27f30533ed$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $4d274c27f30533ed$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $4d274c27f30533ed$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $4d274c27f30533ed$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $4d274c27f30533ed$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $4d274c27f30533ed$var$paramRe = /^:[\w-]+$/;
var $4d274c27f30533ed$var$dynamicSegmentValue = 3;
var $4d274c27f30533ed$var$indexRouteValue = 2;
var $4d274c27f30533ed$var$emptySegmentValue = 1;
var $4d274c27f30533ed$var$staticSegmentValue = 10;
var $4d274c27f30533ed$var$splatPenalty = -2;
var $4d274c27f30533ed$var$isSplat = (s)=>s === "*";
function $4d274c27f30533ed$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($4d274c27f30533ed$var$isSplat)) initialScore += $4d274c27f30533ed$var$splatPenalty;
    if (index) initialScore += $4d274c27f30533ed$var$indexRouteValue;
    return segments.filter((s)=>!$4d274c27f30533ed$var$isSplat(s)).reduce((score, segment)=>score + ($4d274c27f30533ed$var$paramRe.test(segment) ? $4d274c27f30533ed$var$dynamicSegmentValue : segment === "" ? $4d274c27f30533ed$var$emptySegmentValue : $4d274c27f30533ed$var$staticSegmentValue), initialScore);
}
function $4d274c27f30533ed$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $4d274c27f30533ed$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $4d274c27f30533ed$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $4d274c27f30533ed$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $4d274c27f30533ed$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $4d274c27f30533ed$var$normalizePathname($4d274c27f30533ed$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $4d274c27f30533ed$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $4d274c27f30533ed$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $4d274c27f30533ed$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $4d274c27f30533ed$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param));
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $4d274c27f30533ed$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $4d274c27f30533ed$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $4d274c27f30533ed$var$compilePath(path, caseSensitive = false, end = true) {
    $4d274c27f30533ed$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $4d274c27f30533ed$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $4d274c27f30533ed$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $4d274c27f30533ed$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $4d274c27f30533ed$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $4d274c27f30533ed$var$joinPaths([
        basename,
        pathname
    ]);
}
var $4d274c27f30533ed$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $4d274c27f30533ed$var$isAbsoluteUrl = (url)=>$4d274c27f30533ed$var$ABSOLUTE_URL_REGEX.test(url);
function $4d274c27f30533ed$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($4d274c27f30533ed$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $4d274c27f30533ed$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $4d274c27f30533ed$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $4d274c27f30533ed$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $4d274c27f30533ed$var$normalizeSearch(search),
        hash: $4d274c27f30533ed$var$normalizeHash(hash)
    };
}
function $4d274c27f30533ed$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $4d274c27f30533ed$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $4d274c27f30533ed$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $4d274c27f30533ed$var$getResolveToMatches(matches) {
    let pathMatches = $4d274c27f30533ed$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $4d274c27f30533ed$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $4d274c27f30533ed$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $4d274c27f30533ed$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $4d274c27f30533ed$var$getInvalidPathError("?", "pathname", "search", to));
        $4d274c27f30533ed$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $4d274c27f30533ed$var$getInvalidPathError("#", "pathname", "hash", to));
        $4d274c27f30533ed$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $4d274c27f30533ed$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $4d274c27f30533ed$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $4d274c27f30533ed$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $4d274c27f30533ed$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $4d274c27f30533ed$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $4d274c27f30533ed$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $4d274c27f30533ed$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $4d274c27f30533ed$export$4051a07651545597(data2, init) {
    return new $4d274c27f30533ed$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $4d274c27f30533ed$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $4d274c27f30533ed$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $4d274c27f30533ed$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $4d274c27f30533ed$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $4d274c27f30533ed$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $4d274c27f30533ed$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $4d274c27f30533ed$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $4d274c27f30533ed$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
// lib/router/instrumentation.ts
var $4d274c27f30533ed$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $4d274c27f30533ed$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $4d274c27f30533ed$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $4d274c27f30533ed$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            var _handler_UninstrumentedSymbol;
            let original = (_handler_UninstrumentedSymbol = handler[$4d274c27f30533ed$var$UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
            let instrumented = $4d274c27f30533ed$var$wrapImpl(aggregated[key], original, (...args)=>$4d274c27f30533ed$var$getHandlerInfo(args[0]));
            if (instrumented) {
                instrumented[$4d274c27f30533ed$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        var _middleware_UninstrumentedSymbol;
        let original = (_middleware_UninstrumentedSymbol = middleware[$4d274c27f30533ed$var$UninstrumentedSymbol]) !== null && _middleware_UninstrumentedSymbol !== void 0 ? _middleware_UninstrumentedSymbol : middleware;
        let instrumented = $4d274c27f30533ed$var$wrapImpl(aggregated.middleware, original, (...args)=>$4d274c27f30533ed$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$4d274c27f30533ed$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $4d274c27f30533ed$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        var _router_navigate_UninstrumentedSymbol;
        let navigate = (_router_navigate_UninstrumentedSymbol = router.navigate[$4d274c27f30533ed$var$UninstrumentedSymbol]) !== null && _router_navigate_UninstrumentedSymbol !== void 0 ? _router_navigate_UninstrumentedSymbol : router.navigate;
        let instrumentedNavigate = $4d274c27f30533ed$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $4d274c27f30533ed$export$fe53371bee54353d(to) : ".",
                ...$4d274c27f30533ed$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$4d274c27f30533ed$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        var _router_fetch_UninstrumentedSymbol;
        let fetch2 = (_router_fetch_UninstrumentedSymbol = router.fetch[$4d274c27f30533ed$var$UninstrumentedSymbol]) !== null && _router_fetch_UninstrumentedSymbol !== void 0 ? _router_fetch_UninstrumentedSymbol : router.fetch;
        let instrumentedFetch = $4d274c27f30533ed$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href !== null && href !== void 0 ? href : ".",
                fetcherKey: key,
                ...$4d274c27f30533ed$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$4d274c27f30533ed$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $4d274c27f30533ed$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $4d274c27f30533ed$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $4d274c27f30533ed$var$getReadonlyRequest(request),
            context: context != null ? $4d274c27f30533ed$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $4d274c27f30533ed$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $4d274c27f30533ed$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $4d274c27f30533ed$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $4d274c27f30533ed$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $4d274c27f30533ed$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $4d274c27f30533ed$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $4d274c27f30533ed$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $4d274c27f30533ed$var$getReadonlyContext(context)
    };
}
function $4d274c27f30533ed$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $4d274c27f30533ed$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $4d274c27f30533ed$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $4d274c27f30533ed$var$getReadonlyContext(context) {
    if ($4d274c27f30533ed$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $4d274c27f30533ed$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $4d274c27f30533ed$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $4d274c27f30533ed$var$objectProtoNames;
}
// lib/router/router.ts
var $4d274c27f30533ed$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $4d274c27f30533ed$var$validMutationMethods = new Set($4d274c27f30533ed$var$validMutationMethodsArr);
var $4d274c27f30533ed$var$validRequestMethodsArr = [
    "GET",
    ...$4d274c27f30533ed$var$validMutationMethodsArr
];
var $4d274c27f30533ed$var$validRequestMethods = new Set($4d274c27f30533ed$var$validRequestMethodsArr);
var $4d274c27f30533ed$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $4d274c27f30533ed$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $4d274c27f30533ed$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $4d274c27f30533ed$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $4d274c27f30533ed$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $4d274c27f30533ed$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $4d274c27f30533ed$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $4d274c27f30533ed$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $4d274c27f30533ed$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser2 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $4d274c27f30533ed$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $4d274c27f30533ed$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$4d274c27f30533ed$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $4d274c27f30533ed$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $4d274c27f30533ed$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $4d274c27f30533ed$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $4d274c27f30533ed$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $4d274c27f30533ed$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$4d274c27f30533ed$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$4d274c27f30533ed$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$4d274c27f30533ed$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $4d274c27f30533ed$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $4d274c27f30533ed$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $4d274c27f30533ed$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser2) {
            $4d274c27f30533ed$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$4d274c27f30533ed$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>{
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        var _location_state, _location_state1;
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $4d274c27f30533ed$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $4d274c27f30533ed$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $4d274c27f30533ed$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $4d274c27f30533ed$export$cbae47800eb95bc3(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $4d274c27f30533ed$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $4d274c27f30533ed$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $4d274c27f30533ed$var$normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $4d274c27f30533ed$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $4d274c27f30533ed$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $4d274c27f30533ed$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $4d274c27f30533ed$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $4d274c27f30533ed$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $4d274c27f30533ed$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $4d274c27f30533ed$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $4d274c27f30533ed$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $4d274c27f30533ed$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $4d274c27f30533ed$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $4d274c27f30533ed$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $4d274c27f30533ed$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($4d274c27f30533ed$var$isErrorResult(result) && $4d274c27f30533ed$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $4d274c27f30533ed$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $4d274c27f30533ed$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$4d274c27f30533ed$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $4d274c27f30533ed$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $4d274c27f30533ed$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $4d274c27f30533ed$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $4d274c27f30533ed$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $4d274c27f30533ed$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($4d274c27f30533ed$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $4d274c27f30533ed$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($4d274c27f30533ed$var$isErrorResult(result)) {
            let boundaryMatch = $4d274c27f30533ed$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult) {
        let loadingNavigation = overrideNavigation || $4d274c27f30533ed$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $4d274c27f30533ed$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $4d274c27f30533ed$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $4d274c27f30533ed$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $4d274c27f30533ed$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$4d274c27f30533ed$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $4d274c27f30533ed$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $4d274c27f30533ed$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $4d274c27f30533ed$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$4d274c27f30533ed$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $4d274c27f30533ed$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $4d274c27f30533ed$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
        let matches = $4d274c27f30533ed$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $4d274c27f30533ed$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $4d274c27f30533ed$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $4d274c27f30533ed$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $4d274c27f30533ed$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $4d274c27f30533ed$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $4d274c27f30533ed$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $4d274c27f30533ed$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $4d274c27f30533ed$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $4d274c27f30533ed$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($4d274c27f30533ed$var$isRedirectResult(actionResult) || $4d274c27f30533ed$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $4d274c27f30533ed$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($4d274c27f30533ed$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $4d274c27f30533ed$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $4d274c27f30533ed$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($4d274c27f30533ed$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $4d274c27f30533ed$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $4d274c27f30533ed$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $4d274c27f30533ed$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $4d274c27f30533ed$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $4d274c27f30533ed$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ]);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $4d274c27f30533ed$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $4d274c27f30533ed$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $4d274c27f30533ed$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $4d274c27f30533ed$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $4d274c27f30533ed$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $4d274c27f30533ed$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $4d274c27f30533ed$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $4d274c27f30533ed$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $4d274c27f30533ed$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $4d274c27f30533ed$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $4d274c27f30533ed$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $4d274c27f30533ed$var$getDoneFetcher(void 0));
            return;
        }
        if ($4d274c27f30533ed$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $4d274c27f30533ed$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($4d274c27f30533ed$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $4d274c27f30533ed$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $4d274c27f30533ed$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $4d274c27f30533ed$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $4d274c27f30533ed$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser2) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($4d274c27f30533ed$var$isAbsoluteUrl(location)) {
                const url = $4d274c27f30533ed$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $4d274c27f30533ed$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $4d274c27f30533ed$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($4d274c27f30533ed$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $4d274c27f30533ed$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $4d274c27f30533ed$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $4d274c27f30533ed$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        for (let [routeId, result] of Object.entries(results))if ($4d274c27f30533ed$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $4d274c27f30533ed$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $4d274c27f30533ed$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $4d274c27f30533ed$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $4d274c27f30533ed$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $4d274c27f30533ed$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, $4d274c27f30533ed$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $4d274c27f30533ed$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $4d274c27f30533ed$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $4d274c27f30533ed$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $4d274c27f30533ed$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $4d274c27f30533ed$export$386d57f03f0b2883;
        $4d274c27f30533ed$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $4d274c27f30533ed$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $4d274c27f30533ed$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $4d274c27f30533ed$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $4d274c27f30533ed$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$4d274c27f30533ed$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $4d274c27f30533ed$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $4d274c27f30533ed$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $4d274c27f30533ed$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $4d274c27f30533ed$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $4d274c27f30533ed$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $4d274c27f30533ed$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $4d274c27f30533ed$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $4d274c27f30533ed$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $4d274c27f30533ed$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $4d274c27f30533ed$export$3336b097a6fbc59a(routes, opts) {
    $4d274c27f30533ed$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = (opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties) || $4d274c27f30533ed$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$4d274c27f30533ed$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $4d274c27f30533ed$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $4d274c27f30533ed$var$createLocation("", $4d274c27f30533ed$export$fe53371bee54353d(url), null, "default");
        let matches = $4d274c27f30533ed$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $4d274c27f30533ed$export$b8d3e69d4b3eff04();
        if (!$4d274c27f30533ed$var$isValidMethod(method) && method !== "HEAD") {
            let error = $4d274c27f30533ed$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $4d274c27f30533ed$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $4d274c27f30533ed$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $4d274c27f30533ed$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $4d274c27f30533ed$export$f5708dca728d7177(requestContext instanceof $4d274c27f30533ed$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $4d274c27f30533ed$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $4d274c27f30533ed$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $4d274c27f30533ed$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        var _opts2_filterMatchesToLoad;
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? (_opts2_filterMatchesToLoad = opts2.filterMatchesToLoad) !== null && _opts2_filterMatchesToLoad !== void 0 ? _opts2_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true);
                        if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($4d274c27f30533ed$export$6e80290866a84dd4(error)) return error;
                    if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $4d274c27f30533ed$export$f2680fa305b734ca(error.status, error.statusText, await $4d274c27f30533ed$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($4d274c27f30533ed$export$e0163cfdf7bc9cfa(error)) error = $4d274c27f30533ed$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $4d274c27f30533ed$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $4d274c27f30533ed$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        var _matches_find;
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $4d274c27f30533ed$var$findNearestBoundary(matches, ((_matches_find = matches.find((m)=>m.route.id === routeId || m.route.loader)) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $4d274c27f30533ed$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $4d274c27f30533ed$var$createLocation("", $4d274c27f30533ed$export$fe53371bee54353d(url), null, "default");
        let matches = $4d274c27f30533ed$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $4d274c27f30533ed$export$b8d3e69d4b3eff04();
        if (!$4d274c27f30533ed$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $4d274c27f30533ed$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $4d274c27f30533ed$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $4d274c27f30533ed$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $4d274c27f30533ed$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $4d274c27f30533ed$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $4d274c27f30533ed$export$f5708dca728d7177(requestContext instanceof $4d274c27f30533ed$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $4d274c27f30533ed$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $4d274c27f30533ed$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $4d274c27f30533ed$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $4d274c27f30533ed$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($4d274c27f30533ed$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($4d274c27f30533ed$var$dataWithResponseInitToResponse(error));
                if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $4d274c27f30533ed$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($4d274c27f30533ed$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $4d274c27f30533ed$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $4d274c27f30533ed$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($4d274c27f30533ed$var$isDataStrategyResult(e) && $4d274c27f30533ed$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($4d274c27f30533ed$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $4d274c27f30533ed$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $4d274c27f30533ed$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($4d274c27f30533ed$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($4d274c27f30533ed$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($4d274c27f30533ed$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $4d274c27f30533ed$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $4d274c27f30533ed$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($4d274c27f30533ed$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $4d274c27f30533ed$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $4d274c27f30533ed$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw $4d274c27f30533ed$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $4d274c27f30533ed$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $4d274c27f30533ed$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $4d274c27f30533ed$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $4d274c27f30533ed$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $4d274c27f30533ed$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $4d274c27f30533ed$var$callDataStrategyImpl(dataStrategy || $4d274c27f30533ed$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($4d274c27f30533ed$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $4d274c27f30533ed$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($4d274c27f30533ed$export$e0163cfdf7bc9cfa(result.result)) throw $4d274c27f30533ed$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $4d274c27f30533ed$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $4d274c27f30533ed$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $4d274c27f30533ed$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $4d274c27f30533ed$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $4d274c27f30533ed$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $4d274c27f30533ed$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $4d274c27f30533ed$var$resolveTo(to ? to : ".", $4d274c27f30533ed$var$getResolveToMatches(contextualMatches), $4d274c27f30533ed$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $4d274c27f30533ed$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $4d274c27f30533ed$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $4d274c27f30533ed$export$fe53371bee54353d(path);
}
function $4d274c27f30533ed$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$4d274c27f30533ed$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$4d274c27f30533ed$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $4d274c27f30533ed$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $4d274c27f30533ed$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $4d274c27f30533ed$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$4d274c27f30533ed$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$4d274c27f30533ed$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $4d274c27f30533ed$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $4d274c27f30533ed$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $4d274c27f30533ed$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $4d274c27f30533ed$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $4d274c27f30533ed$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($4d274c27f30533ed$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $4d274c27f30533ed$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $4d274c27f30533ed$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $4d274c27f30533ed$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $4d274c27f30533ed$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult) {
    var _state_matches_;
    let actionResult = pendingActionResult ? $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $4d274c27f30533ed$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$4d274c27f30533ed$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $4d274c27f30533ed$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($4d274c27f30533ed$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $4d274c27f30533ed$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
        isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
        currentUrl.search !== nextUrl.search || $4d274c27f30533ed$var$isNewRouteInstance(state.matches[index], match);
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $4d274c27f30533ed$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $4d274c27f30533ed$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $4d274c27f30533ed$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $4d274c27f30533ed$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $4d274c27f30533ed$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
            };
            if ($4d274c27f30533ed$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $4d274c27f30533ed$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $4d274c27f30533ed$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$4d274c27f30533ed$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $4d274c27f30533ed$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $4d274c27f30533ed$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $4d274c27f30533ed$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $4d274c27f30533ed$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $4d274c27f30533ed$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$4d274c27f30533ed$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $4d274c27f30533ed$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $4d274c27f30533ed$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $4d274c27f30533ed$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some((bChild)=>$4d274c27f30533ed$var$isSameRoute(aChild, bChild));
    });
}
var $4d274c27f30533ed$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $4d274c27f30533ed$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $4d274c27f30533ed$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $4d274c27f30533ed$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $4d274c27f30533ed$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $4d274c27f30533ed$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $4d274c27f30533ed$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $4d274c27f30533ed$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $4d274c27f30533ed$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $4d274c27f30533ed$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $4d274c27f30533ed$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $4d274c27f30533ed$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $4d274c27f30533ed$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $4d274c27f30533ed$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $4d274c27f30533ed$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $4d274c27f30533ed$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $4d274c27f30533ed$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $4d274c27f30533ed$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise === null || lazyRoutePromise === void 0 ? void 0 : lazyRoutePromise.catch(()=>{});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $4d274c27f30533ed$var$isNonNullable(value) {
    return value !== void 0;
}
function $4d274c27f30533ed$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $4d274c27f30533ed$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($4d274c27f30533ed$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $4d274c27f30533ed$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $4d274c27f30533ed$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $4d274c27f30533ed$var$defaultDataStrategy(args);
    return $4d274c27f30533ed$var$runClientMiddlewarePipeline(args, ()=>$4d274c27f30533ed$var$defaultDataStrategy(args));
}
function $4d274c27f30533ed$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $4d274c27f30533ed$var$runMiddlewarePipeline(args, handler, processResult, $4d274c27f30533ed$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $4d274c27f30533ed$export$e0163cfdf7bc9cfa(result) ? $4d274c27f30533ed$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $4d274c27f30533ed$var$runClientMiddlewarePipeline(args, handler) {
    return $4d274c27f30533ed$var$runMiddlewarePipeline(args, handler, (r)=>r, // No post-processing needed on the client
    $4d274c27f30533ed$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $4d274c27f30533ed$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $4d274c27f30533ed$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $4d274c27f30533ed$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $4d274c27f30533ed$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    var _request_signal_reason;
    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $4d274c27f30533ed$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result !== null && result !== void 0 ? result : nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $4d274c27f30533ed$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $4d274c27f30533ed$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $4d274c27f30533ed$var$loadLazyRoute(match.route, $4d274c27f30533ed$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $4d274c27f30533ed$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null) {
    let isUsingNewApi = false;
    let _lazyPromises = $4d274c27f30533ed$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof defaultShouldRevalidate === "boolean") return $4d274c27f30533ed$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $4d274c27f30533ed$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$4d274c27f30533ed$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($4d274c27f30533ed$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $4d274c27f30533ed$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $4d274c27f30533ed$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $4d274c27f30533ed$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $4d274c27f30533ed$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $4d274c27f30533ed$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $4d274c27f30533ed$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    })) await Promise.all(matches.map((m)=>{
        var _m__lazyPromises;
        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
    }));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $4d274c27f30533ed$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $4d274c27f30533ed$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>{
            var _m__lazyPromises, _m__lazyPromises1;
            return [
                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
            ];
        }));
    } catch (e) {}
    return results;
}
async function $4d274c27f30533ed$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $4d274c27f30533ed$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $4d274c27f30533ed$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $4d274c27f30533ed$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $4d274c27f30533ed$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $4d274c27f30533ed$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    var _result_init, _result_init1;
    let { result: result, type: type } = dataStrategyResult;
    if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $4d274c27f30533ed$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $4d274c27f30533ed$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($4d274c27f30533ed$export$e0163cfdf7bc9cfa(result)) {
            var _result_init2, _result_init3, _result_init4;
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $4d274c27f30533ed$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $4d274c27f30533ed$export$972111febbeef05b(result) ? result.status : void 0,
                headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $4d274c27f30533ed$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($4d274c27f30533ed$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
        headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $4d274c27f30533ed$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $4d274c27f30533ed$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$4d274c27f30533ed$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $4d274c27f30533ed$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $4d274c27f30533ed$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($4d274c27f30533ed$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $4d274c27f30533ed$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
function $4d274c27f30533ed$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($4d274c27f30533ed$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $4d274c27f30533ed$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $4d274c27f30533ed$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $4d274c27f30533ed$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $4d274c27f30533ed$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $4d274c27f30533ed$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $4d274c27f30533ed$export$f5708dca728d7177(!$4d274c27f30533ed$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($4d274c27f30533ed$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $4d274c27f30533ed$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $4d274c27f30533ed$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $4d274c27f30533ed$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $4d274c27f30533ed$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $4d274c27f30533ed$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $4d274c27f30533ed$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($4d274c27f30533ed$var$isErrorResult(result)) {
            let boundaryMatch = $4d274c27f30533ed$var$findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($4d274c27f30533ed$var$isRedirectResult(result)) $4d274c27f30533ed$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $4d274c27f30533ed$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $4d274c27f30533ed$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $4d274c27f30533ed$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $4d274c27f30533ed$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $4d274c27f30533ed$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $4d274c27f30533ed$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $4d274c27f30533ed$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $4d274c27f30533ed$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $4d274c27f30533ed$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $4d274c27f30533ed$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($4d274c27f30533ed$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $4d274c27f30533ed$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(path) : path;
    return $4d274c27f30533ed$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $4d274c27f30533ed$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $4d274c27f30533ed$var$dataWithResponseInitToResponse(data2) {
    var _data2_init;
    return Response.json(data2.data, (_data2_init = data2.init) !== null && _data2_init !== void 0 ? _data2_init : void 0);
}
function $4d274c27f30533ed$var$dataWithResponseInitToErrorResponse(data2) {
    var _data2_init, _data2_init1;
    var _data2_init_status, _data2_init_statusText;
    return new $4d274c27f30533ed$export$f2680fa305b734ca((_data2_init_status = (_data2_init = data2.init) === null || _data2_init === void 0 ? void 0 : _data2_init.status) !== null && _data2_init_status !== void 0 ? _data2_init_status : 500, (_data2_init_statusText = (_data2_init1 = data2.init) === null || _data2_init1 === void 0 ? void 0 : _data2_init1.statusText) !== null && _data2_init_statusText !== void 0 ? _data2_init_statusText : "Internal Server Error", data2.data);
}
function $4d274c27f30533ed$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $4d274c27f30533ed$var$isDataStrategyResult(value));
}
function $4d274c27f30533ed$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $4d274c27f30533ed$var$isRedirectDataStrategyResult(result) {
    return $4d274c27f30533ed$export$3f1eb41d9a6a6a27(result.result) && $4d274c27f30533ed$var$redirectStatusCodes.has(result.result.status);
}
function $4d274c27f30533ed$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $4d274c27f30533ed$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $4d274c27f30533ed$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $4d274c27f30533ed$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $4d274c27f30533ed$export$794b2760043cf8cd(statusCode) {
    return $4d274c27f30533ed$var$redirectStatusCodes.has(statusCode);
}
function $4d274c27f30533ed$export$6e80290866a84dd4(result) {
    return $4d274c27f30533ed$export$3f1eb41d9a6a6a27(result) && $4d274c27f30533ed$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $4d274c27f30533ed$var$isValidMethod(method) {
    return $4d274c27f30533ed$var$validRequestMethods.has(method.toUpperCase());
}
function $4d274c27f30533ed$export$cbae47800eb95bc3(method) {
    return $4d274c27f30533ed$var$validMutationMethods.has(method.toUpperCase());
}
function $4d274c27f30533ed$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $4d274c27f30533ed$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $4d274c27f30533ed$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $4d274c27f30533ed$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $4d274c27f30533ed$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $4d274c27f30533ed$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $4d274c27f30533ed$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $4d274c27f30533ed$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $4d274c27f30533ed$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $4d274c27f30533ed$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $4d274c27f30533ed$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($4d274c27f30533ed$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $4d274c27f30533ed$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($4d274c27f30533ed$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $4d274c27f30533ed$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $4d274c27f30533ed$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $4d274c27f30533ed$export$2eeee58951ff3c1c = $eyAY5.createContext(null);
$4d274c27f30533ed$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $4d274c27f30533ed$export$315e3ffb01f217 = $eyAY5.createContext(null);
$4d274c27f30533ed$export$315e3ffb01f217.displayName = "DataRouterState";
var $4d274c27f30533ed$export$717f757c655223f1 = $eyAY5.createContext(false);
function $4d274c27f30533ed$var$useIsRSCRouterContext() {
    return $eyAY5.useContext($4d274c27f30533ed$export$717f757c655223f1);
}
var $4d274c27f30533ed$export$3681f408decb40d1 = $eyAY5.createContext({
    isTransitioning: false
});
$4d274c27f30533ed$export$3681f408decb40d1.displayName = "ViewTransition";
var $4d274c27f30533ed$export$cb3f1df1bef00a39 = $eyAY5.createContext(/* @__PURE__ */ new Map());
$4d274c27f30533ed$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $4d274c27f30533ed$var$AwaitContext = $eyAY5.createContext(null);
$4d274c27f30533ed$var$AwaitContext.displayName = "Await";
var $4d274c27f30533ed$export$2666c20e15407622 = (props)=>$eyAY5.createElement($4d274c27f30533ed$var$AwaitContext.Provider, props);
var $4d274c27f30533ed$export$3044ab7fdabeaee6 = $eyAY5.createContext(null);
$4d274c27f30533ed$export$3044ab7fdabeaee6.displayName = "Navigation";
var $4d274c27f30533ed$export$e6a44b110a0c44d3 = $eyAY5.createContext(null);
$4d274c27f30533ed$export$e6a44b110a0c44d3.displayName = "Location";
var $4d274c27f30533ed$export$aac280ed165a4397 = $eyAY5.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$4d274c27f30533ed$export$aac280ed165a4397.displayName = "Route";
var $4d274c27f30533ed$var$RouteErrorContext = $eyAY5.createContext(null);
$4d274c27f30533ed$var$RouteErrorContext.displayName = "RouteError";
var $4d274c27f30533ed$export$945fecf35a8ef089 = true;
function $4d274c27f30533ed$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $4d274c27f30533ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $4d274c27f30533ed$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $4d274c27f30533ed$export$9c954a9d03d32f4a() {
    return $eyAY5.useContext($4d274c27f30533ed$export$e6a44b110a0c44d3) != null;
}
function $4d274c27f30533ed$export$45d76561a5302f2b() {
    $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $eyAY5.useContext($4d274c27f30533ed$export$e6a44b110a0c44d3).location;
}
function $4d274c27f30533ed$export$1b3f31771c5d07c() {
    return $eyAY5.useContext($4d274c27f30533ed$export$e6a44b110a0c44d3).navigationType;
}
function $4d274c27f30533ed$export$6c330e8992e8a295(pattern) {
    $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $4d274c27f30533ed$export$45d76561a5302f2b();
    return $eyAY5.useMemo(()=>$4d274c27f30533ed$export$81336c211d5ff295(pattern, $4d274c27f30533ed$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $4d274c27f30533ed$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $4d274c27f30533ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6).static;
    if (!isStatic) $eyAY5.useLayoutEffect(cb);
}
function $4d274c27f30533ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    return isDataRoute ? $4d274c27f30533ed$var$useNavigateStable() : $4d274c27f30533ed$var$useNavigateUnstable();
}
function $4d274c27f30533ed$var$useNavigateUnstable() {
    $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $eyAY5.useContext($4d274c27f30533ed$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let { matches: matches } = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    let { pathname: locationPathname } = $4d274c27f30533ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($4d274c27f30533ed$var$getResolveToMatches(matches));
    let activeRef = $eyAY5.useRef(false);
    $4d274c27f30533ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eyAY5.useCallback((to, options = {})=>{
        $4d274c27f30533ed$var$warning(activeRef.current, $4d274c27f30533ed$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $4d274c27f30533ed$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $4d274c27f30533ed$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $4d274c27f30533ed$var$OutletContext = $eyAY5.createContext(null);
function $4d274c27f30533ed$export$4138103a3ae699cc() {
    return $eyAY5.useContext($4d274c27f30533ed$var$OutletContext);
}
function $4d274c27f30533ed$export$a3be3530d8e40d0b(context) {
    let outlet = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397).outlet;
    return $eyAY5.useMemo(()=>outlet && /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $4d274c27f30533ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $4d274c27f30533ed$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    let { pathname: locationPathname } = $4d274c27f30533ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($4d274c27f30533ed$var$getResolveToMatches(matches));
    return $eyAY5.useMemo(()=>$4d274c27f30533ed$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $4d274c27f30533ed$export$5d3fca4a98652595(routes, locationArg) {
    return $4d274c27f30533ed$var$useRoutesImpl(routes, locationArg);
}
function $4d274c27f30533ed$var$useRoutesImpl(routes, locationArg, dataRouterState, unstable_onError, future) {
    $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($4d274c27f30533ed$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $4d274c27f30533ed$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $4d274c27f30533ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        let parsedLocationArg = typeof locationArg === "string" ? $4d274c27f30533ed$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $4d274c27f30533ed$export$f5708dca728d7177(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $4d274c27f30533ed$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($4d274c27f30533ed$export$945fecf35a8ef089) {
        $4d274c27f30533ed$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $4d274c27f30533ed$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $4d274c27f30533ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $4d274c27f30533ed$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $4d274c27f30533ed$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, unstable_onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4d274c27f30533ed$var$DefaultErrorComponent() {
    let error = $4d274c27f30533ed$export$ed527bf60f6e05f2();
    let message = $4d274c27f30533ed$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($4d274c27f30533ed$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, /* @__PURE__ */ $eyAY5.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $eyAY5.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $eyAY5.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $eyAY5.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, /* @__PURE__ */ $eyAY5.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $eyAY5.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $eyAY5.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $4d274c27f30533ed$var$defaultErrorElement = /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$DefaultErrorComponent, null);
var $4d274c27f30533ed$var$RenderErrorBoundary = class extends $eyAY5.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        return this.state.error !== void 0 ? /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
};
function $4d274c27f30533ed$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $eyAY5.useContext($4d274c27f30533ed$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $4d274c27f30533ed$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, unstable_onError = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0);
        $4d274c27f30533ed$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && unstable_onError ? (error, errorInfo)=>{
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        unstable_onError(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            unstable_pattern: $4d274c27f30533ed$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $4d274c27f30533ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4d274c27f30533ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $eyAY5.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $4d274c27f30533ed$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $4d274c27f30533ed$var$useDataRouterContext(hookName) {
    let ctx = $eyAY5.useContext($4d274c27f30533ed$export$2eeee58951ff3c1c);
    $4d274c27f30533ed$export$f5708dca728d7177(ctx, $4d274c27f30533ed$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $4d274c27f30533ed$var$useDataRouterState(hookName) {
    let state = $eyAY5.useContext($4d274c27f30533ed$export$315e3ffb01f217);
    $4d274c27f30533ed$export$f5708dca728d7177(state, $4d274c27f30533ed$var$getDataRouterConsoleError(hookName));
    return state;
}
function $4d274c27f30533ed$var$useRouteContext(hookName) {
    let route = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    $4d274c27f30533ed$export$f5708dca728d7177(route, $4d274c27f30533ed$var$getDataRouterConsoleError(hookName));
    return route;
}
function $4d274c27f30533ed$var$useCurrentRouteId(hookName) {
    let route = $4d274c27f30533ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $4d274c27f30533ed$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $4d274c27f30533ed$var$useRouteId() {
    return $4d274c27f30533ed$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $4d274c27f30533ed$export$d0fd4b7106de2769() {
    let state = $4d274c27f30533ed$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $4d274c27f30533ed$export$600dc272ed516c15() {
    let dataRouterContext = $4d274c27f30533ed$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $4d274c27f30533ed$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $eyAY5.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $eyAY5.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $4d274c27f30533ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4d274c27f30533ed$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $eyAY5.useMemo(()=>matches.map((m)=>$4d274c27f30533ed$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $4d274c27f30533ed$export$1448a5050d252c4d() {
    let state = $4d274c27f30533ed$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $4d274c27f30533ed$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $4d274c27f30533ed$export$fd5d37484eab868d(routeId) {
    let state = $4d274c27f30533ed$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $4d274c27f30533ed$export$fdc00f3f26066d5e() {
    let state = $4d274c27f30533ed$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $4d274c27f30533ed$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $4d274c27f30533ed$export$ed527bf60f6e05f2() {
    var _state_errors;
    let error = $eyAY5.useContext($4d274c27f30533ed$var$RouteErrorContext);
    let state = $4d274c27f30533ed$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $4d274c27f30533ed$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
function $4d274c27f30533ed$export$78a72ddb39bdd145() {
    let value = $eyAY5.useContext($4d274c27f30533ed$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._data;
}
function $4d274c27f30533ed$export$17f53340677d5831() {
    let value = $eyAY5.useContext($4d274c27f30533ed$var$AwaitContext);
    return value === null || value === void 0 ? void 0 : value._error;
}
var $4d274c27f30533ed$var$blockerId = 0;
function $4d274c27f30533ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4d274c27f30533ed$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $4d274c27f30533ed$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $eyAY5.useState("");
    let blockerFunction = $eyAY5.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $4d274c27f30533ed$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $4d274c27f30533ed$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $eyAY5.useEffect(()=>{
        let key = String(++$4d274c27f30533ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $eyAY5.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $4d274c27f30533ed$export$386d57f03f0b2883;
}
function $4d274c27f30533ed$var$useNavigateStable() {
    let { router: router } = $4d274c27f30533ed$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $4d274c27f30533ed$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $eyAY5.useRef(false);
    $4d274c27f30533ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eyAY5.useCallback(async (to, options = {})=>{
        $4d274c27f30533ed$var$warning(activeRef.current, $4d274c27f30533ed$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $4d274c27f30533ed$var$alreadyWarned = {};
function $4d274c27f30533ed$var$warningOnce(key, cond, message) {
    if (!cond && !$4d274c27f30533ed$var$alreadyWarned[key]) {
        $4d274c27f30533ed$var$alreadyWarned[key] = true;
        $4d274c27f30533ed$var$warning(false, message);
    }
}
function $4d274c27f30533ed$export$3f79f0b98112cf57(...args) {
    var _state_actionData;
    const currentRouteId = $4d274c27f30533ed$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    var _args_;
    const id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    const state = $4d274c27f30533ed$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
// lib/server-runtime/warnings.ts
var $4d274c27f30533ed$var$alreadyWarned2 = {};
function $4d274c27f30533ed$export$5b28268982f175ba(condition, message) {
    if (!condition && !$4d274c27f30533ed$var$alreadyWarned2[message]) {
        $4d274c27f30533ed$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $4d274c27f30533ed$var$USE_OPTIMISTIC = "useOptimistic";
var $4d274c27f30533ed$var$useOptimisticImpl = $eyAY5[$4d274c27f30533ed$var$USE_OPTIMISTIC];
var $4d274c27f30533ed$var$stableUseOptimisticSetter = ()=>void 0;
function $4d274c27f30533ed$var$useOptimisticSafe(val) {
    if ($4d274c27f30533ed$var$useOptimisticImpl) return $4d274c27f30533ed$var$useOptimisticImpl(val);
    else return [
        val,
        $4d274c27f30533ed$var$stableUseOptimisticSetter
    ];
}
function $4d274c27f30533ed$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($4d274c27f30533ed$export$945fecf35a8ef089) {
            if (route.element) $4d274c27f30533ed$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $eyAY5.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($4d274c27f30533ed$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $4d274c27f30533ed$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $eyAY5.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($4d274c27f30533ed$export$945fecf35a8ef089) {
            if (route.errorElement) $4d274c27f30533ed$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $eyAY5.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $4d274c27f30533ed$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $4d274c27f30533ed$export$f30f7e456d254e83(routes, opts) {
    return $4d274c27f30533ed$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $4d274c27f30533ed$var$createMemoryHistory({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        hydrationRouteProperties: $4d274c27f30533ed$export$e2fd2c03906469db,
        mapRouteProperties: $4d274c27f30533ed$export$9269a41d8c4635e,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
var $4d274c27f30533ed$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $4d274c27f30533ed$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, unstable_onError: unstable_onError, unstable_useTransitions: unstable_useTransitions }) {
    let [_state, setStateImpl] = $eyAY5.useState(router.state);
    let [state, setOptimisticState] = $4d274c27f30533ed$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $eyAY5.useState();
    let [vtContext, setVtContext] = $eyAY5.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $eyAY5.useState();
    let [transition, setTransition] = $eyAY5.useState();
    let [interruption, setInterruption] = $eyAY5.useState();
    let fetcherData = $eyAY5.useRef(/* @__PURE__ */ new Map());
    let setState = $eyAY5.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && unstable_onError) Object.values(newErrors).forEach((error)=>{
            var _newState_matches_;
            var _newState_matches__params;
            return unstable_onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                unstable_pattern: $4d274c27f30533ed$var$getRoutePattern(newState.matches)
            });
        });
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $4d274c27f30533ed$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $4d274c27f30533ed$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $eyAY5.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$4d274c27f30533ed$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        unstable_onError
    ]);
    $eyAY5.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $eyAY5.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $4d274c27f30533ed$var$Deferred());
    }, [
        vtContext
    ]);
    $eyAY5.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $eyAY5.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$4d274c27f30533ed$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $eyAY5.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $eyAY5.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $eyAY5.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eyAY5.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            unstable_onError: unstable_onError
        }), [
        router,
        navigator,
        basename,
        unstable_onError
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions === true
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        unstable_onError: unstable_onError
    })))))), null);
}
function $4d274c27f30533ed$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $4d274c27f30533ed$var$MemoizedDataRoutes = $eyAY5.memo($4d274c27f30533ed$var$DataRoutes);
function $4d274c27f30533ed$var$DataRoutes({ routes: routes, future: future, state: state, unstable_onError: unstable_onError }) {
    return $4d274c27f30533ed$var$useRoutesImpl(routes, void 0, state, unstable_onError, future);
}
function $4d274c27f30533ed$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $eyAY5.useRef();
    if (historyRef.current == null) historyRef.current = $4d274c27f30533ed$var$createMemoryHistory({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eyAY5.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eyAY5.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $eyAY5.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $eyAY5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $4d274c27f30533ed$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $4d274c27f30533ed$export$f5708dca728d7177($4d274c27f30533ed$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    $4d274c27f30533ed$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    let { pathname: locationPathname } = $4d274c27f30533ed$export$45d76561a5302f2b();
    let navigate = $4d274c27f30533ed$export$9770f232ac06a008();
    let path = $4d274c27f30533ed$var$resolveTo(to, $4d274c27f30533ed$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $eyAY5.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $4d274c27f30533ed$export$910ae8079b2c2852(props) {
    return $4d274c27f30533ed$export$a3be3530d8e40d0b(props.context);
}
function $4d274c27f30533ed$export$e7b0ac011bb776c6(props) {
    $4d274c27f30533ed$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $4d274c27f30533ed$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $4d274c27f30533ed$export$f5708dca728d7177(!$4d274c27f30533ed$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eyAY5.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $4d274c27f30533ed$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eyAY5.useMemo(()=>{
        let trailingPathname = $4d274c27f30533ed$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $4d274c27f30533ed$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $4d274c27f30533ed$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $4d274c27f30533ed$export$5d3fca4a98652595($4d274c27f30533ed$export$16da398f5434bdec(children), location);
}
function $4d274c27f30533ed$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $eyAY5.useContext($4d274c27f30533ed$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $eyAY5.useContext($4d274c27f30533ed$export$315e3ffb01f217);
    let onError = $eyAY5.useCallback((error, errorInfo)=>{
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.unstable_onError && dataRouterStateContext) dataRouterContext.unstable_onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            unstable_pattern: $4d274c27f30533ed$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$ResolveAwait, null, children));
}
var $4d274c27f30533ed$var$AwaitErrorBoundary = class extends $eyAY5.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                var _this_props_onError, _this_props;
                (_this_props_onError = (_this_props = this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
};
function $4d274c27f30533ed$var$ResolveAwait({ children: children }) {
    let data2 = $4d274c27f30533ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, toRender);
}
function $4d274c27f30533ed$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $eyAY5.Children.forEach(children, (element, index)=>{
        if (!$eyAY5.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eyAY5.Fragment) {
            routes.push.apply(routes, $4d274c27f30533ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $4d274c27f30533ed$export$f5708dca728d7177(element.type === $4d274c27f30533ed$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $4d274c27f30533ed$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4d274c27f30533ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $4d274c27f30533ed$export$9b5b6d122dea0c88 = $4d274c27f30533ed$export$16da398f5434bdec;
function $4d274c27f30533ed$export$daf73786167a7f72(matches) {
    return $4d274c27f30533ed$var$_renderMatches(matches);
}
function $4d274c27f30533ed$var$useRouteComponentProps() {
    return {
        params: $4d274c27f30533ed$export$99eaa27ddbbb95ef(),
        loaderData: $4d274c27f30533ed$export$1448a5050d252c4d(),
        actionData: $4d274c27f30533ed$export$fdc00f3f26066d5e(),
        matches: $4d274c27f30533ed$export$2378eb7f5ff86053()
    };
}
function $4d274c27f30533ed$export$6c4f3826290c37af({ children: children }) {
    const props = $4d274c27f30533ed$var$useRouteComponentProps();
    return $eyAY5.cloneElement(children, props);
}
function $4d274c27f30533ed$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $4d274c27f30533ed$var$useRouteComponentProps();
        return $eyAY5.createElement(Component4, props);
    };
}
function $4d274c27f30533ed$var$useHydrateFallbackProps() {
    return {
        params: $4d274c27f30533ed$export$99eaa27ddbbb95ef(),
        loaderData: $4d274c27f30533ed$export$1448a5050d252c4d(),
        actionData: $4d274c27f30533ed$export$fdc00f3f26066d5e()
    };
}
function $4d274c27f30533ed$export$f8cff34f39c1932a({ children: children }) {
    const props = $4d274c27f30533ed$var$useHydrateFallbackProps();
    return $eyAY5.cloneElement(children, props);
}
function $4d274c27f30533ed$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $4d274c27f30533ed$var$useHydrateFallbackProps();
        return $eyAY5.createElement(HydrateFallback, props);
    };
}
function $4d274c27f30533ed$var$useErrorBoundaryProps() {
    return {
        params: $4d274c27f30533ed$export$99eaa27ddbbb95ef(),
        loaderData: $4d274c27f30533ed$export$1448a5050d252c4d(),
        actionData: $4d274c27f30533ed$export$fdc00f3f26066d5e(),
        error: $4d274c27f30533ed$export$ed527bf60f6e05f2()
    };
}
function $4d274c27f30533ed$export$e5afde5c4b6d747b({ children: children }) {
    const props = $4d274c27f30533ed$var$useErrorBoundaryProps();
    return $eyAY5.cloneElement(children, props);
}
function $4d274c27f30533ed$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $4d274c27f30533ed$var$useErrorBoundaryProps();
        return $eyAY5.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $4d274c27f30533ed$var$defaultMethod = "get";
var $4d274c27f30533ed$var$defaultEncType = "application/x-www-form-urlencoded";
function $4d274c27f30533ed$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $4d274c27f30533ed$var$isButtonElement(object) {
    return $4d274c27f30533ed$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $4d274c27f30533ed$var$isFormElement(object) {
    return $4d274c27f30533ed$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $4d274c27f30533ed$var$isInputElement(object) {
    return $4d274c27f30533ed$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $4d274c27f30533ed$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $4d274c27f30533ed$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$4d274c27f30533ed$var$isModifiedEvent(event);
}
function $4d274c27f30533ed$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $4d274c27f30533ed$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $4d274c27f30533ed$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $4d274c27f30533ed$var$_formDataSupportsSubmitter = null;
function $4d274c27f30533ed$var$isFormDataSubmitterSupported() {
    if ($4d274c27f30533ed$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $4d274c27f30533ed$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $4d274c27f30533ed$var$_formDataSupportsSubmitter = true;
    }
    return $4d274c27f30533ed$var$_formDataSupportsSubmitter;
}
var $4d274c27f30533ed$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $4d274c27f30533ed$var$getFormEncType(encType) {
    if (encType != null && !$4d274c27f30533ed$var$supportedFormEncTypes.has(encType)) {
        $4d274c27f30533ed$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$4d274c27f30533ed$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $4d274c27f30533ed$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($4d274c27f30533ed$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $4d274c27f30533ed$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $4d274c27f30533ed$var$defaultMethod;
        encType = $4d274c27f30533ed$var$getFormEncType(target.getAttribute("enctype")) || $4d274c27f30533ed$var$defaultEncType;
        formData = new FormData(target);
    } else if ($4d274c27f30533ed$var$isButtonElement(target) || $4d274c27f30533ed$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $4d274c27f30533ed$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $4d274c27f30533ed$var$defaultMethod;
        encType = $4d274c27f30533ed$var$getFormEncType(target.getAttribute("formenctype")) || $4d274c27f30533ed$var$getFormEncType(form.getAttribute("enctype")) || $4d274c27f30533ed$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$4d274c27f30533ed$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($4d274c27f30533ed$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $4d274c27f30533ed$var$defaultMethod;
        action = null;
        encType = $4d274c27f30533ed$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $4d274c27f30533ed$var$HOLE = -1;
var $4d274c27f30533ed$var$NAN = -2;
var $4d274c27f30533ed$var$NEGATIVE_INFINITY = -3;
var $4d274c27f30533ed$var$NEGATIVE_ZERO = -4;
var $4d274c27f30533ed$var$NULL = -5;
var $4d274c27f30533ed$var$POSITIVE_INFINITY = -6;
var $4d274c27f30533ed$var$UNDEFINED = -7;
var $4d274c27f30533ed$var$TYPE_BIGINT = "B";
var $4d274c27f30533ed$var$TYPE_DATE = "D";
var $4d274c27f30533ed$var$TYPE_ERROR = "E";
var $4d274c27f30533ed$var$TYPE_MAP = "M";
var $4d274c27f30533ed$var$TYPE_NULL_OBJECT = "N";
var $4d274c27f30533ed$var$TYPE_PROMISE = "P";
var $4d274c27f30533ed$var$TYPE_REGEXP = "R";
var $4d274c27f30533ed$var$TYPE_SET = "S";
var $4d274c27f30533ed$var$TYPE_SYMBOL = "Y";
var $4d274c27f30533ed$var$TYPE_URL = "U";
var $4d274c27f30533ed$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $4d274c27f30533ed$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $4d274c27f30533ed$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $4d274c27f30533ed$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $4d274c27f30533ed$var$UNDEFINED;
    if (input === null) return $4d274c27f30533ed$var$NULL;
    if (Number.isNaN(input)) return $4d274c27f30533ed$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $4d274c27f30533ed$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $4d274c27f30533ed$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $4d274c27f30533ed$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $4d274c27f30533ed$var$stringify.call(this, input, index);
    return index;
}
function $4d274c27f30533ed$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$4d274c27f30533ed$var$flatten.call(this, k)}":${$4d274c27f30533ed$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$4d274c27f30533ed$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$4d274c27f30533ed$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$4d274c27f30533ed$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$4d274c27f30533ed$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $4d274c27f30533ed$var$flatten.call(this, input2[i]) : $4d274c27f30533ed$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$4d274c27f30533ed$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$4d274c27f30533ed$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$4d274c27f30533ed$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$4d274c27f30533ed$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$4d274c27f30533ed$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$4d274c27f30533ed$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$4d274c27f30533ed$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $4d274c27f30533ed$var$flatten.call(this, k),
                                    $4d274c27f30533ed$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$4d274c27f30533ed$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$4d274c27f30533ed$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$4d274c27f30533ed$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$4d274c27f30533ed$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($4d274c27f30533ed$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$4d274c27f30533ed$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$4d274c27f30533ed$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $4d274c27f30533ed$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $4d274c27f30533ed$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $4d274c27f30533ed$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $4d274c27f30533ed$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $4d274c27f30533ed$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $4d274c27f30533ed$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $4d274c27f30533ed$var$hydrate.call(this, startIndex);
}
function $4d274c27f30533ed$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $4d274c27f30533ed$var$UNDEFINED:
                set(void 0);
                continue;
            case $4d274c27f30533ed$var$NULL:
                set(null);
                continue;
            case $4d274c27f30533ed$var$NAN:
                set(NaN);
                continue;
            case $4d274c27f30533ed$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $4d274c27f30533ed$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $4d274c27f30533ed$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $4d274c27f30533ed$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $4d274c27f30533ed$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $4d274c27f30533ed$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $4d274c27f30533ed$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $4d274c27f30533ed$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $4d274c27f30533ed$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $4d274c27f30533ed$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $4d274c27f30533ed$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $4d274c27f30533ed$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $4d274c27f30533ed$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $4d274c27f30533ed$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $4d274c27f30533ed$var$globalObj && $4d274c27f30533ed$var$globalObj[errorType] ? new $4d274c27f30533ed$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $4d274c27f30533ed$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $4d274c27f30533ed$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $4d274c27f30533ed$var$decode(readable, options) {
    const { plugins: plugins } = options !== null && options !== void 0 ? options : {};
    const done = new $4d274c27f30533ed$var$Deferred2();
    const reader = readable.pipeThrough($4d274c27f30533ed$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $4d274c27f30533ed$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $4d274c27f30533ed$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $4d274c27f30533ed$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $4d274c27f30533ed$var$unflatten.call(this, line)
    };
}
async function $4d274c27f30533ed$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $4d274c27f30533ed$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $4d274c27f30533ed$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $4d274c27f30533ed$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $4d274c27f30533ed$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $4d274c27f30533ed$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options !== null && options !== void 0 ? options : {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $4d274c27f30533ed$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $4d274c27f30533ed$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$4d274c27f30533ed$var$TYPE_PROMISE}${deferredId}:[["${$4d274c27f30533ed$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$4d274c27f30533ed$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$4d274c27f30533ed$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $4d274c27f30533ed$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$4d274c27f30533ed$var$TYPE_ERROR}${deferredId}:[["${$4d274c27f30533ed$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$4d274c27f30533ed$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$4d274c27f30533ed$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $4d274c27f30533ed$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $4d274c27f30533ed$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $4d274c27f30533ed$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $4d274c27f30533ed$export$4cf11838cdc2a8a8(html) {
    return html.replace($4d274c27f30533ed$var$ESCAPE_REGEX, (match)=>$4d274c27f30533ed$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $4d274c27f30533ed$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $4d274c27f30533ed$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $4d274c27f30533ed$var$SingleFetchNoResultError = class extends Error {
};
var $4d274c27f30533ed$export$ae9272e641ead836 = 202;
var $4d274c27f30533ed$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $4d274c27f30533ed$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $eyAY5.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$4d274c27f30533ed$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, scriptTag, /* @__PURE__ */ $eyAY5.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, scriptTag, /* @__PURE__ */ $eyAY5.createElement($eyAY5.Suspense, null, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $4d274c27f30533ed$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename) {
    let dataStrategy = $4d274c27f30533ed$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $4d274c27f30533ed$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule === null || routeModule === void 0 ? void 0 : routeModule.shouldRevalidate)
        };
    }, $4d274c27f30533ed$var$fetchAndDecodeViaTurboStream, ssr, basename);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $4d274c27f30533ed$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $4d274c27f30533ed$var$singleFetchActionStrategy(args, fetchAndDecode, basename);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $4d274c27f30533ed$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename);
        if (fetcherKey) return $4d274c27f30533ed$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename);
        return $4d274c27f30533ed$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut);
    };
}
async function $4d274c27f30533ed$var$singleFetchActionStrategy(args, fetchAndDecode, basename) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $4d274c27f30533ed$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $4d274c27f30533ed$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($4d274c27f30533ed$export$3f1eb41d9a6a6a27(result.result) || $4d274c27f30533ed$export$972111febbeef05b(result.result) || $4d274c27f30533ed$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $4d274c27f30533ed$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $4d274c27f30533ed$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, [
                        routeId
                    ]);
                    return $4d274c27f30533ed$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $4d274c27f30533ed$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$4d274c27f30533ed$var$createDeferred2());
    let singleFetchDfd = $4d274c27f30533ed$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, [
                            routeId
                        ]);
                        return $4d274c27f30533ed$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $4d274c27f30533ed$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $4d274c27f30533ed$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $4d274c27f30533ed$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    var _results_match_route_id;
                    middlewareError = routeResult.error;
                    if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $4d274c27f30533ed$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $4d274c27f30533ed$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $4d274c27f30533ed$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, [
                routeId
            ]);
            return $4d274c27f30533ed$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $4d274c27f30533ed$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $4d274c27f30533ed$export$7b977381851b2c(reqUrl, basename, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname === "/") url.pathname = `_root.${extension}`;
    else if (basename && $4d274c27f30533ed$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
    else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    return url;
}
async function $4d274c27f30533ed$var$fetchAndDecodeViaTurboStream(args, basename, targetRoutes) {
    let { request: request } = args;
    let url = $4d274c27f30533ed$export$7b977381851b2c(request.url, basename, "data");
    if (request.method === "GET") {
        url = $4d274c27f30533ed$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $4d274c27f30533ed$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $4d274c27f30533ed$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $4d274c27f30533ed$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($4d274c27f30533ed$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $4d274c27f30533ed$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $4d274c27f30533ed$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($4d274c27f30533ed$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$4d274c27f30533ed$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
            $4d274c27f30533ed$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $4d274c27f30533ed$export$4023ad4ecd4126a2(body, global) {
    return $4d274c27f30533ed$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $4d274c27f30533ed$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$4d274c27f30533ed$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $4d274c27f30533ed$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $4d274c27f30533ed$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $4d274c27f30533ed$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $4d274c27f30533ed$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $4d274c27f30533ed$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $4d274c27f30533ed$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $4d274c27f30533ed$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        var _module_links;
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2);
    let preloads = $4d274c27f30533ed$var$getModuleLinkHrefs(matches, manifest);
    return $4d274c27f30533ed$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $4d274c27f30533ed$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $4d274c27f30533ed$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $4d274c27f30533ed$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($4d274c27f30533ed$var$prefetchStyleLink));
}
async function $4d274c27f30533ed$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$4d274c27f30533ed$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$4d274c27f30533ed$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$4d274c27f30533ed$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($4d274c27f30533ed$var$prefetchStyleLink));
}
async function $4d274c27f30533ed$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $4d274c27f30533ed$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $4d274c27f30533ed$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $4d274c27f30533ed$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $4d274c27f30533ed$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $4d274c27f30533ed$var$dedupeLinkDescriptors(links.flat(1).filter($4d274c27f30533ed$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $4d274c27f30533ed$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        var // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        _currentMatches_index_route_path;
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $4d274c27f30533ed$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $4d274c27f30533ed$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $4d274c27f30533ed$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $4d274c27f30533ed$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $4d274c27f30533ed$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$4d274c27f30533ed$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($4d274c27f30533ed$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $4d274c27f30533ed$var$_isPreloadSupported;
function $4d274c27f30533ed$var$isPreloadSupported() {
    if ($4d274c27f30533ed$var$_isPreloadSupported !== void 0) return $4d274c27f30533ed$var$_isPreloadSupported;
    let el = document.createElement("link");
    $4d274c27f30533ed$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $4d274c27f30533ed$var$_isPreloadSupported;
}
function $4d274c27f30533ed$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $4d274c27f30533ed$export$945fecf35a8ef089 ? /* @__PURE__ */ $eyAY5.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $4d274c27f30533ed$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $4d274c27f30533ed$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $4d274c27f30533ed$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $4d274c27f30533ed$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$RemixRootDefaultErrorBoundary, {
            error: $4d274c27f30533ed$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $eyAY5.createElement(routeModule.Layout, null, /* @__PURE__ */ $eyAY5.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $eyAY5.createElement(routeModule.Layout, null, /* @__PURE__ */ $eyAY5.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $eyAY5.createElement(routeModule.Layout, null, /* @__PURE__ */ $eyAY5.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $4d274c27f30533ed$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $4d274c27f30533ed$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $4d274c27f30533ed$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$4d274c27f30533ed$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $4d274c27f30533ed$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $4d274c27f30533ed$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $4d274c27f30533ed$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $4d274c27f30533ed$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $4d274c27f30533ed$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $4d274c27f30533ed$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $4d274c27f30533ed$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $4d274c27f30533ed$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $4d274c27f30533ed$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $4d274c27f30533ed$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $4d274c27f30533ed$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $4d274c27f30533ed$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $4d274c27f30533ed$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$4d274c27f30533ed$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $4d274c27f30533ed$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $4d274c27f30533ed$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $4d274c27f30533ed$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $4d274c27f30533ed$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $4d274c27f30533ed$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $4d274c27f30533ed$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $4d274c27f30533ed$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $4d274c27f30533ed$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $4d274c27f30533ed$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $4d274c27f30533ed$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $4d274c27f30533ed$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $4d274c27f30533ed$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $4d274c27f30533ed$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $4d274c27f30533ed$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $4d274c27f30533ed$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $4d274c27f30533ed$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $4d274c27f30533ed$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $4d274c27f30533ed$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $4d274c27f30533ed$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $4d274c27f30533ed$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $4d274c27f30533ed$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $4d274c27f30533ed$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $4d274c27f30533ed$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $4d274c27f30533ed$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $4d274c27f30533ed$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $4d274c27f30533ed$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $4d274c27f30533ed$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $4d274c27f30533ed$var$nextPaths = /* @__PURE__ */ new Set();
var $4d274c27f30533ed$var$discoveredPathsMaxSize = 1e3;
var $4d274c27f30533ed$var$discoveredPaths = /* @__PURE__ */ new Set();
var $4d274c27f30533ed$var$URL_LIMIT = 7680;
function $4d274c27f30533ed$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $4d274c27f30533ed$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $4d274c27f30533ed$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $4d274c27f30533ed$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$4d274c27f30533ed$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($4d274c27f30533ed$var$discoveredPaths.has(path)) return;
        await $4d274c27f30533ed$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $4d274c27f30533ed$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $eyAY5.useEffect(()=>{
        var // @ts-expect-error - TS doesn't know about this yet
        _window_navigator_connection, _window_navigator;
        if (!$4d274c27f30533ed$var$isFogOfWarEnabled(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$4d274c27f30533ed$var$discoveredPaths.has(pathname)) $4d274c27f30533ed$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($4d274c27f30533ed$var$nextPaths.keys()).filter((path)=>{
                if ($4d274c27f30533ed$var$discoveredPaths.has(path)) {
                    $4d274c27f30533ed$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $4d274c27f30533ed$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $4d274c27f30533ed$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $4d274c27f30533ed$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $4d274c27f30533ed$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $4d274c27f30533ed$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($4d274c27f30533ed$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $4d274c27f30533ed$var$URL_LIMIT) {
        $4d274c27f30533ed$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($4d274c27f30533ed$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($4d274c27f30533ed$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($4d274c27f30533ed$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal === null || signal === void 0 ? void 0 : signal.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$4d274c27f30533ed$var$addToFifoQueue(p, $4d274c27f30533ed$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $4d274c27f30533ed$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $4d274c27f30533ed$var$addToFifoQueue(path, queue) {
    if (queue.size >= $4d274c27f30533ed$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $4d274c27f30533ed$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $4d274c27f30533ed$var$useDataRouterContext2() {
    let context = $eyAY5.useContext($4d274c27f30533ed$export$2eeee58951ff3c1c);
    $4d274c27f30533ed$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $4d274c27f30533ed$var$useDataRouterStateContext() {
    let context = $eyAY5.useContext($4d274c27f30533ed$export$315e3ffb01f217);
    $4d274c27f30533ed$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $4d274c27f30533ed$export$208d6a3bc3aa62bd = $eyAY5.createContext(void 0);
$4d274c27f30533ed$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $4d274c27f30533ed$var$useFrameworkContext() {
    let context = $eyAY5.useContext($4d274c27f30533ed$export$208d6a3bc3aa62bd);
    $4d274c27f30533ed$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $4d274c27f30533ed$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $eyAY5.useContext($4d274c27f30533ed$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $eyAY5.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $eyAY5.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $eyAY5.useRef(null);
    $eyAY5.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $eyAY5.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $4d274c27f30533ed$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $4d274c27f30533ed$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $4d274c27f30533ed$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $4d274c27f30533ed$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $4d274c27f30533ed$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $4d274c27f30533ed$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $4d274c27f30533ed$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$4d274c27f30533ed$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $4d274c27f30533ed$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $4d274c27f30533ed$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $4d274c27f30533ed$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $4d274c27f30533ed$var$useDataRouterStateContext();
    let matches = $4d274c27f30533ed$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $eyAY5.useMemo(()=>$4d274c27f30533ed$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $eyAY5.createElement("style", {
        [$4d274c27f30533ed$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $eyAY5.createElement("link", {
        [$4d274c27f30533ed$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$4d274c27f30533ed$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $eyAY5.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $4d274c27f30533ed$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $4d274c27f30533ed$var$useDataRouterContext2();
    let matches = $eyAY5.useMemo(()=>$4d274c27f30533ed$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $4d274c27f30533ed$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $4d274c27f30533ed$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $eyAY5.useState([]);
    $eyAY5.useEffect(()=>{
        let interrupted = false;
        $4d274c27f30533ed$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $4d274c27f30533ed$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let { manifest: manifest, routeModules: routeModules } = $4d274c27f30533ed$var$useFrameworkContext();
    let { basename: basename } = $4d274c27f30533ed$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $4d274c27f30533ed$var$useDataRouterStateContext();
    let newMatchesForData = $eyAY5.useMemo(()=>$4d274c27f30533ed$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $eyAY5.useMemo(()=>$4d274c27f30533ed$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $eyAY5.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            var _routeModules_m_route_id;
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $4d274c27f30533ed$export$7b977381851b2c(page, basename, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $eyAY5.useMemo(()=>$4d274c27f30533ed$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $4d274c27f30533ed$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $eyAY5.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $eyAY5.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $eyAY5.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $4d274c27f30533ed$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $4d274c27f30533ed$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $4d274c27f30533ed$var$useDataRouterStateContext();
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let _matches = $4d274c27f30533ed$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$4d274c27f30533ed$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $eyAY5.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $eyAY5.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps_charSet;
            (_metaProps_charSet = metaProps.charSet) !== null && _metaProps_charSet !== void 0 ? _metaProps_charSet : metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $eyAY5.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $eyAY5.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $4d274c27f30533ed$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $eyAY5.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $4d274c27f30533ed$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $4d274c27f30533ed$var$isHydrated = false;
function $4d274c27f30533ed$export$3be068dde909e563() {
    $4d274c27f30533ed$var$isHydrated = true;
}
function $4d274c27f30533ed$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $4d274c27f30533ed$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $4d274c27f30533ed$var$useDataRouterContext2();
    let { matches: routerMatches } = $4d274c27f30533ed$var$useDataRouterStateContext();
    let isRSCRouterContext = $4d274c27f30533ed$var$useIsRSCRouterContext();
    let enableFogOfWar = $4d274c27f30533ed$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $4d274c27f30533ed$var$getActiveMatches(routerMatches, null, isSpaMode);
    $eyAY5.useEffect(()=>{
        $4d274c27f30533ed$export$3be068dde909e563();
    }, []);
    let initialScripts = $eyAY5.useMemo(()=>{
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $4d274c27f30533ed$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($4d274c27f30533ed$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, /* @__PURE__ */ $eyAY5.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $eyAY5.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $4d274c27f30533ed$var$isHydrated || isRSCRouterContext ? [] : $4d274c27f30533ed$var$dedupe(manifest.entry.imports.concat($4d274c27f30533ed$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $4d274c27f30533ed$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $4d274c27f30533ed$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $eyAY5.createElement("script", {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $eyAY5.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $eyAY5.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $eyAY5.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $4d274c27f30533ed$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $4d274c27f30533ed$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $4d274c27f30533ed$export$32e57f52df4b6e34 = class extends $eyAY5.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
};
function $4d274c27f30533ed$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $eyAY5.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($4d274c27f30533ed$export$972111febbeef05b(error)) return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $eyAY5.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $4d274c27f30533ed$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $eyAY5.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $eyAY5.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $4d274c27f30533ed$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    var _routeModules_root;
    let { routeModules: routeModules } = $4d274c27f30533ed$var$useFrameworkContext();
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $eyAY5.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $eyAY5.createElement("head", null, /* @__PURE__ */ $eyAY5.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $eyAY5.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $eyAY5.createElement("title", null, title)), /* @__PURE__ */ $eyAY5.createElement("body", null, /* @__PURE__ */ $eyAY5.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$ff0bf87698939488, null) : null)));
}
var $4d274c27f30533ed$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($4d274c27f30533ed$var$isBrowser) window.__reactRouterVersion = "7.10.1";
} catch (e) {}
function $4d274c27f30533ed$export$1f3f55432a00e06d(routes, opts) {
    return $4d274c27f30533ed$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $4d274c27f30533ed$export$719fc203c4e16dee({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $4d274c27f30533ed$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $4d274c27f30533ed$export$9269a41d8c4635e,
        hydrationRouteProperties: $4d274c27f30533ed$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
function $4d274c27f30533ed$export$1ba7ed8a3a7b3765(routes, opts) {
    return $4d274c27f30533ed$export$baddd0131ee8c05b({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: $4d274c27f30533ed$var$createHashHistory({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $4d274c27f30533ed$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $4d274c27f30533ed$export$9269a41d8c4635e,
        hydrationRouteProperties: $4d274c27f30533ed$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        unstable_instrumentations: opts === null || opts === void 0 ? void 0 : opts.unstable_instrumentations
    }).initialize();
}
function $4d274c27f30533ed$var$parseHydrationData() {
    var _window;
    let state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $4d274c27f30533ed$var$deserializeErrors(state.errors)
    };
    return state;
}
function $4d274c27f30533ed$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $4d274c27f30533ed$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $4d274c27f30533ed$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $eyAY5.useRef();
    if (historyRef.current == null) historyRef.current = $4d274c27f30533ed$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eyAY5.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eyAY5.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $eyAY5.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $eyAY5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $4d274c27f30533ed$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $eyAY5.useRef();
    if (historyRef.current == null) historyRef.current = $4d274c27f30533ed$var$createHashHistory({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $eyAY5.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eyAY5.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $eyAY5.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $eyAY5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
function $4d274c27f30533ed$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $eyAY5.useState({
        action: history.action,
        location: history.location
    });
    let setState = $eyAY5.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $eyAY5.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $eyAY5.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions === true
    });
}
$4d274c27f30533ed$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $4d274c27f30533ed$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $4d274c27f30533ed$export$a6c7ac8248d6e38a = $eyAY5.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $4d274c27f30533ed$var$ABSOLUTE_URL_REGEX2.test(to);
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && isAbsolute) {
        absoluteHref = to;
        if ($4d274c27f30533ed$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = $4d274c27f30533ed$export$b69e3301ce081aa3(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            $4d274c27f30533ed$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
        }
    }
    let href = $4d274c27f30533ed$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $4d274c27f30533ed$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $4d274c27f30533ed$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $eyAY5.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: $4d274c27f30533ed$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, link, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$4d274c27f30533ed$export$a6c7ac8248d6e38a.displayName = "Link";
var $4d274c27f30533ed$export$b0d92dbee9b5b60d = $eyAY5.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $4d274c27f30533ed$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let routerState = $eyAY5.useContext($4d274c27f30533ed$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4d274c27f30533ed$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $4d274c27f30533ed$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$4d274c27f30533ed$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $4d274c27f30533ed$export$a7fed597f4b8afd8 = $eyAY5.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $4d274c27f30533ed$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let submit = $4d274c27f30533ed$export$47c85c6e3a081d3();
    let formAction = $4d274c27f30533ed$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $4d274c27f30533ed$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition
            });
        if (unstable_useTransitions && navigate !== false) $eyAY5.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $eyAY5.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$4d274c27f30533ed$export$a7fed597f4b8afd8.displayName = "Form";
function $4d274c27f30533ed$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $eyAY5.useContext($4d274c27f30533ed$export$208d6a3bc3aa62bd);
    let { basename: basename } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let matches = $4d274c27f30533ed$export$2378eb7f5ff86053();
    $4d274c27f30533ed$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $eyAY5.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $4d274c27f30533ed$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $eyAY5.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${JSON.stringify(storageKey || $4d274c27f30533ed$var$SCROLL_RESTORATION_STORAGE_KEY)}, ${JSON.stringify(ssrKey)})`
        }
    });
}
$4d274c27f30533ed$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $4d274c27f30533ed$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $4d274c27f30533ed$var$useDataRouterContext3(hookName) {
    let ctx = $eyAY5.useContext($4d274c27f30533ed$export$2eeee58951ff3c1c);
    $4d274c27f30533ed$export$f5708dca728d7177(ctx, $4d274c27f30533ed$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $4d274c27f30533ed$var$useDataRouterState2(hookName) {
    let state = $eyAY5.useContext($4d274c27f30533ed$export$315e3ffb01f217);
    $4d274c27f30533ed$export$f5708dca728d7177(state, $4d274c27f30533ed$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $4d274c27f30533ed$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $4d274c27f30533ed$export$9770f232ac06a008();
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let path = $4d274c27f30533ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $eyAY5.useCallback((event)=>{
        if ($4d274c27f30533ed$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $4d274c27f30533ed$export$fe53371bee54353d(location) === $4d274c27f30533ed$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition
                });
            if (unstable_useTransitions) $eyAY5.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_useTransitions
    ]);
}
function $4d274c27f30533ed$export$f1a78c17382fe22a(defaultInit) {
    $4d274c27f30533ed$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $eyAY5.useRef($4d274c27f30533ed$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eyAY5.useRef(false);
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let searchParams = $eyAY5.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $4d274c27f30533ed$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $4d274c27f30533ed$export$9770f232ac06a008();
    let setSearchParams = $eyAY5.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $4d274c27f30533ed$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $4d274c27f30533ed$var$fetcherId = 0;
var $4d274c27f30533ed$var$getUniqueFetcherId = ()=>`__${String(++$4d274c27f30533ed$var$fetcherId)}__`;
function $4d274c27f30533ed$export$47c85c6e3a081d3() {
    let { router: router } = $4d274c27f30533ed$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let currentRouteId = $4d274c27f30533ed$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $eyAY5.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $4d274c27f30533ed$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $4d274c27f30533ed$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $4d274c27f30533ed$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let routeContext = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    $4d274c27f30533ed$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$4d274c27f30533ed$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $4d274c27f30533ed$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $4d274c27f30533ed$export$fe53371bee54353d(path);
}
function $4d274c27f30533ed$export$5b0d2d9a9921565a({ key: key } = {}) {
    var _route_matches_;
    let { router: router } = $4d274c27f30533ed$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $4d274c27f30533ed$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $eyAY5.useContext($4d274c27f30533ed$export$cb3f1df1bef00a39);
    let route = $eyAY5.useContext($4d274c27f30533ed$export$aac280ed165a4397);
    let routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    $4d274c27f30533ed$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $4d274c27f30533ed$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $4d274c27f30533ed$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $eyAY5.useId();
    let [fetcherKey, setFetcherKey] = $eyAY5.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $eyAY5.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $eyAY5.useCallback(async (href, opts)=>{
        $4d274c27f30533ed$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $4d274c27f30533ed$export$47c85c6e3a081d3();
    let submit = $eyAY5.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $eyAY5.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $eyAY5.useMemo(()=>{
        let FetcherForm2 = $eyAY5.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $4d274c27f30533ed$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $eyAY5.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $4d274c27f30533ed$export$fa996778a3a31087() {
    let state = $4d274c27f30533ed$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $4d274c27f30533ed$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $4d274c27f30533ed$var$savedScrollPositions = {};
function $4d274c27f30533ed$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $4d274c27f30533ed$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $4d274c27f30533ed$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $4d274c27f30533ed$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $4d274c27f30533ed$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $eyAY5.useContext($4d274c27f30533ed$export$3044ab7fdabeaee6);
    let location = $4d274c27f30533ed$export$45d76561a5302f2b();
    let matches = $4d274c27f30533ed$export$2378eb7f5ff86053();
    let navigation = $4d274c27f30533ed$export$d0fd4b7106de2769();
    $eyAY5.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $4d274c27f30533ed$var$usePageHide($eyAY5.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $4d274c27f30533ed$var$getScrollRestorationKey(location, matches, basename, getKey);
            $4d274c27f30533ed$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $4d274c27f30533ed$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($4d274c27f30533ed$var$savedScrollPositions));
        } catch (error) {
            $4d274c27f30533ed$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $eyAY5.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $4d274c27f30533ed$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $4d274c27f30533ed$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $eyAY5.useLayoutEffect(()=>{
            let disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration($4d274c27f30533ed$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$4d274c27f30533ed$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $eyAY5.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $4d274c27f30533ed$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $4d274c27f30533ed$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eyAY5.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $4d274c27f30533ed$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eyAY5.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $4d274c27f30533ed$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $4d274c27f30533ed$export$b273b3273281a049(when);
    $eyAY5.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eyAY5.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $4d274c27f30533ed$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $eyAY5.useContext($4d274c27f30533ed$export$3681f408decb40d1);
    $4d274c27f30533ed$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $4d274c27f30533ed$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $4d274c27f30533ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $4d274c27f30533ed$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $4d274c27f30533ed$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $4d274c27f30533ed$export$81336c211d5ff295(path.pathname, nextPath) != null || $4d274c27f30533ed$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $4d274c27f30533ed$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $4d274c27f30533ed$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $4d274c27f30533ed$var$getStatelessNavigator();
    return /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $4d274c27f30533ed$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $4d274c27f30533ed$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $4d274c27f30533ed$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $4d274c27f30533ed$var$serializeErrors(context.errors)
        };
        let json = $4d274c27f30533ed$var$htmlEscape(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $eyAY5.createElement($eyAY5.Fragment, null, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $eyAY5.createElement($4d274c27f30533ed$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $eyAY5.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $4d274c27f30533ed$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $4d274c27f30533ed$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $4d274c27f30533ed$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($4d274c27f30533ed$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $4d274c27f30533ed$var$getStatelessNavigator() {
    return {
        createHref: $4d274c27f30533ed$var$createHref,
        encodeLocation: $4d274c27f30533ed$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $4d274c27f30533ed$export$69163f0b72ec60d9(routes, opts) {
    return $4d274c27f30533ed$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $4d274c27f30533ed$export$9269a41d8c4635e
    });
}
function $4d274c27f30533ed$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $4d274c27f30533ed$export$87cb1a9238dc3fba(routes, $4d274c27f30533ed$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts === null || opts === void 0 ? void 0 : opts.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $4d274c27f30533ed$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $4d274c27f30533ed$var$createHref,
        encodeLocation: $4d274c27f30533ed$var$encodeLocation,
        getFetcher () {
            return $4d274c27f30533ed$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $4d274c27f30533ed$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $4d274c27f30533ed$var$createHref(to) {
    return typeof to === "string" ? to : $4d274c27f30533ed$export$fe53371bee54353d(to);
}
function $4d274c27f30533ed$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $4d274c27f30533ed$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $4d274c27f30533ed$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $4d274c27f30533ed$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $4d274c27f30533ed$var$ESCAPE_LOOKUP2 = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $4d274c27f30533ed$var$ESCAPE_REGEX2 = /[&><\u2028\u2029]/g;
function $4d274c27f30533ed$var$htmlEscape(str) {
    return str.replace($4d274c27f30533ed$var$ESCAPE_REGEX2, (match)=>$4d274c27f30533ed$var$ESCAPE_LOOKUP2[match]);
}

});

parcelRegister("4hstI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31ded72bbc26ca85$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");

var $4oINZ = parcelRequire("4oINZ");

var $jQI6N = parcelRequire("jQI6N");

var $awgS7 = parcelRequire("awgS7");
var $4emKc = parcelRequire("4emKc");

var $1xL2k = parcelRequire("1xL2k");


var $5rrtz = parcelRequire("5rrtz");

var $bAGRj = parcelRequire("bAGRj");

var $hpc08 = parcelRequire("hpc08");

var $487HQ = parcelRequire("487HQ");

var $3K1bR = parcelRequire("3K1bR");

var $4H7F6 = parcelRequire("4H7F6");
const $31ded72bbc26ca85$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $31ded72bbc26ca85$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $2kU93.default)(options, $31ded72bbc26ca85$var$_excluded);
    if (options.vars) throw new Error((0, $4oINZ.default)(18));
    const palette = (0, $bAGRj.default)(paletteInput);
    const systemTheme = (0, $1xL2k.default)(options);
    let muiTheme = (0, $jQI6N.default)(systemTheme, {
        mixins: (0, $5rrtz.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $487HQ.default).slice(),
        typography: (0, $hpc08.default)(palette, typographyInput),
        transitions: (0, $3K1bR.default)(transitionsInput),
        zIndex: (0, $ibF5z.default)({}, (0, $4H7F6.default))
    });
    muiTheme = (0, $jQI6N.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $jQI6N.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $ibF5z.default)({}, (0, $4emKc.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $awgS7.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $31ded72bbc26ca85$var$warnedOnce = false;
function $31ded72bbc26ca85$export$c469355549431d9b(...args) {
    return $31ded72bbc26ca85$var$createTheme(...args);
}
var $31ded72bbc26ca85$export$2e2bcd8739ae039 = $31ded72bbc26ca85$var$createTheme;

});
parcelRegister("ibF5z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d9207979707ad2$export$2e2bcd8739ae039; });
function $d3d9207979707ad2$export$2e2bcd8739ae039() {
    $d3d9207979707ad2$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3d9207979707ad2$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("2kU93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b39003de73b78c4$export$2e2bcd8739ae039; });
function $1b39003de73b78c4$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("4oINZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $333c28b3734877e0$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $333c28b3734877e0$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});

parcelRegister("jQI6N", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $e73516affd174e64$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $e73516affd174e64$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");
function $e73516affd174e64$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $e73516affd174e64$var$deepClone(source) {
    if (!$e73516affd174e64$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $e73516affd174e64$var$deepClone(source[key]);
    });
    return output;
}
function $e73516affd174e64$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $ibF5z.default)({}, target) : target;
    if ($e73516affd174e64$export$53b83ca8eaab0383(target) && $e73516affd174e64$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($e73516affd174e64$export$53b83ca8eaab0383(source[key]) && key in target && $e73516affd174e64$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $e73516affd174e64$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $e73516affd174e64$export$53b83ca8eaab0383(source[key]) ? $e73516affd174e64$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("awgS7", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $7a89faf872bf19b2$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $7a89faf872bf19b2$export$2e2bcd8739ae039; });

var $jEG8Q = parcelRequire("jEG8Q");

var $3tr7d = parcelRequire("3tr7d");

var $lQ6FO = parcelRequire("lQ6FO");

var $lJ4wZ = parcelRequire("lJ4wZ");

var $4emKc = parcelRequire("4emKc");
function $7a89faf872bf19b2$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $7a89faf872bf19b2$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $7a89faf872bf19b2$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $lQ6FO.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $lQ6FO.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $lQ6FO.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $jEG8Q.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lJ4wZ.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $4emKc.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $lJ4wZ.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $7a89faf872bf19b2$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $3tr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $lJ4wZ.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($7a89faf872bf19b2$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $3tr7d.default)(css, breakpointsValues);
                        }
                    } else css = (0, $3tr7d.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $lJ4wZ.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $7a89faf872bf19b2$var$styleFunctionSx = $7a89faf872bf19b2$export$7d53d8bf2911e013();
$7a89faf872bf19b2$var$styleFunctionSx.filterProps = [
    "sx"
];
var $7a89faf872bf19b2$export$2e2bcd8739ae039 = $7a89faf872bf19b2$var$styleFunctionSx;

});
parcelRegister("jEG8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4f27130bccba62b$export$2e2bcd8739ae039; });

var $4oINZ = parcelRequire("4oINZ");
function $e4f27130bccba62b$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $4oINZ.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});

parcelRegister("3tr7d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28791d1192e8f59e$export$2e2bcd8739ae039; });

var $jQI6N = parcelRequire("jQI6N");
function $28791d1192e8f59e$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $jQI6N.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $28791d1192e8f59e$export$2e2bcd8739ae039 = $28791d1192e8f59e$var$merge;

});

parcelRegister("lQ6FO", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $fe63a182915c4576$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $fe63a182915c4576$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $fe63a182915c4576$export$2e2bcd8739ae039; });

var $jEG8Q = parcelRequire("jEG8Q");


var $lJ4wZ = parcelRequire("lJ4wZ");
function $fe63a182915c4576$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $fe63a182915c4576$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $fe63a182915c4576$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $fe63a182915c4576$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $fe63a182915c4576$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $fe63a182915c4576$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $fe63a182915c4576$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $jEG8Q.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $lJ4wZ.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $fe63a182915c4576$export$2e2bcd8739ae039 = $fe63a182915c4576$var$style;

});
parcelRegister("lJ4wZ", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $fd1150bcfa255058$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $fd1150bcfa255058$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $fd1150bcfa255058$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $fd1150bcfa255058$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $fd1150bcfa255058$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $fd1150bcfa255058$export$980e6a259d807490; });

var $ibF5z = parcelRequire("ibF5z");


var $jQI6N = parcelRequire("jQI6N");

var $3tr7d = parcelRequire("3tr7d");
const $fd1150bcfa255058$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $fd1150bcfa255058$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$fd1150bcfa255058$export$68c286be0e7e55b7[key]}px)`
};
function $fd1150bcfa255058$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $fd1150bcfa255058$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $fd1150bcfa255058$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $fd1150bcfa255058$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $fd1150bcfa255058$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $fd1150bcfa255058$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $ibF5z.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $3tr7d.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $fd1150bcfa255058$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $fd1150bcfa255058$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $fd1150bcfa255058$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $fd1150bcfa255058$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $jQI6N.default)(prev, next), {});
    return $fd1150bcfa255058$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $fd1150bcfa255058$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $fd1150bcfa255058$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $fd1150bcfa255058$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $fd1150bcfa255058$export$2e2bcd8739ae039 = $fd1150bcfa255058$var$breakpoints;

});


parcelRegister("4emKc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $314a1cba9aed8572$export$2e2bcd8739ae039; });

var $lGLZn = parcelRequire("lGLZn");

var $9Rn5m = parcelRequire("9Rn5m");

var $iMfdk = parcelRequire("iMfdk");

var $g96aB = parcelRequire("g96aB");

var $6uh0W = parcelRequire("6uh0W");
const $314a1cba9aed8572$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $9Rn5m.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $9Rn5m.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $9Rn5m.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $9Rn5m.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $9Rn5m.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $9Rn5m.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $9Rn5m.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $g96aB.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $g96aB.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $g96aB.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $lGLZn.padding)
    },
    pt: {
        style: (0, $lGLZn.padding)
    },
    pr: {
        style: (0, $lGLZn.padding)
    },
    pb: {
        style: (0, $lGLZn.padding)
    },
    pl: {
        style: (0, $lGLZn.padding)
    },
    px: {
        style: (0, $lGLZn.padding)
    },
    py: {
        style: (0, $lGLZn.padding)
    },
    padding: {
        style: (0, $lGLZn.padding)
    },
    paddingTop: {
        style: (0, $lGLZn.padding)
    },
    paddingRight: {
        style: (0, $lGLZn.padding)
    },
    paddingBottom: {
        style: (0, $lGLZn.padding)
    },
    paddingLeft: {
        style: (0, $lGLZn.padding)
    },
    paddingX: {
        style: (0, $lGLZn.padding)
    },
    paddingY: {
        style: (0, $lGLZn.padding)
    },
    paddingInline: {
        style: (0, $lGLZn.padding)
    },
    paddingInlineStart: {
        style: (0, $lGLZn.padding)
    },
    paddingInlineEnd: {
        style: (0, $lGLZn.padding)
    },
    paddingBlock: {
        style: (0, $lGLZn.padding)
    },
    paddingBlockStart: {
        style: (0, $lGLZn.padding)
    },
    paddingBlockEnd: {
        style: (0, $lGLZn.padding)
    },
    m: {
        style: (0, $lGLZn.margin)
    },
    mt: {
        style: (0, $lGLZn.margin)
    },
    mr: {
        style: (0, $lGLZn.margin)
    },
    mb: {
        style: (0, $lGLZn.margin)
    },
    ml: {
        style: (0, $lGLZn.margin)
    },
    mx: {
        style: (0, $lGLZn.margin)
    },
    my: {
        style: (0, $lGLZn.margin)
    },
    margin: {
        style: (0, $lGLZn.margin)
    },
    marginTop: {
        style: (0, $lGLZn.margin)
    },
    marginRight: {
        style: (0, $lGLZn.margin)
    },
    marginBottom: {
        style: (0, $lGLZn.margin)
    },
    marginLeft: {
        style: (0, $lGLZn.margin)
    },
    marginX: {
        style: (0, $lGLZn.margin)
    },
    marginY: {
        style: (0, $lGLZn.margin)
    },
    marginInline: {
        style: (0, $lGLZn.margin)
    },
    marginInlineStart: {
        style: (0, $lGLZn.margin)
    },
    marginInlineEnd: {
        style: (0, $lGLZn.margin)
    },
    marginBlock: {
        style: (0, $lGLZn.margin)
    },
    marginBlockStart: {
        style: (0, $lGLZn.margin)
    },
    marginBlockEnd: {
        style: (0, $lGLZn.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $iMfdk.gap)
    },
    rowGap: {
        style: (0, $iMfdk.rowGap)
    },
    columnGap: {
        style: (0, $iMfdk.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $6uh0W.sizingTransform)
    },
    maxWidth: {
        style: (0, $6uh0W.maxWidth)
    },
    minWidth: {
        transform: (0, $6uh0W.sizingTransform)
    },
    height: {
        transform: (0, $6uh0W.sizingTransform)
    },
    maxHeight: {
        transform: (0, $6uh0W.sizingTransform)
    },
    minHeight: {
        transform: (0, $6uh0W.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $314a1cba9aed8572$export$2e2bcd8739ae039 = $314a1cba9aed8572$var$defaultSxConfig;

});
parcelRegister("lGLZn", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $fca2bed087288f4d$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $fca2bed087288f4d$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $fca2bed087288f4d$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $fca2bed087288f4d$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $fca2bed087288f4d$export$6f98e8eaf0be1996; });


var $lJ4wZ = parcelRequire("lJ4wZ");

var $lQ6FO = parcelRequire("lQ6FO");

var $3tr7d = parcelRequire("3tr7d");

var $b9LhI = parcelRequire("b9LhI");
const $fca2bed087288f4d$var$properties = {
    m: "margin",
    p: "padding"
};
const $fca2bed087288f4d$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $fca2bed087288f4d$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $fca2bed087288f4d$var$getCssProperties = (0, $b9LhI.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($fca2bed087288f4d$var$aliases[prop]) prop = $fca2bed087288f4d$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $fca2bed087288f4d$var$properties[a];
    const direction = $fca2bed087288f4d$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $fca2bed087288f4d$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $fca2bed087288f4d$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $fca2bed087288f4d$var$spacingKeys = [
    ...$fca2bed087288f4d$export$aab52a0dde05ad8a,
    ...$fca2bed087288f4d$export$f8397d44f03ab6ad
];
function $fca2bed087288f4d$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $lQ6FO.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $fca2bed087288f4d$export$1def6f833384e3d1(theme) {
    return $fca2bed087288f4d$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $fca2bed087288f4d$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $fca2bed087288f4d$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $fca2bed087288f4d$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $fca2bed087288f4d$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $fca2bed087288f4d$var$getCssProperties(prop);
    const styleFromPropValue = $fca2bed087288f4d$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $lJ4wZ.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $fca2bed087288f4d$var$style(props, keys) {
    const transformer = $fca2bed087288f4d$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$fca2bed087288f4d$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $3tr7d.default), {});
}
function $fca2bed087288f4d$export$7ede87f9b603dd3c(props) {
    return $fca2bed087288f4d$var$style(props, $fca2bed087288f4d$export$aab52a0dde05ad8a);
}
$fca2bed087288f4d$export$7ede87f9b603dd3c.propTypes = {};
$fca2bed087288f4d$export$7ede87f9b603dd3c.filterProps = $fca2bed087288f4d$export$aab52a0dde05ad8a;
function $fca2bed087288f4d$export$6f98e8eaf0be1996(props) {
    return $fca2bed087288f4d$var$style(props, $fca2bed087288f4d$export$f8397d44f03ab6ad);
}
$fca2bed087288f4d$export$6f98e8eaf0be1996.propTypes = {};
$fca2bed087288f4d$export$6f98e8eaf0be1996.filterProps = $fca2bed087288f4d$export$f8397d44f03ab6ad;
function $fca2bed087288f4d$var$spacing(props) {
    return $fca2bed087288f4d$var$style(props, $fca2bed087288f4d$var$spacingKeys);
}
$fca2bed087288f4d$var$spacing.propTypes = {};
$fca2bed087288f4d$var$spacing.filterProps = $fca2bed087288f4d$var$spacingKeys;
var $fca2bed087288f4d$export$2e2bcd8739ae039 = $fca2bed087288f4d$var$spacing;

});
parcelRegister("b9LhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81f536b90db9747b$export$2e2bcd8739ae039; });
function $81f536b90db9747b$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("9Rn5m", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $72daf8912bf622ca$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $72daf8912bf622ca$export$7a57f79000377ca2; });


var $lQ6FO = parcelRequire("lQ6FO");

var $fl9dB = parcelRequire("fl9dB");

var $lGLZn = parcelRequire("lGLZn");

var $lJ4wZ = parcelRequire("lJ4wZ");
function $72daf8912bf622ca$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $72daf8912bf622ca$var$createBorderStyle(prop, transform) {
    return (0, $lQ6FO.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $72daf8912bf622ca$export$1edee58a52776cd9 = $72daf8912bf622ca$var$createBorderStyle("border", $72daf8912bf622ca$export$34e2febe53ae29cc);
const $72daf8912bf622ca$export$f9a7b6bd24892946 = $72daf8912bf622ca$var$createBorderStyle("borderTop", $72daf8912bf622ca$export$34e2febe53ae29cc);
const $72daf8912bf622ca$export$5abca33e6be905d2 = $72daf8912bf622ca$var$createBorderStyle("borderRight", $72daf8912bf622ca$export$34e2febe53ae29cc);
const $72daf8912bf622ca$export$e2ce9f12a980a822 = $72daf8912bf622ca$var$createBorderStyle("borderBottom", $72daf8912bf622ca$export$34e2febe53ae29cc);
const $72daf8912bf622ca$export$47658cca1a909427 = $72daf8912bf622ca$var$createBorderStyle("borderLeft", $72daf8912bf622ca$export$34e2febe53ae29cc);
const $72daf8912bf622ca$export$e7fb0694ba2404fc = $72daf8912bf622ca$var$createBorderStyle("borderColor");
const $72daf8912bf622ca$export$126a92c968acdb85 = $72daf8912bf622ca$var$createBorderStyle("borderTopColor");
const $72daf8912bf622ca$export$85cc51cb8fbb8c0e = $72daf8912bf622ca$var$createBorderStyle("borderRightColor");
const $72daf8912bf622ca$export$340b0327727f6d1a = $72daf8912bf622ca$var$createBorderStyle("borderBottomColor");
const $72daf8912bf622ca$export$60beef91a985b4bf = $72daf8912bf622ca$var$createBorderStyle("borderLeftColor");
const $72daf8912bf622ca$export$f9258c55612cbed7 = $72daf8912bf622ca$var$createBorderStyle("outline", $72daf8912bf622ca$export$34e2febe53ae29cc);
const $72daf8912bf622ca$export$621fe586efeb64b9 = $72daf8912bf622ca$var$createBorderStyle("outlineColor");
const $72daf8912bf622ca$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $lGLZn.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $lGLZn.getValue)(transformer, propValue)
            });
        return (0, $lJ4wZ.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$72daf8912bf622ca$export$7a57f79000377ca2.propTypes = {};
$72daf8912bf622ca$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $72daf8912bf622ca$var$borders = (0, $fl9dB.default)($72daf8912bf622ca$export$1edee58a52776cd9, $72daf8912bf622ca$export$f9a7b6bd24892946, $72daf8912bf622ca$export$5abca33e6be905d2, $72daf8912bf622ca$export$e2ce9f12a980a822, $72daf8912bf622ca$export$47658cca1a909427, $72daf8912bf622ca$export$e7fb0694ba2404fc, $72daf8912bf622ca$export$126a92c968acdb85, $72daf8912bf622ca$export$85cc51cb8fbb8c0e, $72daf8912bf622ca$export$340b0327727f6d1a, $72daf8912bf622ca$export$60beef91a985b4bf, $72daf8912bf622ca$export$7a57f79000377ca2, $72daf8912bf622ca$export$f9258c55612cbed7, $72daf8912bf622ca$export$621fe586efeb64b9);
var $72daf8912bf622ca$export$2e2bcd8739ae039 = $72daf8912bf622ca$var$borders;

});
parcelRegister("fl9dB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2aff7c2210b7c1b$export$2e2bcd8739ae039; });

var $3tr7d = parcelRequire("3tr7d");
function $b2aff7c2210b7c1b$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $3tr7d.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $b2aff7c2210b7c1b$export$2e2bcd8739ae039 = $b2aff7c2210b7c1b$var$compose;

});


parcelRegister("iMfdk", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $dab882e3f9c8368b$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $dab882e3f9c8368b$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $dab882e3f9c8368b$export$8a833ffa5f5dbeda; });

var $lQ6FO = parcelRequire("lQ6FO");

var $fl9dB = parcelRequire("fl9dB");

var $lGLZn = parcelRequire("lGLZn");

var $lJ4wZ = parcelRequire("lJ4wZ");

const $dab882e3f9c8368b$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $lGLZn.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $lGLZn.getValue)(transformer, propValue)
            });
        return (0, $lJ4wZ.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$dab882e3f9c8368b$export$5df9adcb0db95e1e.propTypes = {};
$dab882e3f9c8368b$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $dab882e3f9c8368b$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $lGLZn.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $lGLZn.getValue)(transformer, propValue)
            });
        return (0, $lJ4wZ.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$dab882e3f9c8368b$export$ec60d70ff941a580.propTypes = {};
$dab882e3f9c8368b$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $dab882e3f9c8368b$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $lGLZn.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $lGLZn.getValue)(transformer, propValue)
            });
        return (0, $lJ4wZ.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$dab882e3f9c8368b$export$8a833ffa5f5dbeda.propTypes = {};
$dab882e3f9c8368b$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $dab882e3f9c8368b$export$baf44164ca3a34e8 = (0, $lQ6FO.default)({
    prop: "gridColumn"
});
const $dab882e3f9c8368b$export$8f7213a1cd01e832 = (0, $lQ6FO.default)({
    prop: "gridRow"
});
const $dab882e3f9c8368b$export$b0e0abbc49ba668 = (0, $lQ6FO.default)({
    prop: "gridAutoFlow"
});
const $dab882e3f9c8368b$export$bcd8b929d4b4142 = (0, $lQ6FO.default)({
    prop: "gridAutoColumns"
});
const $dab882e3f9c8368b$export$e5039a674e14c828 = (0, $lQ6FO.default)({
    prop: "gridAutoRows"
});
const $dab882e3f9c8368b$export$42bd9088661ffb03 = (0, $lQ6FO.default)({
    prop: "gridTemplateColumns"
});
const $dab882e3f9c8368b$export$920682ae05b999bc = (0, $lQ6FO.default)({
    prop: "gridTemplateRows"
});
const $dab882e3f9c8368b$export$1b88fbdd482fd33a = (0, $lQ6FO.default)({
    prop: "gridTemplateAreas"
});
const $dab882e3f9c8368b$export$bdb486e40d52d26f = (0, $lQ6FO.default)({
    prop: "gridArea"
});
const $dab882e3f9c8368b$var$grid = (0, $fl9dB.default)($dab882e3f9c8368b$export$5df9adcb0db95e1e, $dab882e3f9c8368b$export$ec60d70ff941a580, $dab882e3f9c8368b$export$8a833ffa5f5dbeda, $dab882e3f9c8368b$export$baf44164ca3a34e8, $dab882e3f9c8368b$export$8f7213a1cd01e832, $dab882e3f9c8368b$export$b0e0abbc49ba668, $dab882e3f9c8368b$export$bcd8b929d4b4142, $dab882e3f9c8368b$export$e5039a674e14c828, $dab882e3f9c8368b$export$42bd9088661ffb03, $dab882e3f9c8368b$export$920682ae05b999bc, $dab882e3f9c8368b$export$1b88fbdd482fd33a, $dab882e3f9c8368b$export$bdb486e40d52d26f);
var $dab882e3f9c8368b$export$2e2bcd8739ae039 = $dab882e3f9c8368b$var$grid;

});

parcelRegister("g96aB", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $bc1245dd93a7bdd0$export$dbaffd4420ea0ac6; });

var $lQ6FO = parcelRequire("lQ6FO");

var $fl9dB = parcelRequire("fl9dB");
function $bc1245dd93a7bdd0$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $bc1245dd93a7bdd0$export$35e9368ef982300f = (0, $lQ6FO.default)({
    prop: "color",
    themeKey: "palette",
    transform: $bc1245dd93a7bdd0$export$dbaffd4420ea0ac6
});
const $bc1245dd93a7bdd0$export$2506f56c10355b33 = (0, $lQ6FO.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $bc1245dd93a7bdd0$export$dbaffd4420ea0ac6
});
const $bc1245dd93a7bdd0$export$8c5a050822fd698c = (0, $lQ6FO.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $bc1245dd93a7bdd0$export$dbaffd4420ea0ac6
});
const $bc1245dd93a7bdd0$var$palette = (0, $fl9dB.default)($bc1245dd93a7bdd0$export$35e9368ef982300f, $bc1245dd93a7bdd0$export$2506f56c10355b33, $bc1245dd93a7bdd0$export$8c5a050822fd698c);
var $bc1245dd93a7bdd0$export$2e2bcd8739ae039 = $bc1245dd93a7bdd0$var$palette;

});

parcelRegister("6uh0W", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $4b92be117608cc1c$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $4b92be117608cc1c$export$488fda99655ff65a; });

var $lQ6FO = parcelRequire("lQ6FO");

var $fl9dB = parcelRequire("fl9dB");

var $lJ4wZ = parcelRequire("lJ4wZ");
function $4b92be117608cc1c$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $4b92be117608cc1c$export$7e3df82ee760448c = (0, $lQ6FO.default)({
    prop: "width",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $lJ4wZ.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $4b92be117608cc1c$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $lJ4wZ.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$4b92be117608cc1c$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $4b92be117608cc1c$export$ee148fbbe8357dd2 = (0, $lQ6FO.default)({
    prop: "minWidth",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$ac607276a8fe9f0a = (0, $lQ6FO.default)({
    prop: "height",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$dc0d8bd0b94f8570 = (0, $lQ6FO.default)({
    prop: "maxHeight",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$a43cf604e12f3b17 = (0, $lQ6FO.default)({
    prop: "minHeight",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$ffed9f14fb65e276 = (0, $lQ6FO.default)({
    prop: "size",
    cssProperty: "width",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$905076ed6620e671 = (0, $lQ6FO.default)({
    prop: "size",
    cssProperty: "height",
    transform: $4b92be117608cc1c$export$8afece71750ec241
});
const $4b92be117608cc1c$export$6ccc93f785106a58 = (0, $lQ6FO.default)({
    prop: "boxSizing"
});
const $4b92be117608cc1c$var$sizing = (0, $fl9dB.default)($4b92be117608cc1c$export$7e3df82ee760448c, $4b92be117608cc1c$export$488fda99655ff65a, $4b92be117608cc1c$export$ee148fbbe8357dd2, $4b92be117608cc1c$export$ac607276a8fe9f0a, $4b92be117608cc1c$export$dc0d8bd0b94f8570, $4b92be117608cc1c$export$a43cf604e12f3b17, $4b92be117608cc1c$export$6ccc93f785106a58);
var $4b92be117608cc1c$export$2e2bcd8739ae039 = $4b92be117608cc1c$var$sizing;

});



parcelRegister("1xL2k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11fd5c0308be79af$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");

var $jQI6N = parcelRequire("jQI6N");

var $gVbBu = parcelRequire("gVbBu");

var $6KWlr = parcelRequire("6KWlr");

var $koJwh = parcelRequire("koJwh");

var $awgS7 = parcelRequire("awgS7");

var $4emKc = parcelRequire("4emKc");

var $dkpA7 = parcelRequire("dkpA7");
const $11fd5c0308be79af$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $11fd5c0308be79af$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $2kU93.default)(options, $11fd5c0308be79af$var$_excluded);
    const breakpoints = (0, $gVbBu.default)(breakpointsInput);
    const spacing = (0, $koJwh.default)(spacingInput);
    let muiTheme = (0, $jQI6N.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $ibF5z.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $ibF5z.default)({}, (0, $6KWlr.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $dkpA7.default);
    muiTheme = args.reduce((acc, argument)=>(0, $jQI6N.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $ibF5z.default)({}, (0, $4emKc.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $awgS7.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $11fd5c0308be79af$export$2e2bcd8739ae039 = $11fd5c0308be79af$var$createTheme;

});
parcelRegister("gVbBu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51af8700c378397$export$2e2bcd8739ae039; });

var $2kU93 = parcelRequire("2kU93");

var $ibF5z = parcelRequire("ibF5z");
const $c51af8700c378397$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $c51af8700c378397$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $c51af8700c378397$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $ibF5z.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $c51af8700c378397$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $2kU93.default)(breakpoints, $c51af8700c378397$var$_excluded);
    const sortedValues = $c51af8700c378397$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $ibF5z.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("6KWlr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb44c02826121fd$export$2e2bcd8739ae039; });
const $4eb44c02826121fd$var$shape = {
    borderRadius: 4
};
var $4eb44c02826121fd$export$2e2bcd8739ae039 = $4eb44c02826121fd$var$shape;

});

parcelRegister("koJwh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed995bc8f2dbea80$export$2e2bcd8739ae039; });

var $lGLZn = parcelRequire("lGLZn");
function $ed995bc8f2dbea80$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $lGLZn.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("dkpA7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b40fc91f3f309a6$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $9b40fc91f3f309a6$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("5rrtz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f64c98456c55374$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");
function $3f64c98456c55374$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $ibF5z.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("bAGRj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87044d5ce80e9ac3$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");

var $4oINZ = parcelRequire("4oINZ");

var $jQI6N = parcelRequire("jQI6N");

var $g6JN1 = parcelRequire("g6JN1");

var $blNh4 = parcelRequire("blNh4");

var $6hyvv = parcelRequire("6hyvv");

var $KuENH = parcelRequire("KuENH");

var $j24Pr = parcelRequire("j24Pr");

var $iJlPk = parcelRequire("iJlPk");

var $9XOLS = parcelRequire("9XOLS");

var $faBbL = parcelRequire("faBbL");

var $cgsMU = parcelRequire("cgsMU");
const $87044d5ce80e9ac3$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $87044d5ce80e9ac3$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $blNh4.default).white,
        default: (0, $blNh4.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $87044d5ce80e9ac3$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $blNh4.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $blNh4.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $87044d5ce80e9ac3$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $g6JN1.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $g6JN1.darken)(intent.main, tonalOffsetDark);
    }
}
function $87044d5ce80e9ac3$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9XOLS.default)[200],
        light: (0, $9XOLS.default)[50],
        dark: (0, $9XOLS.default)[400]
    };
    return {
        main: (0, $9XOLS.default)[700],
        light: (0, $9XOLS.default)[400],
        dark: (0, $9XOLS.default)[800]
    };
}
function $87044d5ce80e9ac3$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $KuENH.default)[200],
        light: (0, $KuENH.default)[50],
        dark: (0, $KuENH.default)[400]
    };
    return {
        main: (0, $KuENH.default)[500],
        light: (0, $KuENH.default)[300],
        dark: (0, $KuENH.default)[700]
    };
}
function $87044d5ce80e9ac3$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $j24Pr.default)[500],
        light: (0, $j24Pr.default)[300],
        dark: (0, $j24Pr.default)[700]
    };
    return {
        main: (0, $j24Pr.default)[700],
        light: (0, $j24Pr.default)[400],
        dark: (0, $j24Pr.default)[800]
    };
}
function $87044d5ce80e9ac3$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $faBbL.default)[400],
        light: (0, $faBbL.default)[300],
        dark: (0, $faBbL.default)[700]
    };
    return {
        main: (0, $faBbL.default)[700],
        light: (0, $faBbL.default)[500],
        dark: (0, $faBbL.default)[900]
    };
}
function $87044d5ce80e9ac3$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $cgsMU.default)[400],
        light: (0, $cgsMU.default)[300],
        dark: (0, $cgsMU.default)[700]
    };
    return {
        main: (0, $cgsMU.default)[800],
        light: (0, $cgsMU.default)[500],
        dark: (0, $cgsMU.default)[900]
    };
}
function $87044d5ce80e9ac3$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iJlPk.default)[400],
        light: (0, $iJlPk.default)[300],
        dark: (0, $iJlPk.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $iJlPk.default)[500],
        dark: (0, $iJlPk.default)[900]
    };
}
function $87044d5ce80e9ac3$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $2kU93.default)(palette, $87044d5ce80e9ac3$var$_excluded);
    const primary = palette.primary || $87044d5ce80e9ac3$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $87044d5ce80e9ac3$var$getDefaultSecondary(mode);
    const error = palette.error || $87044d5ce80e9ac3$var$getDefaultError(mode);
    const info = palette.info || $87044d5ce80e9ac3$var$getDefaultInfo(mode);
    const success = palette.success || $87044d5ce80e9ac3$var$getDefaultSuccess(mode);
    const warning = palette.warning || $87044d5ce80e9ac3$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $g6JN1.getContrastRatio)(background, $87044d5ce80e9ac3$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $87044d5ce80e9ac3$export$55ce6f3a06c59543.text.primary : $87044d5ce80e9ac3$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $ibF5z.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $4oINZ.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $4oINZ.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $87044d5ce80e9ac3$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $87044d5ce80e9ac3$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $87044d5ce80e9ac3$export$55ce6f3a06c59543,
        light: $87044d5ce80e9ac3$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $jQI6N.default)((0, $ibF5z.default)({
        // A collection of common colors.
        common: (0, $ibF5z.default)({}, (0, $blNh4.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $6hyvv.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("g6JN1", function(module, exports) {
"use strict";

var $k87LI = parcelRequire("k87LI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $bba0b9c2d00f389f$var$alpha;
module.exports.blend = $bba0b9c2d00f389f$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $bba0b9c2d00f389f$var$darken;
module.exports.decomposeColor = $bba0b9c2d00f389f$var$decomposeColor;
module.exports.emphasize = $bba0b9c2d00f389f$var$emphasize;
module.exports.getContrastRatio = $bba0b9c2d00f389f$var$getContrastRatio;
module.exports.getLuminance = $bba0b9c2d00f389f$var$getLuminance;
module.exports.hexToRgb = $bba0b9c2d00f389f$var$hexToRgb;
module.exports.hslToRgb = $bba0b9c2d00f389f$var$hslToRgb;
module.exports.lighten = $bba0b9c2d00f389f$var$lighten;
module.exports.private_safeAlpha = $bba0b9c2d00f389f$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $bba0b9c2d00f389f$var$private_safeDarken;
module.exports.private_safeEmphasize = $bba0b9c2d00f389f$var$private_safeEmphasize;
module.exports.private_safeLighten = $bba0b9c2d00f389f$var$private_safeLighten;
module.exports.recomposeColor = $bba0b9c2d00f389f$var$recomposeColor;
module.exports.rgbToHex = $bba0b9c2d00f389f$var$rgbToHex;

var $bba0b9c2d00f389f$var$_formatMuiErrorMessage2 = $k87LI((parcelRequire("br59W")));

var $bba0b9c2d00f389f$var$_clamp = $k87LI((parcelRequire("3K9k3")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $bba0b9c2d00f389f$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $bba0b9c2d00f389f$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $bba0b9c2d00f389f$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $bba0b9c2d00f389f$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $bba0b9c2d00f389f$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $bba0b9c2d00f389f$var$decomposeColor($bba0b9c2d00f389f$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $bba0b9c2d00f389f$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $bba0b9c2d00f389f$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $bba0b9c2d00f389f$var$colorChannel = (color)=>{
    const decomposedColor = $bba0b9c2d00f389f$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $bba0b9c2d00f389f$var$colorChannel;
const $bba0b9c2d00f389f$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $bba0b9c2d00f389f$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $bba0b9c2d00f389f$var$private_safeColorChannel;
function $bba0b9c2d00f389f$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $bba0b9c2d00f389f$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $bba0b9c2d00f389f$var$decomposeColor(color);
    return `#${values.map((n, i)=>$bba0b9c2d00f389f$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $bba0b9c2d00f389f$var$hslToRgb(color) {
    color = $bba0b9c2d00f389f$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $bba0b9c2d00f389f$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $bba0b9c2d00f389f$var$getLuminance(color) {
    color = $bba0b9c2d00f389f$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $bba0b9c2d00f389f$var$decomposeColor($bba0b9c2d00f389f$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $bba0b9c2d00f389f$var$getContrastRatio(foreground, background) {
    const lumA = $bba0b9c2d00f389f$var$getLuminance(foreground);
    const lumB = $bba0b9c2d00f389f$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $bba0b9c2d00f389f$var$alpha(color, value) {
    color = $bba0b9c2d00f389f$var$decomposeColor(color);
    value = $bba0b9c2d00f389f$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $bba0b9c2d00f389f$var$recomposeColor(color);
}
function $bba0b9c2d00f389f$var$private_safeAlpha(color, value, warning) {
    try {
        return $bba0b9c2d00f389f$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $bba0b9c2d00f389f$var$darken(color, coefficient) {
    color = $bba0b9c2d00f389f$var$decomposeColor(color);
    coefficient = $bba0b9c2d00f389f$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $bba0b9c2d00f389f$var$recomposeColor(color);
}
function $bba0b9c2d00f389f$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $bba0b9c2d00f389f$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $bba0b9c2d00f389f$var$lighten(color, coefficient) {
    color = $bba0b9c2d00f389f$var$decomposeColor(color);
    coefficient = $bba0b9c2d00f389f$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $bba0b9c2d00f389f$var$recomposeColor(color);
}
function $bba0b9c2d00f389f$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $bba0b9c2d00f389f$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $bba0b9c2d00f389f$var$emphasize(color, coefficient = 0.15) {
    return $bba0b9c2d00f389f$var$getLuminance(color) > 0.5 ? $bba0b9c2d00f389f$var$darken(color, coefficient) : $bba0b9c2d00f389f$var$lighten(color, coefficient);
}
function $bba0b9c2d00f389f$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $bba0b9c2d00f389f$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $bba0b9c2d00f389f$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $bba0b9c2d00f389f$var$decomposeColor(background);
    const overlayColor = $bba0b9c2d00f389f$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $bba0b9c2d00f389f$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("k87LI", function(module, exports) {
function $ea7a94a959115889$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $ea7a94a959115889$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("br59W", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4oINZ")).default; });

var $4oINZ = parcelRequire("4oINZ");

});

parcelRegister("3K9k3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("inp1X")).default; });

var $inp1X = parcelRequire("inp1X");

});
parcelRegister("inp1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d60dca8207a09df4$export$2e2bcd8739ae039; });
function $d60dca8207a09df4$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $d60dca8207a09df4$export$2e2bcd8739ae039 = $d60dca8207a09df4$var$clamp;

});



parcelRegister("blNh4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8437e0b65c570313$export$2e2bcd8739ae039; });
const $8437e0b65c570313$var$common = {
    black: "#000",
    white: "#fff"
};
var $8437e0b65c570313$export$2e2bcd8739ae039 = $8437e0b65c570313$var$common;

});

parcelRegister("6hyvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $492f18fecc0bd3f5$export$2e2bcd8739ae039; });
const $492f18fecc0bd3f5$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $492f18fecc0bd3f5$export$2e2bcd8739ae039 = $492f18fecc0bd3f5$var$grey;

});

parcelRegister("KuENH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08bc13d94ef1cc26$export$2e2bcd8739ae039; });
const $08bc13d94ef1cc26$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $08bc13d94ef1cc26$export$2e2bcd8739ae039 = $08bc13d94ef1cc26$var$purple;

});

parcelRegister("j24Pr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb1f31891be25f3$export$2e2bcd8739ae039; });
const $ddb1f31891be25f3$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $ddb1f31891be25f3$export$2e2bcd8739ae039 = $ddb1f31891be25f3$var$red;

});

parcelRegister("iJlPk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da2d5c4d4384beb8$export$2e2bcd8739ae039; });
const $da2d5c4d4384beb8$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $da2d5c4d4384beb8$export$2e2bcd8739ae039 = $da2d5c4d4384beb8$var$orange;

});

parcelRegister("9XOLS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $741101d416354338$export$2e2bcd8739ae039; });
const $741101d416354338$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $741101d416354338$export$2e2bcd8739ae039 = $741101d416354338$var$blue;

});

parcelRegister("faBbL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0b4a3127573f059$export$2e2bcd8739ae039; });
const $b0b4a3127573f059$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $b0b4a3127573f059$export$2e2bcd8739ae039 = $b0b4a3127573f059$var$lightBlue;

});

parcelRegister("cgsMU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8edd4f4f3c4d36e6$export$2e2bcd8739ae039; });
const $8edd4f4f3c4d36e6$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $8edd4f4f3c4d36e6$export$2e2bcd8739ae039 = $8edd4f4f3c4d36e6$var$green;

});


parcelRegister("hpc08", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cabe14a8440b33b4$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");

var $jQI6N = parcelRequire("jQI6N");
const $cabe14a8440b33b4$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $cabe14a8440b33b4$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $cabe14a8440b33b4$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $cabe14a8440b33b4$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $cabe14a8440b33b4$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $cabe14a8440b33b4$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $2kU93.default)(_ref, $cabe14a8440b33b4$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $ibF5z.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $cabe14a8440b33b4$var$defaultFontFamily ? {
            letterSpacing: `${$cabe14a8440b33b4$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $cabe14a8440b33b4$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $cabe14a8440b33b4$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $jQI6N.default)((0, $ibF5z.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("487HQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $301de30a89ef8168$export$2e2bcd8739ae039; });
const $301de30a89ef8168$var$shadowKeyUmbraOpacity = 0.2;
const $301de30a89ef8168$var$shadowKeyPenumbraOpacity = 0.14;
const $301de30a89ef8168$var$shadowAmbientShadowOpacity = 0.12;
function $301de30a89ef8168$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$301de30a89ef8168$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$301de30a89ef8168$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$301de30a89ef8168$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $301de30a89ef8168$var$shadows = [
    "none",
    $301de30a89ef8168$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $301de30a89ef8168$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $301de30a89ef8168$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $301de30a89ef8168$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $301de30a89ef8168$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $301de30a89ef8168$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $301de30a89ef8168$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $301de30a89ef8168$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $301de30a89ef8168$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $301de30a89ef8168$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $301de30a89ef8168$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $301de30a89ef8168$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $301de30a89ef8168$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $301de30a89ef8168$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $301de30a89ef8168$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $301de30a89ef8168$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $301de30a89ef8168$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $301de30a89ef8168$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $301de30a89ef8168$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $301de30a89ef8168$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $301de30a89ef8168$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $301de30a89ef8168$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $301de30a89ef8168$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $301de30a89ef8168$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $301de30a89ef8168$export$2e2bcd8739ae039 = $301de30a89ef8168$var$shadows;

});

parcelRegister("3K1bR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b96975948d91f11$export$2e2bcd8739ae039; });

var $2kU93 = parcelRequire("2kU93");

var $ibF5z = parcelRequire("ibF5z");
const $2b96975948d91f11$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $2b96975948d91f11$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $2b96975948d91f11$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $2b96975948d91f11$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $2b96975948d91f11$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $2b96975948d91f11$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $ibF5z.default)({}, $2b96975948d91f11$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $ibF5z.default)({}, $2b96975948d91f11$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $2kU93.default)(options, $2b96975948d91f11$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $2b96975948d91f11$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $2b96975948d91f11$var$formatMs(delay)}`).join(",");
    };
    return (0, $ibF5z.default)({
        getAutoHeightDuration: $2b96975948d91f11$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("4H7F6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36b11f12edbec97a$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $36b11f12edbec97a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $36b11f12edbec97a$export$2e2bcd8739ae039 = $36b11f12edbec97a$var$zIndex;

});


parcelRegister("7dn22", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $540b9cf9d3a03724$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");
parcelRequire("eyAY5");


var $eSwTq = parcelRequire("eSwTq");

var $8T9M8 = parcelRequire("8T9M8");

var $Dkugg = parcelRequire("Dkugg");
"use client";
const $540b9cf9d3a03724$var$_excluded = [
    "theme"
];
function $540b9cf9d3a03724$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $2kU93.default)(_ref, $540b9cf9d3a03724$var$_excluded);
    const scopedTheme = themeInput[0, $8T9M8.default];
    return /*#__PURE__*/ (0, $Dkugg.jsx)((0, $eSwTq.default), (0, $ibF5z.default)({}, props, {
        themeId: scopedTheme ? (0, $8T9M8.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

});
parcelRegister("eSwTq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad4f9fb679cc4555$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $eyAY5 = parcelRequire("eyAY5");


var $g1c4r = parcelRequire("g1c4r");
var $h8EYy = parcelRequire("h8EYy");

parcelRequire("2eN2x");
var $2rRc0 = parcelRequire("2rRc0");

var $iePPp = parcelRequire("iePPp");

var $h1my6 = parcelRequire("h1my6");

var $Dkugg = parcelRequire("Dkugg");
"use client";
const $ad4f9fb679cc4555$var$EMPTY_THEME = {};
function $ad4f9fb679cc4555$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $eyAY5.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $ibF5z.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $ibF5z.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $ibF5z.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $ad4f9fb679cc4555$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $iePPp.default)($ad4f9fb679cc4555$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $h8EYy.default)() || $ad4f9fb679cc4555$var$EMPTY_THEME;
    const engineTheme = $ad4f9fb679cc4555$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $ad4f9fb679cc4555$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === "rtl";
    return /*#__PURE__*/ (0, $Dkugg.jsx)((0, $g1c4r.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $Dkugg.jsx)((0, $2rRc0.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $Dkugg.jsx)((0, $h1my6.default), {
                value: rtlValue,
                children: children
            })
        })
    });
}
var $ad4f9fb679cc4555$export$2e2bcd8739ae039 = $ad4f9fb679cc4555$var$ThemeProvider;

});
parcelRegister("g1c4r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba961a4c7f8e4e87$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $eyAY5 = parcelRequire("eyAY5");



var $d8073 = parcelRequire("d8073");

var $h8EYy = parcelRequire("h8EYy");

var $2u0Fs = parcelRequire("2u0Fs");

var $Dkugg = parcelRequire("Dkugg");
function $ba961a4c7f8e4e87$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $ibF5z.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $ba961a4c7f8e4e87$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $h8EYy.default)();
    const theme = $eyAY5.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $ba961a4c7f8e4e87$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $2u0Fs.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $Dkugg.jsx)((0, $d8073.default).Provider, {
        value: theme,
        children: children
    });
}
var $ba961a4c7f8e4e87$export$2e2bcd8739ae039 = $ba961a4c7f8e4e87$var$ThemeProvider;

});
parcelRegister("d8073", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98ec1c1a4b5b416d$export$2e2bcd8739ae039; });

var $eyAY5 = parcelRequire("eyAY5");
const $98ec1c1a4b5b416d$var$ThemeContext = /*#__PURE__*/ $eyAY5.createContext(null);
var $98ec1c1a4b5b416d$export$2e2bcd8739ae039 = $98ec1c1a4b5b416d$var$ThemeContext;

});

parcelRegister("h8EYy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a2f7f332839777$export$2e2bcd8739ae039; });

var $eyAY5 = parcelRequire("eyAY5");

var $d8073 = parcelRequire("d8073");
function $c7a2f7f332839777$export$2e2bcd8739ae039() {
    const theme = $eyAY5.useContext((0, $d8073.default));
    return theme;
}

});

parcelRegister("2u0Fs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ceee6b8d2ba3693$export$2e2bcd8739ae039; });
const $1ceee6b8d2ba3693$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $1ceee6b8d2ba3693$export$2e2bcd8739ae039 = $1ceee6b8d2ba3693$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";

});


parcelRegister("2eN2x", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $1a12eddeadf50ac9$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $1a12eddeadf50ac9$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $1a12eddeadf50ac9$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("2rRc0")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("2rRc0")).w; });

var $2rRc0 = parcelRequire("2rRc0");

var $eyAY5 = parcelRequire("eyAY5");

var $72eWs = parcelRequire("72eWs");

var $hkghS = parcelRequire("hkghS");

var $F4HzL = parcelRequire("F4HzL");
parcelRequire("jmwy4");
parcelRequire("6Gonh");
parcelRequire("67qtd");

parcelRequire("5vVbB");
var $1a12eddeadf50ac9$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $2rRc0.h).call(props, "css")) return $eyAY5.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $2rRc0.E);
    createElementArgArray[1] = (0, $2rRc0.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $eyAY5.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($1a12eddeadf50ac9$export$c8a8987d4410bf2d || ($1a12eddeadf50ac9$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1a12eddeadf50ac9$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $2rRc0.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $F4HzL.serializeStyles)([
        styles
    ], undefined, $eyAY5.useContext((0, $2rRc0.T)));
    if (!(0, $2rRc0.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $eyAY5.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $eyAY5.useRef();
    (0, $hkghS.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $hkghS.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $72eWs.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $1a12eddeadf50ac9$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $F4HzL.serializeStyles)(args);
}
function $1a12eddeadf50ac9$export$d25ddfdf17c3ad3e() {
    var insertable = $1a12eddeadf50ac9$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $1a12eddeadf50ac9$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $1a12eddeadf50ac9$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $72eWs.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1a12eddeadf50ac9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $hkghS.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $72eWs.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $2rRc0.i) && res !== undefined) rules += res;
        }
        if (!(0, $2rRc0.i)) return rules;
    });
    if (!(0, $2rRc0.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $eyAY5.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $1a12eddeadf50ac9$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $2rRc0.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $2rRc0.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $F4HzL.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $72eWs.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $2rRc0.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $1a12eddeadf50ac9$var$merge(cache.registered, css, $1a12eddeadf50ac9$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $eyAY5.useContext((0, $2rRc0.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $eyAY5.createElement($eyAY5.Fragment, null, /*#__PURE__*/ $eyAY5.createElement($1a12eddeadf50ac9$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("2rRc0", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $1c875d567fb205d2$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $1c875d567fb205d2$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $1c875d567fb205d2$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $1c875d567fb205d2$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $1c875d567fb205d2$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $1c875d567fb205d2$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $1c875d567fb205d2$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $1c875d567fb205d2$export$a9c23c6ac3fc3eca; });

var $eyAY5 = parcelRequire("eyAY5");

var $jmwy4 = parcelRequire("jmwy4");

var $pnzUf = parcelRequire("pnzUf");

var $67qtd = parcelRequire("67qtd");

var $cfDAH = parcelRequire("cfDAH");

var $72eWs = parcelRequire("72eWs");

var $F4HzL = parcelRequire("F4HzL");

var $hkghS = parcelRequire("hkghS");
var $1c875d567fb205d2$export$407448d2b89b1813 = false;
var $1c875d567fb205d2$export$23f2a1d2818174ef = typeof document !== "undefined";
var $1c875d567fb205d2$var$EmotionCacheContext = /* #__PURE__ */ $eyAY5.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $jmwy4.default)({
    key: "css"
}) : null);
var $1c875d567fb205d2$export$e7094788287c5e9b = $1c875d567fb205d2$var$EmotionCacheContext.Provider;
var $1c875d567fb205d2$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $eyAY5.useContext)($1c875d567fb205d2$var$EmotionCacheContext);
};
var $1c875d567fb205d2$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $eyAY5.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $eyAY5.useContext)($1c875d567fb205d2$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$1c875d567fb205d2$export$23f2a1d2818174ef) $1c875d567fb205d2$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $eyAY5.useContext)($1c875d567fb205d2$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $jmwy4.default)({
                key: "css"
            });
            return /*#__PURE__*/ $eyAY5.createElement($1c875d567fb205d2$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $1c875d567fb205d2$export$971d5caa766a69d7 = /* #__PURE__ */ $eyAY5.createContext({});
var $1c875d567fb205d2$export$3b14a55fb2447963 = function useTheme() {
    return $eyAY5.useContext($1c875d567fb205d2$export$971d5caa766a69d7);
};
var $1c875d567fb205d2$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $pnzUf.default)({}, outerTheme, theme);
};
var $1c875d567fb205d2$var$createCacheWithTheme = /* #__PURE__ */ (0, $67qtd.default)(function(outerTheme) {
    return (0, $67qtd.default)(function(theme) {
        return $1c875d567fb205d2$var$getTheme(outerTheme, theme);
    });
});
var $1c875d567fb205d2$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $eyAY5.useContext($1c875d567fb205d2$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $1c875d567fb205d2$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $eyAY5.createElement($1c875d567fb205d2$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $1c875d567fb205d2$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var WithTheme = /*#__PURE__*/ $eyAY5.forwardRef(function render(props, ref) {
        var theme = $eyAY5.useContext($1c875d567fb205d2$export$971d5caa766a69d7);
        return /*#__PURE__*/ $eyAY5.createElement(Component, (0, $pnzUf.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $cfDAH.default)(WithTheme, Component);
}
var $1c875d567fb205d2$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $1c875d567fb205d2$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $1c875d567fb205d2$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($1c875d567fb205d2$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$1c875d567fb205d2$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $1c875d567fb205d2$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $72eWs.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $hkghS.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $72eWs.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$1c875d567fb205d2$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $eyAY5.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $1c875d567fb205d2$var$Emotion = /* #__PURE__ */ $1c875d567fb205d2$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$1c875d567fb205d2$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $72eWs.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $F4HzL.serializeStyles)(registeredStyles, undefined, $eyAY5.useContext($1c875d567fb205d2$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($1c875d567fb205d2$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== "css" && _key2 !== $1c875d567fb205d2$var$typePropName && !$1c875d567fb205d2$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $eyAY5.createElement($eyAY5.Fragment, null, /*#__PURE__*/ $eyAY5.createElement($1c875d567fb205d2$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $eyAY5.createElement(WrappedComponent, newProps));
});
var $1c875d567fb205d2$export$a9c23c6ac3fc3eca = $1c875d567fb205d2$var$Emotion;

});
parcelRegister("jmwy4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e18951d67135477f$export$2e2bcd8739ae039; });

var $1WGUU = parcelRequire("1WGUU");

var $aevEr = parcelRequire("aevEr");

var $67qtd = parcelRequire("67qtd");

var $9sLax = parcelRequire("9sLax");
var $e18951d67135477f$var$isBrowser = typeof document !== "undefined";
var $e18951d67135477f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $aevEr.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $aevEr.token)(character)) break;
        (0, $aevEr.next)();
    }
    return (0, $aevEr.slice)(begin, (0, $aevEr.position));
};
var $e18951d67135477f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $aevEr.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $aevEr.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $e18951d67135477f$var$identifierWithPointTracking((0, $aevEr.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $aevEr.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $aevEr.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $aevEr.from)(character);
    }
    while (character = (0, $aevEr.next)());
    return parsed;
};
var $e18951d67135477f$var$getRules = function getRules(value, points) {
    return (0, $aevEr.dealloc)($e18951d67135477f$var$toRules((0, $aevEr.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $e18951d67135477f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $e18951d67135477f$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$e18951d67135477f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $e18951d67135477f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $e18951d67135477f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $e18951d67135477f$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $e18951d67135477f$var$prefix(value, length) {
    switch((0, $aevEr.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $aevEr.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $aevEr.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MOZ) + value + (0, $aevEr.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + value + value;
        // order
        case 6165:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.replace)(value, /(\w+).+(:[^]+)/, (0, $aevEr.WEBKIT) + "box-$1$2" + (0, $aevEr.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + "flex-item-" + (0, $aevEr.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + "flex-line-pack" + (0, $aevEr.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $aevEr.WEBKIT) + "box-" + (0, $aevEr.replace)(value, "-grow", "") + (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $aevEr.WEBKIT) + (0, $aevEr.replace)(value, /([^-])(transform)/g, "$1" + (0, $aevEr.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $aevEr.replace)((0, $aevEr.replace)((0, $aevEr.replace)(value, /(zoom-|grab)/, (0, $aevEr.WEBKIT) + "$1"), /(image-set)/, (0, $aevEr.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $aevEr.replace)(value, /(image-set\([^]*)/, (0, $aevEr.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $aevEr.replace)((0, $aevEr.replace)(value, /(.+:)(flex-)?(.*)/, (0, $aevEr.WEBKIT) + "box-pack:$3" + (0, $aevEr.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $aevEr.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $aevEr.replace)(value, /(.+)-inline(.+)/, (0, $aevEr.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $aevEr.strlen)(value) - 1 - length > 6) switch((0, $aevEr.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $aevEr.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $aevEr.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $aevEr.WEBKIT) + "$2-$3" + "$1" + (0, $aevEr.MOZ) + ((0, $aevEr.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $aevEr.indexof)(value, "stretch") ? $e18951d67135477f$var$prefix((0, $aevEr.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $aevEr.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $aevEr.charat)(value, (0, $aevEr.strlen)(value) - 3 - (~(0, $aevEr.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $aevEr.replace)(value, ":", ":" + (0, $aevEr.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $aevEr.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $aevEr.WEBKIT) + ((0, $aevEr.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $aevEr.WEBKIT) + "$2$3" + "$1" + (0, $aevEr.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $aevEr.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + value + value;
    }
    return value;
}
var $e18951d67135477f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $aevEr.DECLARATION:
                element["return"] = $e18951d67135477f$var$prefix(element.value, element.length);
                break;
            case 0, $aevEr.KEYFRAMES:
                return (0, $aevEr.serialize)([
                    (0, $aevEr.copy)(element, {
                        value: (0, $aevEr.replace)(element.value, "@", "@" + (0, $aevEr.WEBKIT))
                    })
                ], callback);
            case 0, $aevEr.RULESET:
                if (element.length) return (0, $aevEr.combine)(element.props, function(value) {
                    switch((0, $aevEr.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $aevEr.serialize)([
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(read-\w+)/, ":" + (0, $aevEr.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $aevEr.serialize)([
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(plac\w+)/, ":" + (0, $aevEr.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(plac\w+)/, ":" + (0, $aevEr.MOZ) + "$1")
                                    ]
                                }),
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(plac\w+)/, (0, $aevEr.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $e18951d67135477f$var$getServerStylisCache = $e18951d67135477f$var$isBrowser ? undefined : (0, $67qtd.default)(function() {
    return (0, $9sLax.default)(function() {
        return {};
    });
});
var $e18951d67135477f$var$defaultStylisPlugins = [
    $e18951d67135477f$var$prefixer
];
var $e18951d67135477f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($e18951d67135477f$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $e18951d67135477f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($e18951d67135477f$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $e18951d67135477f$var$compat,
        $e18951d67135477f$var$removeLabel
    ];
    if (!$e18951d67135477f$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $aevEr.stringify),
            (0, $aevEr.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $aevEr.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $aevEr.serialize)((0, $aevEr.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $aevEr.stringify)
        ];
        var _serializer = (0, $aevEr.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $aevEr.serialize)((0, $aevEr.compile)(styles), _serializer);
        };
        var serverStylisCache = $e18951d67135477f$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $1WGUU.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("1WGUU", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $16ac7f9cd12ce15a$export$9d753cd7ae895cce; });
var $16ac7f9cd12ce15a$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $16ac7f9cd12ce15a$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $16ac7f9cd12ce15a$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $16ac7f9cd12ce15a$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$16ac7f9cd12ce15a$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($16ac7f9cd12ce15a$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $16ac7f9cd12ce15a$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("aevEr", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $7757b385c5ee20c2$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $7757b385c5ee20c2$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $7757b385c5ee20c2$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $7757b385c5ee20c2$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $7757b385c5ee20c2$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $7757b385c5ee20c2$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $7757b385c5ee20c2$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $7757b385c5ee20c2$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $7757b385c5ee20c2$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $7757b385c5ee20c2$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $7757b385c5ee20c2$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $7757b385c5ee20c2$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $7757b385c5ee20c2$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $7757b385c5ee20c2$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $7757b385c5ee20c2$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $7757b385c5ee20c2$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $7757b385c5ee20c2$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $7757b385c5ee20c2$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $7757b385c5ee20c2$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $7757b385c5ee20c2$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $7757b385c5ee20c2$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $7757b385c5ee20c2$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $7757b385c5ee20c2$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $7757b385c5ee20c2$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $7757b385c5ee20c2$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $7757b385c5ee20c2$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $7757b385c5ee20c2$export$38bcb760f1d4871c; });
var $7757b385c5ee20c2$export$71ad59f2e432cfe8 = "-ms-";
var $7757b385c5ee20c2$export$2c0f367103c8d01c = "-moz-";
var $7757b385c5ee20c2$export$39dfd62a25e0fe93 = "-webkit-";
var $7757b385c5ee20c2$export$a29989082612d0d9 = "comm";
var $7757b385c5ee20c2$export$aa3a2e812ca8570d = "rule";
var $7757b385c5ee20c2$export$527d108ccf083c2b = "decl";
var $7757b385c5ee20c2$export$d3d35020fa5b54f0 = "@page";
var $7757b385c5ee20c2$export$500415a86c544f73 = "@media";
var $7757b385c5ee20c2$export$a763edbf796b780a = "@import";
var $7757b385c5ee20c2$export$2790aeb8b4e5c826 = "@charset";
var $7757b385c5ee20c2$export$1cc683e23b84b133 = "@viewport";
var $7757b385c5ee20c2$export$9447a5efea57e862 = "@supports";
var $7757b385c5ee20c2$export$ef011b4e114b1fba = "@document";
var $7757b385c5ee20c2$export$6aad947bda0f3f46 = "@namespace";
var $7757b385c5ee20c2$export$b44a8529a35fcb60 = "@keyframes";
var $7757b385c5ee20c2$export$2c16de31893252e6 = "@font-face";
var $7757b385c5ee20c2$export$3d846dd52e150c6f = "@counter-style";
var $7757b385c5ee20c2$export$22314bfbb57653fe = "@font-feature-values";
var $7757b385c5ee20c2$export$d773506282b3cfe6 = "@layer";
var $7757b385c5ee20c2$export$2335f513bbd82c6d = Math.abs;
var $7757b385c5ee20c2$export$6788812c4e6611e6 = String.fromCharCode;
var $7757b385c5ee20c2$export$e6e34fd1f2686227 = Object.assign;
function $7757b385c5ee20c2$export$d6af199866bfb566(e, r) {
    return $7757b385c5ee20c2$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $7757b385c5ee20c2$export$a9db5e087081082d(e, 0)) << 2 ^ $7757b385c5ee20c2$export$a9db5e087081082d(e, 1)) << 2 ^ $7757b385c5ee20c2$export$a9db5e087081082d(e, 2)) << 2 ^ $7757b385c5ee20c2$export$a9db5e087081082d(e, 3) : 0;
}
function $7757b385c5ee20c2$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $7757b385c5ee20c2$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $7757b385c5ee20c2$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $7757b385c5ee20c2$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $7757b385c5ee20c2$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $7757b385c5ee20c2$export$36776f635604f274(e) {
    return e.length;
}
function $7757b385c5ee20c2$export$f9084667e487ed46(e) {
    return e.length;
}
function $7757b385c5ee20c2$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $7757b385c5ee20c2$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $7757b385c5ee20c2$export$53f1d5ea8de3d7c = 1;
var $7757b385c5ee20c2$export$4e0c71f277ca26b3 = 1;
var $7757b385c5ee20c2$export$f24224f1c91d8156 = 0;
var $7757b385c5ee20c2$export$5880b8b5730aff45 = 0;
var $7757b385c5ee20c2$export$c0306caf338ac095 = 0;
var $7757b385c5ee20c2$export$30a86d91af8ff6e6 = "";
function $7757b385c5ee20c2$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $7757b385c5ee20c2$export$53f1d5ea8de3d7c,
        column: $7757b385c5ee20c2$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $7757b385c5ee20c2$export$784d13d8ee351f07(e, r) {
    return $7757b385c5ee20c2$export$e6e34fd1f2686227($7757b385c5ee20c2$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $7757b385c5ee20c2$export$eba6f6f03b0a92e7() {
    return $7757b385c5ee20c2$export$c0306caf338ac095;
}
function $7757b385c5ee20c2$export$232faf9add678146() {
    $7757b385c5ee20c2$export$c0306caf338ac095 = $7757b385c5ee20c2$export$5880b8b5730aff45 > 0 ? $7757b385c5ee20c2$export$a9db5e087081082d($7757b385c5ee20c2$export$30a86d91af8ff6e6, --$7757b385c5ee20c2$export$5880b8b5730aff45) : 0;
    if ($7757b385c5ee20c2$export$4e0c71f277ca26b3--, $7757b385c5ee20c2$export$c0306caf338ac095 === 10) $7757b385c5ee20c2$export$4e0c71f277ca26b3 = 1, $7757b385c5ee20c2$export$53f1d5ea8de3d7c--;
    return $7757b385c5ee20c2$export$c0306caf338ac095;
}
function $7757b385c5ee20c2$export$48cfd1e771a65c4f() {
    $7757b385c5ee20c2$export$c0306caf338ac095 = $7757b385c5ee20c2$export$5880b8b5730aff45 < $7757b385c5ee20c2$export$f24224f1c91d8156 ? $7757b385c5ee20c2$export$a9db5e087081082d($7757b385c5ee20c2$export$30a86d91af8ff6e6, $7757b385c5ee20c2$export$5880b8b5730aff45++) : 0;
    if ($7757b385c5ee20c2$export$4e0c71f277ca26b3++, $7757b385c5ee20c2$export$c0306caf338ac095 === 10) $7757b385c5ee20c2$export$4e0c71f277ca26b3 = 1, $7757b385c5ee20c2$export$53f1d5ea8de3d7c++;
    return $7757b385c5ee20c2$export$c0306caf338ac095;
}
function $7757b385c5ee20c2$export$4d3fb11e950abb9e() {
    return $7757b385c5ee20c2$export$a9db5e087081082d($7757b385c5ee20c2$export$30a86d91af8ff6e6, $7757b385c5ee20c2$export$5880b8b5730aff45);
}
function $7757b385c5ee20c2$export$e88cb2efb12ae807() {
    return $7757b385c5ee20c2$export$5880b8b5730aff45;
}
function $7757b385c5ee20c2$export$58adb3bec8346d0f(e, r) {
    return $7757b385c5ee20c2$export$2f35ab04d2335697($7757b385c5ee20c2$export$30a86d91af8ff6e6, e, r);
}
function $7757b385c5ee20c2$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $7757b385c5ee20c2$export$2de70f21292aac9e(e) {
    return $7757b385c5ee20c2$export$53f1d5ea8de3d7c = $7757b385c5ee20c2$export$4e0c71f277ca26b3 = 1, $7757b385c5ee20c2$export$f24224f1c91d8156 = $7757b385c5ee20c2$export$36776f635604f274($7757b385c5ee20c2$export$30a86d91af8ff6e6 = e), $7757b385c5ee20c2$export$5880b8b5730aff45 = 0, [];
}
function $7757b385c5ee20c2$export$45918ac1574455b1(e) {
    return $7757b385c5ee20c2$export$30a86d91af8ff6e6 = "", e;
}
function $7757b385c5ee20c2$export$410ac95b9ec204b8(e) {
    return $7757b385c5ee20c2$export$87c2784dc9fc4ab($7757b385c5ee20c2$export$58adb3bec8346d0f($7757b385c5ee20c2$export$5880b8b5730aff45 - 1, $7757b385c5ee20c2$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $7757b385c5ee20c2$export$660b2ee2d4fb4eff(e) {
    return $7757b385c5ee20c2$export$45918ac1574455b1($7757b385c5ee20c2$export$5f8c09e3ae6f64e1($7757b385c5ee20c2$export$2de70f21292aac9e(e)));
}
function $7757b385c5ee20c2$export$7af1228ff777d175(e) {
    while($7757b385c5ee20c2$export$c0306caf338ac095 = $7757b385c5ee20c2$export$4d3fb11e950abb9e())if ($7757b385c5ee20c2$export$c0306caf338ac095 < 33) $7757b385c5ee20c2$export$48cfd1e771a65c4f();
    else break;
    return $7757b385c5ee20c2$export$9e1725a4cfeada27(e) > 2 || $7757b385c5ee20c2$export$9e1725a4cfeada27($7757b385c5ee20c2$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $7757b385c5ee20c2$export$5f8c09e3ae6f64e1(e) {
    while($7757b385c5ee20c2$export$48cfd1e771a65c4f())switch($7757b385c5ee20c2$export$9e1725a4cfeada27($7757b385c5ee20c2$export$c0306caf338ac095)){
        case 0:
            $7757b385c5ee20c2$export$10d8903dec122b9d($7757b385c5ee20c2$export$c2ab62c7bf24634($7757b385c5ee20c2$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $7757b385c5ee20c2$export$10d8903dec122b9d($7757b385c5ee20c2$export$410ac95b9ec204b8($7757b385c5ee20c2$export$c0306caf338ac095), e);
            break;
        default:
            $7757b385c5ee20c2$export$10d8903dec122b9d($7757b385c5ee20c2$export$6788812c4e6611e6($7757b385c5ee20c2$export$c0306caf338ac095), e);
    }
    return e;
}
function $7757b385c5ee20c2$export$955ba06d119e085e(e, r) {
    while(--r && $7757b385c5ee20c2$export$48cfd1e771a65c4f())if ($7757b385c5ee20c2$export$c0306caf338ac095 < 48 || $7757b385c5ee20c2$export$c0306caf338ac095 > 102 || $7757b385c5ee20c2$export$c0306caf338ac095 > 57 && $7757b385c5ee20c2$export$c0306caf338ac095 < 65 || $7757b385c5ee20c2$export$c0306caf338ac095 > 70 && $7757b385c5ee20c2$export$c0306caf338ac095 < 97) break;
    return $7757b385c5ee20c2$export$58adb3bec8346d0f(e, $7757b385c5ee20c2$export$e88cb2efb12ae807() + (r < 6 && $7757b385c5ee20c2$export$4d3fb11e950abb9e() == 32 && $7757b385c5ee20c2$export$48cfd1e771a65c4f() == 32));
}
function $7757b385c5ee20c2$export$c889f2fcc19dbf12(e) {
    while($7757b385c5ee20c2$export$48cfd1e771a65c4f())switch($7757b385c5ee20c2$export$c0306caf338ac095){
        case e:
            return $7757b385c5ee20c2$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $7757b385c5ee20c2$export$c889f2fcc19dbf12($7757b385c5ee20c2$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $7757b385c5ee20c2$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $7757b385c5ee20c2$export$48cfd1e771a65c4f();
            break;
    }
    return $7757b385c5ee20c2$export$5880b8b5730aff45;
}
function $7757b385c5ee20c2$export$4254d4e2b3745c4c(e, r) {
    while($7757b385c5ee20c2$export$48cfd1e771a65c4f())if (e + $7757b385c5ee20c2$export$c0306caf338ac095 === 57) break;
    else if (e + $7757b385c5ee20c2$export$c0306caf338ac095 === 84 && $7757b385c5ee20c2$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $7757b385c5ee20c2$export$58adb3bec8346d0f(r, $7757b385c5ee20c2$export$5880b8b5730aff45 - 1) + "*" + $7757b385c5ee20c2$export$6788812c4e6611e6(e === 47 ? e : $7757b385c5ee20c2$export$48cfd1e771a65c4f());
}
function $7757b385c5ee20c2$export$c2ab62c7bf24634(e) {
    while(!$7757b385c5ee20c2$export$9e1725a4cfeada27($7757b385c5ee20c2$export$4d3fb11e950abb9e()))$7757b385c5ee20c2$export$48cfd1e771a65c4f();
    return $7757b385c5ee20c2$export$58adb3bec8346d0f(e, $7757b385c5ee20c2$export$5880b8b5730aff45);
}
function $7757b385c5ee20c2$export$ef7acd7185315e22(e) {
    return $7757b385c5ee20c2$export$45918ac1574455b1($7757b385c5ee20c2$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $7757b385c5ee20c2$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $7757b385c5ee20c2$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $7757b385c5ee20c2$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $7757b385c5ee20c2$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($7757b385c5ee20c2$export$f8e21b1e77979a08(j += $7757b385c5ee20c2$export$77ad94ebf1c2b9ed($7757b385c5ee20c2$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $7757b385c5ee20c2$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $7757b385c5ee20c2$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $7757b385c5ee20c2$export$955ba06d119e085e($7757b385c5ee20c2$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($7757b385c5ee20c2$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $7757b385c5ee20c2$export$10d8903dec122b9d($7757b385c5ee20c2$export$4a34f930e789283c($7757b385c5ee20c2$export$4254d4e2b3745c4c($7757b385c5ee20c2$export$48cfd1e771a65c4f(), $7757b385c5ee20c2$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $7757b385c5ee20c2$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $7757b385c5ee20c2$export$36776f635604f274(j) - l) $7757b385c5ee20c2$export$10d8903dec122b9d(p > 32 ? $7757b385c5ee20c2$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $7757b385c5ee20c2$export$f8483753829ec8f3($7757b385c5ee20c2$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $7757b385c5ee20c2$export$10d8903dec122b9d(y = $7757b385c5ee20c2$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $7757b385c5ee20c2$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $7757b385c5ee20c2$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $7757b385c5ee20c2$export$98e6a39c04603d36(e, y, y, n && $7757b385c5ee20c2$export$10d8903dec122b9d($7757b385c5ee20c2$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $7757b385c5ee20c2$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $7757b385c5ee20c2$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $7757b385c5ee20c2$export$232faf9add678146() == 125) continue;
            }
            switch(j += $7757b385c5ee20c2$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($7757b385c5ee20c2$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($7757b385c5ee20c2$export$4d3fb11e950abb9e() === 45) j += $7757b385c5ee20c2$export$410ac95b9ec204b8($7757b385c5ee20c2$export$48cfd1e771a65c4f());
                    v = $7757b385c5ee20c2$export$4d3fb11e950abb9e(), o = l = $7757b385c5ee20c2$export$36776f635604f274(g = j += $7757b385c5ee20c2$export$c2ab62c7bf24634($7757b385c5ee20c2$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $7757b385c5ee20c2$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $7757b385c5ee20c2$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $7757b385c5ee20c2$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $7757b385c5ee20c2$export$2f35ab04d2335697(e, v + 1, v = $7757b385c5ee20c2$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $7757b385c5ee20c2$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $7757b385c5ee20c2$export$35059013cd4a06db(e, r, a, s === 0 ? $7757b385c5ee20c2$export$aa3a2e812ca8570d : i, f, o, l);
}
function $7757b385c5ee20c2$export$4a34f930e789283c(e, r, a) {
    return $7757b385c5ee20c2$export$35059013cd4a06db(e, r, a, $7757b385c5ee20c2$export$a29989082612d0d9, $7757b385c5ee20c2$export$6788812c4e6611e6($7757b385c5ee20c2$export$eba6f6f03b0a92e7()), $7757b385c5ee20c2$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $7757b385c5ee20c2$export$f8483753829ec8f3(e, r, a, n) {
    return $7757b385c5ee20c2$export$35059013cd4a06db(e, r, a, $7757b385c5ee20c2$export$527d108ccf083c2b, $7757b385c5ee20c2$export$2f35ab04d2335697(e, 0, n), $7757b385c5ee20c2$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $7757b385c5ee20c2$export$82e9f45cca5ba907(n, c, s) {
    switch($7757b385c5ee20c2$export$d6af199866bfb566(n, c)){
        case 5103:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $7757b385c5ee20c2$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$2c0f367103c8d01c + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($7757b385c5ee20c2$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "box-$1$2" + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "flex-item-" + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$7757b385c5ee20c2$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "grid-row-" + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "flex-line-pack" + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "box-" + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "-grow", "") + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $7757b385c5ee20c2$export$39dfd62a25e0fe93 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed($7757b385c5ee20c2$export$77ad94ebf1c2b9ed($7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed($7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "box-pack:$3" + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$7757b385c5ee20c2$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "grid-column-align" + $7757b385c5ee20c2$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $7757b385c5ee20c2$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$7757b385c5ee20c2$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$7757b385c5ee20c2$export$f8e21b1e77979a08(s, "span") ? $7757b385c5ee20c2$export$4659b591c19bdf3d(s, /\d+/) : +$7757b385c5ee20c2$export$4659b591c19bdf3d(s, /\d+/) - +$7757b385c5ee20c2$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $7757b385c5ee20c2$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $7757b385c5ee20c2$export$71ad59f2e432cfe8 + $7757b385c5ee20c2$export$77ad94ebf1c2b9ed($7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($7757b385c5ee20c2$export$36776f635604f274(n) - 1 - c > 6) switch($7757b385c5ee20c2$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($7757b385c5ee20c2$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $7757b385c5ee20c2$export$2c0f367103c8d01c + ($7757b385c5ee20c2$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$7757b385c5ee20c2$export$f8e21b1e77979a08(n, "stretch") ? $7757b385c5ee20c2$export$82e9f45cca5ba907($7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $7757b385c5ee20c2$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $7757b385c5ee20c2$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($7757b385c5ee20c2$export$a9db5e087081082d(n, c + 6) === 121) return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, ":", ":" + $7757b385c5ee20c2$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($7757b385c5ee20c2$export$a9db5e087081082d(n, $7757b385c5ee20c2$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + ($7757b385c5ee20c2$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, ":", ":" + $7757b385c5ee20c2$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $7757b385c5ee20c2$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $7757b385c5ee20c2$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $7757b385c5ee20c2$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $7757b385c5ee20c2$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $7757b385c5ee20c2$export$a763edbf796b780a:
        case $7757b385c5ee20c2$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $7757b385c5ee20c2$export$a29989082612d0d9:
            return "";
        case $7757b385c5ee20c2$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $7757b385c5ee20c2$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $7757b385c5ee20c2$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $7757b385c5ee20c2$export$36776f635604f274(a = $7757b385c5ee20c2$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $7757b385c5ee20c2$export$5a7767152ae0305f(e) {
    var r = $7757b385c5ee20c2$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $7757b385c5ee20c2$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $7757b385c5ee20c2$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $7757b385c5ee20c2$export$527d108ccf083c2b:
                n.return = $7757b385c5ee20c2$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $7757b385c5ee20c2$export$b44a8529a35fcb60:
                return $7757b385c5ee20c2$export$dfdc1655ccc5b9cb([
                    $7757b385c5ee20c2$export$784d13d8ee351f07(n, {
                        value: $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $7757b385c5ee20c2$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $7757b385c5ee20c2$export$aa3a2e812ca8570d:
                if (n.length) return $7757b385c5ee20c2$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($7757b385c5ee20c2$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $7757b385c5ee20c2$export$dfdc1655ccc5b9cb([
                                $7757b385c5ee20c2$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $7757b385c5ee20c2$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $7757b385c5ee20c2$export$dfdc1655ccc5b9cb([
                                $7757b385c5ee20c2$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $7757b385c5ee20c2$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $7757b385c5ee20c2$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $7757b385c5ee20c2$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $7757b385c5ee20c2$export$784d13d8ee351f07(n, {
                                    props: [
                                        $7757b385c5ee20c2$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $7757b385c5ee20c2$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $7757b385c5ee20c2$export$76a88f7de6507443(e) {
    switch(e.type){
        case $7757b385c5ee20c2$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $7757b385c5ee20c2$export$1be1fc439b849fdf($7757b385c5ee20c2$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($7757b385c5ee20c2$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $7757b385c5ee20c2$export$2f35ab04d2335697(r, 1, $7757b385c5ee20c2$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $7757b385c5ee20c2$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $7757b385c5ee20c2$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $7757b385c5ee20c2$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("67qtd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4747edf151c2e915$export$2e2bcd8739ae039; });
var $4747edf151c2e915$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9sLax", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e3b51580d8db123$export$2e2bcd8739ae039; });
function $6e3b51580d8db123$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("pnzUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04c4a00a62a8f445$export$2e2bcd8739ae039; });
function $04c4a00a62a8f445$export$2e2bcd8739ae039() {
    $04c4a00a62a8f445$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $04c4a00a62a8f445$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("cfDAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eb598b4c78575b9$export$2e2bcd8739ae039; });

var $5vVbB = parcelRequire("5vVbB");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $8eb598b4c78575b9$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5vVbB)))(targetComponent, sourceComponent);
};

});
parcelRegister("5vVbB", function(module, exports) {
"use strict";

var $fYKxm = parcelRequire("fYKxm");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $403c34fea0f699e7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $403c34fea0f699e7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $403c34fea0f699e7$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $403c34fea0f699e7$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $403c34fea0f699e7$var$TYPE_STATICS = {};
$403c34fea0f699e7$var$TYPE_STATICS[$fYKxm.ForwardRef] = $403c34fea0f699e7$var$FORWARD_REF_STATICS;
$403c34fea0f699e7$var$TYPE_STATICS[$fYKxm.Memo] = $403c34fea0f699e7$var$MEMO_STATICS;
function $403c34fea0f699e7$var$getStatics(component) {
    // React v16.11 and below
    if ($fYKxm.isMemo(component)) return $403c34fea0f699e7$var$MEMO_STATICS;
     // React v16.12 and above
    return $403c34fea0f699e7$var$TYPE_STATICS[component["$$typeof"]] || $403c34fea0f699e7$var$REACT_STATICS;
}
var $403c34fea0f699e7$var$defineProperty = Object.defineProperty;
var $403c34fea0f699e7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $403c34fea0f699e7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $403c34fea0f699e7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $403c34fea0f699e7$var$getPrototypeOf = Object.getPrototypeOf;
var $403c34fea0f699e7$var$objectPrototype = Object.prototype;
function $403c34fea0f699e7$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($403c34fea0f699e7$var$objectPrototype) {
            var inheritedComponent = $403c34fea0f699e7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $403c34fea0f699e7$var$objectPrototype) $403c34fea0f699e7$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $403c34fea0f699e7$var$getOwnPropertyNames(sourceComponent);
        if ($403c34fea0f699e7$var$getOwnPropertySymbols) keys = keys.concat($403c34fea0f699e7$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $403c34fea0f699e7$var$getStatics(targetComponent);
        var sourceStatics = $403c34fea0f699e7$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$403c34fea0f699e7$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $403c34fea0f699e7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $403c34fea0f699e7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $403c34fea0f699e7$var$hoistNonReactStatics;

});
parcelRegister("fYKxm", function(module, exports) {
"use strict";

module.exports = (parcelRequire("k4woo"));

});
parcelRegister("k4woo", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $e9cd4ed26d47fa4d$export$2b8d127b894957b9; }, function (v) { return $e9cd4ed26d47fa4d$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $e9cd4ed26d47fa4d$export$cea3a54a6425200c; }, function (v) { return $e9cd4ed26d47fa4d$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $e9cd4ed26d47fa4d$export$a7c73072b1a182ae; }, function (v) { return $e9cd4ed26d47fa4d$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $e9cd4ed26d47fa4d$export$9f27bc3417b4524d; }, function (v) { return $e9cd4ed26d47fa4d$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $e9cd4ed26d47fa4d$export$db77ccec0bb4ccac; }, function (v) { return $e9cd4ed26d47fa4d$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $e9cd4ed26d47fa4d$export$8392c0c9d3dcbd35; }, function (v) { return $e9cd4ed26d47fa4d$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e9cd4ed26d47fa4d$export$ffb0004e005737fa; }, function (v) { return $e9cd4ed26d47fa4d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $e9cd4ed26d47fa4d$export$b624eff549462981; }, function (v) { return $e9cd4ed26d47fa4d$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $e9cd4ed26d47fa4d$export$7897aa7841a5380c; }, function (v) { return $e9cd4ed26d47fa4d$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $e9cd4ed26d47fa4d$export$602eac185826482c; }, function (v) { return $e9cd4ed26d47fa4d$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $e9cd4ed26d47fa4d$export$e2c29f18771995cb; }, function (v) { return $e9cd4ed26d47fa4d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e9cd4ed26d47fa4d$export$5f8d39834fd61797; }, function (v) { return $e9cd4ed26d47fa4d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e9cd4ed26d47fa4d$export$74bf444e3cd11ea5; }, function (v) { return $e9cd4ed26d47fa4d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $e9cd4ed26d47fa4d$export$92387174baf9b227; }, function (v) { return $e9cd4ed26d47fa4d$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $e9cd4ed26d47fa4d$export$ec112efeb987d9c6; }, function (v) { return $e9cd4ed26d47fa4d$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $e9cd4ed26d47fa4d$export$b706b080d889d2c9; }, function (v) { return $e9cd4ed26d47fa4d$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $e9cd4ed26d47fa4d$export$5be5a87408f70ddc; }, function (v) { return $e9cd4ed26d47fa4d$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $e9cd4ed26d47fa4d$export$45a5e7f76e0caa8d; }, function (v) { return $e9cd4ed26d47fa4d$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $e9cd4ed26d47fa4d$export$455c2e768291efa6; }, function (v) { return $e9cd4ed26d47fa4d$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $e9cd4ed26d47fa4d$export$9522e17588c12572; }, function (v) { return $e9cd4ed26d47fa4d$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $e9cd4ed26d47fa4d$export$2110ac352bb060b9; }, function (v) { return $e9cd4ed26d47fa4d$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $e9cd4ed26d47fa4d$export$56885ab8b9c456ab; }, function (v) { return $e9cd4ed26d47fa4d$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $e9cd4ed26d47fa4d$export$d927fcb6adf8f9de; }, function (v) { return $e9cd4ed26d47fa4d$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $e9cd4ed26d47fa4d$export$b82d16f27459e05a; }, function (v) { return $e9cd4ed26d47fa4d$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $e9cd4ed26d47fa4d$export$522c17b4f5e123e8; }, function (v) { return $e9cd4ed26d47fa4d$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $e9cd4ed26d47fa4d$export$1aabd8a0274ecfd6; }, function (v) { return $e9cd4ed26d47fa4d$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $e9cd4ed26d47fa4d$export$9b621391a187a31a; }, function (v) { return $e9cd4ed26d47fa4d$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $e9cd4ed26d47fa4d$export$f5bbd400c2f4426f; }, function (v) { return $e9cd4ed26d47fa4d$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e9cd4ed26d47fa4d$export$2b8d127b894957b9;
var $e9cd4ed26d47fa4d$export$cea3a54a6425200c;
var $e9cd4ed26d47fa4d$export$a7c73072b1a182ae;
var $e9cd4ed26d47fa4d$export$9f27bc3417b4524d;
var $e9cd4ed26d47fa4d$export$db77ccec0bb4ccac;
var $e9cd4ed26d47fa4d$export$8392c0c9d3dcbd35;
var $e9cd4ed26d47fa4d$export$ffb0004e005737fa;
var $e9cd4ed26d47fa4d$export$b624eff549462981;
var $e9cd4ed26d47fa4d$export$7897aa7841a5380c;
var $e9cd4ed26d47fa4d$export$602eac185826482c;
var $e9cd4ed26d47fa4d$export$e2c29f18771995cb;
var $e9cd4ed26d47fa4d$export$5f8d39834fd61797;
var $e9cd4ed26d47fa4d$export$74bf444e3cd11ea5;
var $e9cd4ed26d47fa4d$export$92387174baf9b227;
var $e9cd4ed26d47fa4d$export$ec112efeb987d9c6;
var $e9cd4ed26d47fa4d$export$b706b080d889d2c9;
var $e9cd4ed26d47fa4d$export$5be5a87408f70ddc;
var $e9cd4ed26d47fa4d$export$45a5e7f76e0caa8d;
var $e9cd4ed26d47fa4d$export$455c2e768291efa6;
var $e9cd4ed26d47fa4d$export$9522e17588c12572;
var $e9cd4ed26d47fa4d$export$2110ac352bb060b9;
var $e9cd4ed26d47fa4d$export$56885ab8b9c456ab;
var $e9cd4ed26d47fa4d$export$d927fcb6adf8f9de;
var $e9cd4ed26d47fa4d$export$b82d16f27459e05a;
var $e9cd4ed26d47fa4d$export$522c17b4f5e123e8;
var $e9cd4ed26d47fa4d$export$1aabd8a0274ecfd6;
var $e9cd4ed26d47fa4d$export$9b621391a187a31a;
var $e9cd4ed26d47fa4d$export$f5bbd400c2f4426f;
"use strict";
var $e9cd4ed26d47fa4d$var$b = "function" === typeof Symbol && Symbol.for, $e9cd4ed26d47fa4d$var$c = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.element") : 60103, $e9cd4ed26d47fa4d$var$d = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.portal") : 60106, $e9cd4ed26d47fa4d$var$e = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.fragment") : 60107, $e9cd4ed26d47fa4d$var$f = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.strict_mode") : 60108, $e9cd4ed26d47fa4d$var$g = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.profiler") : 60114, $e9cd4ed26d47fa4d$var$h = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.provider") : 60109, $e9cd4ed26d47fa4d$var$k = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.context") : 60110, $e9cd4ed26d47fa4d$var$l = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.async_mode") : 60111, $e9cd4ed26d47fa4d$var$m = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.concurrent_mode") : 60111, $e9cd4ed26d47fa4d$var$n = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.forward_ref") : 60112, $e9cd4ed26d47fa4d$var$p = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.suspense") : 60113, $e9cd4ed26d47fa4d$var$q = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.suspense_list") : 60120, $e9cd4ed26d47fa4d$var$r = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.memo") : 60115, $e9cd4ed26d47fa4d$var$t = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.lazy") : 60116, $e9cd4ed26d47fa4d$var$v = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.block") : 60121, $e9cd4ed26d47fa4d$var$w = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.fundamental") : 60117, $e9cd4ed26d47fa4d$var$x = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.responder") : 60118, $e9cd4ed26d47fa4d$var$y = $e9cd4ed26d47fa4d$var$b ? Symbol.for("react.scope") : 60119;
function $e9cd4ed26d47fa4d$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $e9cd4ed26d47fa4d$var$c:
                switch(a = a.type, a){
                    case $e9cd4ed26d47fa4d$var$l:
                    case $e9cd4ed26d47fa4d$var$m:
                    case $e9cd4ed26d47fa4d$var$e:
                    case $e9cd4ed26d47fa4d$var$g:
                    case $e9cd4ed26d47fa4d$var$f:
                    case $e9cd4ed26d47fa4d$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $e9cd4ed26d47fa4d$var$k:
                            case $e9cd4ed26d47fa4d$var$n:
                            case $e9cd4ed26d47fa4d$var$t:
                            case $e9cd4ed26d47fa4d$var$r:
                            case $e9cd4ed26d47fa4d$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $e9cd4ed26d47fa4d$var$d:
                return u;
        }
    }
}
function $e9cd4ed26d47fa4d$var$A(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$m;
}
$e9cd4ed26d47fa4d$export$2b8d127b894957b9 = $e9cd4ed26d47fa4d$var$l;
$e9cd4ed26d47fa4d$export$cea3a54a6425200c = $e9cd4ed26d47fa4d$var$m;
$e9cd4ed26d47fa4d$export$a7c73072b1a182ae = $e9cd4ed26d47fa4d$var$k;
$e9cd4ed26d47fa4d$export$9f27bc3417b4524d = $e9cd4ed26d47fa4d$var$h;
$e9cd4ed26d47fa4d$export$db77ccec0bb4ccac = $e9cd4ed26d47fa4d$var$c;
$e9cd4ed26d47fa4d$export$8392c0c9d3dcbd35 = $e9cd4ed26d47fa4d$var$n;
$e9cd4ed26d47fa4d$export$ffb0004e005737fa = $e9cd4ed26d47fa4d$var$e;
$e9cd4ed26d47fa4d$export$b624eff549462981 = $e9cd4ed26d47fa4d$var$t;
$e9cd4ed26d47fa4d$export$7897aa7841a5380c = $e9cd4ed26d47fa4d$var$r;
$e9cd4ed26d47fa4d$export$602eac185826482c = $e9cd4ed26d47fa4d$var$d;
$e9cd4ed26d47fa4d$export$e2c29f18771995cb = $e9cd4ed26d47fa4d$var$g;
$e9cd4ed26d47fa4d$export$5f8d39834fd61797 = $e9cd4ed26d47fa4d$var$f;
$e9cd4ed26d47fa4d$export$74bf444e3cd11ea5 = $e9cd4ed26d47fa4d$var$p;
$e9cd4ed26d47fa4d$export$92387174baf9b227 = function(a) {
    return $e9cd4ed26d47fa4d$var$A(a) || $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$l;
};
$e9cd4ed26d47fa4d$export$ec112efeb987d9c6 = $e9cd4ed26d47fa4d$var$A;
$e9cd4ed26d47fa4d$export$b706b080d889d2c9 = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$k;
};
$e9cd4ed26d47fa4d$export$5be5a87408f70ddc = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$h;
};
$e9cd4ed26d47fa4d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e9cd4ed26d47fa4d$var$c;
};
$e9cd4ed26d47fa4d$export$455c2e768291efa6 = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$n;
};
$e9cd4ed26d47fa4d$export$9522e17588c12572 = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$e;
};
$e9cd4ed26d47fa4d$export$2110ac352bb060b9 = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$t;
};
$e9cd4ed26d47fa4d$export$56885ab8b9c456ab = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$r;
};
$e9cd4ed26d47fa4d$export$d927fcb6adf8f9de = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$d;
};
$e9cd4ed26d47fa4d$export$b82d16f27459e05a = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$g;
};
$e9cd4ed26d47fa4d$export$522c17b4f5e123e8 = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$f;
};
$e9cd4ed26d47fa4d$export$1aabd8a0274ecfd6 = function(a) {
    return $e9cd4ed26d47fa4d$var$z(a) === $e9cd4ed26d47fa4d$var$p;
};
$e9cd4ed26d47fa4d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $e9cd4ed26d47fa4d$var$e || a === $e9cd4ed26d47fa4d$var$m || a === $e9cd4ed26d47fa4d$var$g || a === $e9cd4ed26d47fa4d$var$f || a === $e9cd4ed26d47fa4d$var$p || a === $e9cd4ed26d47fa4d$var$q || "object" === typeof a && null !== a && (a.$$typeof === $e9cd4ed26d47fa4d$var$t || a.$$typeof === $e9cd4ed26d47fa4d$var$r || a.$$typeof === $e9cd4ed26d47fa4d$var$h || a.$$typeof === $e9cd4ed26d47fa4d$var$k || a.$$typeof === $e9cd4ed26d47fa4d$var$n || a.$$typeof === $e9cd4ed26d47fa4d$var$w || a.$$typeof === $e9cd4ed26d47fa4d$var$x || a.$$typeof === $e9cd4ed26d47fa4d$var$y || a.$$typeof === $e9cd4ed26d47fa4d$var$v);
};
$e9cd4ed26d47fa4d$export$f5bbd400c2f4426f = $e9cd4ed26d47fa4d$var$z;

});




parcelRegister("72eWs", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $51f44f717d49bd37$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $51f44f717d49bd37$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $51f44f717d49bd37$export$6f077d94b33a01aa; });
var $51f44f717d49bd37$var$isBrowser = typeof document !== "undefined";
function $51f44f717d49bd37$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $51f44f717d49bd37$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $51f44f717d49bd37$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $51f44f717d49bd37$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $51f44f717d49bd37$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$51f44f717d49bd37$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$51f44f717d49bd37$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("F4HzL", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $07b77a23037d7181$export$6321afa313b251b5; });

var $4KsAp = parcelRequire("4KsAp");

var $gEa4S = parcelRequire("gEa4S");

var $9sLax = parcelRequire("9sLax");
var $07b77a23037d7181$var$isDevelopment = false;
var $07b77a23037d7181$var$hyphenateRegex = /[A-Z]|^ms/g;
var $07b77a23037d7181$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $07b77a23037d7181$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $07b77a23037d7181$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $07b77a23037d7181$var$processStyleName = /* #__PURE__ */ (0, $9sLax.default)(function(styleName) {
    return $07b77a23037d7181$var$isCustomProperty(styleName) ? styleName : styleName.replace($07b77a23037d7181$var$hyphenateRegex, "-$&").toLowerCase();
});
var $07b77a23037d7181$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($07b77a23037d7181$var$animationRegex, function(match, p1, p2) {
                $07b77a23037d7181$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $07b77a23037d7181$var$cursor
                };
                return p1;
            });
    }
    if ((0, $gEa4S.default)[key] !== 1 && !$07b77a23037d7181$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $07b77a23037d7181$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $07b77a23037d7181$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $07b77a23037d7181$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $07b77a23037d7181$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $07b77a23037d7181$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $07b77a23037d7181$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $07b77a23037d7181$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $07b77a23037d7181$var$cursor;
                var result = interpolation(mergedProps);
                $07b77a23037d7181$var$cursor = previousCursor;
                return $07b77a23037d7181$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $07b77a23037d7181$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $07b77a23037d7181$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($07b77a23037d7181$var$isProcessableValue(asString)) string += $07b77a23037d7181$var$processStyleName(key) + ":" + $07b77a23037d7181$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $07b77a23037d7181$var$isDevelopment) throw new Error($07b77a23037d7181$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($07b77a23037d7181$var$isProcessableValue(value[_i])) string += $07b77a23037d7181$var$processStyleName(key) + ":" + $07b77a23037d7181$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $07b77a23037d7181$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $07b77a23037d7181$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $07b77a23037d7181$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $07b77a23037d7181$var$cursor;
function $07b77a23037d7181$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $07b77a23037d7181$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $07b77a23037d7181$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $07b77a23037d7181$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $07b77a23037d7181$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $07b77a23037d7181$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $4KsAp.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $07b77a23037d7181$var$cursor
    };
}

});
parcelRegister("4KsAp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3751a1f2a36da83c$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3751a1f2a36da83c$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("gEa4S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1e832f615b8eff9$export$2e2bcd8739ae039; });
var $c1e832f615b8eff9$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("hkghS", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $c9d0f042c8985423$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $c9d0f042c8985423$export$811a713a7276cb9d; });

var $eyAY5 = parcelRequire("eyAY5");
var $c9d0f042c8985423$var$isBrowser = typeof document !== "undefined";
var $c9d0f042c8985423$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c9d0f042c8985423$var$useInsertionEffect = $eyAY5.useInsertionEffect ? $eyAY5.useInsertionEffect : false;
var $c9d0f042c8985423$export$db21c7ffa21794e7 = !$c9d0f042c8985423$var$isBrowser ? $c9d0f042c8985423$var$syncFallback : $c9d0f042c8985423$var$useInsertionEffect || $c9d0f042c8985423$var$syncFallback;
var $c9d0f042c8985423$export$811a713a7276cb9d = $c9d0f042c8985423$var$useInsertionEffect || $eyAY5.useLayoutEffect;

});


parcelRegister("6Gonh", function(module, exports) {
function $4dd99292449b1e30$var$_extends() {
    module.exports = $4dd99292449b1e30$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $4dd99292449b1e30$var$_extends.apply(this, arguments);
}
module.exports = $4dd99292449b1e30$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("iePPp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d471bcce0ce3c551$export$2e2bcd8739ae039; });

var $eyAY5 = parcelRequire("eyAY5");
parcelRequire("2eN2x");
var $2rRc0 = parcelRequire("2rRc0");
"use client";
function $d471bcce0ce3c551$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $d471bcce0ce3c551$var$useTheme(defaultTheme = null) {
    const contextTheme = $eyAY5.useContext((0, $2rRc0.T));
    return !contextTheme || $d471bcce0ce3c551$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $d471bcce0ce3c551$export$2e2bcd8739ae039 = $d471bcce0ce3c551$var$useTheme;

});

parcelRegister("h1my6", function(module, exports) {

$parcel$export(module.exports, "useRtl", function () { return $c644056cfd7daec3$export$b2dd014b6c321cb; });
$parcel$export(module.exports, "default", function () { return $c644056cfd7daec3$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");

var $eyAY5 = parcelRequire("eyAY5");


var $Dkugg = parcelRequire("Dkugg");
const $c644056cfd7daec3$var$_excluded = [
    "value"
];
const $c644056cfd7daec3$var$RtlContext = /*#__PURE__*/ $eyAY5.createContext();
function $c644056cfd7daec3$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $2kU93.default)(_ref, $c644056cfd7daec3$var$_excluded);
    return /*#__PURE__*/ (0, $Dkugg.jsx)($c644056cfd7daec3$var$RtlContext.Provider, (0, $ibF5z.default)({
        value: value != null ? value : true
    }, props));
}
const $c644056cfd7daec3$export$b2dd014b6c321cb = ()=>{
    const value = $eyAY5.useContext($c644056cfd7daec3$var$RtlContext);
    return value != null ? value : false;
};
var $c644056cfd7daec3$export$2e2bcd8739ae039 = $c644056cfd7daec3$var$RtlProvider;

});


parcelRegister("8T9M8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $678b0af8b8665156$export$2e2bcd8739ae039; });
var $678b0af8b8665156$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("lONbt", function(module, exports) {

$parcel$export(module.exports, "alpha", function () { return $fe246b6c09af067d$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "darken", function () { return $fe246b6c09af067d$export$4b073707ff63303; });
$parcel$export(module.exports, "lighten", function () { return $fe246b6c09af067d$export$c0816ed86df316af; });
$parcel$export(module.exports, "emphasize", function () { return $fe246b6c09af067d$export$e665714f76e581fd; });

var $4oINZ = parcelRequire("4oINZ");

var $inp1X = parcelRequire("inp1X");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $fe246b6c09af067d$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $inp1X.default)(value, min, max);
}
function $fe246b6c09af067d$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $fe246b6c09af067d$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $fe246b6c09af067d$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $fe246b6c09af067d$export$677b39864803984e($fe246b6c09af067d$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $4oINZ.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $4oINZ.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $fe246b6c09af067d$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $fe246b6c09af067d$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $fe246b6c09af067d$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $fe246b6c09af067d$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $fe246b6c09af067d$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $fe246b6c09af067d$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $fe246b6c09af067d$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$fe246b6c09af067d$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $fe246b6c09af067d$export$29fb7152bd3f781a(color) {
    color = $fe246b6c09af067d$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $fe246b6c09af067d$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $fe246b6c09af067d$export$c852d90bf7403b62(color) {
    color = $fe246b6c09af067d$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $fe246b6c09af067d$export$677b39864803984e($fe246b6c09af067d$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $fe246b6c09af067d$export$d061e26956a60b0a(foreground, background) {
    const lumA = $fe246b6c09af067d$export$c852d90bf7403b62(foreground);
    const lumB = $fe246b6c09af067d$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $fe246b6c09af067d$export$58f0f39f63f3cf42(color, value) {
    color = $fe246b6c09af067d$export$677b39864803984e(color);
    value = $fe246b6c09af067d$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $fe246b6c09af067d$export$211a73f2b8c10ce4(color);
}
function $fe246b6c09af067d$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $fe246b6c09af067d$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $fe246b6c09af067d$export$4b073707ff63303(color, coefficient) {
    color = $fe246b6c09af067d$export$677b39864803984e(color);
    coefficient = $fe246b6c09af067d$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $fe246b6c09af067d$export$211a73f2b8c10ce4(color);
}
function $fe246b6c09af067d$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $fe246b6c09af067d$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $fe246b6c09af067d$export$c0816ed86df316af(color, coefficient) {
    color = $fe246b6c09af067d$export$677b39864803984e(color);
    coefficient = $fe246b6c09af067d$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $fe246b6c09af067d$export$211a73f2b8c10ce4(color);
}
function $fe246b6c09af067d$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $fe246b6c09af067d$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $fe246b6c09af067d$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $fe246b6c09af067d$export$c852d90bf7403b62(color) > 0.5 ? $fe246b6c09af067d$export$4b073707ff63303(color, coefficient) : $fe246b6c09af067d$export$c0816ed86df316af(color, coefficient);
}
function $fe246b6c09af067d$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $fe246b6c09af067d$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $fe246b6c09af067d$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $fe246b6c09af067d$export$677b39864803984e(background);
    const overlayColor = $fe246b6c09af067d$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $fe246b6c09af067d$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}

});

parcelRegister("6ljNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49e40e9667c45d8c$export$2e2bcd8739ae039; });

var $2kU93 = parcelRequire("2kU93");

var $ibF5z = parcelRequire("ibF5z");

var $eyAY5 = parcelRequire("eyAY5");


var $elJQ7 = parcelRequire("elJQ7");


var $f3hMw = parcelRequire("f3hMw");

var $2eN2x = parcelRequire("2eN2x");

var $8D0Sn = parcelRequire("8D0Sn");

var $aOzfC = parcelRequire("aOzfC");

var $c4vUP = parcelRequire("c4vUP");

var $4ly0G = parcelRequire("4ly0G");

var $Dkugg = parcelRequire("Dkugg");
"use client";
let $49e40e9667c45d8c$var$_ = (t)=>t, $49e40e9667c45d8c$var$t, $49e40e9667c45d8c$var$t1, $49e40e9667c45d8c$var$t2, $49e40e9667c45d8c$var$t3;
const $49e40e9667c45d8c$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $49e40e9667c45d8c$var$_1 = (t)=>t, $49e40e9667c45d8c$var$_t, $49e40e9667c45d8c$var$_t2, $49e40e9667c45d8c$var$_t3, $49e40e9667c45d8c$var$_t4;
const $49e40e9667c45d8c$var$SIZE = 44;
const $49e40e9667c45d8c$var$circularRotateKeyframe = (0, $2eN2x.keyframes)($49e40e9667c45d8c$var$_t || ($49e40e9667c45d8c$var$_t = $49e40e9667c45d8c$var$_1($49e40e9667c45d8c$var$t || ($49e40e9667c45d8c$var$t = $49e40e9667c45d8c$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $49e40e9667c45d8c$var$circularDashKeyframe = (0, $2eN2x.keyframes)($49e40e9667c45d8c$var$_t2 || ($49e40e9667c45d8c$var$_t2 = $49e40e9667c45d8c$var$_1($49e40e9667c45d8c$var$t1 || ($49e40e9667c45d8c$var$t1 = $49e40e9667c45d8c$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $49e40e9667c45d8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $8D0Sn.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $8D0Sn.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $f3hMw.default)(slots, (0, $4ly0G.getCircularProgressUtilityClass), classes);
};
const $49e40e9667c45d8c$var$CircularProgressRoot = (0, $c4vUP.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $8D0Sn.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $ibF5z.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $2eN2x.css)($49e40e9667c45d8c$var$_t3 || ($49e40e9667c45d8c$var$_t3 = $49e40e9667c45d8c$var$_1($49e40e9667c45d8c$var$t2 || ($49e40e9667c45d8c$var$t2 = $49e40e9667c45d8c$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $49e40e9667c45d8c$var$circularRotateKeyframe));
const $49e40e9667c45d8c$var$CircularProgressSVG = (0, $c4vUP.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $49e40e9667c45d8c$var$CircularProgressCircle = (0, $c4vUP.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $8D0Sn.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $ibF5z.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $2eN2x.css)($49e40e9667c45d8c$var$_t4 || ($49e40e9667c45d8c$var$_t4 = $49e40e9667c45d8c$var$_1($49e40e9667c45d8c$var$t3 || ($49e40e9667c45d8c$var$t3 = $49e40e9667c45d8c$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $49e40e9667c45d8c$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $49e40e9667c45d8c$var$CircularProgress = /*#__PURE__*/ $eyAY5.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $aOzfC.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $2kU93.default)(props, $49e40e9667c45d8c$var$_excluded);
    const ownerState = (0, $ibF5z.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $49e40e9667c45d8c$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($49e40e9667c45d8c$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $Dkugg.jsx)($49e40e9667c45d8c$var$CircularProgressRoot, (0, $ibF5z.default)({
        className: (0, $elJQ7.default)(classes.root, className),
        style: (0, $ibF5z.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $Dkugg.jsx)($49e40e9667c45d8c$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$49e40e9667c45d8c$var$SIZE / 2} ${$49e40e9667c45d8c$var$SIZE / 2} ${$49e40e9667c45d8c$var$SIZE} ${$49e40e9667c45d8c$var$SIZE}`,
            children: /*#__PURE__*/ (0, $Dkugg.jsx)($49e40e9667c45d8c$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $49e40e9667c45d8c$var$SIZE,
                cy: $49e40e9667c45d8c$var$SIZE,
                r: ($49e40e9667c45d8c$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $49e40e9667c45d8c$export$2e2bcd8739ae039 = $49e40e9667c45d8c$var$CircularProgress;

});
parcelRegister("elJQ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94486efa912de0a6$export$2e2bcd8739ae039; });
function $94486efa912de0a6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $94486efa912de0a6$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $94486efa912de0a6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $94486efa912de0a6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $94486efa912de0a6$export$2e2bcd8739ae039 = $94486efa912de0a6$export$4f5d2d50c9deca37;

});

parcelRegister("f3hMw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af54ede771f4f9a8$export$2e2bcd8739ae039; });
function $af54ede771f4f9a8$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("8D0Sn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6482a532c903f46a$export$2e2bcd8739ae039; });

var $jEG8Q = parcelRequire("jEG8Q");
var $6482a532c903f46a$export$2e2bcd8739ae039 = (0, $jEG8Q.default);

});

parcelRegister("aOzfC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7df9eafcf9d9b774$export$2e2bcd8739ae039; });

var $21L3q = parcelRequire("21L3q");

var $hETT4 = parcelRequire("hETT4");

var $8T9M8 = parcelRequire("8T9M8");
"use client";
function $7df9eafcf9d9b774$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $21L3q.default)({
        props: props,
        name: name,
        defaultTheme: $hETT4.default,
        themeId: (0, $8T9M8.default)
    });
}

});
parcelRegister("21L3q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17a02cc0c37aeb77$export$2e2bcd8739ae039; });

var $irsOR = parcelRequire("irsOR");

var $9hx4X = parcelRequire("9hx4X");
"use client";
function $17a02cc0c37aeb77$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $9hx4X.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $irsOR.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("irsOR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6d11a88f14cb652$export$2e2bcd8739ae039; });

var $kPFIq = parcelRequire("kPFIq");
function $d6d11a88f14cb652$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $kPFIq.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("kPFIq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a8eded2443e49f$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");
function $f2a8eded2443e49f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $ibF5z.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $ibF5z.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $ibF5z.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $f2a8eded2443e49f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("9hx4X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c1f5c676c0d610c$export$2e2bcd8739ae039; });

var $1xL2k = parcelRequire("1xL2k");

var $iePPp = parcelRequire("iePPp");
"use client";
const $6c1f5c676c0d610c$export$35e57303dbd8a66 = (0, $1xL2k.default)();
function $6c1f5c676c0d610c$var$useTheme(defaultTheme = $6c1f5c676c0d610c$export$35e57303dbd8a66) {
    return (0, $iePPp.default)(defaultTheme);
}
var $6c1f5c676c0d610c$export$2e2bcd8739ae039 = $6c1f5c676c0d610c$var$useTheme;

});


parcelRegister("hETT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdb18625cbca7d18$export$2e2bcd8739ae039; });

var $4hstI = parcelRequire("4hstI");
"use client";
const $cdb18625cbca7d18$var$defaultTheme = (0, $4hstI.default)();
var $cdb18625cbca7d18$export$2e2bcd8739ae039 = $cdb18625cbca7d18$var$defaultTheme;

});


parcelRegister("c4vUP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c9e9d84213e14d5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("88bST")).default; });

var $acAN1 = parcelRequire("acAN1");

var $hETT4 = parcelRequire("hETT4");

var $8T9M8 = parcelRequire("8T9M8");

var $88bST = parcelRequire("88bST");

"use client";
const $8c9e9d84213e14d5$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($acAN1)))({
    themeId: (0, $8T9M8.default),
    defaultTheme: $hETT4.default,
    rootShouldForwardProp: $88bST.default
});
var $8c9e9d84213e14d5$export$2e2bcd8739ae039 = $8c9e9d84213e14d5$var$styled;

});
parcelRegister("acAN1", function(module, exports) {
"use strict";

var $k87LI = parcelRequire("k87LI");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76d790091c095819$var$createStyled;
module.exports.shouldForwardProp = $76d790091c095819$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $76d790091c095819$var$_extends2 = $k87LI((parcelRequire("jMfol")));

var $76d790091c095819$var$_objectWithoutPropertiesLoose2 = $k87LI((parcelRequire("1wyJQ")));

var $76d790091c095819$var$_styledEngine = $76d790091c095819$var$_interopRequireWildcard((parcelRequire("lzvDq")));

var $jQI6N = parcelRequire("jQI6N");

var $76d790091c095819$var$_capitalize = $k87LI((parcelRequire("lYewH")));

var $76d790091c095819$var$_getDisplayName = $k87LI((parcelRequire("5VICX")));

var $76d790091c095819$var$_createTheme = $k87LI((parcelRequire("1pClC")));

var $76d790091c095819$var$_styleFunctionSx = $k87LI((parcelRequire("ieZHF")));
const $76d790091c095819$var$_excluded = [
    "ownerState"
], $76d790091c095819$var$_excluded2 = [
    "variants"
], $76d790091c095819$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $76d790091c095819$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($76d790091c095819$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $76d790091c095819$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $76d790091c095819$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $76d790091c095819$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $76d790091c095819$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $76d790091c095819$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $76d790091c095819$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $76d790091c095819$var$_createTheme.default)();
const $76d790091c095819$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $76d790091c095819$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $76d790091c095819$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $76d790091c095819$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $76d790091c095819$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $76d790091c095819$var$_objectWithoutPropertiesLoose2.default)(_ref, $76d790091c095819$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $76d790091c095819$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$76d790091c095819$var$processStyleArg(resolvedStyle, (0, $76d790091c095819$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $76d790091c095819$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $76d790091c095819$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $76d790091c095819$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $76d790091c095819$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $76d790091c095819$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $76d790091c095819$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $76d790091c095819$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $76d790091c095819$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $76d790091c095819$var$_styleFunctionSx.default)((0, $76d790091c095819$var$_extends2.default)({}, props, {
            theme: $76d790091c095819$var$resolveTheme((0, $76d790091c095819$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $76d790091c095819$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $76d790091c095819$var$defaultOverridesResolver($76d790091c095819$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $76d790091c095819$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $76d790091c095819$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $76d790091c095819$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($76d790091c095819$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $76d790091c095819$var$_styledEngine.default)(tag, (0, $76d790091c095819$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $jQI6N.isPlainObject)(stylesArg)) return (props)=>$76d790091c095819$var$processStyleArg(stylesArg, (0, $76d790091c095819$var$_extends2.default)({}, props, {
                    theme: $76d790091c095819$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $76d790091c095819$var$resolveTheme((0, $76d790091c095819$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $76d790091c095819$var$processStyleArg(slotStyle, (0, $76d790091c095819$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $76d790091c095819$var$resolveTheme((0, $76d790091c095819$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $76d790091c095819$var$processStyleArg({
                    variants: themeVariants
                }, (0, $76d790091c095819$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("jMfol", function(module, exports) {
function $e65e7074cae63b47$var$_extends() {
    module.exports = $e65e7074cae63b47$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $e65e7074cae63b47$var$_extends.apply(this, arguments);
}
module.exports = $e65e7074cae63b47$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1wyJQ", function(module, exports) {
function $11c3b9f398e12f48$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $11c3b9f398e12f48$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lzvDq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fb4567e797b72ab5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $fb4567e797b72ab5$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("2rRc0")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("2eN2x")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("2eN2x")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("d7MTS")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("kftdw")).default; });
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $lA09d = parcelRequire("lA09d");

var $2eN2x = parcelRequire("2eN2x");
var $2rRc0 = parcelRequire("2rRc0");

var $d7MTS = parcelRequire("d7MTS");

var $kftdw = parcelRequire("kftdw");
"use client";
function $fb4567e797b72ab5$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $lA09d.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $fb4567e797b72ab5$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("lA09d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb5d1315761d553c$export$2e2bcd8739ae039; });

var $deh0i = parcelRequire("deh0i");
parcelRequire("6Gonh");

parcelRequire("F4HzL");
parcelRequire("hkghS");
parcelRequire("72eWs");
parcelRequire("eyAY5");
parcelRequire("l2Abk");
var $fb5d1315761d553c$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
// bind it to avoid mutating the original function
var $fb5d1315761d553c$export$2e2bcd8739ae039 = (0, $deh0i.default).bind(null);
$fb5d1315761d553c$var$tags.forEach(function(tagName) {
    $fb5d1315761d553c$export$2e2bcd8739ae039[tagName] = $fb5d1315761d553c$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("deh0i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a19c5c923a99623$export$2e2bcd8739ae039; });

var $pnzUf = parcelRequire("pnzUf");
parcelRequire("2eN2x");
var $2rRc0 = parcelRequire("2rRc0");

var $F4HzL = parcelRequire("F4HzL");

var $hkghS = parcelRequire("hkghS");

var $72eWs = parcelRequire("72eWs");

var $eyAY5 = parcelRequire("eyAY5");

var $l2Abk = parcelRequire("l2Abk");
var $9a19c5c923a99623$var$isBrowser = typeof document !== "undefined";
var $9a19c5c923a99623$var$isDevelopment = false;
var $9a19c5c923a99623$var$testOmitPropsOnStringTag = (0, $l2Abk.default);
var $9a19c5c923a99623$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $9a19c5c923a99623$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9a19c5c923a99623$var$testOmitPropsOnStringTag : $9a19c5c923a99623$var$testOmitPropsOnComponent;
};
var $9a19c5c923a99623$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9a19c5c923a99623$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $72eWs.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $hkghS.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $72eWs.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9a19c5c923a99623$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $eyAY5.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9a19c5c923a99623$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9a19c5c923a99623$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9a19c5c923a99623$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $2rRc0.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $eyAY5.useContext((0, $2rRc0.T));
            }
            if (typeof props.className === "string") className = (0, $72eWs.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $F4HzL.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9a19c5c923a99623$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $eyAY5.createElement($eyAY5.Fragment, null, /*#__PURE__*/ $eyAY5.createElement($9a19c5c923a99623$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $eyAY5.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && $9a19c5c923a99623$var$isDevelopment) return "NO_COMPONENT_SELECTOR";
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $pnzUf.default)({}, options, nextOptions, {
                shouldForwardProp: $9a19c5c923a99623$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("l2Abk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f515d9d2b500b9ee$export$2e2bcd8739ae039; });

var $9sLax = parcelRequire("9sLax");
// eslint-disable-next-line no-undef
var $f515d9d2b500b9ee$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $f515d9d2b500b9ee$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9sLax.default)(function(prop) {
    return $f515d9d2b500b9ee$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("d7MTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98e1dc60d0ac8d44$export$2e2bcd8739ae039; });
parcelRequire("eyAY5");


var $2rRc0 = parcelRequire("2rRc0");

var $7QoWY = parcelRequire("7QoWY");

var $Dkugg = parcelRequire("Dkugg");
"use client";
let $98e1dc60d0ac8d44$var$cache;
if (typeof document === "object") $98e1dc60d0ac8d44$var$cache = (0, $7QoWY.default)({
    key: "css",
    prepend: true
});
function $98e1dc60d0ac8d44$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $98e1dc60d0ac8d44$var$cache ? /*#__PURE__*/ (0, $Dkugg.jsx)((0, $2rRc0.C), {
        value: $98e1dc60d0ac8d44$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("7QoWY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b60be4b73a9fd75$export$2e2bcd8739ae039; });

var $bYnRY = parcelRequire("bYnRY");

var $aevEr = parcelRequire("aevEr");
parcelRequire("3Vt5e");
parcelRequire("7AKfr");
var $5b60be4b73a9fd75$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $aevEr.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $aevEr.token)(character)) break;
        (0, $aevEr.next)();
    }
    return (0, $aevEr.slice)(begin, (0, $aevEr.position));
};
var $5b60be4b73a9fd75$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $aevEr.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $aevEr.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $5b60be4b73a9fd75$var$identifierWithPointTracking((0, $aevEr.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $aevEr.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $aevEr.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $aevEr.from)(character);
    }
    while (character = (0, $aevEr.next)());
    return parsed;
};
var $5b60be4b73a9fd75$var$getRules = function getRules(value, points) {
    return (0, $aevEr.dealloc)($5b60be4b73a9fd75$var$toRules((0, $aevEr.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $5b60be4b73a9fd75$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $5b60be4b73a9fd75$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$5b60be4b73a9fd75$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $5b60be4b73a9fd75$var$fixedElements.set(element, true);
    var points = [];
    var rules = $5b60be4b73a9fd75$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $5b60be4b73a9fd75$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $5b60be4b73a9fd75$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $5b60be4b73a9fd75$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($5b60be4b73a9fd75$var$ignoreFlag) > -1;
};
var $5b60be4b73a9fd75$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($5b60be4b73a9fd75$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $5b60be4b73a9fd75$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $5b60be4b73a9fd75$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$5b60be4b73a9fd75$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $5b60be4b73a9fd75$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $5b60be4b73a9fd75$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$5b60be4b73a9fd75$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $5b60be4b73a9fd75$var$nullifyElement(element);
    } else if ($5b60be4b73a9fd75$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $5b60be4b73a9fd75$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $5b60be4b73a9fd75$var$prefix(value, length) {
    switch((0, $aevEr.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $aevEr.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $aevEr.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MOZ) + value + (0, $aevEr.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + value + value;
        // order
        case 6165:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.replace)(value, /(\w+).+(:[^]+)/, (0, $aevEr.WEBKIT) + "box-$1$2" + (0, $aevEr.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + "flex-item-" + (0, $aevEr.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + "flex-line-pack" + (0, $aevEr.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $aevEr.WEBKIT) + "box-" + (0, $aevEr.replace)(value, "-grow", "") + (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $aevEr.WEBKIT) + (0, $aevEr.replace)(value, /([^-])(transform)/g, "$1" + (0, $aevEr.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $aevEr.replace)((0, $aevEr.replace)((0, $aevEr.replace)(value, /(zoom-|grab)/, (0, $aevEr.WEBKIT) + "$1"), /(image-set)/, (0, $aevEr.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $aevEr.replace)(value, /(image-set\([^]*)/, (0, $aevEr.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $aevEr.replace)((0, $aevEr.replace)(value, /(.+:)(flex-)?(.*)/, (0, $aevEr.WEBKIT) + "box-pack:$3" + (0, $aevEr.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $aevEr.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $aevEr.replace)(value, /(.+)-inline(.+)/, (0, $aevEr.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $aevEr.strlen)(value) - 1 - length > 6) switch((0, $aevEr.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $aevEr.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $aevEr.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $aevEr.WEBKIT) + "$2-$3" + "$1" + (0, $aevEr.MOZ) + ((0, $aevEr.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $aevEr.indexof)(value, "stretch") ? $5b60be4b73a9fd75$var$prefix((0, $aevEr.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $aevEr.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $aevEr.charat)(value, (0, $aevEr.strlen)(value) - 3 - (~(0, $aevEr.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $aevEr.replace)(value, ":", ":" + (0, $aevEr.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $aevEr.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $aevEr.WEBKIT) + ((0, $aevEr.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $aevEr.WEBKIT) + "$2$3" + "$1" + (0, $aevEr.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $aevEr.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + (0, $aevEr.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $aevEr.WEBKIT) + value + (0, $aevEr.MS) + value + value;
    }
    return value;
}
var $5b60be4b73a9fd75$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $aevEr.DECLARATION:
                element["return"] = $5b60be4b73a9fd75$var$prefix(element.value, element.length);
                break;
            case 0, $aevEr.KEYFRAMES:
                return (0, $aevEr.serialize)([
                    (0, $aevEr.copy)(element, {
                        value: (0, $aevEr.replace)(element.value, "@", "@" + (0, $aevEr.WEBKIT))
                    })
                ], callback);
            case 0, $aevEr.RULESET:
                if (element.length) return (0, $aevEr.combine)(element.props, function(value) {
                    switch((0, $aevEr.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $aevEr.serialize)([
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(read-\w+)/, ":" + (0, $aevEr.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $aevEr.serialize)([
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(plac\w+)/, ":" + (0, $aevEr.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(plac\w+)/, ":" + (0, $aevEr.MOZ) + "$1")
                                    ]
                                }),
                                (0, $aevEr.copy)(element, {
                                    props: [
                                        (0, $aevEr.replace)(value, /:(plac\w+)/, (0, $aevEr.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $5b60be4b73a9fd75$var$defaultStylisPlugins = [
    $5b60be4b73a9fd75$var$prefixer
];
var $5b60be4b73a9fd75$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $5b60be4b73a9fd75$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $5b60be4b73a9fd75$var$compat,
        $5b60be4b73a9fd75$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $aevEr.stringify),
        (0, $aevEr.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $aevEr.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $aevEr.serialize)((0, $aevEr.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $bYnRY.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bYnRY", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $8b77d05285799e84$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $8b77d05285799e84$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $8b77d05285799e84$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $8b77d05285799e84$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($8b77d05285799e84$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $8b77d05285799e84$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("3Vt5e", function(module, exports) {
var $2dbd415318e50ad9$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7AKfr", function(module, exports) {
function $586fc51879110529$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("kftdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebdbdf491345fc79$export$2e2bcd8739ae039; });
parcelRequire("eyAY5");


var $2eN2x = parcelRequire("2eN2x");

var $Dkugg = parcelRequire("Dkugg");
"use client";
function $ebdbdf491345fc79$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $ebdbdf491345fc79$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($ebdbdf491345fc79$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $Dkugg.jsx)((0, $2eN2x.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("lYewH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jEG8Q")).default; });

var $jEG8Q = parcelRequire("jEG8Q");

});

parcelRegister("5VICX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lWUtc")).default; });

var $lWUtc = parcelRequire("lWUtc");
$parcel$exportWildcard(module.exports, $lWUtc);

});
parcelRegister("lWUtc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $ffaad184de9c34ad$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $ffaad184de9c34ad$export$2e2bcd8739ae039; });

var $ddopK = parcelRequire("ddopK");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $ffaad184de9c34ad$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $ffaad184de9c34ad$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($ffaad184de9c34ad$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $ffaad184de9c34ad$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $ffaad184de9c34ad$export$aad197c7121a6651(Component) || fallback;
}
function $ffaad184de9c34ad$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ffaad184de9c34ad$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ffaad184de9c34ad$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $ffaad184de9c34ad$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $ddopK.ForwardRef:
            return $ffaad184de9c34ad$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $ddopK.Memo:
            return $ffaad184de9c34ad$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("ddopK", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1ifdb"));

});
parcelRegister("1ifdb", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $0f13459fa076740b$export$a7c73072b1a182ae; }, function (v) { return $0f13459fa076740b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $0f13459fa076740b$export$9f27bc3417b4524d; }, function (v) { return $0f13459fa076740b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $0f13459fa076740b$export$db77ccec0bb4ccac; }, function (v) { return $0f13459fa076740b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $0f13459fa076740b$export$8392c0c9d3dcbd35; }, function (v) { return $0f13459fa076740b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0f13459fa076740b$export$ffb0004e005737fa; }, function (v) { return $0f13459fa076740b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $0f13459fa076740b$export$b624eff549462981; }, function (v) { return $0f13459fa076740b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $0f13459fa076740b$export$7897aa7841a5380c; }, function (v) { return $0f13459fa076740b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $0f13459fa076740b$export$602eac185826482c; }, function (v) { return $0f13459fa076740b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $0f13459fa076740b$export$e2c29f18771995cb; }, function (v) { return $0f13459fa076740b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0f13459fa076740b$export$5f8d39834fd61797; }, function (v) { return $0f13459fa076740b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0f13459fa076740b$export$74bf444e3cd11ea5; }, function (v) { return $0f13459fa076740b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $0f13459fa076740b$export$998bcd577473dd93; }, function (v) { return $0f13459fa076740b$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $0f13459fa076740b$export$92387174baf9b227; }, function (v) { return $0f13459fa076740b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $0f13459fa076740b$export$ec112efeb987d9c6; }, function (v) { return $0f13459fa076740b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $0f13459fa076740b$export$b706b080d889d2c9; }, function (v) { return $0f13459fa076740b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $0f13459fa076740b$export$5be5a87408f70ddc; }, function (v) { return $0f13459fa076740b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $0f13459fa076740b$export$45a5e7f76e0caa8d; }, function (v) { return $0f13459fa076740b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $0f13459fa076740b$export$455c2e768291efa6; }, function (v) { return $0f13459fa076740b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $0f13459fa076740b$export$9522e17588c12572; }, function (v) { return $0f13459fa076740b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $0f13459fa076740b$export$2110ac352bb060b9; }, function (v) { return $0f13459fa076740b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $0f13459fa076740b$export$56885ab8b9c456ab; }, function (v) { return $0f13459fa076740b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $0f13459fa076740b$export$d927fcb6adf8f9de; }, function (v) { return $0f13459fa076740b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $0f13459fa076740b$export$b82d16f27459e05a; }, function (v) { return $0f13459fa076740b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $0f13459fa076740b$export$522c17b4f5e123e8; }, function (v) { return $0f13459fa076740b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $0f13459fa076740b$export$1aabd8a0274ecfd6; }, function (v) { return $0f13459fa076740b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $0f13459fa076740b$export$3d6c20d97e46b957; }, function (v) { return $0f13459fa076740b$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $0f13459fa076740b$export$9b621391a187a31a; }, function (v) { return $0f13459fa076740b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $0f13459fa076740b$export$f5bbd400c2f4426f; }, function (v) { return $0f13459fa076740b$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0f13459fa076740b$export$a7c73072b1a182ae;
var $0f13459fa076740b$export$9f27bc3417b4524d;
var $0f13459fa076740b$export$db77ccec0bb4ccac;
var $0f13459fa076740b$export$8392c0c9d3dcbd35;
var $0f13459fa076740b$export$ffb0004e005737fa;
var $0f13459fa076740b$export$b624eff549462981;
var $0f13459fa076740b$export$7897aa7841a5380c;
var $0f13459fa076740b$export$602eac185826482c;
var $0f13459fa076740b$export$e2c29f18771995cb;
var $0f13459fa076740b$export$5f8d39834fd61797;
var $0f13459fa076740b$export$74bf444e3cd11ea5;
var $0f13459fa076740b$export$998bcd577473dd93;
var $0f13459fa076740b$export$92387174baf9b227;
var $0f13459fa076740b$export$ec112efeb987d9c6;
var $0f13459fa076740b$export$b706b080d889d2c9;
var $0f13459fa076740b$export$5be5a87408f70ddc;
var $0f13459fa076740b$export$45a5e7f76e0caa8d;
var $0f13459fa076740b$export$455c2e768291efa6;
var $0f13459fa076740b$export$9522e17588c12572;
var $0f13459fa076740b$export$2110ac352bb060b9;
var $0f13459fa076740b$export$56885ab8b9c456ab;
var $0f13459fa076740b$export$d927fcb6adf8f9de;
var $0f13459fa076740b$export$b82d16f27459e05a;
var $0f13459fa076740b$export$522c17b4f5e123e8;
var $0f13459fa076740b$export$1aabd8a0274ecfd6;
var $0f13459fa076740b$export$3d6c20d97e46b957;
var $0f13459fa076740b$export$9b621391a187a31a;
var $0f13459fa076740b$export$f5bbd400c2f4426f;
"use strict";
var $0f13459fa076740b$var$b = Symbol.for("react.element"), $0f13459fa076740b$var$c = Symbol.for("react.portal"), $0f13459fa076740b$var$d = Symbol.for("react.fragment"), $0f13459fa076740b$var$e = Symbol.for("react.strict_mode"), $0f13459fa076740b$var$f = Symbol.for("react.profiler"), $0f13459fa076740b$var$g = Symbol.for("react.provider"), $0f13459fa076740b$var$h = Symbol.for("react.context"), $0f13459fa076740b$var$k = Symbol.for("react.server_context"), $0f13459fa076740b$var$l = Symbol.for("react.forward_ref"), $0f13459fa076740b$var$m = Symbol.for("react.suspense"), $0f13459fa076740b$var$n = Symbol.for("react.suspense_list"), $0f13459fa076740b$var$p = Symbol.for("react.memo"), $0f13459fa076740b$var$q = Symbol.for("react.lazy"), $0f13459fa076740b$var$t = Symbol.for("react.offscreen"), $0f13459fa076740b$var$u;
$0f13459fa076740b$var$u = Symbol.for("react.module.reference");
function $0f13459fa076740b$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $0f13459fa076740b$var$b:
                switch(a = a.type, a){
                    case $0f13459fa076740b$var$d:
                    case $0f13459fa076740b$var$f:
                    case $0f13459fa076740b$var$e:
                    case $0f13459fa076740b$var$m:
                    case $0f13459fa076740b$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0f13459fa076740b$var$k:
                            case $0f13459fa076740b$var$h:
                            case $0f13459fa076740b$var$l:
                            case $0f13459fa076740b$var$q:
                            case $0f13459fa076740b$var$p:
                            case $0f13459fa076740b$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $0f13459fa076740b$var$c:
                return r;
        }
    }
}
$0f13459fa076740b$export$a7c73072b1a182ae = $0f13459fa076740b$var$h;
$0f13459fa076740b$export$9f27bc3417b4524d = $0f13459fa076740b$var$g;
$0f13459fa076740b$export$db77ccec0bb4ccac = $0f13459fa076740b$var$b;
$0f13459fa076740b$export$8392c0c9d3dcbd35 = $0f13459fa076740b$var$l;
$0f13459fa076740b$export$ffb0004e005737fa = $0f13459fa076740b$var$d;
$0f13459fa076740b$export$b624eff549462981 = $0f13459fa076740b$var$q;
$0f13459fa076740b$export$7897aa7841a5380c = $0f13459fa076740b$var$p;
$0f13459fa076740b$export$602eac185826482c = $0f13459fa076740b$var$c;
$0f13459fa076740b$export$e2c29f18771995cb = $0f13459fa076740b$var$f;
$0f13459fa076740b$export$5f8d39834fd61797 = $0f13459fa076740b$var$e;
$0f13459fa076740b$export$74bf444e3cd11ea5 = $0f13459fa076740b$var$m;
$0f13459fa076740b$export$998bcd577473dd93 = $0f13459fa076740b$var$n;
$0f13459fa076740b$export$92387174baf9b227 = function() {
    return !1;
};
$0f13459fa076740b$export$ec112efeb987d9c6 = function() {
    return !1;
};
$0f13459fa076740b$export$b706b080d889d2c9 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$h;
};
$0f13459fa076740b$export$5be5a87408f70ddc = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$g;
};
$0f13459fa076740b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0f13459fa076740b$var$b;
};
$0f13459fa076740b$export$455c2e768291efa6 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$l;
};
$0f13459fa076740b$export$9522e17588c12572 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$d;
};
$0f13459fa076740b$export$2110ac352bb060b9 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$q;
};
$0f13459fa076740b$export$56885ab8b9c456ab = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$p;
};
$0f13459fa076740b$export$d927fcb6adf8f9de = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$c;
};
$0f13459fa076740b$export$b82d16f27459e05a = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$f;
};
$0f13459fa076740b$export$522c17b4f5e123e8 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$e;
};
$0f13459fa076740b$export$1aabd8a0274ecfd6 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$m;
};
$0f13459fa076740b$export$3d6c20d97e46b957 = function(a) {
    return $0f13459fa076740b$var$v(a) === $0f13459fa076740b$var$n;
};
$0f13459fa076740b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0f13459fa076740b$var$d || a === $0f13459fa076740b$var$f || a === $0f13459fa076740b$var$e || a === $0f13459fa076740b$var$m || a === $0f13459fa076740b$var$n || a === $0f13459fa076740b$var$t || "object" === typeof a && null !== a && (a.$$typeof === $0f13459fa076740b$var$q || a.$$typeof === $0f13459fa076740b$var$p || a.$$typeof === $0f13459fa076740b$var$g || a.$$typeof === $0f13459fa076740b$var$h || a.$$typeof === $0f13459fa076740b$var$l || a.$$typeof === $0f13459fa076740b$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$0f13459fa076740b$export$f5bbd400c2f4426f = $0f13459fa076740b$var$v;

});




parcelRegister("1pClC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1xL2k")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("gVbBu")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("dkpA7")).default; });

var $1xL2k = parcelRequire("1xL2k");

var $gVbBu = parcelRequire("gVbBu");

var $dkpA7 = parcelRequire("dkpA7");

});

parcelRegister("ieZHF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("awgS7")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("awgS7")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("5eYJN")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("4emKc")).default; });

var $awgS7 = parcelRequire("awgS7");

var $5eYJN = parcelRequire("5eYJN");

var $4emKc = parcelRequire("4emKc");

});
parcelRegister("5eYJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d0d5fca8fbb7ec5$export$2e2bcd8739ae039; });

var $ibF5z = parcelRequire("ibF5z");

var $2kU93 = parcelRequire("2kU93");

var $jQI6N = parcelRequire("jQI6N");

var $4emKc = parcelRequire("4emKc");
const $3d0d5fca8fbb7ec5$var$_excluded = [
    "sx"
];
const $3d0d5fca8fbb7ec5$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $4emKc.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $3d0d5fca8fbb7ec5$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $2kU93.default)(props, $3d0d5fca8fbb7ec5$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $3d0d5fca8fbb7ec5$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $jQI6N.isPlainObject)(result)) return systemProps;
        return (0, $ibF5z.default)({}, systemProps, result);
    };
    else finalSx = (0, $ibF5z.default)({}, systemProps, inSx);
    return (0, $ibF5z.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("88bST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eb84a10dc58a7ae$export$2e2bcd8739ae039; });

var $lvqCJ = parcelRequire("lvqCJ");
const $5eb84a10dc58a7ae$var$rootShouldForwardProp = (prop)=>(0, $lvqCJ.default)(prop) && prop !== "classes";
var $5eb84a10dc58a7ae$export$2e2bcd8739ae039 = $5eb84a10dc58a7ae$var$rootShouldForwardProp;

});
parcelRegister("lvqCJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa812527096d08ff$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $fa812527096d08ff$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $fa812527096d08ff$export$2e2bcd8739ae039 = $fa812527096d08ff$var$slotShouldForwardProp;

});



parcelRegister("4ly0G", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", function () { return $32a38140259c0a20$export$29cad1383b3f235d; });

var $6Liqn = parcelRequire("6Liqn");

var $4qTcl = parcelRequire("4qTcl");
function $32a38140259c0a20$export$29cad1383b3f235d(slot) {
    return (0, $4qTcl.default)("MuiCircularProgress", slot);
}
const $32a38140259c0a20$var$circularProgressClasses = (0, $6Liqn.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $32a38140259c0a20$export$2e2bcd8739ae039 = $32a38140259c0a20$var$circularProgressClasses;

});
parcelRegister("6Liqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ec56c8e2328d898$export$2e2bcd8739ae039; });

var $4qTcl = parcelRequire("4qTcl");
function $4ec56c8e2328d898$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4qTcl.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("4qTcl", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $33a468537896ad04$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $33a468537896ad04$export$2e2bcd8739ae039; });

var $fKFWc = parcelRequire("fKFWc");
const $33a468537896ad04$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $33a468537896ad04$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $33a468537896ad04$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $fKFWc.default).generate(componentName)}-${slot}`;
}
function $33a468537896ad04$export$34c0130b1f3e8ae3(slot) {
    return $33a468537896ad04$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("fKFWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b77baed702169417$export$2e2bcd8739ae039; });
const $b77baed702169417$var$defaultGenerator = (componentName)=>componentName;
const $b77baed702169417$var$createClassNameGenerator = ()=>{
    let generate = $b77baed702169417$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $b77baed702169417$var$defaultGenerator;
        }
    };
};
const $b77baed702169417$var$ClassNameGenerator = $b77baed702169417$var$createClassNameGenerator();
var $b77baed702169417$export$2e2bcd8739ae039 = $b77baed702169417$var$ClassNameGenerator;

});





parcelRegister("bg4h8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8324814ed9d3a3db$export$2e2bcd8739ae039; });

var $eyAY5 = parcelRequire("eyAY5");

var $bNOR0 = parcelRequire("bNOR0");

var $irsOR = parcelRequire("irsOR");

var $iePPp = parcelRequire("iePPp");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $8324814ed9d3a3db$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $eyAY5.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $bNOR0.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $8324814ed9d3a3db$var$maybeReactUseSyncExternalStore = $eyAY5.useSyncExternalStore;
function $8324814ed9d3a3db$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $eyAY5.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $eyAY5.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $eyAY5.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $8324814ed9d3a3db$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $8324814ed9d3a3db$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $iePPp.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $irsOR.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $8324814ed9d3a3db$var$maybeReactUseSyncExternalStore !== undefined ? $8324814ed9d3a3db$var$useMediaQueryNew : $8324814ed9d3a3db$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

});
parcelRegister("bNOR0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $897bb7d7ad8a6545$export$2e2bcd8739ae039; });

var $eyAY5 = parcelRequire("eyAY5");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $897bb7d7ad8a6545$var$useEnhancedEffect = typeof window !== "undefined" ? $eyAY5.useLayoutEffect : $eyAY5.useEffect;
var $897bb7d7ad8a6545$export$2e2bcd8739ae039 = $897bb7d7ad8a6545$var$useEnhancedEffect;

});


parcelRegister("jM5Le", function(module, exports) {

$parcel$export(module.exports, "pages", function () { return $3f643abd215b74f0$export$da3bc2f57520e3c3; });
$parcel$export(module.exports, "filteredPages", function () { return $3f643abd215b74f0$export$e0041c700ae6c2ef; });

var $eyAY5 = parcelRequire("eyAY5");
const $3f643abd215b74f0$var$NAVBAR_EXCLUDES = [
    "imprint"
];



const $3f643abd215b74f0$export$da3bc2f57520e3c3 = {
    // resume: {
    //   title: "Résumé",
    //   path: "resume",
    //   Element: lazy(() => import("./pages/Resume")),
    // },
    about: {
        title: "About Me",
        path: "*",
        explizitPath: "about",
        Element: /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("4Qnrb")))
    },
    projects: {
        title: "Projects / Achievements",
        path: "projects-and-achievements",
        Element: /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("lqthu")))
    },
    imprint: {
        title: "Imprint (Impressum)",
        path: "imprint",
        Element: /*#__PURE__*/ (0, $eyAY5.lazy)(()=>(parcelRequire("bNnnX")))
    }
};
const $3f643abd215b74f0$export$e0041c700ae6c2ef = Object.entries($3f643abd215b74f0$export$da3bc2f57520e3c3).filter(([_, { path: path }])=>!$3f643abd215b74f0$var$NAVBAR_EXCLUDES.includes(path)).reduce((obj, [key, value])=>({
        ...obj,
        [key]: value
    }), {});

});
parcelRegister("4Qnrb", function(module, exports) {


module.exports = (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("94Ba5")).then(()=>parcelRequire("gFfxE"));

});
parcelRegister("hVJNz", function(module, exports) {
"use strict";

var $4UnGM = parcelRequire("4UnGM");
module.exports = $4UnGM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("4UnGM", function(module, exports) {
"use strict";
var $392ec48ba7a899cb$var$cachedBundles = {};
var $392ec48ba7a899cb$var$cachedPreloads = {};
var $392ec48ba7a899cb$var$cachedPrefetches = {};
function $392ec48ba7a899cb$var$getCache(type) {
    switch(type){
        case "preload":
            return $392ec48ba7a899cb$var$cachedPreloads;
        case "prefetch":
            return $392ec48ba7a899cb$var$cachedPrefetches;
        default:
            return $392ec48ba7a899cb$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $392ec48ba7a899cb$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("lqthu", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("8gJg9"))((parcelRequire("02AXE")).resolve("PmNul")),
    (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("qJwA7")),
    (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("8ncJs"))
]).then(()=>parcelRequire("7PpdG"));

});
parcelRegister("8gJg9", function(module, exports) {
"use strict";

var $4UnGM = parcelRequire("4UnGM");
module.exports = $4UnGM(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRegister("bNnnX", function(module, exports) {


module.exports = (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("hthkq")).then(()=>parcelRequire("lcnSA"));

});


parcelRegister("023Mx", function(module, exports) {

$parcel$export(module.exports, "useIsMobile", function () { return $151683e4a026e17f$export$2b96349243a56116; });
$parcel$export(module.exports, "useIsDarkTheme", function () { return $151683e4a026e17f$export$bd656dda9b97c79c; });

var $eyAY5 = parcelRequire("eyAY5");
function $151683e4a026e17f$export$2b96349243a56116() {
    return (0, $eyAY5.useMemo)(()=>navigator.userAgent.includes("Mobile"), []);
}
function $151683e4a026e17f$export$bd656dda9b97c79c(theme) {
    return (0, $eyAY5.useMemo)(()=>theme.palette.mode === "dark", [
        theme.palette.mode
    ]);
}
function $151683e4a026e17f$var$getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width: width,
        height: height
    };
}
function $151683e4a026e17f$export$f715c0e61b2c1a36() {
    const [windowDimensions, setWindowDimensions] = (0, $eyAY5.useState)($151683e4a026e17f$var$getWindowDimensions());
    (0, $eyAY5.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($151683e4a026e17f$var$getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}

});

parcelRegister("domgl", function(module, exports) {

module.exports = (parcelRequire("aztVG")).getBundleURL("7lpHJ") + "bg-light.7952c70f.png";

});

parcelRegister("7N6qs", function(module, exports) {

module.exports = (parcelRequire("aztVG")).getBundleURL("7lpHJ") + "bg-dark.eb61a23f.png";

});

parcelRegister("edX0V", function(module, exports) {


module.exports = (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("l1kpY")).then(()=>parcelRequire("4xGUd"));

});

parcelRegister("hLnD1", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("gAhUd")),
    (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("jQIKJ")),
    (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("cLQMU"))
]).then(()=>parcelRequire("11gox"));

});

parcelRegister("cQI3P", function(module, exports) {


module.exports = (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("kuUeW")).then(()=>parcelRequire("cYIbo"));

});

parcelRegister("iSo3z", function(module, exports) {


module.exports = (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("9DOQI")).then(()=>parcelRequire("do5O4"));

});

parcelRegister("43mnz", function(module, exports) {


module.exports = (parcelRequire("hVJNz"))((parcelRequire("02AXE")).resolve("fgaRB")).then(()=>parcelRequire("7c687"));

});



var $Dkugg = parcelRequire("Dkugg");
var $68aa0d31691919aa$exports = {};
"use strict";
function $68aa0d31691919aa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($68aa0d31691919aa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$68aa0d31691919aa$var$checkDCE();

$68aa0d31691919aa$exports = (parcelRequire("iBcuS"));




var $58OAM = parcelRequire("58OAM");
/**
 * Why? Because I can...
 */ const $2a6057c7aba3bf4f$var$crazyStyle = "font-weight: bold; font-size: 50px;color: red; text-shadow: 3px 3px 0 rgb(217,31,38) , 6px 6px 0 rgb(226,91,14) , 9px 9px 0 rgb(245,221,8) , 12px 12px 0 rgb(5,148,68) , 15px 15px 0 rgb(2,135,206) , 18px 18px 0 rgb(4,77,145) , 21px 21px 0 rgb(42,21,113)";
const $2a6057c7aba3bf4f$var$defaultTextStyle = "color: rgb(2,135,206); font-size: 15px";
const $2a6057c7aba3bf4f$var$divider = `%c ${"#".repeat(14)} `;
console.info($2a6057c7aba3bf4f$var$divider, $2a6057c7aba3bf4f$var$crazyStyle);
console.info("%c	Hi \uD83D\uDE0A\uD83D\uDC4B	", $2a6057c7aba3bf4f$var$crazyStyle);
console.info("%cWhat are you looking for? Here is nothing to see.", $2a6057c7aba3bf4f$var$defaultTextStyle);
console.info("%cFeel free to visit my GitHub: https://github.com/flokol120", $2a6057c7aba3bf4f$var$defaultTextStyle);
console.info($2a6057c7aba3bf4f$var$divider, $2a6057c7aba3bf4f$var$crazyStyle);



var $eyAY5 = parcelRequire("eyAY5");
const $f25e85c08ff84b11$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($68aa0d31691919aa$exports))).createRoot(document.getElementById("root"));
$f25e85c08ff84b11$var$root.render(/*#__PURE__*/ (0, $Dkugg.jsx)((0, $eyAY5.StrictMode), {
    children: /*#__PURE__*/ (0, $Dkugg.jsx)((0, $58OAM.default), {})
}));

})();
//# sourceMappingURL=index.0842f319.js.map
